/* eslint-disable prettier/prettier */
/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * Japanese resource file
 */

import {
    ArcTimeLineValidationTypes,
    ArcTimelineGroups,
    Entity,
    GAComponentDocumentStatus,
    GALinkStatus,
    GARoleTypeId,
    TaskListTypes,
    actionTypes,
    activityType,
    assignmentTypes,
    bulkAssignment,
    bulkAssignmentConstants,
    clientRequestNoteTab,
    confidentialityTypes,
    filters,
    financialStatementType,
    gaRecommendationType,
    gaScopes,
    groupSummaryTabs,
    independenceActionIds,
    instructionStatus,
    instructionType,
    ipFilterType,
    ipInputType,
    linkType,
    milestoneBuildTaskIds,
    notesFilter,
    reviewNoteRoutes,
    rnhFilterTypeQuery,
    rnhQuickFilter,
    snapshotComparisonIds,
    syncStatus,
    todoListTimeframeOptions,
    trialBalanceType,
    uiViews,
    receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {

    //Review notes tile 2

    reviewNoteTileGraphHeader: "期日別オープンレビューノート",
    reviewNoteTileGraphHeaderAssignedToMe: "私に割当てられたオープンのレビューノート（期日ごと）",
    reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date',
    reviewNoteYAxisLabel: "レビューノート",
    overDueCatFirst: "期日超過 >90",
    overDueCatSecond: "期日超過 31～90",
    overDueCatThird: "期日超過 10-30",
    overDueCatFourth: "期日超過 <10",
    catFifth: '<10',
    catSixth: '10-30',
    catSeventh: '31-90',
    catEighth: '>90',
    noNotesAvailable: "利用可能なノートなし",


    //ReviewNoteTiles
    totalOpen: "オープンの合計",
    totalCleared: "クリア済の合計",
    changeDueDate: "期日の変更",
    reviewNoteHashValue: '#',

    //Rejected PSPs
    rejectedPSPsTitle: 'Rejected PSPs',
    noRejectedPSPs: 'No rejected PSPs',
    updateRejectedPSPs: 'Update rejected PSPs',


    //CRA Build Step 2 Labels
    inherentRiskTypeId: "固有リスク評価",
    controlRiskTypeId: "統制リスク評価",
    viewUnRelatedWCGWs: "関連付けのないWCGWsを表示する",
    unrelatedWCGWsInstruction: "以下に表示されたWCGWsはどのアサーションにも関連付けられていません。少なくとも１つのアサーションに関連付けるか削除する必要があります。SCOTsのドロップダウンから\'関連付けのないWCGWs\'を選択すると、'WCGWsとアサーションの関連付け'モーダルにおいてこれらのWCGWsを簡単に見つけることができます。WCGWが関連付いていないか編集する必要がある場合、元のページの\'WCGWs及び統制の識別'\リンクをクリックして変更してください。",
    relatedWCGWsInstruction: "WCGWを選択したアサーションに関連付けてください。特定のSCOTからWCGWを関連付けるにはSCOTを選択するか、すべてのSCOTからオプションを選択します。アサーションに関連付ける必要があるWCGWのリストについては、\'関連付けのないWCGW'\を選択してください。",
    allScots: " すべてのSCOTs",
    allWCGWs: "すべてのWCGWs",
    unRelatedWCGWs: " 関連付けのないWCGWs",
    //CRA Build Step 4 Header Label
    craValue: "CRA",
    incompleteCraValue: "未完了のCRA",
    // Panel Headers
    taskCategories: "タスクナビゲーション",
    taskCategoryExecution: "実施",
    taskList: "タスクリスト",
    taskDetails: "タスクの詳細",
    fullScreen: "フルスクリーン",
    exitFullScreen: "フルスクリーンを終了",
    defaultDropdown: "ドロップダウンメニュー",
    status: "ステータス",
    language: "言語",
    channel: "チャンネル",
    header: "ヘッダー",
    headerName: "ヘッダー名",
    sectionCustomLabelLabel: "カスタムラベル",
    sectionNamePlaceHolder: "セクションのタイトルの入力",
    showRelatedObjectLabel: "関連するオブジェクトの表示",
    errorBanner: "エラー件数　{0}",
    customize: "カスタマイズ",
    customized: "カスタマイズ済",
    custom: "カスタム",
    description: "説明",
    seeDescription: "説明を確認",
    section: "セクション",
    entities: "企業",
    edit: "編集",
    delete: "削除",
    collapse: "折りたたむ",
    collapseAll: "すべてを折りたたむ",
    expand: "展開する",
    expandAll: "すべてを展開する",
    incompleteResponse: "対応不十分",
    unresolvedComments: "未対応のコメント",
    saving: "保存中...",
    tasks: "タスク",
    requests: "リクエスト",

    //BodyType Placeholder
    numericValuePlaceholder: "金額を入力してください",

    //Modal
    addButton: "ボタンの追加",
    evidence: "エビデンス",
    temporary: "一時ファイル",
    temporaryFiles: "一時ファイル",
    priorPeriod: "前期",
    externaldocuments: "外部文書",
    eydocuments: "EY文書",
    clientRequestClientAnalytics: "アナリティクス名",
    groupdocuments: "グループ文書",
    name: "名前",
    reason: "理由",
    browse: "ブラウズ",
    uploadFile: "ファイルのアップロード",
    uploadDocument: "文書のアップロード",
    duplicateDocumentHeader: "このエンゲージメントには、同じ名前の文書が1つ以上存在します（エビデンス又は一時ファイルとして）。",
    duplicateDocumentInstruction: "「上書き」を選択して文書をアップロードし、既存のファイルを置き換えるか、[破棄]を選択してキャンセルします。この既存のファイルがエビデンスにある場合、文書はエビデンスにアップロードされます。既存のファイルが一時ファイルにある場合、文書は一時ファイルにアップロードされます。",
    overwriteLabel: "上書き",
    discardLabel: "破棄",
    discardChangesLabel: "変更の破棄",
    note: "ノート",
    notes: "ノート",
    signOffs: "サインオフ",
    related: "関連",
    attributes: "属性",
    approveChanges: "変更の承認",
    nodocumentsAdded: "利用可能な文書はありません",
    noEntitiesAvailable: "利用可能なエンティティがありません",
    noDocumentsUpload: "アップロードされている文書はありません",
    noSections: "セクションは利用できません",
    noRequestMessage: "このエンゲージメントには、要求または外部タスクはありません",
    noResultFound: "結果が見つかりません。",
    noRequestsFound: "リクエストが見つかりません",
    noTimePhasesFound: "利用可能なタイムフェーズなし",
    noEntitiesFound: "結果がありません",
    relatedEntities: "関連するエンティティ",
    noClickableRelatedEntities: "このタスクはエンティティの関連付けを編集することができません",
    taskByEntityLabel: "エンティティ別タスク",
    relEntityLabel: "エンティティ",
    singleEntity: "{0}エンティティ",
    multipleEntity: "{0}エンティティ",
    engagementDeliveryLabel: "エンティティ別タスク",
    onlyShowRelEntities: "関連するエンティティのみ表示",
    engDeliveryDescription: "このタスクはエンゲージメントにおけるすべてのエンティティに関連付けられています。",
    relEntitiesDescription: "タスクに関連付けられたエンティティを表示します。関連付けられたエンティティはOSP及びOSTタスクでのみ編集できます。",
    relEntitiesPSTorPSPDesc: "タスクに関連付けられたエンティティを表示します。PST及びPSPタスクではエンティティの関連付けを編集できません。",
    warningRelMsg: "タスクは1つ以上のエンティティに関連付ける必要があります。タスクをエンゲージメント全体のタスクとするには、「エンティティ別タスク」トグルで変更してください。",
    reldetailDescription: "デフォルト設定では、OSPおよびOSTタスクはエンゲージメント全体のタスクとなっており、すべてのエンティティに関連付けられています。タスクはエンティティ別タスクを有効化することで、1つ以上のエンティティに関連付けることができます。",
    results: "結果",
    searchPlaceholder: "検索",
    searchDocPlaceholder: "文書を検索",
    searchCanvasForms: "Canvasフォームの検索",
    searchControlForms: "SCOTsの検索",
    canvasFormListDescription: "以下のリストからCanvasフォームを選択することで関連するCanvasフォームレポートを参照することができます。",
    controlFormListDescription: "SCOTを選択すると関連する統制フォームが表示されます。",
    object: "オブジェクト",
    relateCollaboration: "コラボレーションの関連付け",
    reviewNote: "レビューノート",
    reviewNoteSingle: "レビューノート",
    documentReviewNotes: "文書ノート",
    noEvidenceFilesAssociated: "このタスクに関連付けられたエビデンスファイルはありません",
    taskReviewNoteWithParenthesess: "タスクノート",
    taskNotes: "タスクノート",
    documentsNotes: "文書ノート",
    addNewDocumentNote: "文書ノートの追加",
    selectDocument: "文書の選択",
    taskReviewNotes: "タスクノート",
    showCleared: "クリア済を表示",
    Replied: "返信：",
    showClosed: "クローズ済を表示",
    allNotes: "全てのノート",
    myNotes: "私のノート",
    noTasksAvailable: "利用可能なタスクがありません",
    noWCGWAvailableForTask: "重要な虚偽表示リスクがありません",
    noSubstantiveTasksAvailable: "関連する実証タスクがありません",
    noNotesAssociatedWithDocument: "この文書に関連するノートなし",
    noNotesAssociatedWithTak: "このタスクに関連するノートなし",
    otherEngagementNotes: "他のエンゲージメントノート",
    to: "に",
    deleteReviewNote: "削除",
    missingToUserError: "必須",
    missingReviewNoteTextError: "レビューノートテキストが必要です",
    invalidReviewNoteTextError: "入力された文字が制限を超えています",
    dueDateRequiredTextError: "期日は必須です",
    saveNoteTextError: "続行するには、保存またはキャンセルを実行してください",
    engagementName: "エンゲージメント名：",
    assignmentsCountLabel: "割当て",
    AssignmentsDays: "日",
    closedOnTime: "期限内クローズ済",
    daysToPrepare: "作成日数",
    daysToReview: "レビュー日数",
    totalAssignments: "合計 <br>割当て",
    currentlyAssigned: "現在 <br>割当て済",
    UpcomingAssignments: "今後の予定",
    authoredByMe: "私が作成",
    commentsLabel: "レビューノート",
    clearedOnTime: "期限内クリア済",
    daysToClear: "クリア日数",
    daysToClose: "クローズ日数",
    totalLabel: "全ノート",

    criticalAndHighRn: "クリティカル及び高のノート",
    criticalAndHighComments: "クリティカル及び高のノート",
    lowAndMediumComments: "中及び低のノート",
    metricsInstructionalText: "下記のあなたの割当て及びノートに関するパフォーマンス指標を表示してください。<br>チームメンバーを選択しメンバー別指標を確認するか、<b>エンゲージメントビュー</b>を選択し全体のサマリを確認してください。",
    metricsNewInstructionalText: "チームメンバーを選択して割当てられたレビューノート及び割当てを表示するか、<b>エンゲージメントビュー</b>を選択して全体サマリーを表示してください。",
    switchToViewPlaceholder: "表示するデータはありません。<br>別のチームメンバーを選択するか <b>エンゲージメント画面</b>に切替えてください。",
    tasksClosedOnTime: "期限内に終了したタスク",
    daysDetailReview: "詳細レビュー日数",
    daysGeneralReview: "一般レビュー日数",
    totalDaysReview: "レビュー日数合計",
    metricsInstructionalTextconfiguration: "下記の割当て及びノートに関するパフォーマンス指標の全体サマリーを確認してください。",

    //document download
    docSizeMB: "MB",
    docSizeKB: "KB",
    labelForExpiredPackage: "パッケージが期限切れです。",
    headerForDocumentDownload: "ファイル名をクリックしダウンロードしてください。",
    labelForNoFiles: "選択されたカテゴリーにファイルがありません。",
    labelForProcessing: "ファイルは処理中です。",

    //create dropdown texts
    create: "作成",
    addRequestText: "リクエスト",
    addExternalTaskText: "外部タスク",
    addFindingText: "発見事項",
    show: "表示:",
    riskTypeHeader: "リスクタイプ",
    wcgwHeader: "WCGW",
    hasNotes: "オープンノート",
    hasNote: "未完了のノート",
    noNotes: "（オープンノートは0）",
    addTemporaryFiles: "一時ファイルの追加",
    addPriorPeriodEvidence: "前期を追加",
    addExternalDocuments: "外部文書の追加",
    //Nav
    navHeaderTasks: "タスク",
    quickFilterAllCompletedTasks: "完了したすべてのタスク",
    quickFilterMyCompletedAssignmnets: "完了した私への割当て",
    quickFilterMyUpcomingAssignments: "今後の私への割当て",
    navHeaderTaskCategory: "タスクのカテゴリー",
    navFilterBy: "フィルタオプション",
    navHeaderDocuments: "文書",
    navHeaderCollaboration: "コラボレーション",
    navHeaderAssignments: "割当",
    navHeaderAutomation: "オートメーション",
    navHeaderMore: "詳細",
    navDashboard: "ダッシュボード",
    navReviewnotes: "レビューノート",
    navHeaderManageteam: "チーム管理",
    navHeaderMangeteamNew: "チームの管理－新規",
    mangeteam: "チームの管理",
    postArchive: "アーカイブ後",
    addmember: "メンバーの追加",
    addnewmember: "新メンバーの追加",
    addPriorPeriodMembers: "非アクティブなメンバーの追加",
    addPriorPeriodUsers: "非アクティブなメンバーの追加",
    createPackage: "パッケージの作成",
    engagementrole: "エンゲージメントの役割",
    noPendingPriorPeriodUsers: "インバイトできる非アクティブなメンバーはいません。",
    sendPriorPeriodUserInvitesWithCount: "インバイトを{0}個送信",
    sendPriorPeriodUserInvitesWithoutCount: "インバイトの送信",
    priorPeriodMembersModalHeaderMessage: "エンゲージメントに追加したい非アクティブなメンバーを選択してください。メンバーは、再アクティブ化時に以前エンゲージメント内で有していた権限が付与されます。",
    priorPeriodIndependenceModalHeaderMessage: "「独立性のみ」の回答している非アクティブなメンバーのうち、エンゲージメントに追加したいメンバーを選択してください。",
    disabledPriorPeriodMembersButtonToolTip: "以前のメンバーを追加する権限がありません。このアクションを実行する適切な権限を持つチームメンバーに連絡してください。",
    disabledNewMembersButtonToolTip: "新しいメンバーを追加する権限がありません。このアクションを実行する適切な権限を持つチームメンバーに連絡してください。",
    disabledNewMembersButtonToolTipThirdpartyuser: "新たな第三者メンバーの追加について十分な権限がありません。この操作について、適切な権限のあるチームメンバーと協議してください。",
    rbacNoRightsForContentUpdateToolTip: "コンテンツアップデートを実行するための権限が不足しています。エンゲージメント管理者に連絡してコンテンツアップデートを実施するための権限をもらってください。",
    deactivateInternalUsersWithCount: "{0} 名のメンバーを選択  ",
    canvasFormSelectionMessageSingular: "{0} Canvasフォーム選択済",
    canvasFormSelectionMessagePlural: "{0} Canvasフォーム選択済",
    pspAccountSelectionMessageSingular: "{0} 勘定選択済み",
    pspAccountSelectionMessagePlural: "{0} 勘定選択済み",
    manageTeamGroupLabel: "グループ",
    manageTeamGroupsLabel: "グループ",
    allAccessGroups: "すべてのアクセスグループ",
    reactivate: "再アクティブ化",
    deactivate: "非アクティブ化",
    unselect: "すべての選択を解除",
    deactivateInternalModalTitle: "内部メンバーの非アクティブ化",
    deactivateInternalModalMessage: "次のチームメンバーを非アクティブ化してもよろしいですか？",
    deactivateInternalUsersSuccessMessage: "{0} 名のメンバーは正常に非アクティブ化されました。",
    deactivateExternalModalTitle: "外部メンバーの非アクティブ化",
    deactivateExternalModalMessage: "次のチームメンバーを {0}から非アクティブ化してもよろしいですか？割当てられたアイテムはそれぞれのアクセスグループに再割当てされます。",
    deactivateExternalSuccessMessage: "メンバーは正常に非アクティブ化されました。",
    internalMember: "内部メンバー",
    addinternalmember: "内部メンバーの追加",
    addThirdPartymember: "第三者メンバーの追加",
    missingResponsiblePerson: "責任者がいません",
    sentRequests: "送信済",
    receivedRequests: "受信済",
    syncProfileNotAllowed: "同期プロファイルは許可されていません",
    allSyncProfileNotAllowedMessage: "同期プロファイルは許可されていません。このプロファイルではフォームを利用できません。",
    allCanvasFormsContentUpdateMessage: "共有されたEY Canvas FITイネーブルメントアクティビティにコンテンツを配信できません。これらのアクティビティのリンクを解除しコンテンツアップデートを続行してください。",
    someFormContentUpdateMessage: "コンテンツがないため、一部のフォームをエンゲージメントプロファイルに同期できません",
    linkedFormContentUpdateMessage: "共有されたEY Canvas FITイネーブルメントアクティビティにコンテンツを配信できません。これらのアクティビティのリンクを解除してください。",
    leaveUsFeedback: "Leave us feedback",

    notApplicableLabel: "N/A",
    addThirdPartyMemberDescription: "この機能は、第三者のレビューアーにこのEY Canvasエンゲージメントへのアクセスを許可するためにのみに使用します。プロフェッショナルプラクティスから適切な承認を得なければなりません。",
    hasOverallResponsibilityDescription: "監査又はエンゲージメントチームメンバーで、監査の指揮、監督及び実施、並びに状況に適合した報告及び/又はインターオフィスコンクルージョンに関する全般的責任を有する者",
    partnerInChargeHeader: "筆頭業務執行社員/エグゼクティブ",
    picFlag: "PIC",
    CannotUpdatePicInArchivedEngagement: "制限されたフィールドへの編集処理ができません。ページを更新し再試行してください。",

    noGroupFound: "このエンゲージメントではアクセスグループは作成されていません。「アクセスグループの追加」を選択して、新しい外部チームメンバーアクセスグループを作成します。",
    addGroup: "グループの追加",
    deleteGroup: "アクセスグループの削除",
    deleteGroupMessage: "{0} アクセスグループを削除してもよろしいですか？",
    addAccessGroup: "アクセスグループの追加",
    accessGroupCreated: "新しいアクセスグループ{0}が正常に作成されました。",
    accessGroupUpdated: "アクセスグループ {0} の変更は正常に保存されました",
    editAccessGroup: "アクセスグループの編集",
    sharedGroupwarning: "これは共有アクセスグループであり、これに対する変更はすべての関連するエンゲージメントに反映されます。",
    groups: "グループ",
    addExternalMembers: "全ての外部メンバー",
    members: "メンバー",
    externalMember: "外部メンバー",
    member: "メンバー",
    role: "役割",
    actions: "アクション",
    internalUserEdit: "編集",
    internalUserDeactivate: "非アクティブ化",
    usersFilter: "フィルター",
    externalUserEdit: "編集",
    externalUserDeactivate: "非アクティブ化",
    externalUserGroupLabel: "グループ",
    externalNoUserInGroup: "アクセスグループにメンバーは追加されていません。",
    externalNoUserInAllGroup: "エンゲージメントにメンバーは追加されていません。",
    alias: "別名",
    independence: "独立性",
    navManagegroup: "グループの管理",
    navCRAsummary: "CRAサマリー",
    navAuditplan: "監査計画",
    navWorkplan: "作業計画",
    navSEM: "Substantive evaluation matrix",
    nav440GL: "報告書日後の変更",
    navFindings: "発見事項",
    navCanvasformupdates: "Canvasフォームの更新",
    navPSPContentUpdates: "PSPコンテンツの更新",
    navCopyhubNew: "コピーハブ - NEW",
    navCopyhub: "コピーハブ",
    navArchiveChecklist: "アーカイブチェックリスト",
    navExporthub: "エクスポートハブ",
    navReporting: "レポーティング",
    navAccountSummary: "勘定科目サマリー",
    navScotSummary: "SCOTサマリー",
    navItSummary: "ITサマリー",
    navGroupInstructionSummary: "グループインストラクション",
    navGroupInvolvement: "Group involvement",
    navHelixProjects: "EY Helix接続",
    navContentUpdates: "コンテンツの更新",
    contentUpdateErrorMsg: "変更を保存する権限がありません。変更を行うには、これらの権限を持つ他のチームメンバーに連絡してください。",
    contentUpdateTitleTip: "コンテンツ更新の実行に必要な権限がありません。エンゲージメントの管理者へ連絡しコンテンツ更新を開始するために必要な権限付与を依頼してください。",
    noPreviousUpdates: "過去の更新はありません",
    noContentUpdateResults: "結果が見つかりません",
    noPSPAccountsToUpdate: "アップデートが必要な勘定科目はありません",
    rbcaUnavailableMsg: "EY Canvas上変更の保存ができませんでした。再試行しても問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    showErrInProgressMsg: "29007 - 他の更新の進行中は、コンテンツの更新を開始できません。現在のコンテンツの更新が完了するまで待つか、ページを更新してもう一度お試しください。",
    navHelp: "一般的なヘルプ",
    validationNavHelp: "検証のヘルプ",
    searchUserText: "ユーザーの検索",
    superModelTitle: "エンゲージメントオブジェクト",
    superModelText: "スーパーモーダル",
    independenceOnlyMembers: "「独立性のみ」の回答しているメンバー",
    noIndependenceOnlyPriorPeriodUsers: "インバイトできる「独立性のみ」の回答している非アクティブなメンバーはいません",

    //Copyright
    copyRight: "Copyright © <year> all rights reserved",

    //Copyhub List labels
    moreRecipient: "更に表示",
    copyHubPackageName: "パッケージ名",
    copyHubSentBy: "送信者",
    copyHubSentTo: "送信先",
    copyHubReceivedBy: "受信者",
    copyHubDate: "日付",
    copyHubRemainingTime: "残り時間",
    copyHubAvailableFor: "利用可能：",
    copyHubStatus: "ステータス",
    noCopyHubSentPackages: "コピーパッケージが作成されていません。パッケージの作成を選択し、新しいデータパッケージを作成してください。",
    noCopyHubReceivedPackages: "このエンゲージメントに利用可能なコピーパッケージはありません",
    remainingTimeTooltip: "アイテムはアーカイブ時または作成から10日を経た時点で完全に消去されます",
    copyHubDeleteText: "削除",
    appendDays: "日",
    generalInformation: "全般情報",
    copyDocuments: "文書",
    copyFiles: "ファイル",
    scots: "SCOTs",
    accounts: "勘定科目",
    copyHubImport: "インポート",
    copyHubPackageType: "パッケージタイプ：",
    copyHubCreatedModal: "作成済：",
    copyHubRemainingTimeModal: "残り時間：",
    copyHubAvailableForModal: "利用可能：",
    copyHubInstructionModal: "インストラクション：",
    copyHubCategories: "カテゴリー",
    copyHubPendingDeletion: "削除待ち",
    copyHubVersionMismatchCat: "パッケージのバージョンが異なるためカテゴリーを表示できません",
    copyHubVersionMismatchPersonInfo: "パッケージのバージョンが異なるため送信者情報、受信者情報を表示できません",
    copyHubViewLegacyPacakgeDetails: "詳細情報が利用できないレガシーコピーパッケージです。",
    associateTasks: "タスクの関連付け",
    backToForms: "フォームに戻る",
    noTaskSelected: "少なくとも1つのタスクを選択する必要があります",
    taskLabel: "タスク",
    taskMessage: "タスクをこれらのインポートフォームに関連付ける必要があります。",
    importSuccessMessage: "インポート要求が正常にキューに入れられました",
    taskSelectedText: "選択したタスク",
    insufficientPermissionsToImport: "コピーパッケージをインポートするための権限が不十分です。エンゲージメント管理者に連絡して、コピーパッケージをインポートする許可を依頼してください。",
    cannotImportExpiredPackage: "期限切れのコピーパッケージはインポートできません",
    cannotImportWhileInProgress: "既に進行中のコピーパッケージはインポートできません。",
    deletePackageHeader: "パッケージの削除",
    copyPackageDeleted: "パッケージは削除されました",
    copyPackageDeleteConfirmation: "このパッケージを削除してよろしいですか？",
    insufficientPermissionsToDelete: "コピーパッケージ削除に関する十分な権限がありません。エンゲージメント管理者に連絡しコピーパッケージの削除権限をリクエストしてください。",
    insufficientPermissions: "不十分な権限",
    GuidedWorkflowsPackageDisplayText: "インポートを選択すると、コピーからこのエンゲージメントに一致するガイド付きワークフローをアップデートします。一致するものがないガイド付きワークフローはインポートがなされません。",
    copyRequestStatusInQueue: "順番待ち",
    GuidedWorkflowImportError: "ガイドワークフローインポートはマルチエンティティエンゲージメントでは利用できません",

    //TopHeaderLayout.js
    topHeaderLayoutMilestoneText: "財務情報を基礎となる会計記録と一致または調整させます。期中の財務情報が、基礎となる会計記録と一致または調整されている証拠を入手します。 ",
    //TaskLayoutHeader
    taskLayoutHeaderSearchPlaceholder: "タスクの検索",
    taskLayoutHeaderAssignments: "割当て",
    taskLayoutHeaderAddTask: "新しいタスク",
    wcgwSearchPlaceholder: "WCGWの検索",
    //TaskListHeader
    taskTypeHeader: "タイプ",
    taskNameHeader: "名称",
    taskDueDateHeader: "期日",
    reviewNoteChangeDueDate: "期日の変更",
    taskListHeaderSortByDueDate: "期日",
    taskListHeaderSortByTaskName: "タスク名",
    sortBy: "並べ替え：",
    ascending: "昇順",
    descending: "降順",
    taskListHeaderSortByKnowledge: "監査計画",
    taskListHeaderDeleteWarning: "選択したタスクを削除しますか？",
    taskListHeaderSortText: "並び替え",
    taskListHeaderSortOrderText: "並べ替え順序",
    taskListHeaderTimePhaseText: "タイムフェーズの設定",
    taskListHeaderBookMarkText: "ブックマーク",
    taskListHeaderFavoriteText: "お気に入り",
    taskListHeaderEditText: "タスク名の編集",
    moreMenu: "詳細",
    taskListHeaderMoveTaskText: "タスクグループの変更",
    taskGroupIconHoverText: "タスクグループを変更してください",
    taskGroupLabel: "グループの変更",
    task: "タスク",
    toc: "TOC",
    tenNotes: "10 Notes",
    source: "ソース",
    nature: "手続の種類",
    assertion: "アサーション",
    relatedAccounts: "関連する勘定科目",
    testOfDetail: "詳細テスト",
    testOfControl: "統制テスト",
    substantiveAnalyticalProcedure: "分析的実証手続",
    tod: "TOD",
    sap: "SAP",
    int: "内部",
    ext: "外部",
    notSel: "未選択",
    internal: "内部",
    external: "外部",
    notSelected: "未選択",
    documentCannotOpen: "この文書をタスクの詳細から開くことはできません。ドキュメントリストに移動して、この文書を開きます。",
    //TaskPanelLayout
    emptyTaskDetailsMessage: "タスクを選択して詳細を表示します。",
    multiTaskSelectedMessage: "一括コントロールを有効にするには、Ctrlキーを使用して複数のタスクを選択します。\ n 個別のタスクで作業する場合は、タスクリストからそのタスクを選択します。",
    emptyAndMultiSelectedMessage: "一括制御を有効にするには、チェックボックスを使用して1つ以上のタスクを選択してください。一度に複数のタスクを選択するには、Shiftキーを使用してください。また、個々のタスクについて作業する場合は、リストからそのタスクを選択してください。 ",
    //Evidence
    evidenceDragAndDrop: "ドラッグ&ドロップまたは",
    //Timephases
    noResultTimePhase: "結果が見つかりません。",
    //handoff
    handoff: "ハンドオフ",
    handoffConfirmButtonText: "ハンドオフ",
    handoffModalTitle: "タスクハンドオフ",
    handoffTitle: "次のチームメンバーにハンドオフ",
    handoffTextLine2: "エビデンスファイルにサインオフするには、以下の選択肢から選んでください。",
    return: "差戻",
    returnDisabledMessage: "このタスクは次の理由で差戻できません。理由：(1)作成者として割当てられている、(2)タスクステータスが[レビュー中]又は[完了]でない、(3)作成者が割当てられていない。",
    handOffTitleTip: "レビューのためのハンドオフ",
    //Mark Complete
    markCompleteTitleTip: "完了とマーク",
    markCompleteTitle: "タスクを完了とマークする",
    markCompleteText: "サインオフは、以下に示すこのタスクに関連付けられたエビデンスに適用されます。このタスクは完了とマークされます。",
    markCompleteTextLine1: "このタスクを次のチームメンバーにハンドオフしてください。",
    markCompleteTextLine2: "エビデンスファイルにサインオフするには、以下のオプションから選択してください。このタスクの割当てがあり、タスクを完了している場合は、 <b>はい</b> を選択して閉じます。このタスクでPICまたはEQR のサインオフが必要な場合は、以下のオプションから選択してください。",
    markCompleteConfirm: "完了とマーク",
    signOffAs: "すべてのサインオフ:",
    additionalSignOff: "追加で必要なサインオフ",
    additionalTaskStatus: "私の割当てのクローズ",
    markCompleteModalHeaderTextPart1: "このタスクは完了としてマークされます。",
    markCompleteModalHeaderTextPart2: "エビデンスファイルにサインオフするには、以下のオプションから選択してください。このタスクの割当てがあり、タスクを完了している場合は、 <b>はい</b> を選択して閉じます。このタスクでPICまたはEQR のサインオフが必要な場合は、以下のオプションから選択してください。",
    ep: "PIC",
    eqr: "EQR",
    closeMyAssignment: "割り当てをクローズします",
    tempMarkCompleteMessage: "タスクを完了とすることができません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    tempMarkCompleteEnable: "完了とマークする権限-　有効化",
    tempMarkCompleteDisable: "完了とマークする権限-　無効化",
    //TaskDetails
    seeTask: "タスクを表示",
    NoTasksFound: "タスクが見つかりません。",
    taskDetailsAddRelate: "追加/関連付ける",
    taskDetailsDocument: "文書",
    taskDetailsAutomationRequest: "オートメーション・リクエスト",
    taskDetailsExternalTask: "外部タスク",
    taskDetailsFinding: "発見事項",
    taskDetailsRequest: "リクエスト",
    taskDetailsNotes: "注",
    taskDetailsRelatedTask: "関連するタスク",
    epeqr: "PIC/EQR",
    epeqrsignoffheader: "サインオフ必須",
    addTaskGroupLabel: "タスクグループに追加",
    itgcTaskDescription: "ITGCに関する設計したテストを実施して、依拠する期間全体におけるITGCの運用状況の有効性に関する十分かつ適切な監査証拠を入手してください。",
    //create assignment
    createassignmentheaderLine1: "選択されたチームメンバーにはこのタスクの割当がありません。",
    createassignmentheaderLine2: "ここでは割当を作成します。既に他のチームメンバーに同じタイプの不完全な割当がある場合、",
    createassignmentheaderLine3: "以下を選択し-",
    createassignmentheaderLine4: "この割当てに置き換えます。",
    overwriteIncompleAssignments: "不完全な割当ての上書き",
    //Create Assignment
    createassignmentheader1: "選択しているチームメンバーはこのタスクに割当てられていません。",
    createassignmentheader2: "割当ての作成",
    //Guidance
    atlasLink: "Atlasリンク",
    automationLink: "スマートオートメーションリンク",
    otherLink: "その他のリンク",
    helixLink: "Helix link",
    relatedAutomations: "関連するオートメーション",
    noSuggestedAutomationLabel: "このタスクについて推奨されるオートメーションはありません。",
    noSuggestedItemLabel: "このタスクに推奨される項目はありません",
    noAutomationRequestLabel: "このタスクと関連するオートメーションはありません。 開始するには、新しいオートメーションを作成するか、既存のオートメーションとの関連付けを行ってください。",
    relateAutomation: "関連付け",
    relateAutomationModelHeader: "スマートオートメーションの関連付け",
    automationSolution: "ソリューション",
    automationName: "オートメーション名",
    relateAutomationTextLine1: "このタスクにスマートオートメーションを関連付ける",
    relateAutomationTextLine2: "いったん関連付けられると、タスクの詳細からオートメーションを表示し、クリックして開くことができます。",
    noSamrtAutomationForEngagement: "エンゲージメントにスマートオートメーションが作成されていません。",
    searchAutomationLabel: "オートメーションの検索",

    //RelatedItemHeader
    relatedItemsHeader: "関連項目",
    relateButtonText: "関連付け",
    createButtonText: "作成",
    relatedItemREQ: "リクエスト",
    relatedItemET: "外部タスク",
    relatedItemATM: "オートメーション",
    relatedItemRelatedTask: "関連するタスク",
    relateObjectsToTaskTitle: "このタスクへのオブジェクトの関連付け",
    relateObjectsToTaskSubTitle: "このタスクに１つ以上のオブジェクトを関連付けてください。 これらのオブジェクトはタスク詳細の関連項目に表示されます。",
    relateObjectOptionsHeaderPSPOSP: "勘定科目、アサーション及びリスクが限定的な勘定科目",
    relateObjectOptionsHeaderITWalkthrough: "IT プロセス",
    relateObjectOptionsHeaderITControl: "IT 統制 (ITGCs 及び ITSPs)",
    // SDM Nextwave services
    scheduledServicesText: "関連するサービス",
    suggestedServicesText: "提案されたサービス",
    suggestedServicesDefaultMessage: "本タスクについて提案されたNextWaveサービスがあります。",
    suggestedServicesDefaultMessage1: '+',
    suggestedServicesDefaultMessage2: "アイコンにより開始できます",
    suggestedServicesPlaceholderMessage: "本タスクについて、推奨されたサービスはありません。",
    nextWaveServiceOfferingLabel: "サービス",
    nextWaveServiceStatusLabel: "ステータス",
    nextWaveServiceStartDateLabel: "開始日",
    nextWaveServiceDueDateLabel: "期限",
    nextWaveServiceRequestCreate: "リクエストの作成",
    nextWaveServiceRequests: "集中化サービスのリクエスト",
    nextWaveServiceGatewayRequests: "サービスゲートウェイリクエスト",
    onlyShowSelectedTask: "選択したタスクのみを表示",
    sdmRestrictAddTaskLabel: "[続行]をクリックして、次の手順に進みます。タスクの選択は、サービスオファリングが承諾され、GDSプロセスベースのチームマネージャーが完了すべき作業について話し合った後に行うことができます。",
    //Links
    linksText: "リンク",
    //Forms
    formsText: "フォーム",
    /*Accounts*/
    associatedTasks: "WCGWアイテムに関連付けられたタスク",
    noAssertionsChecked: "アサーションを選択して関連するWCGWを表示する",
    noAccountsCreated: "勘定科目は作成されませんでした",
    noDesignationSelected: "指定の選択がありません",
    noRelatedAccounts: "関連する勘定科目がありません。",
    manageAccount: "勘定科目及び開示の管理",
    /*Risks*/
    risk: "リスク",
    risks: "リスク",
    wcgw: "WCGW",
    riskWcgw: "リスク:WCGW",
    wcgwTasks: "WCGW: タスク",
    riskWcgwLabel: "リスクをWCGWsに関連付ける",
    wcgwTasksLabel: "WCGWをタスクに関連付ける",
    noRiskTypes: "リスクタイプが見つかりません",
    saveRisk: "保存",
    noRisksFound: "リスクは見つかりません",
    haveBeenIdentified: "が識別されました",
    noAssertionFound: "このエンゲージメントに該当する関連アサーションはありません",
    noAssertionApplicable: "このエンゲージメントに該当するアサーションは関連付けられていません",
    noWCGWFound: "このリスクに関連するWCGWsがありません。「関連付けの編集」をクリックして1つ以上のWCGWｓを関連付けてください。",
    noRelatedWCGWs: "関連するWCGWはありません",
    noRelatedControls: "関連する統制がありません。",
    noRelatedRisks: "関連するITリスクがありません",
    noRelatedITGCs: "関連するITGCがありません",
    iTriskVal: "ITリスク",
    iTrisksVal: "ITリスク",
    iTGCVal: "ITGC",
    iTGCsVal: "ITGCs",
    iTSPVal: "ITSP",
    iTSPsVal: "ITSPs",
    iTGCname: "ITGC名",
    iTSPname: "ITSP名",
    noWCGWAvailable: "選択されたアサーションに対してROMMが使用できません",
    relevantWcgwCountHint: "勘定科目名の横に表示されている数字は、WCGWｓの総数に対する、統制非依拠戦略に関連するアサーション及び高リスク見積項目に関連するアサーションに係るWCGWのうち対応実証タスクがあるものの数を示しています。",
    noAccountsFound: "レコードが見つかりません",
    selectAssertionToRelateWCGW: "「アサーション」を選択すると、リスクをWCGWに関連付けることができます。",
    significantAccounts: "重要勘定",
    riskName: "リスク: ",
    accountName: "勘定科目 ",
    noScotsFound: "関連するSCOTsがありません",
    relatedwcgw: "関連付けられた起こり得るエラー（WCGW）",
    relatedRisks: "関連するリスク",
    noRelatedAssertionsLabel: "勘定科目に対して選択されたアサーションがありません。",
    boltIconTitle: "関連するリスク",
    instructions: "インストラクション",
    expandRisk: "1.リスクの展開",
    selectAssertion: "2.アサーションの選択",
    identifyRelatedWCGW: "3. リスクに関連付いたWCGWsを識別する",
    clickAccount: "1.アカウントをクリックします",
    selectWCGW: "2.WCGWを選択します",
    identifyRelatedTask: "3.WCGWに対応するタスクを特定します",
    information: "情報",
    requiredAssertions: "必要なアサーション",
    wcgwWithoutTasks: "タスクのないWCGW",
    found: "見つかった",
    editAssociations: "関連付けを編集",
    riskWCGW: "リスクとWCGWの関係性の検証",
    wcgwTask: "WCGWとタスクの関係",
    requireTaskToBeRelated: "関連するタスクは必須です",
    expandCollapse: "ここをクリックして展開/折りたたむ",
    requiredAssertionsInfo: "統制非依拠戦略に関連するアサーション及び高リスク見積項目に関連するアサーションのみを表示",
    wCGWwithoutTasksInfo: "統制非依拠戦略に関連するアサーション及び高リスク見積項目に関連するアサーションに係るWCGWのうち対応実証タスクがないもののみ表示",
    noBuildStepsAvailable: "表示できるビルドステップはありません。",
    accountRiskAssessmentSummary: "勘定科目及び開示",
    manageRisk: "リスクの管理",
    addResponsivePSPOSP: "対応するPSP/OSPを追加",
    assertionlbl: "アサーション",
    addResponsiveControl: "対応する統制を追加",
    addResponsiveTOC: "対応するTOCを追加",
    showOnlyRelatedItems: "関連付けのあるもののみを表示",
    relatedControlCounter: "{0} 統制",
    relatedControlsCounter: "{0} 統制",
    noControlsAvailableForRelateItem: "利用可能な統制がありません",
    relateControlName: "統制",
    relateContolsAPIErrorMessage: "統制をアサーションに関連付けることができません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    relateTasksAPIErrorMessage: "アサーションにタスクを関連付けることができません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    toggleFilterWarningMessage: "実証手続の関連付けのない勘定科目及び開示のみを表示",
    toggleFilterWarningMessageForRisk: "対応する実証手続又は統制/TOCのないリスクを表示する",
    warningIconHoverText: "対応する実証手続又は統制/TOCのないリスク",
    filterYes: "Yes",
    filterNo: "No",

    /*OrphanedControls*/
    orphanedControls: 'View unrelated controls',
    unRelatedOrphanControls: 'Unrelated controls',
    noOrphanedControlsDataLabel: "No unrelated controls available",
    noOrphanedControlsResultLabel: "No unrelated controls available",
    noControlSelected: 'At least one control must be selected for deletion.',
    controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
    controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
    deleteControlModalHeader: 'Confirm deletion of selected control',
    deleteControlsModalHeader: 'Confirm deletion of selected controls',

    /*SEM*/
    select: "選択",
    selectAnAccountFromTheDropDown: "1.ドロップダウンから勘定科目を選択する",
    applyAsertionsFilters: "2.アサーションフィルターを適用する",
    reviewTheTasksThatRespondToTheRisks: "3.リスクに対応するタスクのレビュー",
    riskOfMaterialMisstatement: "重要な虚偽表示リスク",
    expandScot: "1.SCOTを展開する",
    selectWCGWToDisplayTheResponsiveTask: "2.重要な虚偽表示リスクを選択して対応するタスクを表示する",
    tasksWithNoRelatedWCGW: "タスクに関連する重要な虚偽表示リスクがありません",
    selected: "選択済",
    clearSelections: "すべての選択を解除",
    romm: "ROMM",
    selectAccount: "勘定科目",
    selectHeader: "ヘッダーの選択",
    riskOfMaterialMisstatementsWithoutRelatedTask: "関連するタスクが無い重要な虚偽表示リスク",
    selectOneOrMoreTasksToSeeTheRelatedROMM: "1つまたは複数のタスクを選択して関連する重要な虚偽表示リスクを表示する",
    invalidRelatedEntity: "関連するアカウントが見つかりません。ページを更新して再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    scrollUp: "上へスクロール",
    scrollDown: "下へスクロール",
    duplicate: "複製",
    showIndex: "インデックスを表示",
    noContentAvailable: "利用できるコンテンツがありません",
    navigateTo: "移動先",
    /*validations */
    semValidation: "SEMバリデーション",
    riskWCGWValidation: "リスクWCGWバリデーション",
    showValidation: "バリデーション",
    wcgwWithNoRelatedTask: "関連する実証タスクがないWCGW",
    riskWithNoRelatedWCGW: "関連するWCGWがないリスク",
    noValidationIdentified: "識別されたバリデーションがありません",
    onlyShowScotWithNoControlNoWCGW: "WCGWまたは統制の関連付けがないSCOTを表示する",
    /*CRA Badge*/
    ir: "固有リスク",
    cr: "統制リスク",
    cra: "CRA",
    selectToEdit: "選択して編集",
    both: "両方",
    prefix: "プレフィックス",
    suffix: "サフィックス",
    optional: "（任意）",
    title: "タイトル",
    charLimitExceeded: "文字数が上限を超えています",
    requiredField: "必須フィールド",
    Lastmodifiedby: "最終編集者",
    fileSize: " | {1} KB",
    fileSizeInKB: "{1} KB",
    fileSizeHeader: "ファイルサイズ",
    daysAgo: "日前",
    weekAgo: "週間前",
    weeksAgo: "週間前",
    monthAgo: "ヶ月前",
    monthsAgo: "ヶ月前",
    yearAgo: "年前",
    yearsAgo: "年前",
    currentlyBeingModifiedBy: "現在の編集者",
    beingEditedInCoeditModeError: 'Being edited in multi-user edit',
    beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} ',
    beingEditedInCoeditModeOn: 'on {0}.',
    coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends.',
    coEditModeIsEnding: "マルチユーザー編集が終了しています",
    coEditMode: "マルチユーザー編集",
    checkInInProgressMessage: "チェックインが進行中です。チェックインには20分程度かかることがあります。更新してアップデートしてください。",
    checkOutInProgressMessage: "チェックアウトが進行中です。チェックアウトには20分程度かかることがあります。更新してアップデートしてください。",
    daasErrorMessage: "オペレーションが完了できません。ページを更新して再試行してください。問題が解決しない場合は、ヘルプデスクにご連絡ください。",
    coEditModeIsStarting: "マルチユーザー編集を開始しています",
    daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
    daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
    documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
    documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
    documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
    documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing',
    documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
    documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
    startMultiuserEditing: 'Start',
    continue: "続行",
    openReadOnly: "読み取り専用で開く",
    takeControlFromTeam: "現在のチームメンバーからコントロールを引き取る",
    itapplication: "ITアプリケーション",
    aggregateITevaluation: "IT総合評価:",
    control: "統制",
    itgcitsp: "ITGC/IT実証手続",
    limitedRisk: "リスクが限定的な勘定科目",
    so: "SO",
    itApp: "ITアプリケーション",
    itAppType: "ITアプリケーション",
    deleteTaskModalHeader: "選択したタスクの削除確認",
    deleteTasksModalHeader: "選択したタスクの削除を確認",
    deleteTaskModalMessage: "選択したタスクを削除しますか？ ",
    deleteTaskModalMessage1: "このエンゲージメントにおける他のタスクと関係のない関連するエビデンスは、一時ファイルに移動されます。他のエビデンスと関係のない発見事項および対応タスクは削除されます",
    deleteTasksModalMessage: "選択したタスクを削除しますか？ ",
    someTasksCannotBeDeleted: "削除できないタスクがあります。",
    onlySomeTasksCanBeDeleted: "選択したタスクのうち、一部のタスクのみ削除できます。",
    tasksThatCanBeDeleted: "続行する場合は、あなたのエンゲージメントから<b>下記タスクが削除されます</b>。あなたのエンゲージメントの他のタスクに関連しないエビデンスは一時ファイルに移動します。他のエビデンスに関連しない発見事項及び対応タスクについても削除されます。",
    tasksThatCannnotBeDeleted: "あなたのエンゲージメントから<b>下記タスクは削除できません</b>。しかしながら、必要であれば監査計画から差戻しできます。",
    accountHeader: "勘定科目",
    noAccountsIdentified: "勘定科目が識別されていません",
    noRisksIdentified: "リスクが識別されていません",
    noAssertionsIdentified: "アサーションが識別されていません",
    noWcgwsIdentified: "WCGWが識別されていません",
    // Tasks/TaskDetails/Evidence
    addEvidence: "エビデンスの追加",
    relateEvidence: "エビデンスの関連付け",
    relateTemporary: "一時ファイルの関連付け",
    relatePriorPeriod: "前期のエビデンスの関連付け",
    relateExtDoc: "外部文書の関連付け",
    relateFile: "ファイルの関連付け",
    relateAnalytics: "アナリティクスを関連付ける",
    quickAddButton: "クイックな追加",
    createPaperProfile: "ペーパープロファイルの作成",
    paperProfileInformationMessage: "我々はすべての監査調書を電子文書で作成し、作成者および査閲者のサインオフを含めます。経営管理者又は第三者から紙面の形式でしか提供されないもので、電子データが入手できないもの（例えば、企業と第三者間の契約書の写し）のみ紙面文書が監査調書に含まれることが認められます。",
    paperProfileName: "ペーパープロファイルの名前",
    paperProfileAdd: "追加",
    paperProfileError: "有効なペーパープロファイル名を入力してください",
    otherEngagementsInWorkspace: "このワークスペース内のその他のエンゲージメント",
    relateDescription: "この文書をこのエンゲージメントまたはこのワークスペースにある別のエンゲージメントと関連付けます。",
    onlyShowRelatedDocuments: "関連する文書のみを表示",
    relateDescriptionTemp: "このエンゲージメントの文書を関連付けます。",
    added: "追加済",
    documentLocation: "ドキュメントの場所",
    documentIneligibleForSharingMessage: "機密文書は共有できません。",
    confidentialityNotAppropiateForSharing: "この文書を送信する適切な機密保持レベルがありません。",
    documentIsCheckedOut: "文書は共同編集モードであり、共有できません。共同編集モードを終了し文書を共有してください。",
    addCanvasFormNew: "新しいCanvasフォームの追加",
    documentCount: " {0} 文書",
    documentsCount: " {0} 文書",
    fitDocumentCannotbeSelected: "FIT文書はエンゲージメント間で共有できません。",
    // Task/TaskDetail/Description
    noDescriptionAvailable: "利用できる説明はありません",
    knowledge: "ナレッジ",
    knowledgeDescription: "ナレッジの説明",
    descriptionInstructions: "インストラクションからの記載",
    fromInstructions: "インストラクションから",
    customizeDescription: "カスタマイズされた説明",
    custimizeTaskDescription: "タスクの説明をカスタマイズする",
    editTaskDescription: "タスクの説明を編集する",
    saveLabel: "保存",
    okLabel: "OK",
    cancelLabel: "キャンセル",
    leaveCommentLabel: "コメントを記載する",
    addLabel: "追加",
    closeLabel: "閉じる",
    editText: "編集",
    enterReply: "返信を入力してください",
    reply: "返信",
    deleteTagDesc: "タグの削除は取消しできません。続行してよろしいですか？",
    requiredText: "テキストが必要です",
    descriptionEmptyError: "説明が必要です",
    descriptionMaxLengthError: "説明長が最大許容長を超えました",
    assignmentDueDate: "割当て期限",
    navigateToGuidedWorkflow: "EY Canvas FITイネーブルメントへ移動",
    openInTasksPage: "タスクで開く",
    copyTaskLink: "タスクリンクをコピー",
    copyReviewNoteLink: "レビューノートリンクをコピーする",
    urlCopiedLabel: "リンクのコピーが成功しました",
    //Related Tasks
    showOnlyRelatedTask: "関連付けのあるもののみを表示",
    noTaskAvailable: "タスクがありません",

    // Client Request / Client Request Detail /  Client Request Drawer
    openInCollaborationPage: "コラボレーションで開く",
    copyRequestLink: "リクエストリンクをコピー",
    requestType2MessageTitleDrawer: "このリクエストは追加機能があります。",
    requestType2MessageSubtitleDrawer1: "Please",
    requestType2MessageSubtitleDrawer2: "click here",
    requestType2MessageSubtitleDrawer3: "to navigate to it",

    // SeeMore component
    showMore: "さらに表示",
    showLess: "表示を減らす",
    showMoreEllipsis: "さらに表示",
    showLessEllipsis: "表示を減らす",

    // Request Description
    saveAndCloseButtonLabel: "保存して閉じる",
    saveButtonLabel: "保存",
    cancelButtonLabel: "閉じる",

    // Request Description Modal labels
    discardChangesModalText: "変更の破棄",
    inlineSaveUnsavedChanges: "未保存の変更があります。続行しますか？",

    // RelateWCGWModal labels
    wcgwName: "WCGW名",
    wcgwByScot: "SCOTごとのWCGWs",
    unrelatedSCOTsHeader: "関連付けのないSCOTs",
    unrelatedSCOTPlaceholder: "関連付けのないSCOTsがありません",
    noWcgwPlaceholder: "作成されたWCGWsがありません",
    showOnlyUnrelatedWCGW: "関連付けのないもののみを表示",

    // CharCount component.
    of: "の",
    characters: "文字",
    fromUserLabel: "from",
    toUserLabel: "to",
    handoffto: "ハンドオフ先",
    priorityLabel: "優先順位",
    addNoteLabel: "追加",
    replyNoteLabel: "返信",
    characterCountLabel: " 4000文字",
    taskNotePlacehodler: "タスクノートの入力",
    documentNotePlacehodler: "文書ノートの入力",
    taskNoteStatusBy: "作成者:",
    addNewReviewNoteButtonText: "新規のノート",
    fromKnowledge: "ナレッジより",
    /*day labels*/
    mon: "月",
    tues: "火",
    wed: "水",
    thurs: "木",
    fri: "金",
    sat: "土",
    sun: "日",
    /*month labels*/
    jan: "1月",
    feb: "2月",
    march: "3月",
    april: "4月",
    may: "5月",
    june: "6月",
    july: "7月",
    august: "8月",
    sept: "9月",
    oct: "10月",
    nov: "11月",
    dec: "12月",
    /*Rename*/
    documentDropdown: "ドキュメントのドロップダウン",
    fileNameRequired: "ファイル名は必須です",
	invalidCharacters: '次の文字はファイル名に使用できません: */:<>\\?|\"',
    existingFileName: "ファイル名が重複しています。ページを更新するか、ファイルの名前を変更してこのメッセージを削除します。",
    unknowError: "予期しないエラーが発生しました。ページを更新してこのメッセージを削除します。",
    maxLengthExceeded: "文書名の最大文字数は115文字です。",
    documentNameSyncErrorMessage: "文書名を Canvasクライアントポータルに同期できませんでした。 ページを更新し再試行してください。",
    /*Delete*/
    deleteFileTitle: "ドキュメントの削除",
    deleteFileCloseBtnTitle: "キャンセル",
    deleteFileConfirmBtnTitle: "削除",
    deleteFileCloseTitle: "閉じる",
    deleteFileModalMessage: "選択したアイテムを削除しますか？",
    none: "なし",
    /*Unlink*/
    unlinkFileTitle: "共有エビデンスのリンク解除",
    unlinkSource: "ソース",
    unlinkTarget: "ターゲット",
    unlinkFileCloseBtnTitle: "キャンセル",
    unlinkFileConfirmBtnTitle: "確認",
    unlinkFileCloseTitle: "閉じる",
    unlinkFileModalMessage: "共有エビデンスファイルのリンクを解除しますか？",
    /*Relate Tasks*/
    relateTasksTitle: "関連タスク",
    relateTaskSearchPlaceholder: "検索値を入力",
    relateTaskInstructionalText: "文書が関連するタスクを追加または削除してください。文書がエビデンスの場合、最後のタスクから削除すると、一時ファイルに移動されます。",
    relatedTaskInstructionalText: "この文書は、このエンゲージメントの次のタスクに関連しています。タスクに移動したい場合にはタスク名をクリックしてください。",
    relateTaskName: "タスク名",
    relateTaskType: "タイプ",
    relatedTaskCounter: "{0}タスク",
    relatedTasksCounter: "{0}タスク",
    /*Relate Entities*/
    relateEntitiesTitle: "エンティティを関連付ける",
    relateEntitiesSearchPlaceholder: "名前を入力して検索する",
    relateEntitiesName: "エンティティ名",
    relateEntitiesIndex: "エンティティ標準インデックス",
    relatedEntitiesCounter: "{0}エンティティ",
    relatedEntityCounter: "{0}エンティティ",
    onlyShowRelatedEntities: "関連するエンティティのみを表示する",
    unableToRemoveSystemAssociatedRelatedEntity: "文書とエンティティ間のシステム関係を削除できません",
    /* Finalize document */
    document: "調書",
    finalize: "完了",
    finalizeDocument: "調書の完了",
    finalizeDocumentTitle: "この調書が完了していることをプライマリーチームに通知してよろしいですか？",
    finalizeDocumentSubtitle: "調書の完了によりこれ以上送信予定の調書がないことをプライマリーチームに通知し、調書ステータスは<b>最終バージョン送付済</b>に変更されます。なお、完了した調書に変更を加える場合でも、プライマリーチームへの新たなバージョンの送信はできます。",
    /* Remove From Task */
    removeEvidenceModalTitle: "タスクから削除",
    remove: "削除",
    removeFromTaskModalContent: "このタスクから選択した文書を削除しますか？この文書はエンゲージメントにおける他のタスクと関連付けられていないため、一時ファイルに移動されます。",
    sharedEvidenceRemoveFromTaskModalContent: "選択した文書をこのタスクから削除してよろしいですか？この文書は共有エビデンスですが、このエンゲージメントの他のタスクと関連付けられていません。削除するとあなたのエンゲージメントでは利用できなくなります。",
    /*AddDocumentToTasksModal*/
    modalCheckboxHeading: "1つまたは複数のタスクにエビデンスを追加する",
    modalRadioHeading: "1つまたは複数のタスクに文書を関連付ける",
    confirm: "確認",
    proceed: "実行",
    modalCheckboxMessage: "この文書を追加する関連タスクを選択します。",
    selectedDocument: "選択された文書",
    modalRadioMessage: "この文書は既にエビデンスまたは一時ファイルに追加されています。",
    modalRadioMessage1: "この文書を再度追加すると、重複したコピーが作成されます。この文書の既存のコピーを関連付けるか、この文書の新しいコピーを作成するかを選択します。",
    option: "オプション",
    option1Message: "既存の文書をこのタスクに関連付ける",
    option2Message: "この文書の新しいコピーを作成する",
    addToEvidenceSelectAll: "すべて選択",
    currentTask: "現在のタスク：",
    createNewCopy: "新しいコピーの作成",
	fileNameMaxLenError: (maxFileLen) => ` ファイル名は ${maxFileLen} 文字までに制限されています.`,
    /* Confidentiality */
    confidentiality: "機密性",
    confidentialityType: "機密性 (任意)",
    confidentialityTitle: "文書の機密性",
    confidentialityPlaceholder: "機密性の選択",
    confidentialityText: "この文書を開くために必要なアクセスレベルを設定してください。アクセスレベルの設定はチーム管理ページのエンゲージメント管理で行います。 この文書の機密性が設定済みである場合、文書を開くことができるユーザーのみが文書を変更できます。",
    confidentialityNotOpenable: "エンゲージメントの権限が十分ではないため、文書を開けません。アクセスレベルの設定はチーム管理ページのエンゲージメント管理で行います。",
    confidentialityTargetNotOpenable: "機密文書はソースエンゲージメントからのみ開くことができます。",
    /*Sign-off requirements*/
    signOffRequirements: "サインオフ要件",
    signoffRequirementsModalTitle: "サインオフ要件",
    signoffRequirementsModalDescription1: "以下で、この文書\のエグゼクティブのサインオフ要件 を調整します。",
    signoffRequirementsModalDescription2: "一部のサインオフ要件は、EY Canvasで必須のため調整できません。",
    signoffRequirementsModalSaveLabel: "保存",
    signoffRequirementsModalCancelLabel: "キャンセル",
    signoffRequirementsModalCloseLabel: "閉じる",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    /*SEM summary*/
    nextAccount: '>',
    prevAccount: "<",
    reviewedBy: "査閲者",
    displaytoc: "TOCの表示",
    viewBy: "表示方法",
    substantiveEvaluation: "Substantive evaluation matrix",
    reviewed: "レビュー済",
    estimate: "見積り",
    /*440GL*/
    FourFortyTitle: "報告日（{0}）後に編集されたエビデンス",
    LeftContainerTitle440GL: "変更理由",
    approvals: "承認",
    approveChangesColumnTitle: "変更の承認",
    approveChangesButton: "変更の承認",
    deleteApproval: "承認を削除",
    unauthorizedAction: "アクションはエンゲージメントエグゼクティブのみが実行できます",
    reasonColumnTitle: "理由",
    approvedBy: "承認者:",
    approvedByPeople: "人",
    noChangeReasonCommentAvailable: "文書における歯車オプションから理由の編集をクリックし、入力してください",
    changeReasonModalTitle: "変更理由の編集",
    changeReasonModalText: "報告日後に文書を変更する理由を選択してください。事務的な変更を複数行う場合は最も重要な変更を以下の選択肢から選んでください。事務的な変更と事務的な目的でない変更の両方を行う場合はnon-administrativeを選んでください。",
    changeReasonUploadModalTitle: "文書のアップロードの理由",
    changeReasonUploadModalText: "報告日後に文書を変更する理由を選択してください。事務的な変更を複数行う場合は最も重要な変更を以下の選択肢から選んでください。事務的な変更と事務的な目的でない変更の両方を行う場合はnon-administrativeを選んでください。",
    changeReasonModalComboPlaceholder: "選択",
    changeReasonModalAnnotationText: "直面した状況及び情報を追加した理由を、新たに又は追加で実施した監査手続、入手した監査証拠及び到達した結論、監査報告書に与える影響を文書化します。",
    changeReasonUploadModalAnnotationText: "直面した状況及び情報を追加した理由を、新たに又は追加で実施した監査手続、入手した監査証拠及び到達した結論、監査報告書に与える影響を文書化します。",
    changeReasonModalAnnotationPlaceHolder: "変更の理由を入力してください",
    changeReasonModalChangeReasonRequired: "理由を変更し保存してください",
    noDocumentsModifiedAfterReportDate: "報告書日後に修正された文書はありません",
    noReasonSelected: "変更理由が選択されていません",
    fileSizeColumn: "ファイルサイズ",
    changePercent: "% 変動",
    toolTipChangePercent: "ファイルサイズの変動は、報告日のファイルサイズと現在のファイルサイズを使用して計算されます",
    /*Account Conclusion*/
    AccountConclusion: "勘定科目の結論",
    AccountDetails: "詳細",
    Conclusions: "結論",
    accountDetailsTab: "詳細",
    conclusionsTab: "結論",
    accountConclusionNoContentText: "このフォームのコンテンツは配信されていません。グローバルナビゲーションの詳細メニューからCanvasフォームの更新に移動し、コンテンツを手動で更新してください。",
    validations: "検証",
    /*RelatedFindings*/
    deficiency: "関連する不備　{0}",
    misstatement: "関連する虚偽表示　{0}",
    relatedDeficiency: "関連する不備　{0}",
    relatedMisstatement: "関連する虚偽表示　{0}",
    deficiencies: "不備",
    misstatements: "虚偽表示",
    pagingShowtext: "表示",
    documentOpenModelLabel: "現在文書は編集中です",
    openedLabelText: "オープン済 ",
    modelDocumentOpenedText: "この文書は現在次のユーザーにより編集中です。",
    modelUserOpenedTheDocumentText: "文書を開いたユーザー ",
    modelOpenedDocumentConflictText: "文書を開くとコンフリクトが発生する可能性があるので、読み込み専用で開くことをお勧めします。このドキュメントを編集したい場合は、 ",
    clickHereEnabledText: "ここをクリックしてください。",
    reviewNotesTemporeryFilesTitle: "一時ファイルに対するレビューノート",
    addNewReviewNoteTitle: "タスクノート",
    /*Assignments*/
    assignedTo: "割当て先",
    createAssignment: "割当ての作成",
    createAssignments: "割当ての作成",
    editAssignments: "割当ての編集",
    deleteAssignments: "割当ての削除",
    removeAssignments: "割当ての解除",
    noTimephaseSelected: "未選択",
    unassigned: "割当て未了",
    unassignedCapitalized: "未割当て",
    dueDateBlank: "期限",
    reviewerAssignment: "査閲者の割当て",
    manageAssignments: "タスク割当ての管理",
    manageTaskAssignments: "割当ての作成",
    selectedTasks: "選択されたタスク",
    someTasksCannotBeMoved: "移動できないいくつかのタスクがあります。",
    onlySomeTaskCanMoveToOtherGroup: "選択したタスクのうちいくつかのものが別のタスクグループに移動できます。",
    taskThatCanBeMovedToOtherGroup: "続行する場合は、選択したタスクグループに<b>下記タスクが移動します</b>。",
    tasksThatCannotBeMovedToOtherGroup: "別のタスクグループに<b>下記タスクは移動できません</b>。",
    taskGroupSectionNotFound: "結果がありません",
    placeholderForSearch: "検索",
    taskFilter: "フィルター",
    noResultsAvavilable: "表示する結果がありません",
    noTasksAvavilable: "タスクがありません",
    clearAll: "すべてクリア",
    engagementPhase: "監査フェーズ",
    noOptionAvailable: "オプションは利用できません",
    noTimePhase: "割り当てられたタイムフェーズがありません",
    roles: "役割",
    users: "チームメンバー",
    rommAssociatedWNotRelyAssertion: "重要な虚偽表示リスクは、見積りを含む勘定科目について、統制非依拠戦略に関連するアサーションまたは固有リスク評価が［高(higher)］のアサーションに関連付けられています。",
    hasRiskAssociated: "関連づけられたリスク",
    canvas: "Canvas",
    workingoffline: "オフライン作業",
    syncinprogress: "同期中",
    prepareoffline: "オフラインでのデータの準備",
    connectionavilable: "接続可能",
    createAnAssignment: "割当ての作成",
    createAssignmentEnd: "このタスクを開始します。",
    // Manage Assignments
    step01: "Step 01",
    step02: "Step 02",
    step03: "Step 03",
    step04: "Step 04",
    step05: "Step 05",
    manageAssigmentsStep1: "アクションの選択.",
    manageAssigmentsStep2: "タスクの割当ての編集",
    editAssignment: "割当ての編集",
    deleteAssignment: "割当ての削除",
    manageAssigmentsStep3: "割当ての完了",
    taskAssigmentStatusHeader: "割当てステータス",
    taskAssigmentStatusTileHeader: "タスクおよび割当てステータス",
    taskAssignmentName: "割当て",
    dueDateAssigment: "期日",
    editDueDate: "任意：業務終了日前の編集日付",
    teamMemberAssigmentLabel: "チームメンバー",
    currentAssigmentLabel: "現在",
    handOffToAssigmentLabel: "ハンドオフ先：",
    priorToEndDateLabel: "終了日前",
    noTimePhaseAssigmentLabel: "割り当てられたタイムフェーズがありません",
    closedByAssigmentLabel: "完了者 ",
    onAssingmentLabel: "対象",
    preparerAssigmentOpenTitleTip: "タスクをハンドオフしてタスクの割当てを完了とする",
    reviewerAssigmentOpenTitleTip: "タスクの割当てを完了とマークする",
    reviewerAssigmentClosedTitleTip: "タスクの割当てを未完了とマークする",
    AssigmentLabel: "タスクをハンドオフしてタスクの割当てを完了とする",
    noEvidenceReviewerAssigmentTitleTip: "エビデンスを追加してタスクの割当てを完了とマークする",
    noTaskEvidencesHandoffModal: "このタスクに関連付けられたエビデンスファイルはありません。",
    back: "戻る",
    savecontinue: "保存して続行",
    finish: "終了",
    save: "保存",
    emptyManageAssignmentStep: "...",
    selectAssignmentActionToContinue: "アクションを選択して続行",
    createNewTaskAssingment: "新規のタスクの割当ての作成",
    deleteTaskAssingment: "タスク割当ての削除",
    createTaskAssingment: "タスクの割当ての作成",
    editExistingTaskAssingment: "既存のタスクの割当ての編集",
    editTaskAssingment: "タスクの割当ての編集",
    removeExistingTaskAssingment: "既存のタスクの割当ての削除",
    warningPopUpPreparerAssignmentTitle: "既存の作成者割当ての上書き",
    warningPopUpPreparerAssignmentText: "このタスクには既に作成者の割当てがあります。この割当てを上書きしてもよろしいですか？",
    warningPopUpPreparerAssignmentConfirm: "確認",
    warningPopUpPreparerAssignmentCancel: "キャンセル",
    selectTaskAssingment: "タスクの割当ての選択",
    viewHistoryAndConflicts: "履歴の表示",
    noHistoryAvailable: "履歴はありません",
    teamMember: "チームメンバー",
    dateEdited: "最終編集日：",
    viewHistoryHeader: "この文書のバージョン履歴は以下に表示されます。",
    viewHistorySubHeader: "チームメンバーの名前をクリックして、このド文書の以前のバージョンを読み取り専用モードで開きます。この以前のバージョンに加えられた変更は、EY Canvasに保存されません。",
    docConflictedMessage: "この文書に関連するコンフリクトがあります。文書リストのコンフリクトタブに移動して解消してください。",
    removeTaskAssingment: "タスクの割当ての削除",
    addAssignmentInstructionalText: "新規タスクの割当ての名称の入力（例えば、詳細レビューアー、一般レビューアー）",
    addNewAssingmentName: "新規の割当ての名称の追加",
    addTaskAssignmentName: "タスクの割当ての名称の追加",
    assignmentName: "割当ての名称",
    selectedTask: "選択されたタスク",
    createTaskAssignmentHeading: "ここに新規割当てを作成",
    createTaskAssignmentHeading1: "以下の割当ての詳細を入力し、<b>保存して閉じる</b>を選択して終了してください。他の割当てを作成するには、<b>保存して別のものを作成する</b>を選択してください。",
    saveDelete: "保存して削除",
    createTaskAssignmentFinishLabel: "保存して閉じる",
    createTaskAssignment: "保存して追加",
    editTaskAssignment: "保存して他を管理",
    createTaskAssignmentSaveAndContinueLabel: "保存して他のタスクを管理",
    daysPriorToEndDate: "終了日までの日数",
    daysdue: "期日",
    daysPriorToEndDateOptional: "任意：業務終了日前の編集日付",
    timephase: "タイムフェーズ",
    timephasesLabel: "タイムフェーズ",
    manageTimePhase: "タイムフェーズの管理",
    removeTaskAssingmentSingleTaskHeading: "削除したい割当てを選択してください。",
    removeTaskAssingmentSingleTaskHeading2: "完了したら[保存して閉じる]をクリックします。別のタスクの割当てを管理する場合は、[保存して他のタスクを管理]をクリックします。",
    removeTaskAssingmentMultipleTaskHeading: "選択されたタスクに、割当てとチームメンバーの組合せがある場合、割当ては削除されます。終了するには以下から選択し、<b>保存して閉じる</b>を選択してください。別の割当てを削除するには、<b>保存して削除</b>を選択してください。",
    editTaskAssingnmentStep2Heading: "編集するタスクの割当てを選択します。",
    selectedAssignment: "選択された割当て：",
    editTaskAssingmentBulkHeading: "編集したい割当てを選択",
    editTaskAssingmentBulkSubHeading1: "選択されたタスクに割当てとチームメンバーの組み合わせがある場合、タスクは再割当てされます。<b>終了日までの日数</b>を編集することができます。この値を編集すると、再割当てされた全てのタスクが更新されます。編集して終了するには<b>保存して閉じる</b>を選択してください。別の割当てを編集するためには、<b>保存して他を管理</b>を選択してください。",
    noResultInCategory: "タスクカテゴリに結果が見つかりません",
    searchTaskList: "タスクリストの検索",
    searchCanvasFormList: "検索",
    clearHoverText: "クリア",
    filtersWarningMessage: "フィルタの数が上限を超えています。一度に適用できるフィルターは25までです。",
    reviewNotesWarningMessage: "データの受け取り中にエラーが発生しました。再試行し、問題が解決しない場合は、ヘルプデスクまでお問い合わせください。",
    editTaskAssingmentSept3Header: "選択した割当てを編集",
    editTaskAssingmentSept3Header2: "完了したら[保存して閉じる]をクリックします。別のタスクの割当てを管理する場合は、[保存して他のタスクを管理]をクリックします。",
    editTaskAssignmentHeaderPart1: "以下の割当の詳細を編集して<b>変更を保存</b>を選択してください。",
    calculatedDate: "計算日",
    saveAndAddbtn: "保存して別のものを追加",

    //Calendar Toggle Labels
    daysPriorToEndDateRequired: "業務終了日までの日数（必須）",
    dueDateRequired: "期日（必須）",
    selectDate: "日付を選択する",
    calculateDate: "日付を計算する",

    /* Bulk TimePhase*/
    taskText: "タスク",
    timephasesetsuccess: "{0} タイムフェーズが設定されました。",
    timephasessetsuccess: "{0} タイムフェーズが設定されました。",
    addTimephaseLabel: "タイムフェーズの追加",
    infoSetTimePhase: "<h3>タイムフェーズの設定</h3><p>タイムフェーズにドラッグアンドドロップすると選択されたアイテムのタイムフェーズを設定できます。</p>",
    infoEditTimePhase: "<h3>タイムフェーズの編集</h3><p>3点リーダーから編集を選択するとタイムフェーズプロパティを編集できます。</p>",
    infoAddTimePhase: "<h3>タイムフェーズの追加</h3><p>タイムフェーズの追加をクリックすると新規タイムフェーズを作成できます。</p>",
    infoDeleteTimePhase: "<h3>タイムフェーズの削除</h3><p>3点リーダーから削除を選択するとタイムフェーズを削除できます。</p>",
    deletedTimePhaseFilterWarningMessage: "タイムフェーズは別のユーザにより削除されました。",

    //Set assignment dates modal labels
    setAssignmentTitle: "割当て期限を設定する",
    setAssignmentDesc: "割当て期限を設定していません。以下の割当てについて期限を選択して続行してください。",
    setAssignmentDesc2: "1つ以上のタスクのタイムフェーズの日付が、選択した期日{0}より前の日付となっています。タスクまたはタイムフェーズの期限を調整して続行してください。",
    timePhaseNameLabel: "タイムフェーズ",
    timephaseEndDate: "タイムフェーズの終了日",
	tasksLabel: "タスク数",
    assignmentDateLabel: "割当て",
    noAssignedTimePhase: "割当てられたタイムフェーズがありません",
    endDate: "終了日",
    calendarDateError: "期日はタイムフェーズの終了日より前の日付にする必要があります。",

    /* Events*/
    addEventLabel: "イベントの追加",
    sharedWithClient: "共有済",
    noEventsMessage: "識別されたイベントなし",
    naLabel: "N/A",
    deleteEventModalTitle: "イベントの削除",
    deleteEventDescription: "このイベントを削除してよろしいですか？",
    showEventeName: "イベント",
    eventDateLabel: "日付",
    eventDatesLabel: "日付",
    showEventStartDate: "開始日",
    showEventEndDate: "終了日",
    deleteEventSuccessMessage: "イベントが削除されました",
    eventTypeLabel: "イベントタイプ",
    singleDayEventLabel: "1日",
    multiDayEventLabel: "複数日",
    dateRangeEventLabel: "日付の範囲",
    eventSharedWithClientLabel: "クライアントと共有済",
    editEventLabel: "イベントの編集",
    eventUpdateSuccessMessage: "イベントが更新されました",
    noTimephasesMessage: "識別されたタイムフェーズなし",

    /* Review Notes */
    showAll: "すべて",
    reviewNotesLabel: "レビューノート",
    athoredByMeLabel: "私が作成",
    assignedToMe: "私に割当て",
    assignedToOpen: "割当て先（オープン）",
    authoredByCleared: "作成者（クリア済）",
    totalOpenReviewLabel: "オープンレビューノートの合計",
    totalClearedReviewLabel: "クリア済レビューノートの合計",
    agingLabel: "Aging",
    openLabel: "オープン",
    clearedLabel: "クリア済",
    noUsersFoundLabel: "結果が見つかりません",
    chartDataLabel: "利用可能なデータがありません",
    noClientDataAvailable: "利用可能なデータがありません。",
    DaysLessThan10: "<10日",
    Days11To30: "<30日",
    Days31To60: "<60日",
    Days61To90: "<90日",
    DaysMoreThan90: "> 90日",
    noReviewNotesFound: "レビューノートが見つかりません",

    formMaxLength: "文字数は {number} 字以内にしてください。",
    voiceNote: "ボイスノート",
    microphoneBlockedMessage: "ボイスノートを使用するために、ブラウザからマイクへのアクセスを許可してください。既に許可されている場合は、更新して再試行してください。",
    microphoneBlockedOnVideoMessage: "画面録画で音声を使用できるようにするには、ブラウザがマイクにアクセスできるようにします。既に許可されている場合は、更新して再試行してください。",
    notInMainWindowVoice: "ドロワー内での音声録音は許可されていません。アクションを実行するには、新しいタブで文書を開いてください。",
    notInMainWindowScreen: "ドロワー内での画面録画は許可されていません。アクションを実行するには、新しいタブで文書を開いてください。",
    screenRecord: "画面録画",
    playbackReview: "プレイバック・レビュー",
    recording: "記録",

    /* Sign Offs */
    preparerHoverText: "作成者としてサインオフ",
    reviewerHoverText: "レビューアーとしてサインオフ",
    preparerTitle: "作成者サインオフ",
    reviewerTitle: "レビューアーサインオフ",
    preparerLetter: "P",
    reviewerLetter: "R",
    deleteHoverText: "サインオフの削除",
    signoffsrequired: "サインオフ必須",
    signoffsOptional: "PIC/EQR は任意",
    eqrLabel: "EQR",
    partnerInChargeLabel: "PIC",

    landingPage: "ランディングページ",
    dashboardPage: "ダッシュボード",
    tasksPage: "タスク",
    documentsPage: "文書",
    collaborationPage: "コラボレーション",
    automationPage: "オートメーション",
    newContentUpdate: "コンテンツの更新",
    contentUpdatesHistory: "履歴",
    history: "履歴",
    contentUpdateType: "コンテンツ更新タイプ",
    iniciatedBy: "作成者",
    date: "日付",
    clickForOptions: "更なるオプションについては、ここをクリック",
    offline: "オフライン",
    eyServiceGateway: 'EY Service Gateway',
    eyAutomation: 'EY Automation',
    eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

    // ContentUpdates
    contentUpdate: "コンテンツの更新",
    canvasFormUpdates: "Canvasフォームの更新",
    syncFormProfile: "フォームプロファイルの同期",
    documentName: "文書名",
    analyticName: "アナリティクス名",
    formType: "フォームタイプ",
    dateOfContent: "コンテンツ日付",
    formStatus: "ステータス",
    formsWarningMessage: "一つ以上のEY Canvasフォームを選択してアップデートしてください",
    formsUpdateSuccessMessage: "EY Canvasフォームのアップデートが提出されました",
    filterTypeOfFormLabel: "フォームタイプ",
    filterSourceOfFormLabel: "フォームのソース",
    documentSelectionRequired: "文書を選択し上書き",
    overwriteForm: "フォームの上書き",
    overwriteFormInstructionalText: "フォームを選択すると、現在のCanvasフォームのデータで応答を上書きできます。 現在のCanvasフォームは一時ファイルに移動するので注意してください。 ",
    confirmOverwrite: "上書きの確認",
    confirmOverwriteAreYouSure: "'{0}’フォームを'{1}’フォームに上書きしてよろしいですか？",
    confirmOverwriteDesc: "応答は \'{1}\'フォームに上書きされますが、関連するエビデンスとオブジェクトは上書きされません。上書きが完了した後、該当する関連するエビデンスとオブジェクトを\'{1}\'フォームに再度関連付ける必要があります。'{0}'フォームは既存のプロファイリング/GAMレイヤーを維持するので、そのプロファイリングが'{1}'フォームと異なる場合はコピーしたコンテンツを再確認してクリーンアップしてください。",
    confirmOverwriteDoNotClose: "上書きプロセスの進行中は、ブラウザを閉じたり、別のページに移動したりしないでください。上書きが完了すると、\'{0}\'フォームは一時ファイルに移動します。 この操作は元に戻せません。",
    sourceDocument: "ソース文書",
    targetDocument: "ターゲット文書",
    profileLayers: "GAMレイヤー",
    pspAccountWarningMessage: "アップデートのためには1つ以上の勘定科目を選択する必要があります。",
    pspAccountUpdateSuccessMessage: "PSPコンテンツアップデートが提出されました。",
    pspAccountconfirmUpdateMessage: "これらの重要勘定のアップデートはコンテンツに重大な影響を与える可能性があります。一度コンテンツアップデートを開始すると、完了するまで追加のコンテンツアップデートは実施できません。",
    est: "見積りを含む",
    bookmarkTaskModalHeader: "選択されたタスクをダウンロードできません",
    bookmarkTaskModalMessage: "選択したタスクはオフラインで作業するためにダウンロードできません。",
    noGuidanceAvailable: "利用可能なガイダンスがありません",
    next: "次へ",
    previous: "前へ",
    guidanceLink: "リンク",
    addToEvidenceLabel: "エビデンスに追加",
    otherEngagements: "その他のエンゲージメント",
    navigationView: "ナビゲーションビュー",
    listView: "リストビュー",
    detailsView: "詳細ビュー",
    closeguidance: "ガイダンスを閉じる",
    reviewNotesModalClose: "閉じる",
    gamGuidanceLinkLabel: "GAMガイダンス",
    inProgess: "進行中",
    upcomingReview: "レビュー待ち",
    teamSummaryEmptyTaskDetailsMesage1: "チームサマリーを使用して、ステータスごとに各チームメンバーの作成者及び査閲者の割当てを表示できます。すべての割当てを管理するには、以下を選択してください。",
    teamSummaryEmptyTaskDetailsMesage2: "割当ての管理",
    teamSummaryEmptyTaskDetailsMesage3: "タスクの一括操作を行うにはチェックボックスを使用し1つ以上のタスクを選択してください。 いくつかのタスクを一度に選択する場合はShiftキーを使用します。個々のタスクで作業する場合は、リストからそのタスクを選択します。",
    taskSummaryPoint1: "各チームメンバーの実施者の割当てのリストを表示するには、「実施」を選択します。",
    taskSummaryPoint2: "各チームメンバーの査閲者の割当てのリストを表示するには、「査閲」を選択します。",
    taskSummaryPoint3: "割当ては、割当てステータス(未着手、処理中、完了)ごとに並んでいます。",
    noLinksfound: "このタスクに利用可能なリンクはありません。",
    noFormsfound: "このタスクに利用可能なフォームはありません。",
    workofflinemsg: "これにより、選択したタスクの最新バージョンがダウンロードされ、引き続きオフラインで編集できるようになります。再接続によって、変更を後で同期することができます。",
    workonlinemsg: "オンラインで戻ると、自動的に変更が同期されます。再接続する前にインターネット接続が利用できることを確認します。",
    workoffline: "オフラインで作業する",
    workonline: "オンラインで作業する",
    duplicateFileNames: "ファイル名の複製",
    training: "トレーニング",
    duplicateFileNameValidationMessage: "このエンゲージメントに追加しようとしているファイルは、このエンゲージメントの既存のファイルと同じ名前です。続行するには、いずれかのファイルの名前を変更してください。",
	documentHelperConnectionIssue: 'EY Canvas Document Helperについて問題が見つかりました。問題の解消方法については<a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">こちら</a> をクリックして下さい。',
    incompleteCra: "未完了のCRA",
    noteItemCreated: "作成日：",
    NetworkErrorMessage: "アプリケーションネットワークでエラーが発生しています。ページを更新して後ほど再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    saveClose: "保存して閉じる",
    contentupdatePSPs: "コンテンツの更新 - PSPs",
    /* PAANS */
    paansIsNotReachable: "EYポリシーの管理サービスが利用できません。そのため、すべてのポリシーへの確認ができない状況です。関連ポリシーのレビューが未了であればページを更新し再試行してください。問題が解消しない場合には、ヘルプデスクに連絡してください。",

    /* Add New Task */
    standardtask: "標準タスク – OST",
    substantivetask: "実証タスク – OSP",
    walkthroughtask: "ウォークスルータスク – WT",
    controltask: "統制タスク – TOC",
    addnewTask: "新規タスクの追加",
    taskType: "タスクタイプ",
    taskTypeError: "タスクタイプを選択してください",
    selectTaskTypeHeader: "タスクタイプを選択して続行",
    selectTaskType: "タスクタイプの選択",
    enterTaskDetails: "タスクの詳細の入力",
    assignTask: "タスクの割当て",
    taskGroup: "タスクグループ",
    finishLabel: "保存して閉じる",
    addTaskContinueLabel: "保存して割当てる",
    AssignTaskStepSaveandContinueLabel: "保存して別のタスク割当てを追加",
    addTaskDetailsHeader: "続行するためにタスクの詳細を入力する。",
    addTaskAssignmentHeader: "任意: 本タスクに関する割当ての作成。",
    addTaskDetailsSubHeader: "今このタスクを割当てたい場合には<b>保存して割当てる</b>をクリックし、後でタスクを割当てたい場合には<b>保存して閉じる</b>をクリックしてください。",
    addTaskAssignmentSubHeader: "以下の割当ての詳細を入力し「保存して閉じる」を選択し終了してください。 別の割当ての作成の際は「保存して追加」を選択してください。",
    addTaskAssignmentSubHeader1: "以下に割当ての詳細を入力し、終了するには<b>保存して閉じる</b>を選択してください。 別の割当てを作成するには、<b>保存して追加</b>を選択してください",
    addTaskGroup: "ここに新しいグループタスクを追加してください。一度追加すると、新しいタスクを作成した際にこのタスクグループを選択することと、既存のOSTタスクをこのタスクグループに移動することができます。",
    relateObjectHeaderAccount: "重要な勘定科目又は開示について1つ以上のアサーションを選択するか、リスクが限定的な勘定科目を選択してください。",
    relateObjectSubHeaderAccount: "タスクは1つの勘定科目又は開示にのみ関連付けられます。",
    relateObjectHeader: "続行するには、1つ以上のオブジェクトを関連付けてください。",
    limitedRiskAccount: "リスクが限定的な勘定科目",
    onlyShowAddedObject: "追加されたオブジェクトのみ表示",
    relateObjectRequiredError: "続行するには1つ以上のオブジェクトを選択してください",
    invalidSelectionWarning: "タスクは1つの勘定科目又は開示にのみ関連付けられます。選択されたアサーション又はリスクが限定的な勘定科目を削除し、別の勘定科目又は開示もしくは別のリスクが限定的な勘定科目を関連付けてください。",
    invalidSelctionCRA: "1つのオブジェクトタイプを選択",
    relateObjectOptionsHeaderAccountTask: "アサーション及びリスクが限定的な勘定科目",
    relateObjectOptionsHeaderITWalkthroughTask: "IT/SOプロセス",
    relateObjectOptionsHeaderITControlTask: "ITGC",
    relateObjectOptionsHeaderITSubstantiveTask: "IT実証手続",
    relateObjectOptionsHeaderSCOTControlTask: "統制",
    relateObjectOptionsHeaderSCOTWalkthroughTask: "SCOTs",
    StrategyTypeControls: "統制依拠",
    StrategyTypeSubstantive: "実証単独",

    //Manage quick filters labels
    manageQuickFilterHeader: "保存されたもしくは推奨されたフィルターをデフォルトとして選択する。",
    manageQuickFilterText: "デフォルトを選択すると、タスクリストに進んだ際にこのフィルターが適用されます。",
    noDefaultFilter: "デフォルトフィルタなし",
    suggestedFiltersHeading: "推奨されたフィルタ",
    savedFiltersHeading: "保存されたフィルタ",
    manageQuickFilters: "クイックフィルタの管理",
    manageLabel: "管理",


    /* RNH Labels */
    emptyNoteDetailsMessage: "ノートを選択すると詳細が表示されます。一括操作を行うには、CtrlキーまたはShiftキーをを使用して、複数のレビューノートを選択します。個別のノートについて作業したい場合は、リストからそのノートを選択します。",
    emptyRepliesMessage: "返答なし",
    emptyRepliesMessageAlt: "返信がありません",
    reviewNotes: "レビューノート",
    reviewNotesStatus: "レビューノートステータス",
    reviewNotesStatusAssignedToMe: "私に割当てられたレビューノートのステータス",
    reviewNotesStatusAuthoredByMe: "私が作成したレビューノートのステータス",
    comments: "レビューノート",
    showHideNotes: "ノートの表示/非表示",
    fileType: "ファイルタイプ",
    noteType: "タイプ",
    statusId: "ステータス",
    rnhPriority: "優先度",
    rnhDueDate: "期限：",
    rnhModifiedDate: "更新",
    textAreaPlaceholder: "ノートの入力",
    requiredFieldErrorMessage: "これは必須フィールドです",
    meLabel: "私",
    editIconHoverText: "編集",
    deleteIconHoverText: "削除",
    deleteIconModalTitle: "ノートの削除",
    deleteIconCommentModalTitle: "ノートの削除",
    deleteReplyIconModalTitle: "返答の削除",
    deleteIconModalConfirmMessage: "このノートへの返信を削除してもよろしいですか？",
    deleteIconModalConfirmMessageParent: "選択されたノートを削除しますか？",
    deleteIconModalCommentConfirmMessage: "この返答を削除してよろしいですか？",
    deleteIconModalCommentConfirmMessageParent: "このノートを削除してよろしいですか？このノートへの全ての回答は削除されます。",
    deleteIconModalAcceptText: "削除",
    replyInputPlaceholder: "このノートへの回答",
    changeStatus: "ステータスの変更",
    emptyReplyErrorMsg: "テキストかボイスノートを追加して続行します。",
    lengthReplyErrorMsg: "返答は4,000字を超えることはできません。",
    closeTitle: "クローズ",
    closedBy: "クローズした担当者",
    ClearedBy: "クリアした担当者",
    ReopenedBy: "再オープンした担当者",
    commentTitle: "ノート",
    noteDueDateLabel: "期限",
    reopen: "再オープン",
    noNotesAssociatedWithDocumentLabel: "以下のインプットを使用してノートを作成してください。ユーザーにノートを割当て、優先度及び期日を設定してください。",
    noNotesFound: "ノートがありません",

    /* Add new review note RNH */
    addNewNoteButtonTitle: "新規のノート",
    addNewNoteModalTitle: "新規ノートの追加",
    addNewNoteModalClose: "クローズ済",
    backButtonLabel: "戻る",
    cancelButtonLabel: "キャンセル",
    addNewNoteStep1Title: "ノートタイプの選択",
    addNewNoteStep2Title: "文書またはタスクの選択",
    addNewNoteStep3Title: "ノートの詳細を入力",
    editNoteModalTitle: "ノートの編集",
    editReplyModelTitle: "返答の編集",
    voiceNoteButtonLabel: "ボイスノート",
    stopRecordingButtonLabel: "停止",
    enterText: "文字を入力する",

    /* RNH Review note hub Step 1 */
    step1Title: "ノートタイプを選択し続行してください。",
    step1Subtitle: "ここには文書又はタスクノートのみ追加できます。Canvasフォームコメントは各Canvasフォーム内に追加が必要です。",
    step1NoTypeSelectedError: "ノートタイプを選択し続行してください。",

    /* RNH Review note hub Step 2 */
    step2DocumentTitle: "ノートを追加したい文書を選択してください。",
    step2TaskTitle: "ノートを追加したいタスクを選択してください。",
    step2SearchTitle: "検索",
    step2SearchClearTitleTip: "クリア",
    step2ErrorMessageTop: "続行するために項目を選択してください。",
    step2ErrorMessageBottom: "続行するためには、上記の必須フィールドに入力してください。",
    step2EmptySearch: "結果が見つかりません",

    /* RNH Review note hub Step 3 */
    step3InstructionalText: "選択された文書又はタスクに関するノートの詳細を入力してください。",
    step3InstructionalSubTitle: "終了する場合には<b>保存して閉じる</b>をクリックし、選択した文書又はタスクに別のノートを追加する場合には、<b>保存して別のノートを追加</b>をクリックします。",
    step3SelectedDocument: "選択した文書:",
    step3SelectedTask: "選択したタスク:",
    step3SaveAndContinue: "保存してさらに追加する",
    step3SaveAndClose: "保存して閉じる",

    /* RNH List Layout Labels*/
    searchReviewNotes: "ノートの検索",
    searchReviewNotesResultsNotFound: "このノートカテゴリ―内で検索結果は見つかりませんでした。",
    searchReviewNotesNotAvailable: "利用可能なノートなし",
    notesRepliesNotFound: "選択されたノートに関する返答なし",

    selectValueToContinue: "値を選択して続行",
    required: "必須",
    invalidEngagementId: "エンゲージメントIDが無効です。ページを更新して再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    accessDenied: "アクセスの拒否",
    annotationDeletedError: "選択されたノートは削除されました。ページを更新して再試行してください。",

    /* RNH Filters */
    rnhClearAll: "全てクリア",
    rnhShowMore: "追加",
    rnhFilter: "フィルター",
    hideFiltersLabel: "表示しない",
    noDocumentChangeTypes: "結果なし",
    selectatasktype: "タスクタイプの選択",
    importfromknowledge: "ナレッジからインポート",
    assigntaskoptional: "タスクの割当て（任意）",
    relateanobject: "オブジェクトの関連付け",
    account: "勘定科目",
    userOrRole: "ユーザーまたはロール",
    userSummary: "ユーザーサマリー",
    other: "その他",
    userNotFound: "ユーザーは見つかりませんでした",
    dueOnOrBefore: "期限前",
    dueOnOrAfter: "期限後",

    /*Dashboard - Milestone tile*/
    milestonesLabel: "マイルストーン",
    scopeAndStrategy: "スコープ及び戦略",
    scopeAndStrategyTabLabel: "スコープ及び戦略",
    executionTabLabel: "実施",
    conclusionTabLabel: "総括",
    viewAllTabLabel: "すべてを表示する",
    noTaskAssociatedToMilestoneMsg: "この監査フェーズでは、マイルストーンに関連付けられているタスクはありません。",
    overdueLabel: "期日超過",
    upcomingLabel: "期限間近",
    quickLinkText: "クイックリンク",
    inreviewLabel: "レビュー中",
    CompleteLabel: "完了",
    completeLabel: "完了",
    startLabel: "スタート",
    endLabel: "エンド",
    auditPhaseSummary: "監査フェーズサマリー",
    milestoneView: "マイルストーン表示",
    timePhaseView: "タイムフェーズ表示",
    localLandingPageHeader: "このページはこのデータセンターにおいて利用可能なEY Canvasエンゲージメントのみが表示されます。",
    localLandingPage: "ローカルランディングページ",
    noEngagementsAvailable: "このデータセンターに利用可能なエンゲージメントがありません",
    engagements: "エンゲージメント",
    /* Document List */
    docListRelatedTasks: "関連タスク",
    temporaryFilesTab: "一時ファイル",
    priorPeriodEvidenceTab: "前期のエビデンス",
    conflictsTab: "コンフリクト",
    recentlyDeletedTab: "最近削除されたもの",
    docListSelectedDocument: "{0}文書選択中",
    docListSelectedDocuments: "{0}文書選択中",
    shared: "共有済",
    shareStatusOwned: "共有元",
    shareStatusShared: "共有先",
    unlinkInprogress: "リンク解除中",
    unlinkError: "リンク解除エラー",
    documentList: "文書",
    restoreModalTitle: "一時ファイルへリストア",
    restoreModalText: "この文書を一時ファイルへ戻すにはリストアしてください。",
    permanentlyDeleteModalTitle: "完全に削除",
    permanentlyDeleteModalText: "文書の完全削除を選択した場合、EY Canvasから削除され、元に戻すことはできません。問題なければ文書の完全削除をクリックしてください。",
    misstatementsInstructionalText: "この文書は、このエンゲージメントにおける以下の虚偽表示に関連しています。移動するためには虚偽表示をクリックしてください。",
    deficienciesInstructionalText: "この文書は、このエンゲージメントにおける以下の不備に関連しています。移動するためには不備をクリックしてください。",
    referenceId: "ID",
    findingDescription: "説明",
    deficienciesModalTitle: "関連する不備",
    misstatementsModalTitle: "関連する虚偽表示",
    startsWith: "始まる",
    contains: "含む",
    documentsWherePICEQRSignOffIsRequired: "PIC/EQR サインオフが必須の文書",
    otherDocuments: "他の文書",
    documentsWherePICSignOffIsRequired: "PICのサインオフが必要な文書",
    documentSignoffRequiredLabel: "必須のサインオフ:",
    timePhaseFilterLabel: "タイムフェーズ",
    drillDownTimePhaseFilterLabel: "タイムフェーズ別表示",
    auditPhasesLabel: "監査フェーズ",
    openedLabel: "オープン済",

    clientApprovals: "外部サインオフ",
    noTeamsAvailable: "作成済のチームがありません。チームの作成及びリンクリクエストの送信を行い開始してください。",
    noDocumentRecieved: "受領済文書なし",
    team: "チーム",
    pendingEvidence: "未了エビデンス",
    noTimePhasePlaceHolder: "タイムフェーズなし",

    regionComponentEvidence: "リージョン及び構成単位のエビデンス",
    preparersignoffs: "作成者サインオフ",
    reviewersignoffs: "査閲者サインオフ",
    receivedon: "受領日：",
    nosignoffsyet: "サインオフ未了",
    noRegionComponentEvidence: "調書を受け取っていません。未だ調書を送信していないリージョン又は構成単位のリストを閲覧したい場合、 <b>未提出の調書</b>を選択してください。",
    noComponentEvidence: "受領済文書はありません",
    assignToRegionOrComponent: "リージョン又は構成単位への割当て",
    assignRegionComponentModalText: "本文書の割当先となるリージョン又は構成単位を選択してください。",
    documentAssignedToPGT: "この文書は既に他のリージョンまたは構成単位に割当てられています。このため、割当てに利用できません。",
    assignedToRegionComponent: "割当てられたリージョンまたは構成単位",
    noRegionComponentsAvailable: "利用可能なリージョン又は構成単位がありません",
    documentUnassignedFromComponent: "{0}の{1}からの割当てが未了です。",
    documentUnassigned: "{0} のアサインが未了です。",
    documentReturnedToComponent: "{0}が{1}に差し戻されました。",
    documentReturned: "{0} が差し戻されました。",
    regionComponentName: "リージョン又は構成単位名",
    relatedReviewNoteCount: "他のエンゲージメントからの1 オープンノート",
    relatedReviewNotesCount: "他のエンゲージメントからの{0} オープンノート",

    deleteVersion: "バージョンの削除",
    deleteVersionMessage: "続行するには、バージョンを選択してください。",
    deleteVersionDisabledMessage: "過去のバージョンは、エンゲージメント管理者のみが文書のソースエンゲージメントから削除できます。",
    deleteVersionTitle: "文書バージョンを削除",
    deleteVersionPlaceholder: "この過去のバージョンを削除してよろしいですか？この操作は元に戻せません。",

    childDocumentsCountLabel: "既存コピー",
    childDocumentsModalTitle: "既存コピー",
    childDocumentsModalDescription: "下記文書はオリジナルの文書から作成されました。",
    childDocumentsModalColumnDocumentName: "文書名",
    childDocumentsModalColumnDocumentType: "文書タイプ",
    childDocumentsModalColumnRelatedTasks: "関連タスク",
    childDocumentsModalColumnSignoffs: "サインオフ",

    bulkAddToEvidenceDescription1: "エビデンスとして表示された文書の新規コピーを作成するか、利用可能な既存コピーを選択してください。",
    bulkAddToEvidenceDescription2: "デフォルトでは、新規作成文書は従前の文書が関連付けられていた全てのタスク及びCanvasフォームに追加されます。「高度なオプション」を使用して、マニュアルでタスク及びCanvasフォームを選択し新規文書の関連付けができます。検索及び置換機能を使用して、新規文書名の特定部分 (例: 年度)を置換えることもできます（この機能は複数回使用できます）。",
    bulkAddToEvidenceDescription3: "既存文書を選択した場合、現在のタスクにのみ追加されます。1つしか既存文書が利用可能でない場合、事前に選択済みとなります。追加したい既存コピーがあればそちらを選択してください。",
    bulkAddToEvidenceAdvancedOn: "高度なオプション",
    bulkAddToEvidenceAdvancedOff: "オフ",
    bulkAddToEvidenceFindText: "テキストの検索",
    bulkAddToEvidenceFindTextRequired: "有効なテキスト検索を入力してください。",
    bulkAddToEvidenceReplaceWith: "置換え後とするもの",
    bulkAddToEvidenceReplaceSuccess: "{0} を {1} に置換え済",
    bulkAddToEvidenceUseExisting: "既存のものを使用",
    bulkAddToEvidenceCreateNew: "新規作成",
    bulkAddToEvidenceDocumentName: "文書名",
    bulkAddToEvidenceExistingDocument: "既存文書",
    bulkAddToEvidenceSelectANewOrExistingCopy: "新規又は既存コピーの選択",
    bulkAddToEvidenceAssociateToTasks: "タスクへの関連付け",
    bulkAddToEvidenceAssociateToCanvasForms: "Canvasフォームへの関連付け",
    bulkAddToEvidenceOtherRelatedTasks: "その他の関連タスク",
    bulkAddToEvidenceAssociateToTasksPlaceholder: "新規作成文書のみタスクに関連付けできます。既存文書は自動的に現在のタスクに関連付けられます。",
    bulkAddToEvidenceSelectedTask: "{0} 関連タスク",
    bulkAddToEvidenceSelectedTasks: "{0} 関連タスク",
    bulkAddToEvidenceSelectedTasksPlaceholder: "利用可能な関連タスクなし",
    bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: "新規作成文書のみCanvasフォームに関連付けできます。",
    bulkAddToEvidenceRelatedCanvasForms: "関連Canvasフォーム",
    bulkAddToEvidenceSelectedForm: "{0} 関連Canvasフォーム",
    bulkAddToEvidenceSelectedForms: "{0} 関連Canvasフォーム",
    bulkAddToEvidenceSelectedFormsPlaceholder: "関連Canvasフォームなし",
    picRequiredValidation: "PICタスクにPICのサインオフが必要な文書が関連付けられていません。",
    eqrRequiredValidation: "EQR タスクにEQR のサインオフが必要な文書が関連付けられていません。",
    picEqrRequiredValidation: "PIC/EQR タスクにPIC/EQR サインオフが必要な文書が関連付けられていません。",

    viewSwitcherDefault: "デフォルト画面",
    viewSwitcherEntity: "エンティティ画面",
    viewSwitcherAllEntities: "すべてのエンティティ",
    viewByEntities: "エンティティ別表示",

    /* bulk delete modal */
    bulkDeleteFilesModalMessage: "選択された文書を削除してよろしいですか？",
    bulkDeleteFIlesModalMessageSub: "削除できない文書は下記のとおりです。",
    bulkDeleteModalLabel: "文書の削除",
    bulkDeleteSuccessMessage: "文書は正常に削除されました。",
    bulkDeleteValidDocumentsHeader: "下記文書は削除されます。",
    bulkDeleteInvalidDocumentsHeader: "下記文書は削除できません。",

    /* Bulk sign-off requirements modal */
    bulkSignOffRequirementsModalMessage: "以下で、選択した文書\に関するエグゼクティブサインオフの要件を調整します。EY Canvasの設定によりサインオフ要件が調整できない文書もあります。",
    bulkSignOffRequirementsResultMessage: " {0} 文書のサインオフ要件のアップデートが成功しました。",


    bulkOpenCountWarning: "選択された文書数は上限を超えております。最初の {0} のみ開きます。",

    /* Pending evidence modal */
    pendingEvidenceInstructionalText: "下記にリストされたチームから送信されたグループ文書はありません。",
    pendingEvidenceDueDate: "期日",
    searchRegionComponentLabel: "リージョン及び構成単位の検索",

    /* Review Notes Count */
    noReviewNotesAssignedOrAuthored: "選択されたチームメンバーへのノートはありません。",
    noUserSelected: "ユーザーを選択して内容を表示するEY Canvasの役割にはノートを割り当てられません",
    reviewNotesText: "レビューノート",
    assigned: "割当済",
    authored: "作成済",
    overdue: "期日超過",
    comingDue: "期限間近",
    cleared: "クリア済",
    open: "オープン",
    closed: "完了",
    noTaskAssignedToUser: "選択されたチームメンバーもしくは役割に割当てられたタスクはありません。",
    preparer: "作成者",
    reviewer: "査閲者",
    assignments: "割当て",
    notStarted: "未着手",
    inProgress: "進行中",
    done: "完了",
    forUpcomingReview: "レビュー依頼前",
    noTaskOrNotesAssigned: "選択されたメンバーまたは役割へのタスクまたはノートのいずれもありません。",
    fromTo: "From / To",

    /* Collaboration grid */
    overdueCollaboration: "期限超過",
    comingDueCollaboration: "期限間近",

    /*Document Conflict*/
    documentConflict: "文書の競合",
    documentConflictModalConfirm: "このバージョンを残す",
    documentConflictModalClose: "キャンセル",
    documentConflictInstruction: "競合を解消するには、保存すべき文書のバージョンを選択してください。",
    documentConflictMessage: "読み取り専用で過去のバージョンを開くには、メンバー名をクリックしてください。過去のバージョンに加えられた変更はEY Canvasに保存されません。",
    lastmodifiedDate: "最終更新日",
    modifiedBy: "編集者",
    documentConflictErrorMessage: "続行するには、バージョンを選択してください。",
    currentVersion: "現在のバージョン",
    documentConflictError: "文書の競合のエラーメッセージ",
    documentConflictHeader: "この文書は競合しています。",
    viewHistory: "履歴を表示する",
    confirmButtonToolTip: "グループ文書の競合を解消するには権限が必要です。エンゲージメント管理者に連絡して、この操作を実行する許可を要求してください。",
    documentHistoryHeader: "文書\のバージョン履歴は以下の通りです。",
    documentHistoryMessage: "チームメンバー\の名前をクリックして、この文書の以前のバージョンを読み取り専用で開きます。この以前のバージョンに加えられた変更は、EY Canvasに保存されません。",

	documentHistoryInstruction: '現行バージョンのファイルを以前のバージョンのファイルに戻したい場合には、そのバージョンを選択し"バージョンの更新 "をクリックします。',
	documentHistoryAdminInstruction: 'また、バージョン履歴として保持する必要がないバージョンについては、そのバージョンを選択し"    バージョンの削除 "をクリックすることで履歴から削除できます。',

    documentHistoryModalConfirm: "バージョンの更新",
    documentHistoryModalClose: "閉じる",
    documentHistoryErrorMessage: "文書に競合が生じているため、処理する前に解消してください。",

    /* Dashboard  - Collaboration Tile*/
    clientCollboration: "クライアントコラボレーション",
    nextwaveServices: "集中化サービス",
    receivedStatusLabel: "受領済",
    acceptedStatusLabel: "承諾済",
    outstandingStatusLabel: "期限超過",
    collaborationNonUsageMessage1: "コラボレーションを利用してリクエストと外部タスクを外部のチームメンバーに直接EY Canvasで送信することが可能です。コラボレーションをアクティブ化するためには、まずクライアントをEY Canvasクライアントポータルに登録してください。次に、アクセスグループを設定します。そのうえでリクエストを作成又は外部タスクを割り当ててください。クリックする",
    collaborationNonUsageMessage2: "利用開始に当たってのイネーブルメントはこちら。",
    collaborationNonUsageMessageHyperlinkText: "こちら",
    collaborationNonSentMessage1: "移動先",
    collaborationNonSentMessage2: "ドラフトを送信し利用開始する",
    collaborationNonSentMessageHyperlinkText: "コラボレーション",
    noBodies: "本文がありません",
    editResponse: "返答の編集",
    unsentDrafts: "未送信のドラフト",
    unsentDraft: "未送信ドラフト",
    noUnsentDrafts: "未送信のドラフトはありません",
    requestsSent: "送信済リクエスト",
    nextWavetotalTasks: "タスク合計",
    comingDueTimeframe: "タイムフレーム",
    otherTimeframeDataAvailableMessage: "データを表示する別のタイムフレームを選択してください",

    /* Dashboard Engagement Metrics */
    engagementMetricsTileHeader: "エンゲージメント指標",
    overdueColumnHeader: "期限超過",
    comingDueColumnHeader: "期限間近",
    whatsNewColumnHeader: "新着",
    placeholderMessageNoContentInSpecifiedTimeframe: "データを表示する別の期間を選択してください",
    placeholderMessageNoEngagementMetrics: "エンゲージメントに利用できる指標はありません。",
    performanceMetrics: "パフォーマンス指標",
    reviewNotesAndAssignments: "レビューノート及び割当て",
    /*Dashboard Engagement overview*/
    engagementOverview: "エンゲージメントの概要",
    engagementOverviewInstructionalText: "下記の監査フェーズ別のエンゲージメントの進捗を確認してください。",

    /*Dashboard Milestone tile*/
    milestoneprogressTileHeader: "マイルストーン",
    milestoneprogressSubHeader: "以下の監査フェーズを選択するとマイルストーン別タスク完了を表示できます。<b>タイムフェーズ別表示</b>を選択するとタイムフェーズ別タスク完了を表示できます。  <b>詳細を表示</b>を選択するとマイルストーンやタイムフェーズ別の詳細な進捗を確認できます。",
    tasksStatus: "タスクステータス",
    preparerAssignments: "作成者の割当て",
    reviewerAssignments: "査閲者の割当て",
    openComments: "オープンノート",
    /* Dashboard Profile Page */
    groupAudit: "グループ監査",
    groupStatus: "グループステータス",
    viewInstructions: "インストラクションの表示",
    instructionsInstructionalText: "プライマリーチームから受領したインストラクションは下記に表示されています。リンクを選択するとインストラクションを表示できます。",
    noInstructionsAccepted: "承諾済のインストラクションはありません。",

    /* Dashboard SDM Summary */
    nextWaveservices: "集中化サービス",
    totalTasksLabel: "タスク合計",
    tasksUsingNextWaveservices: "集中化サービスで用いるタスク",
    tasksSuggestedForNextwaveUse: "集中化サービスについて推奨されるタスク",
    outOf: "／",
    tasksUsing: "タスク使用",
    suggestedFor: "推奨事項",
    nextwaveUse: "集中化サービス",
    draftRequests: "リクエストのドラフト",
    draftRequest: "リクエストのドラフト",
    createRequests: "リクエストの作成",
    noRequestCreated: "作成されたリクエストがありません. 開始するためにはリクエストを作成し送信してください.",

    /* RNH Bulk Controls */
    rnhBulkAssignPriorityTitle: "優先度の変更",
    rnhBulkAssignPriorityTooltip: "優先",
    rnhBulkDueDateTooltip: "期日",
    rnhBulkAssignPriorityModalHeader: "選択されたノートの編集ができません。",
    rnhBulkAssignPriorityModalContent: "オープンノートのみ優先度を変更できます。クリア済又はクローズ済ノートについては、再オープン化すると優先度を変更できます。",
    rnhBulkAssignDueDateModalContent: "オープンノートのみ期日を変更できます。クリア済又はクローズ済ノートについては、再オープン化すると期日を変更できます。",
    rnhBulkAssignUserTooltip: "再割り当て",
    rnhBulkAssignUserSearch: "検索",
    rnhBulkAssignUserTitle: "選択されたレビューノートの編集ができません。",
    rnhBulkAssignUserText: "オープンのレビューノートのみ再割当てできます。クリア済又はクローズ済のレビューノートについては、再オープン化すると再割当てできます。",
    rnhBulkAssignStatusTooltip: "ステータス",
    rnhBulkAssignUserNoFound: "検索結果なし",
    rnhBulkDueDatePlaceholder: "日付を選択",
    rnhBulkDeleteTextCorrect: "選択されたノートを削除してよろしいですか？削除すると、アクセスできなくなります。",
    rnhBulkDeleteTextIncorrect: "クローズ済ノートのみ削除できます。オープン又はクリア済ノートについては、クローズ済にすると削除できます。",
    rhnBulkDeleteTitleCorrect: "選択されたノートを削除してください。",
    rhnBulkDeleteTitleIncorrect: "選択されたノートは削除できません。",
    rnhBulkDeleteTextIncorrectComment: "クローズ済のレビューノートのみ削除できます。オープン又はクリア済のレビューノートについては、クローズ済にすると削除できます。",
    rhnBulkDeleteDescriptionAuthorComment: "作成したノートのみ削除できます。",
    rnhBulkDeleteEngagementComment: "選択されたレビューノートを削除してよろしいですか？削除すると、アクセスできなくなります。",
    rhnBulkDeleteTitleCorrectEngagementComment: "選択されたノートを削除してください。",
    rhnBulkDeleteTitleCommentCloseStatus: "選択されたノートは削除できません。",


    fourFortyFilters: "フィルター",
    fourFortySearch: "検索",

    /* Add External Member Start*/
    addExternalModalTitle: "外部メンバーの追加",
    accessGroupSelection: "アクセスグループの選択",
    noRecordinGroups: "検索結果なし",
    permission: "許可",
    permissionProjectManagement: "プロジェクトマネジメント",
    permissionProjectManagementDesc: "EY Canvas Client Portal内のクライアントリクエスト及び外部タスクのステータスの表示権限。外部メンバーはクライアントリクエスト及び外部タスクの詳細にアクセスできません。",
    permissionInfoTooltip: "全許可権限のリスト",
    groupInfoTooltip: "グループ一覧",
    groupRequired: "グループリストを選択してください",
    firstnameRequired: "姓は必須です",
    lastnameRequired: "名は必須です",
    initialsRequired: "イニシャルは必須です",
    roleRequired: "エンゲージメント役割は必須です",
    confidentialityRequired: "機密保持レベルが必要です",
    groupLabel: "アクセスグループ",
    firstnameLabel: "姓",
    lastnameLabel: "名",
    initialsLabel: "イニシャル",
    userinfo: "ユーザー情報",
    userinfoDescription: "インバイトしたいチームメンバーの姓、名もしくはメールアドレスを入力し、enterキーを押下してください",
    inviteAndClose: "インバイトし閉じる",
    inviteAndAddOther: "インバイトしさらに追加する",
    addAndClose: "インバイトして閉じる",
    addAndAddOther: "インバイトして他のユーザーを追加",
    externalUserCreatedSuccessMessage: "正常に追加されました。",
    accessGroupSelectionMessage: "アクセスグループを使用すると、EY Canvasクライアントポータルに送信されたリクエストを閲覧可能な外部チームメンバーを、チームで管理できます。EY Canvasクライアントポータルにアクセス可能なアクセスグループ及びユーザーのリストについてクライアントと合意してください。リクエストがグループの一部の外部ユーザーに割当てられた場合、当該グループの各メンバーが閲覧できます。",
    accessGroupSectionMessage1: "外部チームメンバーをEY Canvasに追加する場合に、My EY管理ポータルを使用して登録する必要があります。以下のリンクをクリックしてください。",
    accessGroupSectionMessage2: "：My EY管理ポータル",
    accessGroupMessageHyperlinkText: "リンク",
    accessGroupUserMessage1: "新規ユーザーに関する更なる情報については、以下のリンクをクリックしてください。",
    accessGroupUserMessage2: "：EY Atlas",
    noRecordForExternalMember1: "Eメールアドレスは見つかりませんでした。",
    noRecordForExternalMember2: "外部チームメンバーがMy EYに登録されているか確認してください。",

    /* Add External Member End*/

    /* Edit External Member Start*/

    editExternalModalTitle: "外部メンバーの編集",
    editExternalaccessGroupSelection: "アクセスグループの選択",
    editExternalGroupInfoTooltip: "グループ一覧",
    editExternalGroupLabel: "アクセスグループ",
    editExternalGroupRequired: "1つ以上のグループを選択してください",
    editExternalNoRecordinGroups: "データが見つかりません",
    editExternalUserinfo: "ユーザー情報",
    editExternalUserinfoDescription: "名（First name）、姓（Last name）、またはイニシャルを編集してください。",
    editExternalEmailLabel: "Eメール",
    editExternalFirstnameLabel: "名（First name）",
    editExternalLastnameLabel: "姓（Last name）",
    editExternalInitialsLabel: "イニシャル",
    editExternalSaveLabel: "保存",
    editExternalUsersSuccessMessage: "{0} {1}への変更が正常に保存されました。",
    editExternalUsersCloseLabel: "閉じる",

    /* Edit External Member End*/



    /*access group*/
    groupName: "グループ名",
    groupNameHelp: "アクセスグループを作成するには名前が必須です。",
    groupNameHelpOnEdit: "名前は必須です",
    groupNameReq: "グループ名は必須です",
    groupNameInvalidCharacter: "無効な文字",
    grpDomainManage: "グループ管理",
    grpDomainHelp: "ドメインはアクセスグループに追加可能なユーザーを制限しています。アクセスグループを作成するには、少なくとも1つのドメインが必要です。ドメインは@記号の後の文字を指します。ワイルドカードには*（例: *.ey.com）を使用してください。",
    btnAddNewDomain: "新規ドメインの追加",
    btnAddExistingDomain: "既存ドメインの追加",
    domainValidation01: "少なくとも1つの有効なドメインが必要です",
    domainValidation02: "ドメインの選択",
    domainValidation03: "エントリーの重複",
    domainValidation04: "無効なドメイン名",
    domainValidation05: "ドメイン名が必要です",
    domainName: "ドメイン名",
    emailDomain: "Eメールドメイン",
    groupDeletionErrorPendingReqMsg: "アクセスグループの削除中にエラーが発生しました。このグループまたはグループメンバーに割当てられたリクエスト/外部タスクがないことを確認し、再試行してください。",
    groupDeletionSuccessMsg: "{0} は正常に削除されました。すべてのアクティブメンバーは非アクティブ化されました。",

    /* uncommon values for internal mem */
    editInternalMember: "内部メンバーを編集してください",
    editThirdPartyMember: "第三者メンバーの編集",
    listOfAllPerm: "全許可権限のリスト",
    internalPermiInviteExt: "内部メンバーのインバイト",
    internalPermiInviteInt: "外部メンバーのインバイト",
    internalPermiAssignPer: "許可の割り当て",
    internalPermiDeleteEng: "エンゲージメントの削除",
    internalPermiArchEng: "エンゲージメントのアーカイブ",
    internalPermiUpdateContet: "コンテンツのアップデート",

    internalPermiInviteExtToolTp: "エンゲージメントへ内部チームメンバーをインバイトする権限",
    internalPermiInviteIntToolTp: "エンゲージメントへ外部チームメンバーをインバイトする権限",
    internalPermiAssignPerToolTp: "エンゲージメントへ内部及び外部チームメンバーをアサインする権限",
    internalPermiDeleteEngToolTp: "エンゲージメントの削除権限",
    internalPermiArchEngToolTp: "エンゲージメントのアーカイブ権限",
    internalPermiUpdateContetToolTp: "プロファイルの入力及びコンテンツの更新権限",
    internalMemberInviteSuccessMessage: " {0} {1}へのインバイトは正常に送信されました。",
    internalMemberPostArchivalAdditionSuccessMessage: " {0} {1}は正常に追加されました",
    invitePriorPeriodUsersSuccessMessage: "非アクティブユーザーへインバイトを送付しました。",
    editInternalUsersSuccessMessage: "{0} {1} への変更が正常に保存されました",
    rbacErrorEditUser: "変更を保存できません。もう一度お試しください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    universalQueueErrorEditUser: "EY Canvasのランディングページは現在アクセスできず、編集する必要があります。再試行しても問題が解消しない場合は、ITサービスデスクにご連絡ください。",
    removeExternalUsersSuccessMessage: "{0} {1}は正常に削除されました。",
    reActivateExternalUsersSuccessMessage: "{0} {1}は次のアクセスグループで再アクティブ化されました：{2}",

    /*user search component*/
    seachInputRequired: "検索値の入力は必須です",
    nameOrEmail: "名前もしくはメールアドレス",
    emailForExternal: "Eメール",
    noRecord: "検索結果なし",
    userSearchPlaceholder: "結果を表示するために名前もしくはメールアドレスを入力",
    userSearchPlaceholderForExternal: "結果を表示するには、メールアドレスを入力し、Enterを押して下さい。",
    clearAllValues: "全ての値のクリア",
    inValidEmail: "有効なメールアドレスを入力して下さい",

    maxLengthForEditResponse: "リッチテキスト形式を含め最大文字数は30,000字(全角15,000字）です。不要な形式を変更し再試行してください。",
    clickEditResponseToContinue: "続行するためには返答の編集をクリック",
    bodyDescriptionFromKnowledge: "ナレッジから提供される本文の内容",
    execution: "実施",
    cannotpasteimages: "画像を貼り付けることができません",
    pastingImagesNotAllowed: "イメージの貼り付けはできません。必要な場合エビデンスとしてアップロードし関連付けてください。",
    saveResponse: "保存されていない変更があります。続行しますか",
    conclusion: "総括",
    referenceDocsPlaceHolder: "頻繁にアクセスするファイルをすばやく開くためにはここに追加してください。",
    referenceDocsTeamPlaceHolder: "チーム参照文書がこのエンゲージメントに追加されていません。 開始するには[文書の追加]をクリックしてください。",
    referenceDocsMyPlaceHolder: "参照文書を追加していません。[文書の追加]をクリックして開始します。",
    teamDocuments: "チームがピン留めしたもの",
    myDocuments: "私がピン留めしたもの",
    teamDocumentsModalTitle: "チーム文書",
    myDocumentsModalTitle: "私の文書",
    referenceDocuments: "チームがピン留めしたもの",

    /* PinnedDocument  */
    PinnedDocument: "ピン留めされた文書",
    PinnedDocumentSubTite: "アイテムを下記の自身又はチームのリストにピン留めすると、よくアクセスされる文書のリストを作成できます。<b>文書の追加</b>を選択すると、リストを修正できます。",
    PinnedDocPaceholder: "あなたがピン留めした文書はありません。<br> <b>文書の追加</b>を選択すると、ここに文書をピン留めできます。",
    PinnedTeamDocPlaceholder: "チームがピン留めした文書はありません。<br> <b>文書の追加</b>を選択すると、ここに文書をピン留めできます。",
    PinnedDocAddDocHeaderText: "エビデンス及び一時ファイルを選択すると、ピン留めされた文書のリストをカスタマイズできます。",
    onlyShowPinnedDocuments: "ピン留めされた文書のみ表示",
    pinned: "ピン留め済",
    /* Arc Timeline */
    arcTitle: "アーカイブチェックリスト",
    arcCompleted: "完了",
    arcSubmit: "アーカイブの提出",
    arcDescription: "このエンゲージメントをアーカイブするには、チェックリストのすべての項目を完了してください",
    invalidEngagementCode: "無効なエンゲージメントコード",
    invalidClientCode: "無効なクライアントコード",
    arcCheckBox: "アーカイブの上書き",
    arcUnlinkEvidenceButtonText: "すべてのリンクを解除",
    arcUnlinkEvidenceModalTitle: "すべての共有エビデンスのリンクを解除",
    arcUnlinkEvidenceModalText: "エンゲージメントにおけるすべての共有エビデンスを、このワークスペースの他のエンゲージメントからリンク解除してもよろしいですか？この操作を完了すると、元に戻すことはできません。",
    arcUnlinkEvidenceModalConfirmButton: "すべてのリンクを解除",
    arcUnlinkEvidenceModalCancelButton: "キャンセル",
    arcUnlinkEvidenceButtonUnlinkInProgress: "リンク解除中",
    arcUnlinkEvidenceButtonUnlinkError: "リンク解除エラー",
    arcUnlinkGroupEngagementButtonText: "グループからリンクを解除",
    arcUnlinkGroupEngagementModalTitle: "このエンゲージメントへのリンクをグループから解除します。",
    arcUnlinkGroupEngagementModalText: "このエンゲージメントへのリンクを同一ワークスペースの他のエンゲージメントから解除してもよろしいですか？この操作を実施すると元に戻すことはできません",
    arcUnlinkGroupEngagementModalConfirmButton: "リンク解除",
    arcUnlinkGroupEngagementModalCancelButton: "キャンセル",
    arcUnlinkGroupEngagementButtonUnlinkInProcess: "リンク解除中",
    arcModalTitle: "既存のARCレコード",
    arcProceedWithArchive: "アーカイブを続行",
    arcModalBodyText: "リストアしたエンゲージメントファイルをアーカイブしようとしています。このファイルはアーカイブレコードセンター（ARC）に既に存在しますが続行しますか？",
    noDataAvailabel: "利用可能なデータはありません。ページを更新して、再試行してください。エラーが解決しない場合は、ヘルプデスクにお問い合わせください。",
    reportDateBeforeCurrentDate: "エンゲージメント報告書日は現在日以前とする必要があります。「エンゲージメントの主な日付の正確性の確認」のリンクのクリックにより報告書日を更新し先に進んでください。",

    /*Helix Projects*/
    linkedProjects: "リンクされたプロジェクト",
    suggestedAnalyzers: "推奨されるアナライザー",
    linkSelected: "選択したリンク",
    noLinkedProjectsAvailable: "リンクされたプロジェクトはありません",
    helixProjectTitle: "EY Helixプロジェクト",
    findProjects: "プロジェクトを検索",
    findProjectsModalTitle: "EY Helixプロジェクトを探す",
    selectProjectsToLink: "以下の1つ以上のEY Helixプロジェクトを選択し、EY Canvasエンゲージメントへのリンクを作成してください。他のEY Helixプロジェクトを検索するには、クライアントコードで検索してください。",
    newSearch: "新規の検索",
    noResultsFound: "結果が見つかりません。",
    enterClientCode: "クライアントコードを入力し再検索してください。",
    enterClientCodeToDisplayAnalizers: "クライアントコードを入力して利用可能なアナライザーを表示します。",
    defaultClientCodeIsInvalid: "デフォルトのクライアントコード{0}は無効です。有効なクライアントコードを入力し利用可能なアナライザーのリストを表示してください。",
    mirrorCodesNotAccepted: "ミラーコードは受け付けられませんでした。",
    helixProjectSearch: "検索",
    helixProjectsSearchPlaceholderText: "検索するクライアントコードを入力して下さい",
    helixWizardProjectsSearchPlaceholderText: "クライアントコードでアナライザーを検索",
    selectOneOrMoreProjects: "リンク先リストから1つ以上のHelixプロジェクトを選択してください",
    noPermissionLabel: "このエンゲージメントをアーカイブするためにはアーカイブ権限が必要です",
    linkProject: "プロジェクトのリンク付け",
    oneAnalyzerMustBeSelected: "1つのアナライザーを選択する必要があります。",
    selectAnAnalyzer: "アナライザーの選択",
    selectOneAnalyzer: "以下からEY Helixアナライザーを選択し、EY Canvasエンゲージメントへのリンクを作成してください。クライアントコードによりマニュアルでEY Helixプロジェクトや関連付けられたアナライザーを検索できます。",
    selectAnalyzerModalTitle: "アナライザーを選択する",
    selectAnalyzerModalBodyText: "EY Helix analyzerを選択してEY Canvas エンゲージメントにリンク付けしてください。",
    selectAnalyzerModalSubmitButtonLabel: "プロジェクトのリンク付け",
    projectCanNotBeLikedTootip: "このEY HelixプロジェクトはEY Canvasエンゲージメントとロケーションが一致しないため、利用できません。",
    unlinkProjectConfirmationModalTitle: "警告 - プロジェクトのリンクを解除します",
    unlinkProjectConfirmationModalBodyText: "リンクを解除しようとしているEY Helixアナライザーには、このエンゲージメントに関連付けられたクライアントのブックマークがあります。EY Helixアナライザーのリンクを解除すると、それらのブックマークは使用できなくなります。この操作は元に戻すことができません。続行しますか？",
    defineConnectionSettings: "接続の設定を決定する",

    helixConnectionPageTitle: "EY Helix接続",
    helixConnectionPageSubtitle: "接続されたEY Helixアナライザー、そのインポートされたデータおよびEY勘定科目にマッピングされたGL勘定科目の割合です。マッピングを調整するには、マッピングされた割合をクリックしてください。接続とインポートされたデータの間でマッピングされた割合は異なる場合があります。例えば、インポートされた日付の後にマッピングが行われた場合などです。最新のマッピングを取得するには、データを再インポートしてください。",
    helixIntegrationPageNoConnectedAnalyzerLabel: "接続されたアナライザーがありません",
    helixIntegrationPageTitle: "EY Helixとの統合",
    helixIntegrationPageSubtitle: "EY Canvasエンゲージメントに1つ以上のEY Helixアナライザーを関連付けてください",
    helixIntegrationPageNoHelixProjectLinkedLabel1: "関連付けられたアナライザーはありません。新しいアナライザーを関連付けるためには、",
    helixIntegrationPageNoHelixProjectLinkedLabel2: " ここをクリックしてください。",
    helixIntegrationPageColumnConnectionName: "接続名",
    helixIntegrationPageColumnConnectionType: "接続タイプ",
    helixIntegrationPageColumnAnalysisPeriod: "分析日",
    helixIntegrationPageColumnAnalyzerName: "EY Helixアナライザー名",
    helixIntegrationPageColumnLastConnectedBy: "最終接続者：",
    connectAnalyzer: "アナライザーへ接続",
    dataImportModalTitle: "独立性確認のインポート",
    dataImportModalBodyLabel: "このエンゲージメントには、「スコープ及び戦略」のインポートが既に存在します。各エンゲージメントにインポートできる「スコープ及び戦略」は１つのみです。このデータをインポートすると既存の「スコープ及び戦略」が上書きされます。続行しますか？この操作は元に戻せません。",
    dataImportModalBodyLabelMest: "「スコープ及び戦略」のインポートファイルがこのエンティティにすでに存在します。エンティティごとに「スコープ及び戦略」のインポートは1つだけ許可されています。このデータをインポートすることで既存の「スコープ及び戦略」データは上書きされます。続行しますか？この操作は取り消しできません。",
    dataImportModalCancelButtonLabel: "キャンセル",
    dataImportModalCloseButtonLabel: "閉じる",
    dataImportModalConfirmButtonLabel: "インポート",
    dataImportModalImportError: "接続されているEY Helix Analyzerに関連したエラーが発生しました。データがインポートできません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    //Entites to Business Mapping Modal
    entityMappingModalTitle: 'Entity mapping',
    entityMappingModalCancelLabel: 'Cancel',
    entityMappingModalSaveLabel: 'Save',
    entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
    entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s)',
    entityMappingModalAllBusinessUnitsLabel: 'All business units',
    entityMappingModalBusinessUnitSelectedCount: '{0} business unit',
    entityMappingModalBusinessUnitsSelectedCount: '{0} business units',
    entityMappingModalNoResultsFound: 'No results found',
    entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement.',
    entityMappingModalNoEntitiesLabel2: 'Create an entity to get started.',
    entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable.',
    /*Entites to Business Table*/
    entityMappingTableEntityColumnLabel: 'Entity',
    entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s)',

    helixProjectPageTitle: "EY Helixプロジェクト",
    helixProjectPageSubtitle: "このEY Canvasエンゲージメントに関連するEY Helixプロジェクトをリンク付けしてください。1つ以上のEY Helixプロジェクトがリンク付けされている場合、1つをプライマリープロジェクトとして選択し、EY Canvasへのデータ統合を利用可能にします。プライマリープロジェクトのみがEY Canvasに統合されるため、プライマリープロジェクトにはエンゲージメントに関連する日付のすべての仕訳アクティビティが含まれる必要があります。",
    helixProjectPageNoHelixProjectLinkedLabel1: "現在エンゲージメントにリンクしているEY Helixプロジェクトはありません。",
    helixProjectPageNoHelixProjectLinkedLabel2: "新しいEY Helixプロジェクトを追加する：",
    helixProjectPageNoHelixProjectLinkedLabel3: "して開始",
    helixProjectPageNoHelixProjectLinkedLabel4: "クリック",
    linkToHelixProject: "EY Helixを開く",
    addNewEYHelixProject: "新しいEY Helixプロジェクトの追加",
    eyHelixSetup: "EY Helixデータを統合する",
    existingConnectionDetectedModalTitle: "既存の接続を検出しました",
    existingConnectionDetectedDescription: "選択されたアナライザーは過去にこのEY Canvasエンゲージメントに接続されています。新しい接続を作成するか、既存の接続を以下から選択してください。",
    selectExistingConnection: "既存の接続を選択する",
    selectCreateNewConnection: "新しい接続を作成する",
    connectionNoRecords: "接続が見つかりません",
    selectOneOfTheOptionsToProceed: "オプションの一つを選択して進む。",
    saveHelixProjectErrorMessage: "接続されたアナライザーを保存できませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    noResultFoundForAnalyzerSelection: "検索中のアナライザーが有効な状態にあること及びアナライザーへのアクセス権が付与されていることを確認してください。詳細についてはEY Helix管理者に連絡してください。クライアントコードを入力し、もう一度検索してください。",

    /*Helix Analyzer Details Drawer*/
    connectButtonLabel: "接続",
    reConnectButtonLabel: "再接続",
    demoteFromFinancialStatementsOptionLabel: "財務諸表から除外する",
    promoteToFinancialStatementsOptionLabel: "財務諸表に接続する",
    deleteOptionLabel: "削除",
    projectAndAnalyzerDetailsSectionTitle: "プロジェクトとアナライザーの詳細",
    projectNameLabel: "プロジェクト名",
    clientCodeLabel: "クライアントコード",
    analyzerNameLabel: "アナライザー名",
    periodEndDateLabel: "期末日",
    analysisDateLabel: "分析日",
    lastConnectedByLabel: "最終接続者：",
    connectionSettingsSectionTitle: "接続設定",
    connectionTypesLabel: "接続タイプ",
    currencyTypeLabel: "通貨タイプ",
    currencyLabel: "通貨",
    currencyCodeLabel: "通貨コード",
    businessUnitsLabel: "ビジネスユニット",
    entitiesLabel: "エンティティ",
    analysisPeriodLabel: "分析日",
    comparativePeriod1Label: "比較日付1",
    comparativePeriod2Label: "比較日付2",
    manageAccountMappingSectionTitle: "勘定科目マッピングの管理",
    manageAccountMappingButtonLabel: "勘定科目マッピングの管理",
    mappedGLAccountsLabel: "マッピングされたGL勘定科目の%",
    updateSettingsButtonLabel: "設定をアップデートする",
    deleteConnection: "接続の削除",
    deleteConnectionQuestion: "選択された接続を削除してよろしいですか？この接続に関連する以前に統合されたデータはすべて削除されます。この操作は元に戻せません。",
    deleteConnectionWithAnalyticsQuestion: "選択された接続を削除してよろしいですか？この接続に関連する以前に統合されたデータはすべて削除されます。また、選択された接続には、このエンゲージメントに関連付けられたクライアントブックマークがあります。接続を削除することでこれらのブックマークも利用できなくなります。この操作は元に戻せません。",

    /*Helix Projects Table*/
    tableShowing: "以下の結果を表示する：",
    tableClientCode: " - クライアントコード： ",
    tableEngagementCode: "エンゲージメントコード",
    tableEngagementCodeName: "エンゲージメント名",
    tableProjectID: "プロジェクトID",
    tableProjectName: "プロジェクト名",
    tableAnalyzerName: "アナライザー名",
    tablePeriodEndDate: 'Period end date',
    tableEYHelixPeriodEndDate: "期末日",
    tableAnalysisDate: "分析日",
    tableEYHelixAnalysisDate: "分析日",
    tableAssignedPartner: "担当パートナー",
    tableProjectLinked: "リンク付けされたプロジェクト",
    tableTooltipAnalizerIsDeleted: "EY Helixからアナライザーが削除されました。接続を永久に削除するには、クリックして詳細ドロワーを開いてください。削除する際は、他のアナライザーが接続されている可能性を考慮してください。",
    tableTooltipAnalizerIsUnavailable: "アナライザーがEY Helixにおいて利用できません。詳細についてはEY Helix管理者に連絡してください。接続を永久に削除するには、クリックして詳細ドロワーを開いてください。削除する際は、他のアナライザーが接続されている可能性を考慮してください。",
    tableTooltipNotValidUser: "選択されたアナライザーへチームメンバーとしてアクセスがありません。EY Helixプロジェクト管理者に連絡しアクセス権を得て再試行してください。",

    /*Helix Project Cards*/
    cardAnalyzerConnectionLabel: "接続",
    cardAnalyzerHelixLabel: "EY Helix analyzers",
    cardAnalyzerMappedGLAccountsLabel: "マッピングされたGL勘定科目",
    cardAnalyzerEntityMappingLabel: 'Entity mapping',
    cardAnalyzerManageGLAccountsLink: "勘定科目マッピングの管理",
    cardAnalyzerSectionScopeAndStrategy: "スコープ及び戦略",
    cardAnalyzerSectionFinancialStatements: "財務諸表",
    cardAnalyzerSectionButtonLink: "こちら",
    cardAnalyzerSectionButtonDisconnect: "アナライザーの接続を切断する",
    cardAnalyzerSectionScopeAndStrategyNoBalance: "スコープ及び戦略のデータは重要性などのスコープ及び戦略アクティビティの現在の残高の表示のために利用されます。{0}をクリックしてスコープ及び戦略データをインポートしてください。",
    cardAnalyzerSectionFinancialStatementsNoBalance: "財務諸表はEY Canvasにインポートすると、EY Canvasエンゲージメントで手続を実施した箇所を財務諸表からドリルダウンすることができます。{0}をクリックして財務諸表をインポートしてください。",
    cardAnalyzerSectionAnotherAnalyzerType: "このアナライザーが接続されたため、EY Canvas、EY Helix及び/又はEY Smart Sampling間での統合が図られます。{0}をクリックするとこのアナライザーの接続を解除できます。",
    cardAnalyzerSectionButtonLinkDisableTooltip: "リンクされたアナライザーへチームメンバーとしてのアクセス権がありません。EY Helixプロジェクト管理者へ連絡してアクセス権を入手してください。",
    cardAnalyzerSectionButtonLinkDisableTooltipPermission: "このデータをインポートする権限がありません。このCanvasエンゲージメントにおいて「EY Helixデータのインポート」権限があることを確認し再試行してください。",
    cardAnalyzerTrialBalanceAnalisysPeriod: "分析日",
    cardAnalyzerTrialBalanceComparativePeriod: "比較日付",
    cardAnalyzerTrialBalanceSecondComparativePeriod: "第2比較日付",
    cardAnalyzerTrialBalanceLastImportDate: "最後にインポートされた日付",
    cardAnalyzerTrialBalanceCurrency: "通貨",
    cardAnalyzerTrialBalanceBusinessUnits: "ビジネスユニット",
    cardAnalyzerTrialBalanceMapedGLAccounts: "マッピングされたGL勘定科目",
    cardAnalyzerTrialBalanceImportStatus: "ステータスのインポート",
    cardAnalyzerTrialBalanceCurrencyTypeFunctional: "機能通貨",
    cardAnalyzerTrialBalanceCurrencyTypeReporting: "報告通貨",
    cardAnalyzerTrialBalanceImportData: "データのインポート",
    cardAnalyzerTrialBalanceAdjustmentModule: "調整モジュール",
    cardAnalyzerTrialBalanceReImport: "再インポート",
    cardAnalyzerTrialBalanceRemove: "削除",
    cardAnalyzerTrialBalanceImportStatusInProgress: "進行中",
    cardAnalyzerTrialBalanceImportStatusImported: "インポート済",
    cardAnalyzerTrialBalanceImportStatusError: "エラー",
    cardAnalyzerTrialBalanceImportStatusDisconnected: "切断済",
    cardAnalyzerTrialBalanceImportModalTitle: "データのインポート",
    cardAnalyzerTrialBalanceImportModalDescription: "インポートの属性を選択し、「インポート」をクリックしてインポートする",
    cardAnalyzerTrialBalanceImportModalButton: "インポート",
    cardAnalyzerTrialBalanceReImportModalTitle: "データの再インポート",
    cardAnalyzerTrialBalanceReImportModalDescription: "インポートの属性を選択し、「再インポート」をクリックして再インポートする。",
    cardAnalyzerTrialBalanceReImportModalButton: "再インポート",
    cardAnalyzerTrialBalanceImportInProgressTooltip: "インポート中です。これには数分かかる場合があります。",
    cardAnalyzerTrialBalanceImportEntityTooltip: "再インポート中にエンティティを変更することはできません。新しいインポートを作成し、別のエンティティを選択してください。",
    cardAnalyzerTrialBalanceImportMestEntity: "この選択は以前のステップで作成されたものです。編集のためにはそのステップに戻る必要があります。",
    cardAnalyzerTrialBalanceMestBusinessUnit: "この選択は上記のエンティティに基づいています。ビジネスユニット関係を編集するには、サマリーページ内の「エンティティマッピング」にアクセスしてください。",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "このフィールドを有効化するにはまず「通貨タイプ」を選択してください。",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "このフィールドを有効化するにはまず「通貨」を選択してください。",

    /*Helis Linked Projects Cards*/
    analysisDate: "分析日:",
    unlinkProject: "プロジェクトのリンク解除",
    editAnalyzer: "アナライザーを編集する",
    deleteProject: "プロジェクトの削除",
    projectDeleted: "プロジェクトは削除されました",
    loadingProjectDataLinked: "EY Helixのデータロード中",
    projectMarkPrimaryConfirmationHeader: "プライマリEY Helixプロジェクトを変更する ",
    projectMarkPrimaryConfirmationMsg: "プライマリEY Helixプロジェクトを変更してもよろしいですか？ ",
    projectPrimaryEYHexliProject: "プライマリEY Helixプロジェクト",
    helixProjectUnlink: "リンク解除",
    helixProjectDelete: "削除",
    analyzersLabel: "アナライザー:",


    /*Helix Import List*/
    importHelixList: "EY Helixインポートリスト",
    importDocumentName: "文書名",
    importDocumentID: "文書ID",
    importFileSize: "ファイルサイズ（KB）",
    importDownload: "ダウンロード",
    importNoRecords: "文書がありません",
    importInvalidDocumentID: "文書IDは検索において完全一致が必要です。完全な文書IDを含んでいることを確認してください。",

    /*Helix Connect analyzer modal*/
    connectAnalyzerClientLabel: "クライアント：",
    addConnectionNameLabel: "接続名を追加する",
    connectionNamePlaceholder: "接続名",
    connectionNameRequired: "必須",
    connectAnalyzerModalTitle: "アナライザーへ接続",
    connectAnalyzerDescription: "アナライザーを以下から選択しこのEY Canvas エンゲージメントへのリンクを作成します。クライアントコードによりEY Helixプロジェクト及び関連するアナライザーを検索してください。",
    analyzerLocationIncompatibleErrorMessage: "アナライザーは、そのデータがEY Canvasエンゲージメントと互換性のないロケーションに保存されているため、接続することができません。",
    analyzerMaxConnectionReachedErrorMessage: "選択されたアナライザーの許可された最大接続数に達しました。続行するには別のアナライザーを選択してください。",
    helixAnalyzerErrorMessage: "EY Helixアナライザーへの接続時にエラーが発生しました。ページを更新して再試行してください。問題が解決しない場合は、ヘルプデスクに連絡してください。",
    helixAnalyzerGLAConnectionErrorMessage: "EY Helixアナライザーに接続中にマッピングされた勘定科目数を取得する際に、1つ以上のエラー発生しました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    helixReImportErrorMessage: "EY Helixからのデータインポート中にエラーが発生しました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /*Helix Select Entity Modal*/
    selectEntityModalTitle: "エンティティの選択",
    noEntitiesMappedToBusiness: "ビジネスユニットにマッピングされたエンティティがありません。",
    noEntitiesMappedToBusinessFirst: "こちらを",
    noEntitiesMappedToBusinessLink: "クリックして",
    noEntitiesMappedToBusinessLinkText: "開始",
    searchEntityPlaceholder: "エンティティの検索",
    entityListHeader: "エンティティ",
    selectEntityErrorMessage: "エンティティを選択して続行する",
    entityAlreadyConnectedToScopeAndStrategy: "「スコープ及び戦略」のインポートファイルがこのエンティティにすでに存在します。エンティティごとに「スコープ及び戦略」のインポートは1つだけ許可されています。この選択を有効にするには、既存のインポートを削除してください。",
    selectEntityNoEntitiesFound: "結果が見つかりません。",
    selectEntityModalDescription: "データをインポートしたいエンティティを選択する。",

    /*Manage Account Mapping*/
    manageAccountMapping: "勘定科目マッピングの管理",
    manageAccountMappingErrorMessage: "EY Helixに接続できませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    helixViewerLoader: "Helixビューアーをロード中…",

    /*Helix Remove Import Modal*/
    removeImportModalTitle: "インポートの削除",
    removeImportRemoveButtonLabel: "削除",
    removeImportDescription: "以下のインポートを削除してもよろしいですか？",
    removeImportActionUndoneDescription1: "以下のインポートを削除してもよろしいですか？",
    removeImportActionUndoneDescription2: "この操作は元に戻せません。",
    removeImportErrorMessage: "あなたがこの画面を開いた後にインポートされたデータが変更されています。削除して続行するには、ページを更新し再試行してください。",

    /*Disconnect analyzer modal*/
    disconnectAnalyzerModalTitle: "アナライザーの接続の切断",
    disconnectAnalyzerDisconnectButtonLabel: "切断済",
    disconnectAnalyzerDescription: "選択したアナライザーの接続を切断してもよろしいですか？",
    disconnectAnalyzerImportsExistErrorMessage: "この画面を開いてから、この接続にインポートが追加されました。接続を切断するには、関連するインポートをすべて削除する必要があります。ページを更新し再試行してください。",

    /*Content Update */
    quote: '"',
    performContentUpdate: "コンテンツの更新の実施",
    contentupdate: "コンテンツの更新",
    btnContentUpdate: "更新",
    btnContentUpdateSelected: "更新",
    updateSuccessMessage: "コンテンツの更新が送信されました",
    msgContentUpdate: "コンテンツを更新するには、以下から1つ以上のカテゴリを選択してください。 多くの作業が既に完了している場合は、コンテンツの更新が適切かどうかをエンゲージメントエグゼクティブとディスカッションしてください。コンテンツの更新は元に戻すことができません。 ",
    msgIndependance: "独立性を更新すると、独立性の確認を再度完了する必要がある場合があります。 ",
    msgProfile: "プロファイルを更新すると、エンゲージメントコンテンツに重要な影響を与える可能性があります。 新しいプロファイルが提出されるまで、ユーザーはエンゲージメントにアクセスできなくなる可能性があります。 このアクションは元に戻せません。 ",
    msgHistoryContentUpdate: "以前に実施されたコンテンツ更新とそれらのステータス",
    msgWarningTitle: "警告",
    btnProceedContentUpdate: "続行",
    btnCancelContentUpdate: "キャンセル",
    confirmationMessageP1: "選択したコンテンツカテゴリのコンテンツ更新を完了しようとしています。以下を選択してください",
    confirmationMessageP2: "続行または選択",
    confirmationMessageP3: "今回コンテンツの更新を完了しない場合は",
    warningMessage: "更新するためには1つ以上のコンテンツタイプを選択する必要があります",
    groupReportingFormsSent: "グループレポーティング <b>送信済フォーム</b>",
    groupReportingFromStatus: "グループレポーティングフォームのステータス",
    primaryTeamReviewStatus: "プライマリーチームによるレビューステータス",
    reportingStatus: "レポーティングステータス",
    taskStatusLabel: "タスクステータス",
    primaryTeam: "プライマリーチーム",
    componentTeam: "構成単位チーム",
    groupTasksReceived: "グループ監査 <b>受領済タスク</b>",
    group: "グループ",
    regionalTeam: "リージョナルチーム",
    unlinkedLabel: "リンク解除",
    linkedLabel: "リンク済",
    unlinkedTasks: "<b>リンクされていないタスク</b>",
    unlinkedTask: "<b>リンクされていないタスク</b>",
    primaryTeamGroupTaskPlaceholder: "ここで構成単位を作成し、グループインストラクションを送信して進行状況を監視します。",
    componentTeamGroupTaskPlaceholder: "プライマリーチームからの構成単位グループタスクを承諾し、進捗状況のサマリーをここで確認します。",
    confirmUpdateMessage1: "これらのフォームの更新はコンテンツに重要な影響を及ぼす場合があります。開始すると、これらが完了するまで追加のコンテンツ更新を実施できません。",
    confirmUpdateMessage2: "「続行」を選択し続行するか、コンテンツ更新を完了したくない場合は「キャンセル」を選択してください。",
    updateSelectedTitle: "選択した更新",
    statusCodeForbidden: 403,
    pspAccountHeader: "勘定科目",
    pspAccountDateHeader: "コンテンツ日付",
    pspAccountStatus: "ステータス",
    pspAccountSelected: "選択済",

    /*Preapre for Arc*/
    YearEndDate: "期末日:",
    PeriodEndDate: "対象期間終了日:",
    ReportDate: "報告書日:",
    ArcDeadlineDate: "アーカイブ期日:",
    ClientCode: "クライアントコード：",
    PrimaryEngCode: "プライマリーエンゲージメントコード:",
    SecondaryEngCode: "セカンダリーエンゲージメントコード:",
    ReportType: "報告書は何らかの限定付ですか？強調事項がありますか?:",
    ProtectedDocuments: "注：保護された文書は、必要でない限り、エンゲージメント内のファイルとして保管すべきではありません。",
    noObjectsAvailable: "使用できるオブジェクトがありません",
    CurrentlyUnavailable: "現在使用できません",
    showMoreToggle: "表示数を増やす",
    showLessToggle: "表示数を減らす",

    //#region Document upload status

	docListUploadTemporaryPlaceholder: '<center>利用可能な文書はありません<br />―<br />1つ以上の文書をドラッグ＆ドロップするかボタンをクリックしてください。 <button class="motif-button motif-text-alt-button motif-button-small">一時ファイルを追加</button></center>',
    uploadEvidencePlaceholder: "１つ以上の文書をドラッグアンドドロップするか <a>エビデンスの追加</a> をクリックしてください",
    uploadTemporaryPlaceholder: "1つ以上の文書をドラッグアンドドロップするか <a>一時ファイルの追加</a>をクリックしてください",

    processing: "処理中",
    uploading: "アップロード中",
    uploadComplete: "処理中",
    downloading: "ダウンロード中",
    downloadComplete: "ダウンロード完了",
    loading: "読込中",

    //#region Filter

    filter: "フィルター",
    noFiltersAvailable: "利用可能なフィルターはありません",
    pickADate: "日付の選択",
    filterYes: "Yes",
    filterNo: "No",

    //#region Document list filters
    filterGroupDocumentsLabel: "文書",
    filterDocumentContentLabel: "文書の内容",
    filterSharedEvidenceLabel: "共有エビデンス",
    filterFileExtensionLabel: "ファイル拡張子",
    filterDocumentConflictLabel: "競合",
    filterDuplicateFileNameLabel: "ファイル名の重複",
    filterCanvasFormsLabel: "Canvasフォーム",

    filterGroupModificationsLabel: "修正",
    filterLastModifyUserLabel: "最終編集者",
    filterModifyAfterReviwerSignoffLabel: "レビューアーサインオフ後に修正",
    filterModifiedAfterLabel: "選択日付よりも後に編集",

    filterGroupReviewNotesLabel: "レビューノート",
    filterReviewNoteStatusLabel: "ステータス",
    filterReviewNoteAssignedToLabel: "宛先",
    filterReviewNoteAuthoredByLabel: "作成者",
    filterReviewNoteOtherEngagementLabel: "他のエンゲージメントから",

    filterGroupSignOffsLabel: "サインオフ",
    filterSignOffMissingLabel: "サインオフ未了",
    filterSignedOffByUserLabel: "サインオフ者",
    filterNotSignedOffByUserLabel: "サインオフ未了者",
    filterSignOffRequirementsLabel: "サインオフの要求",

    filterGroupOtherLabel: "その他",
    documentLink: "文書リンク",
    filterByCopyLinkDocument: "コピーリンク文書によりフィルター済",
    filterGroupAuditComponentLabel: "リージョン/構成単位チーム",
    noGroupAuditComponents: "構成単位は作成されていません",
    filterFindingsLabel: "発見事項",
    filterGroupInstruction: "グループインストラクション",
    noGroupInstruction: "インストラクションが作成されていません",

    documentSearchPlaceholderLabel: "文書の検索",
    analyticSearchPlaceholderLabel: "アナリティクスを検索する",
    //#endregion

    //#endregion

    pendingResponseLabel: "対応待ち",
    receivedLabel: "受領済",
    dueToPrimaryTeam: "プライマリーチームによる",
    sentToPrimaryTeam: "プライマリーチームに送信",
    documentationPending: "文書化の保留",
    documentationComplete: "文書化の完了",
    viewBytimephaseTextLabel: "タイムフェーズ別表示",
    showDetails: "詳細の表示",
    referenceDocAddDocHeaderText: "ダッシュボードからアクセスするためには、このエンゲージメントからのエビデンス又は一時ファイルを関連付けてください。",
    addDocsToTeam: "文書をチーム文書に追加",
    addDocsToMy: "文書を私の文書に追加",
    addDocument: "文書の追加",
    externalUserRemove: "削除",

    // Internal user roles abbr
    adminRole: "管理者",
    readOnlyRoleForThirdPartyUser: "読み取り専用",
    legacy: "制限なし",
    permissionLabel: "権限",
    displayPermissionErrorText: "権限を表示できません。もう一度お試しください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    onlyShowRelatedTasks: "関連するタスクのみ表示",

    softwareUpdate: "ソフトウェアアップデート",
    updateNow: "今すぐアップデート",
    updateMsg: "EY Canvasのソフトウェアのアップデートが利用できます。今すぐ更新を選択してダウンロードし、アップデートをインストールしてください。",

    processingError: "処理中のエラー",

    //Create tag modal labels
    createtags: "タグ作成",
    reportDate: "報告日",
    managetags: "タグ管理",
    savechanges: "変更内容を保存",
    manageTagGroupCreate: "作成",
    manageTagGroupDiscard: "破棄",
    manageTagGroupCreateTooltip: "タググループ",
    deletetag: "タグの削除",
    deletetaggroup: "タググループの削除",
    createTagGroup: "タググループの作成",
    manageTagGroupName: "タググループ",
    countOftasksAssigned: "割当て済タスク数",
    createTagGroupMessage: "タググループ及びタグを作成して開始します。{0}をクリックしてタググループを作成します。",
    tagsContnetSearchPlaceholder: "タグ検索",
    deleteTagHoverText: "保存すると、削除したタグ又はタグのグループは元に戻せません",
    deleteTagGroupHoverText: "このタグはエンゲージメントの全タスクから削除されます",
    tagSaveChangesInfoText: "このグループのすべてのタグがエンゲージメントの全タスクから削除されます",
    tagConfirmModalTitleText: "保存すると変更が適用されます",
    tagConfirmModalPrimaryMessage: "変更を保存してよろしいですか？",
    tagConfirmModalSecondaryMessage: "変更を保存してよろしいですか?",
    tagDeleteModalSecondaryMessage: "保存すると、削除されたタグを復元することはできません。 ",
    createNewTag: "新規タグの作成",
    tagWillBeRemovedFromRequests: "このタグは、エンゲージメントのすべてのリクエストから削除されます。 ",
    eyTags: "EY作成タグ",
    clientTags: "クライアント作成タグ",
    allTags: "全てのタグ",
    // Add canvas form
    addCanvasForm: "Canvasフォームの追加",
    addCanvasFormName: "文書名",
    addCanvasFormNameBlankMessage: "文書名は必須です",
	addCanvasFormNameInvalidCharacterMessage: '名称に次の文字は使用できません: */:<br>\\?|"',
    addCanvasFormDigital: "Digital",
    addCanvasFormCore: "Core",
    addCanvasFormNonComplex: "複雑でない",
    addCanvasFormComplex: "複雑",
    addCanvasFormListed: "上場",
    addCanvasFormGroupAudit: "グループ監査",
    addCanvasFormPCAOBFS: "PCAOB-FS",
    addCanvasFormPCAOBIA: "PCAOB-IA",
    addCanvasFormStandards: "基準",
    addCanvasFormStandardsNotSelectedMessage: "基準が必要です",
    addCanvasFormLanguage: "言語",
    addCanvasFormLanguageNotSelectedMessage: "言語が必要です",
    addCanvasFormNoResultFound: "結果が見つかりません",
    addCanvasFormManageTasks: "タスク管理",
    addCanvasFormAvailableTasks: "タスク名称",
    addCanvasFormAvailableTaskType: "タイプ",
    addCanvasFormTypeOfForm: "フォームタイプ",
    addCanvasFormSubServiceLine: "サブサービスライン",
    addCanvasFormTypeOfFormNotSelectedMessage: "フォームのタイプが必要です",
    addCanvasFormSelectedTasks: "選択済みタスク",
	addCanvasFormNoTaskDataAvailable: "タスクが選択されていません。 フォームを作成するには少なくとも1つ以上のタスクを選択してください",
    addCanvasFormCreateForm: "フォーム作成",
    addCanvasFormCancel: "キャンセル",
    addCanvasFormSuccessMessage: "{0} が作成されました。コンテンツ配信には10分ほど要する場合あります。",
    // Add Canvas form manage Objects
    addCanvasFormManageObjects: "{0}を管理",
    addCanvasFormAvailableObjects: "{0} 名称 //",
    addCanvasFormSelectedObjects: "{0} 選択済",
    addCanvasFormClickHereToOpenManageTab: "こちらをクリックして、「{0}の管理」タブを開きます。",
    addCanvasFormNoObjectsDataAvailableRequired: "{0} が選択されていません。フォームを作成するには1つ以上選択してください。",
    addCanvasFormNoObjectsDataAvailableOptional: "{0} が選択されていません",
    addCanvasFormObjectNotDefinedMessage: "このフォームではオブジェクトを利用できません",
    addCanvasFormOptional: "(任意)",
    addCanvasFormObjects: "オブジェクト",
    addCanvasFormObject: "オブジェクト",
    addCanvasFormSCOT: "SCOT",
    addCanvasFormSCOTs: "SCOTs",
    addCanvasFormITProcess: "ITプロセス",
    addCanvasFormITProcesses: "ITプロセス",
    addCanvasFormControl: "統制",
    addCanvasFormControls: "統制",
    addCanvasFormITControl: "IT統制",
    addCanvasFormITControls: "IT統制",
    addCanvasFormITApplication: "ITアプリケーション",
    addCanvasFormITApplications: "ITアプリケーション",
    addCanvasFormSignoffRequirements: "サインオフが必須:",
    addCanvasFormPICCheckBox: "PIC",
    addCanvasFormEQRCheckBox: "EQR",
    itProcessRelatedITGCITSP: "ITプロセス及び関連するITGCs/ITSPs",
    taskTitle: "ITプロセスの理解及び文書化: {0}",
    taskDescription: "ITプロセスの理解を文書化してください。ITプロセスの理解をサポートするエビデンスとして関連フォームを添付してください。<br>タスク属性セクションにITGCが表示される場合、ウォークスルー手続を実施してITGCの理解を確認し、デザイン及び業務への適用の評価を行ってください。実施した手続のエビデンスを添付してください。",
    addCanvasFormAccounts: "勘定科目",
    addCanvasFormAccount: "勘定科目",
    addCanvasFormErrorMessage: "このフォームは1つの勘定科目にのみ関連付けすることができます。",
    addCanvasFormValidationMessage: "選択が必須です。",
    addCanvasFormEstimates: "見積り",
    addCanvasFormEstimate: "見積り",
    addEstimateCanvasFormErrorMessage: "このフォームは1つの見積りにのみ関連付けることができます",
    addControlCanvasFormErrorMessage: "このフォームは1つの統制のみに関連付けができます。",
    addScotCanvasFormErrorMessage: "このフォームは1つのSCOTのみに関連付けができます。",

    //Independence Confirmation
    sortOrderIndependence: "並べ替え",
    confirmationStatus: "確認ステータス",
    confirmationDate: "確認日付",
    independenceConfirmationSearch: "チームメンバー検索",
    editTemplate: "テンプレートの編集",
    viewTemplate: "テンプレートの表示",
    confirmedBy: "確認者",
    overriddenBy: "無効者",
    grantedBy: "アクセス付与者",
    deniedBy: "アクセス拒否者",
    list: "リスト",
    paginationShow: "表示",
    options: "オプション",
    removeTeamMemberModalText: "このチームメンバーをエンゲージメントから削除してもよろしいですか？",
    removeTeamMemberModalTitle: "チームメンバーの削除",
    overrideRemovedBy: "上書き削除者",

    // Custom instructions
    addCustomInstruction: "カスタムインストラクションの追加",
    editCustomInstruction: "カスタムインストラクションの編集",
    customInstructionInstructionalText: "カスタムインストラクションをここで追加または編集します。これらのインストラクションは、各チームメンバーの独立性確認に表示され、クライアント特有の質問に対する回答を作成する際のガイダンスを提供します。",
    customInstructionPermissionTooltip: "このアクションを実行するには、<b>エンゲージメントの管理</b>権限が必要です。<b>エンゲージメント管理者</b>に相談して権限をリクエストしてください。",
    customInstructionMaxLengthExceeded: "文字数が最大許容数を超えました",

    //Independence Confirmation Details
    details: "詳細",
    question: "質問",
    answer: "回答",
    countTeamMembers: "チームメンバー数",
    executiveApproval: "エグゼクティブの承認",
    yes: "Yes",
    no: "No",
    independenceModalText: "ここでは、個人の独立性確認に対してこの回答を選択したチームメンバーを見ることができます",
    notApplicable: "該当なし",
    readMore: "さらに表示",
    readLess: "表示を少なくする",
    teamMembsersTitle: "チームメンバーの詳細",

    tasksSelected: "選択されたタスク",
    taskSelected: "選択されたタスク",
    unselectAll: "すべての選択を解除",
    addForm: "フォーム追加",
    addFormName: "名称",
    addFormDigital: "Digital",
    addFormCore: "Core",
    addFormNonComplex: "複雑でない",
    addFormComplex: "複雑",
    addFormListed: "上場",
    addFormGroupAudit: "グループ監査",
    addFormPCAOBFS: "PCAOB-FS",
    addFormPCAOBIA: "PCAOB-IA",
    addFormStandards: "基準",
    addFormLanguage: "言語",
    addFormManageTasks: "タスク管理",
    addFormManageObjects: "オブジェクト管理",
    addFormAvailableTasks: "利用可能タスク",
    addFormAvailableObjects: "利用可能オブジェクト",
    addFormTypeOfForm: "フォームタイプ",
    addFormSelectedTasks: "選択済みタスク",
    addFormSelectedObjects: "選択済みオブジェクト",
    addFormCreateForm: "フォーム作成",
    addFormCancel: "キャンセル",
    createtag: "タグ作成",
    tagsLabel: "タグ",

    //Group instruction summary
    sInstruction: "スコープ",
    iInstruction: "個人",

    //CGT and CGT Unlinked related labels
    cgtSend: "送信",
    cgtDueDate: "期日",
    cgtFrom: "フォーム",

    notesSelected: "選択済みノート",
    noteSelected: "選択済みノート",
    cgtUnlinkedLabel: "リンク解除",
    cgtUnlinkedInformationMessage: "このタスクは別のグループエンゲージメントにリンクされていません。不要になった場合は削除できます。",
    sendtoPrimaryTeam: "プライマリーチームに送信",
    sendtoPrimaryTeamdisableBtn: "このタスクをプライマリーチームに送信するためには、少なくとも作成者および査閲者がエビデンスにサインオフしなければなりません。",
	cgtSendModalHeader: '1つ以上の文書を選択しプライマリーチームに送信してください。<span class="modal-instruction-text">CanvasフォームはPDFフォーマットで送信されます。プライマリーチームに送信されたPDFによるCanvas フォームの記録は一時ファイルで利用可能です。</span>',
    cgtNotifyCheck: "これ以上送信予定の文書がないことをプライマリーチームに通知してください",
    cgtCanvasFormValidation: "このCanvasフォームには未解決のバリデーションがあります。プライマリーチームへの送付前にバリデーションが解決済みかを検討してください。",
    finalVersionLabel: "最終バージョン",
    draftVersionLabel: "ドラフトバージョン",
    otherEvidence: "他のエビデンス",
    selectAtLeastOneDocument: "1つ以上の文書を選択し続行します。",
	cgtsendmodelinstructionheader: '1つ以上の文書を選択しプライマリーチームに送信してください。<span class="modal-instruction-text">文書に<b>ドラフトバージョン</b>のマークを付すと、プライマリーチームに対し、文書は作業中で、追加バージョンを送付する可能性がある旨通知します。一方、文書に<b>最終バージョン</b>のマークを付すと、プライマリーチームに対し、文書は完了済で、追加バージョンを送付する予定がない旨通知します。</span>',
    //Independence confirmation
    undefined: "未定義",
    incomplete: "未完了",
    nomattersidentified: "除外事項なし",
    matteridentifiedpendingaction: "除外事項あり - 対応待ち",
    matterresolveddeniedaccess: "除外事項解決済 - アクセス不可",
    matterresolvedgrantedaccess: "除外事項解決済 - アクセス許可",
    notapplicable: "該当なし",
    restored: "リストア済",
    overriden: "上書き済",
    override: "上書き",
    priornomattersidentified: "前期 - 除外事項なし",
    priormatteridentifiedpendingaction: "前期 - 除外事項あり - アクション未了",
    priormatterresolvedgrantedaccess: "前期 - 除外事項解消済み - アクセス許可",
    priormatterresolveddeniedaccess: "前期 - 除外事項解消済み - アクセス拒否",
    addTagsLabelForTaskList: "タグ追加",
    addTagLabelForTaskDetails: "+ タグ追加",
    manageTagsColorInputLabel: "カラー",
    manageTagsTagNameInputLabel: "タグ名称",
    addTagRequiredMessage: "要求事項",
    addNewTagLinkText: "新規タグの追加",
    manageTagsLabel: "タグ管理",
    manageTagGroupHeader: "ここに新規タグ及びグループを作成してください。既存のタグ及びグループを編集や削除も可能です。タスクをタグ付けするとエンゲージメントの体系やプロジェクト管理の改善に役立ちます",
    //add tag color dropdown
    addTagRedColorText: "赤",
    addTagOrangeColorText: "オレンジ",
    addTagTealColorText: "ティール",
    addTagBlueColorText: "青",
    addTagPurpleColorText: "紫",
    addTagGreenColorText: "緑",
    deleteAssignmentConfirmationMessage: "この割当てを削除してよろしいですか?",

    // Return label for Returned document
    recieved: "受領済",

    selectServiceOffering: "サービスオファリングを選択してください",
    selectTasks: "タスクを選択してください",
    reviewSuggestedTasks: "推奨されるタスクのレビュー",
    reviewAvailableTasks: "利用可能なタスクのレビュー",
    setDueDate: "期日を設定してください",
    schedulerCreateRequestStep4TabText: "操作及びコミュニケーションプロトコル",
    createWorkRequestHeadingpart1: "開始するにはサービスリクエストに名前をつけ、サービスオファリングを選択してください",
    createWorkRequestHeadingpart2: "以下のサービスオファリングはエンゲージメントプロファイル及びリージョンで利用可能なサービスに基づいています。割当てリソースの職階及び複雑性によりコストは変動する場合があります。",
    createWorkRequestHeadingpart3: "エンゲージメントがロールフォワードされると、前期のエンゲージメントで使用されたサービスオファリングが次のようにラベル付けされます",
    createWorkRequestHeadingpart4: "前期",
    createWorkRequestHeadingpart5: "バッジ",
    createWorkRequestStep2Headingpart1: "利用可能なレビュータスク",
    createWorkRequestStep2Headingpart2: "サービスオファリング",
    createWorkRequestStep2Headingpart3: "<u>チームがWave 2集中化パイロットに参加する場合</u>、チームメンバーが実施できる次の基準に基づき、関連タスクを選択してください: (1) 客観的な監査手続 (i.e. 判断が不要/僅少なもの)、(2) 主観的な監査手続 (i.e. 判断が必要なもの）但し、低リスク見積項目又は関連アサーションの固有リスクが低い場合のみ。別の集中化サービスリクエストに既に含まれているタスクには次のラベルが付けられます",
    createWorkRequestStep2Headingpart4: "以前にこのサービスを利用したことがある場合、前期のリクエストに含まれていたタスクには次のラベルが付けられます",
    createWorkRequestStep2Headingpart5: "前期",
    requestName: "リクエスト名称",
    submittedBy: "提出者",

    // Next wave labels
    totalTasks: "タスク",
    noServiceRequest: "サービスリクエストが作成されていません。開始するにはサービスリクエストを作成しサブミットしてください。",
    eyContact: "EY担当者",
    requestStatusText: "リクエストのステータス",
    requestsByStatusText: "ステータス別リクエスト",
    serviceRequest: "サービスリクエスト",
    serviceGateway: "サービスゲートウェイ",
    centralizedServices: "サービスのリクエスト",
    serviceRequestDueDate: "期限",
    NA: "該当なし",
    more: "詳細",
    eycontacts: "EY担当者",
    addEYContact: "EY担当者の追加",
    editEYContacts: "EY担当者の編集",
    addEYContactInstructions: "このリクエストのEY担当者を追加または削除してください。更新されたEY担当者は、リソースマネージャと割当てられたリソースに送信されます。",
    editEYContactDisabledInstructions: "このアクションの実行には<b>サービスリクエスト</b> 権限が必要です。エンゲージメント管理者に相談し権限を取得してください。",
    emptyEYContactsPlaceholder: "少なくとも1人のEY担当者を追加し続行してください。",
    estimatedHours: "完了時間 (時間)",
    resourceManagers: "リソースマネージャー",
    nextWaveServices: "集中サービス",
    centralizedservices: "集中化サービス",
    onlyShowAccepetedRequests: "承認されたリクエストのみを表示",
    showSelectedOnly: "選択されたもののみ表示",
    emptyEngCodeMessage: "エンゲージメントに対する有効なコードがありません",
    primary: "プライマリー",
    estimatedCosts: "見積費用",
    assignedResources: "割当てられたリソース",
    generalAuditTasks: "全般監査タスク",
    generalInfo: "全般情報",
    requestID: "リクエストID",
    createdDate: "作成日",
    startDate: "開始日",
    serviceRequestDue: "期限",
    comingDueIn: "期限まで ",
    comingDueTodayLabel: "本日期限到来",
    daysLabel: " 日",
    dayLabel: " 日",
    createByLabel: " 作成者",
    notProvidedLabel: "未提供",
    editLabel: "編集",
    serviceRequestNoHistoryLabel: "このリクエストには履歴がありません",
    serviceRequestHistoryLabel: "ログ履歴",
    serviceRequestTasks: "サービスリクエストタスク",
    suggestedRequestTasks: "推奨されたリクエストタスク",
    estimatedCost: "見積費用",
    addinstructionsAndRelatedFiles: "このリクエストへのその他操作及びコミュニケーションプロトコルの追加",
    instructionText: "リクエストに関連するエビデンスはアーカイブされ、翌年のエンゲージメントにロールフォワードする場合にリクエストとともに含まれます。一時ファイルはアーカイブされず、ロールフォワードした場合に含まれません。",
    instructionPlaceHolder: "操作及びコミュニケーションプロトコル",
    warningText: "エビデンスはリクエストとともにアーカイブされますが、一時ファイルはアーカイブされません。",
    availableDocuments: "利用可能な文書",
    noDocumentsAvailable: "利用可能な文書がありません.",
    selectAll: "全て選択",
    deselectAll: "すべての選択を解除",
    documentsSelected: "選択された文書",
    selectedDocuments: "文書を選択しました",
    noDocumentSelected: "文書が選択されていません。開始するには文書を選択してください (任意)。",
    TaskName: "タスク名",
    AssignmentsLabel: "割当て",
    noTaskAssociatedToServiceRequest: "このリクエストに関連するタスクはありません。",
    requestServices: "サービスのリクエスト",

    serviceNotEditable1: "このリクエストに含まれているタスクの編集するために選択してください",
    serviceNotEditable2: "編集",
    serviceNotEditable3: "on",
    serviceNotEditable4: "タスク",
    serviceNotEditable5: "追加の変更またはこのサービスリクエストをキャンセルするには、",
    serviceNotEditable6: "リソースマネージャーに連絡してください。",
    serviceNotEditable7: "(割当てがある場合)",

    serviceReqMarkComplete: "集中化サービスのリクエストを完了にマークすると、追加業務の要求がないこと及びレビューが完了したことがサービスプロバイダーに通知されます。一度サービスリクエストを完了にマークすると、取り消しできません。",
    serviceReqMarkCompleted: "完了",
    editServiceRequestTasks1: "このサービスリクエスト用に選択されたタスクをレビューします。",
    editServiceRequestTasks2: "推奨されたタスクの対象となる",
    editServiceRequestTasks3: "サービスオファリングオファリングはここに表示されています。タスクを追加するには以下のリストから選択してください。タスクを除くには選択を解除してください。",

    submitServiceRequestConfirmation1: "このサービスリクエストを提出しますか？",
    submitServiceRequestConfirmation2: "選択されたサービスオファリングはこのエンゲージメントにおいて既に提出されたものです。",
    alreadyScheduledHeader: "予定済みのサービスオファリング",

    createServiceRequestPermission1: "続行するにはサービスリクエスト作成権限が必要です",
    createServiceRequestPermission: "このアクションの実行には<b>サービスリクエストの管理</b>権限が必要です。エンゲージメント管理者に相談し権限を取得してください。",
    schedulerRequestSubmissionError: "このリクエストをスケジューラーへ提出できないエラーが生じました。<b>再提出</b>を選択して再試行してください。 エラーが続く場合は、ヘルプデスクに連絡してください。",
    resubmit: "再提出",
    noServiceManager: "このリクエストにはリソースマネージャーが割当てられていません。",
    noAssignedResource: "このリクエストにはリソースが割当てられていません。",
    noMileStoneSetForService: "このリクエストにはマイルストーンの開始日及び期限が設定されていません。",
    isEngagementNominnatedForCentralizeService: "エンゲージメントはGDS集中化パイロット先への参加についてリージョンからの選定又は確認を受けていますか？",
    needApprovalForSericeRequestCreation: "リージョナルAMP(リージョナル・アシュアランス・マネージング・パートナー)に連絡し、このサービスリクエストを継続する適切な承認を得てください。",

    //TaskList Filters
    filterMissingRelatedTaskLabel: "タスクに関連付けられていないPIC/EQR文書",
    filterRelatedToRisksLabel: "リスクに関連",
    filterGroupTasksLabel: "タスク",
    filterGroupAssignmentsLabel: "割当て",
    filterGroupDocumentsignoffsLabel: "文書のサインオフ",
    filterGroupProjectManagementLabel: "プロジェクト管理",
    filterAssignmentTypeLabel: "割当てタイプ",
    filterTaskStatusLabel: "タスクのステータス",
    filterTaskTypeLabel: "タスクのタイプ",
    filterAssignedToLabel: "割当先",
    filterAssignmentStatusLabel: "割当てステータス",
    filterTaskReviewNoteStatusLabel: "ステータスに注意してください",
    filterTaskCommentStatusLabel: "ノートステータス",
    filterTaskReviewNoteAssignedToLabel: "割当先",
    filterTaskReviewNoteAuthoredByLabel: "作成者",
    filterPICDocumentsAssociated: "関連付けられたPIC文書",
    filterEQRDocumentsAssociated: "関連付けられたEQR 文書",
    missingSignOffs: "サインオフなし",
    signedOffBy: "サインオフ者",
    notSignedOffBy: "サインオフ未了者",
    filterTimePhaseLabel: "タイムフェーズ",
    filterMilestoneLabel: "マイルストーン",
    filterAuditPhaseLabel: "監査フェーズ",
    filterEngagementPhaseLabel: "エンゲージメントフェーズ",
    filterDocumentConflictsLabel: "文書のコンフリクト",
    filterEntitiesLabel: "エンティティ",
    missingEntityDocuments: "エンティティ文書がありません",
    filterDownloadedForOfflineLabel: "オフライン用にダウンロード",
    filterNextwaveServicesLabel: "集中化サービス",
    filterServiceGateway: "サービスゲートウェイ",
    filterScheduledServicesLabel: "関連するサービス",
    filterSuggestedServicesLabel: "推奨されたサービス",
    NoDocumentSignedOffLabel: "サインオフした文書がない者",
    SomeDocumentSignedOffLabel: "一部の文書にサインオフした者",
    AllDocumentSignedOffLabel: "全ての文書にサインオフした者",
    usersLabel: "チームメンバー",
    serviceRequests: "集中化サービス",
    backToMainPage: "メインページに戻る",
    suggestedNextwaveRequests: "推奨された集中化リクエスト",
    /* Component Send Status */
    deliveredDate: "配信済: {0}",
    sentDate: "送信済: {0}",
    sentFailure: "配信に失敗しました。再試行してください。問題が継続する場合はヘルプデスクに連絡してください。",
    chooseTaskInstructionLabel: "このリクエストに含めるタスクを選択してください。",
    createSRstep2InstructionalTextPart1: "既に別のリクエストに含まれているタスクには、次のラベルが付けられます：",
    createSRstep2InstructionalTextPart2: "このサービスオファリングを以前に使用している場合、前期のリクエストに含まれるタスクは次のようにラベル付けされます。",
    createSRstep2InstructionalTextPart3: "提案されたタスクのみを表示したい場合、以下のトグルを使用してください。",
    availableTasksLabel: "利用可能なタスク",
    guidance: "Atlasガイダンス",
    helixAnalyzers: "Helix analyzers",
    eyHelix: "EY Helix",
    smartAutomationLinks: "Smart Automation",
    createAutomation: "オートメーションの作成",
    noProjectTitle: "Herixプロジェクトへリンク",
    multipleProjectsTitle: "リンクされたHelixプロジェクトを選択",
    noProjectMessage: "Helix analyzerを開始するには、Helixプロジェクトをこのエンゲージメントにリンクしてください。",
    multipleProjectsMessage: "このエンゲージメントには複数のHelixプロジェクトにリンクしています。続行するには、以下のリストからHelixプロジェクトを選択してください。",

    automationGuidanceHeader: "提案されたオートメーション",
    helixAnalyzersHeader: "選択されたアナライザー",
    linkToHelixLabel: "Helixへのリンク",
    noSelectedTasksText: "タスクがまだ選択されていません。開始するには、タスクを選択してください。",
    selectedTasksLabel: "選択済のタスク",
    serviceOffering: "サービスオファリング",
    submitRequest: "リクエストの送信",
    scheduleYourRequest: "リクエストをスケジューリングしてください。",
    serviceRequestStep3HeaderText: "割り当てられたリソースがこれらのタスクの作業を開始する開始日を選択してください。次に、これらのタスクの完了日を選択してください。",
    serviceRequestMilestoneDueDateHeaderText1: "指定",
    startanddue: "開始日及び期日",
    eachmilestone: "各マイルストーン",
    serviceRequestMilestoneDueDateHeaderText2: "チームは全ての成果物について最終的な責任を有しています。このため、選択された期日はチームが成果物をレビューする十分な時間を有するものでなければなりません。",
    serviceRequestMilestoneDueDateHeaderText3: "見積工数にはサービス提供者が負担すると見込まれる時間のみを含めなければなりません。",
    schedulerBudgetMainQuestion: "あなたのエンゲージメントチームは：",
    schedulerBudgetFirstQuestion: "財務、プライシング、プランニングプロセスのすべての成果物が含まれていますか？",
    schedulerBudgetSecondQuestion: "このリクエストについてオンショアのエクスペリエンスマネージャーに通知していますか？",
    schedulerBudgetThirdQuestion: "オンショアチームメンバーの工数を適切に調整しましたか？",
    timetocompleteinfo1: "残工数にはサービス提供者が負担すると見込まれる時間のみを含め、",
    timetocompleteinfo2: "エンゲージメントチームのレビューや監督時間を含めてはなりません。",
    serviceRequestStartDate: "開始日",
    saveDraft: "ドラフトを保存",
    step3ValidationError: "期日は開始日より後でなければなりません",
    scheduledLabel: "Scheduled",
    suggestedLabel: "Suggested",
    searchTasksLabel: "タスクの検索",
    submit: "提出",
    selectTaskRequiredErrorMessage: "続行するには、1つ以上のタスクを選択する必要があります。",
    moveToCompleted: "完了への移行",
    requestResubmitMessagePart1: "このリクエストを再送信すると、ステータスが以下にリセットされます：",
    requestResubmitMessagePart2: "保留中",
    requestResubmitMessagePart3: "作成されたいかなる変更もスケジューラーによりレビューされます。",
    showSuggestedTaskToggle: "推奨されたタスクのみ表示",

    // Assignments
    addAssignmentName: "割当て名の追加",
    editAssignmentName: "割当て名の編集",
    deleteAssignmentName: "割当て名の削除",
    deleteAssignmentNameInstructionalTextHeader: "この割当て名を削除しますか？",
    deleteAssignmentNameInstructionalText: "一旦削除すると、この割当てはエンゲージメント内の全てのチームメンバー及び役割から削除されます。",
    assignmentType: "割当てタイプ",
    assignmentTypeInstructionalText: "割当てタイプを選択し、以下に名前を入力してください。完了したら、<b>追加</b>をクリックしします。",
    assignmentEditInstructionalText: "以下の割当てタイプと割当て名を編集してください。 完了したら、<b>変更を保存</b>をクリックしてください。",
    noSuggestedTaskLabel: "このカテゴリーに推奨されたタスクはありません。",
    manageAssignmentsLabel: "割当ての管理",
    myAssignmentsLabel: "私の割当て",
    myAssignedTasks: "私に割当てられたタスク",
    currentlyAssignedTasks: "現在の割当て",
    assignmentModalInstructionalText1: "チームメンバーやロールに割当てられたタスクを再割当てまたは削除するには、以下で名前を選択してください。<b>削除</b>アイコンを使用して、チームメンバーまたはロールへのすべての割当てを削除することもできます。割当ての名前を編集または削除するには<b>三点リーダー（・・・）</b>メニューを選択してください。",
    unassignedTasks: "未割当てのタスク",
    assignedTasks: "割当て済のタスク",
    type: "タイプ",
    priorperiodservicerequests: "過年度のサービスリクエスト",
    unmarkcomplete: "完了マークの解除",
    taskAttributes: "タスク属性",
    engagementTeam: "エンゲージメントチーム",
    assignTo: "割当て先",
    reAssignTo: "再割当て先",
    assign: "割当て先",
    reAssign: "再割当て",
    reAssignWarningLabel: "再割当てを行う場合には1つ以上のタスクを選択してください。",
    assignWarningLabel: "割当てを行う場合には1つ以上のタスクを選択してください。",
    searchByTaskName: "タスク名で検索",
    searchByTimePhaseName: "タイムフェーズ名で検索",
    assignment: "割当て",
    noMembersWithThisAssignment: "この割当てを有するチームメンバー又は役割はありません。",
    deleteTaskAssingmentByMemberAndAssignmentIntructionalText: "割当てはエンゲージメントの全てのタスクから削除されます。",
    noTaskAttributes: "このタスクには属性がありません。作成または関連付けを選択して開始してください。",
    assignmentWithoutAssignedUser: "この割当て名称は現在使用されておりません。",

    // v2 profile navigation Zeus to Hercules to Kronos message
    v2ProfileDocumentIdAvailableMessage: "プロファイル情報を収集中のため、しばらくお待ちください",
    v2ProfileDocumentIdDeletedMessage: "プロファイル情報が見つかりません。ページを更新して再試行してください。エラーが解消しない場合、ヘルプデスクに連絡してください。",
    accountAndRelatedAssertions: "勘定科目及び関連するアサーション",
    risks: "リスク",
    scotName: "SCOT名",
    strategy: "戦略",
    transactionType: "取引タイプ",
    notSelectedText: "未選択",
    relatedBy: "関連付け元",
    collaboration: "コラボレーション",
    controlsLabel: "統制",
    scotAndRelatedControls: "SCOT及び関連する統制",
    scotAndRelatedRisks: "SCOT及び関連する重要な虚偽表示リスク",
    frequencyLabel: "頻度",
    operatingEffectively: "運用が有効",
    designedEffectively: "デザインが有効",
    timeToCompleteHours: "完了時間 (時間)",
    completeRequiredFieldValidationError: "続行するには、すべての必須フィールドに入力してください。 ",
    itgcsAndItsps: "ITGCs及びITSPs",
    itprocessItgcsAndItsps: "ITプロセス及び ITGC/ITSPs",
    approachLabel: "アプローチ",
    typeLabel: "タイプ",
    itProcessName: "ITプロセス名",
    processEvaluation: "プロセス評価",
    unrelatedControls: "関連しない統制",
    disableNextwavePlaceholder: "集中化サービスは現在あなたの国では利用できません。問題が解決しない場合は、ヘルプデスクに連絡してください。",
    disableNextwavePlaceholderDataCenter: "集中サービスはあなたのローカルデータセンターでは利用できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    dataPrivacyInviteMessage: "インバイトする前に、データプライバシー規制のために適用される可能性がある監査調書へのアクセス制限を適切に検討しましたか？",
    //Session Timeout
    sessionTimerMsg: "操作が行われなかったため、作業セッションはまもなく中断されます。セキュリティ上の理由から、EY Canvasセッションは30分間操作がないと自動的に終了します。現在のセッションは{0}分後に中断されます。ログインしたままにする場合は、続行をクリックしてください。",
    logout: "ログアウト",
    sessionPopupTitle: "セキュリティ保護のため自動ログアウトされました。",
    allSuggestedTasks: "タスク",
    viewByAccount: "勘定科目で表示",
    viewBySCOT: "SCOTで表示",
    noServiceOfferingsAvailable: "利用できるサービスオファリングはありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    //Collaboration
    myRequests: "マイリクエスト",
    allRequests: "すべてのリクエスト",
    calendar: "カレンダー",
    calendarTodayButton: "今日",
    requestsListButton: "リクエストリスト",
    eventsButton: "イベント",
    analyticsButton: "アナリティクス",
    showAssignedToMe: "私のリクエストを表示",
    selectRequestsTitle: "詳細を表示するには、リクエストを選択してください 。",
    selectRequestsSub1: "一括制御を有効にするには、チェックボックスを使用するか、 ",
    selectRequestsSub2: "複数のリクエストを選択しながら、ShiftキーまたはCtrlキーを押してください。 ",
    noTagMessage: "まだタグは作成されていません。<b>こちら<b>をクリックして開始してください。",
    tagAs: "タグ:",
    addTag: "タグの追加",
    searchTag: "タグの検索",
    documentsAttached: "添付文書",
    editDraftRequest: "ドラフトリクエストの編集",
    deleteRequest: "リクエストの削除",
    deleteLabel: "削除",
    deleteLabelDisabled: "一括削除について十分な権限がありません。エンゲージメント管理者に相談し一括削除の権限を依頼してください。",
    DeleteRequestConfirmMsg1: "このリクエストを削除してよろしいですか？",
    DeleteRequestConfirmMsg2: "この操作は元に戻せません。",
    deleteRequestSuccess: "リクエストは削除されました。",
    DeleteRequestsConfirmMsg1: "これら{0} のリクエストを削除してよろしいですか？",
    dueDateCollabLabel: "期日",
    requestLabel: "リクエスト",
    statusLabel: "ステータス",
    inValidRequestTitleLabel: "現在のステータスでは次のリクエストを削除できません。",
    bulkSendButton: "送信",
    bulkDeleteButton: "削除",
    commentSyncFailedRetry: "EY Canvas Client Portalへのコメントの送付はできませんでした。",
    commentSyncFailedRetrySendAgain: "再送付してください。",
    commentDeleted: "このメッセージは削除されました。",
    CommmentDeletionSyncFailed: "コメントはEY Canvas Client Portalから削除できませんでした。",
    clickLabel: "クリック",
    toRetry: "再試行",
    replySyncFailedRetry: "EY Canvas Client Portalへの回答の送付はできませんでした。",
    quickFilterPriority: "優先度",
    quickFilterErrorCounterTooltip: "1つ以上のリクエストにエラーがあり、対応が必要です。",

    eyContactNoResultsFound: "ユーザーが見つかりません。",
    eyContactClear: "クリア",
    eyContactSearch: "検索",
    eyContactCollaboration: "EY担当者",
    eyParticipantsCollaboration: "EY参加者",
    externalParticipantsCollaboration: "外部の参加者",
    syncInProgressEYContact: "同期中",
    syncErrorEyContact: "同期エラー。再試行してください。",
    noAssignedContact: "割当てられた担当者なし。",
    noAssignedParticipant: "外部の参加者が追加されていません",

    commentsTooltipLabel: "コメント",
    recordingVirusScanInProgress1: "ウイルススキャン中です。完了次第、ボイスノートを利用できます。",
    screenrecordVirusScanInProgress1: "ウィルススキャンが進行中です。完了次第、画面録画が利用可能です。",
    recordingVirusScanInProgress2: "更新し再試行してください。",
    confidentialDocumentsModalTitle: "機密文書",
    confidentialDocumentsModalMsg1: "以下の機密文書がリクエストに追加されました。",
    confidentialDocumentsModalMsg2: "「続行」をクリックすると、文書をEY Canvas Client Portalに送信するための適切な機密性レベルを有していること、及びリクエストの割当てをレビューしたことを確認したことになります。",
    confidentialDocumentsModalMsg3: "1つ以上のこれらの文書をEY Canvas Client Portalに送信するための適切な機密性レベルを有していません。続行するには、アクセス権のない機密文書を全て削除してください。",
    confidentialityLevel: "機密性レベル",
    voiceNoteUploadError: "文書の詳細の取得エラーです。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    requestEventTitle: "イベント",
    noTaskDescription: "タスクの詳細がありません",

    newRequestLabel: "新しいリクエスト",
    newEventLabel: "新しいイベント",

    //Analytics Tab
    analyticsCreateDateLabel: "作成日: ",
    createdByLabel: "作成者:",
    expirationDateLabel: "有効期限:",
    sharedWithLabel1: "共有者",
    sharedWithLabel2: "リクエスト",
    sharedWithLabel3: "リクエスト",
    analyticsTabTitle: "アナリティクス",
    analyticsTabSubtitle: "EY Helixプロジェクトへの接続によりクライアントとアナリティクスを共有します。開始するには以下のブックマークペインからクライアントへの質問を作成します：",
    analyticsTabSubtitle2: "EY Helix",
    analyticsTabSubtitle3: '.',
    noActiveAnalyticsLabel: "アナリティクスが選択されていません",
    noActiveAnalyticsSubtitleLabel1: "アナリティクスが作成されていません。クリックしてください",
    noActiveAnalyticsSubtitleLabel2: "こちら",
    noActiveAnalyticsSubtitleLabel3: "から開始",
    noActiveAnalyticsSubtitleLabel4: "プロジェクトをリンクさせEY Helixにブックマークを保存した後、このページに戻ってEY Canvas Client Portalにおいて共有可能なアナリティクスのプレビューを確認してください。",
    selectAnalyticsLabel: "アナリティクスの選択",
    analyticsNoPrimaryHelixProjectsMessage: "このエンゲージメントは主要なEY Helixプロジェクトにリンクしていません。",
    selectAnalyticsModal: {
        closeTitleTip: "閉じる",
        modalTitle: "アナリティクスの選択",
        modalHeader: "外部のチームメンバーと共有するアナリティクスの選択",
        selectAnalyticPlaceholder: "アナリティクスの選択",
        selectAnalyticError: "アナリティクスは必須です",
        analyticNamePlaceholder: "アナリティクス名を入力してください（必須）",
        analyticNameError: "アナリティクス名は必須です",
        cancel: "キャンセル",
        viewPreview: "アナリティクスの表示",
        noPreviewAvailable: "プレビューは利用できません",
        noPreviewDescription: "アナライザーを選択してプレビューを確認",
        clickPreviewAnalytic: "クリックして選択したアナリティクスのプレビューを確認",
        documentObservation: {
            label: "選択した分析に関する所見もしくは質問を文書化してください",
            placeHolderLabel: "所見もしくは質問を入力してください（任意）"
        }
    },
    viewAnalyticsModal: {
        closeTitleTip: "閉じる",
        observationFieldPlaceholder: "選択した分析に関する所見もしくは質問",
        noObservationField: "この分析に関連する所見もしくは質問がありません。",
        appliedFiltersLabel: "適用されたフィルター",
		appliedFilters: [
			{
                id: '1',
                label: "分析通貨"
            },
            {
                id: '2',
                label: "通貨コード"
            },
            {
                id: '3',
                label: "端数処理の表示"
            },
            {
                id: '4',
                label: "ビジネスユニットグループ"
            },
            {
                id: '5',
                label: "ビジネスユニット"
            },
            {
                id: '6',
                label: "主要勘定科目タイプ"
            },
            {
                id: '7',
                label: "主要勘定科目サブタイプ"
            },
            {
                id: '8',
                label: "主要勘定科目クラス"
            },
            {
                id: '9',
                label: "主要勘定科目サブクラス"
            },
            {
                id: '10',
                label: "主要勘定科目名"
            },
            {
                id: '11',
                label: "主要EY勘定科目指定"
            },
            {
                id: '12',
                label: "主要EY勘定科目"
            },
            {
                id: '13',
                label: "ビジネスユニット"
            },
            {
                id: '14',
                label: "分析日"
            },
            {
                id: '15',
                label: "比較日付"
            },
            {
                id: '16',
                label: "セグメント01グループ"
            },
            {
                id: '17',
                label: "セグメント02グループ"
            },
            {
                id: '18',
                label: "セグメント03グループ"
            },
            {
                id: '19',
                label: "セグメント04グループ"
            },
            {
                id: '20',
                label: "セグメント05グループ"
            }
        ],
        save: "保存",
        cancel: "キャンセル",
        disabledEdit: "リクエストが既にEY Canvas Client Portalに送信されているため、所見を編集できません。この操作を可能にするにはリクエストを引き戻してください。",
        errors: {
            unautorizedUser: "関連付けられたEY Helixプロジェクトへチームメンバーとしてアクセスがありません。EY Helixプロジェクトの管理者へ連絡し再試行してください。",
            bookmarkNotFound: "選択したアナリティクスは削除されました。EY Helixに移動し、削除されたアナリティクスを管理するか、新しいアナリティクスを作成してください。",
            unautorizedAccessToBookmark: "リクエストされたEY Helixブックマークへのアクセス権がありません。EY Helixプロジェクトの管理者へ連絡し再試行してください。",
            authenticationError: "認証エラーです。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
            genericError: "ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
            defaultError: "{0} ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。"
        }
    },
    deleteAnalyticModal: {
        modalTitle: "アナリティクスの削除",
        modalHeader: "このアナリティクスを削除してよろしいですか？ このアナリティクスは EY Canvas 内で利用できなくなります。"
    },
    // activity feed
    search: "検索",
    searchTeams: "チームを検索",
    clear: "クリア",
    groupActivityLabel: "グループアクティビティ",
    documents: "文書",
    documentLabel: "文書",
    linkRequests: "リンクリクエスト",
    received: "受領済",
    returned: "差戻済",
    rejected: "取下げ済",
    accepted: "承諾済",
    sent: "送信済",
    unlinked: "リンク解除",
    finalized: "確定",
    groupActivityFeed: "グループアクティビティフィード",
    component: "構成単位",
    noExternalApprovalsMessage: "外部承認がありません",
    noFileSelectedMessage: "文書を選択すると詳細を表示します",
    noInstructionSelectedMessage: "アイテムを選択し詳細を表示",
    noLinkRequestSelectedMessage: "アイテムを選択し詳細を表示",
    noItemSelectedMessage: "アイテムを選択すると詳細を表示します",
    viewGroupActivity: "グループアクティビティを表示",
    pointOfContact: "連絡先",
    currentStatus: "現在のステータス",
    resolved: "解決済",
    viewVersion: "バージョンの表示",

    // activity feed right pane headings
    scope: "スコープ",
    groupRole: "グループの役割",
    linkRequestStatus: "リンクリクエストステータス",
    instructionStatus: "インストラクションステータス",
    linkStatus: "リンクステータス",
    today: "今日",
    yesterday: "昨日",
    thisWeek: "今週",
    lastWeek: "先週",
    twoWeeksAgo: "2週間前",
    threeWeeksAgo: "3週間前",
    lastMonth: "先月",
    older: "それ以前",
    actionsDateNote: "全ての日付と時刻はGMT時間で報告されます。",
    noActionsMessage: "表示するデータがありません",
    noManageRequestPermissionMessagePart1: "この操作を実行するには <b>サービスリクエストの管理</b>の許可が必要です。",
    guidedWorkflow: "EY Canvas FITイネーブルメント",
    navExecution: "実施",
    navCanvasEconomics: "EY Canvas Economics",
    navOversight: "EY Canvas Oversight",
    navConclusion: "結論",
    navTeamMemberIndependence: "チームメンバーの独立性",
    navGroupAudit: "グループ管理",
    navGroupActivityFeed: "グループアクティビティフィード",
    navPrimaryStatus: "プライマリーステータス",
    navComponentStatus: "構成単位ステータス",
    navGroupStatus: "グループステータス",
    navEngagementManagement: "エンゲージメント管理",
    navProfile: "プロファイル",
    navGroupStructureSummary: "グループ構造",
    OpenGuidedWorkflowDocument: "EY Canvas FITイネーブルメントでこの文書を開いてください",
    navNotApplicable: "該当なし",
    canvasForms: "Canvasフォーム",
    eYCanvasEconomics: "EY Canvas Economics",
    overDueAssignments: "期限超過割当て",
    comingDueAssignments: "期限間近の割当て",
    overDueReviewNotes: "期限超過レビューノート",
    comingDueReviewNotes: "期限間近のレビューノート",

    //Group Audit/Status  for DashboardV2

    Reportingformsbystatus: "ステータス別報告フォーム",
    ReportingStatusSubTitle: "以下で構成単位チームに割当てられたグループタスク及びステータス別受領済グループ文書のサマリを確認することができます。<br/> チーム又はグループタスク別で詳細な進捗をレビューすることができます。",

    Total: "合計",
    Returned: "差戻し済",
    Overdue: "期限超過",
    PendingResponse: "回答未了",
    Received: "受領済",
    ReadyForReview: "レビュー可能",
    messageNoDocument: "受領済文書なし",
    byTeam: "チーム別",
    byGroupTask: "グループタスク別",
    groupStructureLabel: "グループ構造",
    instructionPending: "インストラクション承諾未了",
    linkRequestPending: "リンクリクエスト未了",
    notusingeycanvas: "EY Canvas未使用",
    pendingLabel: "未了",
    teams: "チーム",
    NoDocumentReceiced: "受領済文書なし",
    selectTeamToSeeData: "利用可能なデータはありません。ここでデータを見るにはチームを選択してください。",
    noDataAvailable: "利用可能なデータなし。",
    prepared: "作成済",
    tasksAssigned: "割当てタスク",
    taskAssigned: "割当てタスク",
    instructionNotSent: "未送信インストラクション",
    assignedTeamNotProvidedDocForTasks: "\{0}\ チームはこれらのタスクに関する文書を送信していません。 |  \{1}\ 文書 (予定)",
    documentRecievedOutOfAssignedTasks: "割当てたタスクに対する文書の受領状況　<br><b>\{0}\</b> / \{1}\ ",
    documentRecievedOutOfAssignedTeams: "割当てたチームからの文書の受領状況 <br><b>\{0}\</b> / \{1}\ ",

    groupStatusSubTitle: "以下でプライマリーチームが割当てたグループタスク及びステータス別グループ文書のサマリを確認することができます。<br/> タスク又は文書ステータス別でグループタスクのフィルタ処理ができます。",
    notSent: "送信前",
    draftsent: "ドラフト送信済",
    finalsent: "最終版送信済",
    noTaskForComponent: "利用可能なデータはありません。<p> プライマリーチームから送信されたグループタスクは承諾後にこちらに表示されます。</p>",
    noTaskForComponentWithStatus: "利用可能なデータがありません。 <p> 1つ以上のステータスオプションを選択し、こちらのデータを確認してください。</p>",

    //Dashboard V2 - activity feed
    activityFeedSubHeadingText: "アクティビティタイプを選択すると過去10日間の関連するエンゲージメントアクティビティを確認できます。 <br/> 特定項目の <b>アクティビティ</b> アイコンをクリックすると、その項目に関する全てのアクティビティを表示できます。 <br/> トグルスイッチを使用すると表示を絞り込むこともできます。",
    activityFeedSubHeadingGroupAudit: "アクティビティタイプを選択すると過去10日間の関連するエンゲージメントアクティビティを確認できます。 <br/> 特定項目の <b>アクティビティ</b> アイコンをクリックすると、その項目に関する全てのアクティビティを表示できます。 <br/> トグルスイッチを使用すると表示を絞り込むこともできます。",
    teamHistoryInstructionalText: "過去10日間のこのチームのアクティビティを確認",
    teamHistory: "チームの履歴",
    onlySeeMyActivity: "私のアクティビティのみ表示",

    taskAddedBy: "タスク追加者",
    taskMarkedCompleteBy: "タスク完了マーク付与者",
    taskUnmarkedCompleteBy: "タスク完了マーク解除者",
    taskHandedOffBy: "タスクハンドオフ者",
    assignmentAddedBy: "割当て追加者",
    assignmentEditedBy: "割当て編集者",
    assignmentClosedBy: "割当てクローズ者",
    assignmentReOpenedBy: "割当再オープン者",
    assignmentDeletedBy: "割当て削除者",
    noteAddedBy: "ノートを追加した者",
    noteClearedBy: "ノートをクリアした者",
    noteClosedBy: "ノートをクローズした者",
    noteReopenedBy: "ノートを再オープン化した者",

    linkRequestSent: "リンクリクエスト送信者",
    instructionSentBy: "インストラクション送信者",
    linkRequestAcceptedBy: "リンクリクエスト承諾者",
    engagementUnlinkedBy: "エンゲージメントリンク解除者",
    instructionAcceptedBy: "インストラクション承諾者",
    instructionReturnedBy: "インストラクション返却者",
    labelTo: "to",
    instructionReceivedFrom: "インストラクション送信者",
    filtersLabel: "フィルタ",
    advanceOptions: "一括処理",
    advanceOptionsLabel: "一括処理",
    relatedScots: "関連するSCOTs",
    noRelatedScots: "関連するSCOTsなし",
    materialityLabel: "重要性",
    currentPeriod: "当期",
    previousPeriod: "前期",
    showCurrentPeriod: "当期の表示",
    showPriorPeriod: "前期の表示",
    planningMateriality: "PM",
    tolerableError: "許容誤謬額",
    sadNominalAmount: "監査差異要約表記載基準額",
    pmLabel: "PM",
    teLabel: "TE",
    sadLabel: "SAD",
    accountBalance: "勘定残高",
    mapAccountBalances: "勘定残高をマッピングする",
    connectToHelixProject: "Helixプロジェクトに接続する",
    connectToImportBalances: "勘定残高をインポートするため",
    helixMultiple: "複数",
    selectMESTentity: "エンティティを選択して詳細を表示",
    relatedWCGWAndControls: "関連するWCGWsと統制",
    relateAtLeastOneWCGW: "統制依拠戦略の各アサーションには、少なくとも1つの関連するWCGWが必要です。",
    notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
    relatedITProcesses: "関連するITプロセス",
    noRelatedITProcesses: "関連するITプロセスがありません",
    relatedITRiskITGCs: "関連付けられたITリスク、ITGC及びITSP",
    relatedITRisks: "関連するITリスク",
    ALRAHigherRiskCode: "高",
    materialityMestSelectEntity: "エンティティを選択して詳細を表示",
    OARCurrentPeriod: "分析日",
    OARComparative1Period: "比較日付1",
    xTELabel: "xTE",
    priorPeriodDesignation: "前期の指定:",
    priorPeriodEstimate: "前期の見積:",
    notApplicableAbbreviation: "N/A",
    accountDetails: "勘定科目の詳細",
    launchGuidedWorkflow: "ガイド付きワークフローを開始する",
    guidedWorkflowTitle: 'Guided workflow',
    viewAccountBalace: "勘定残高を表示する",
    viewAccountBalaceForEntity: "エンティティを選択して勘定科目残高を表示する",
    mainActivities: "主要アクティビティ",
    oversightProjectTile: {
        typeOversight: "Oversight",
        createProject: "プロジェクトの作成",
        oversightProjectengagementNotConnectedMessage1: "EY Canvas Oversightアプリケーションは、接続されたエンゲージメントのマイルストーン、プロジェクト管理、およびグループ監査の進捗状況を集約して表示します。 これを使用して、グループ監査またはエンゲージメントのポートフォリオが順調に進んでいることを確認できます。 ",
        oversightProjectengagementNotConnectedMessage2: "あなたのエンゲージメントは、EY Canvas Oversightプロジェクトとは関係ありません。 ",
        click: "クリック",
        togetstarted: "して開始します。",
        clickProjectmessage: "<b> +プロジェクトの作成</ b>をクリックして開始します。 ",
        lblclient: "クライアント：",
        lblEngagementCount: "エンゲージメント：",
        lblTaskscompleted: "完了したタスク：",
        lblMore: "さらに表示",
        myProject: "マイプロジェクト",
        OtherProject: "他のプロジェクト",
        oversightNoProjectConnectedMessage: "あなたは、EY Canvas Oversightプロジェクトのメンバーではありません。 ",
        oversightOtherProjectNotConnectedMessage: "あなたは、エンゲージメントが関係しているすべてのEY Canvas Oversightプロジェクトのメンバーです。 ",
        draft: "ドラフト",
        allTask: "全てのタスク",
        totalTask: "タスク合計"
    },

    economicsProjectTile: {
        typeEconomics: "エコノミクス",
        economicsProjectengagementNotConnectedMessage1: "EY Canvas Economicsアプリケーションは財務及びEY Canvasの進捗を要約します。エンゲージメントポートフォリオの管理に利用してください。",
        economicsProjectengagementNotConnectedMessage2: "EY Canvas Economicsプロジェクトに関連付けられたエンゲージメントはありません。",
        clickProjectmessage: "<b> +プロジェクトの作成</ b>をクリックして開始します。 ",
        economicsNoProjectConnectedMessage: "エンゲージメントが関連付けられたEY Canvas Economicsプロジェクトのうち、あなたがメンバーとなっているものはありません。",
        lblForecasted: "予測:",
        lblActual: "実績:",
        lblETC: "ETC:",
        lblVariance: "差異"
    },
    leftNavigation: {

        engagementOverview: "エンゲージメントの概要",
        myProgress: "私の進捗状況",
        executiveTasks: "フォーカスエリア",
        integration: "統合",
        groupAudit: "グループステータス",
        pinnedDocuments: "ピン留めされた文書",
        Validations: "検証",
        activityFeed: "アクティビティフィード",
        primaryStatus: "プライマリーステータス",
        componentStatus: "構成単位ステータス",
        picProgress: "PIC進捗状況",
        picEQRProgress: "PIC/EQR  進捗状況",
        drillDown: "ドリルダウン",
        maps: "マッピング",
        financialStatement: "財務諸表"
    },
    nowRowOverlayClientRequest: {
        createNew: "リクエストの追加をクリックし新規リクエストを作成してください。",
        all: "作成されたリクエストはありません",
        draft: "ドラフトステータスのリクエストはありません",
        pending: "返信を保留中のリクエストはありません",
        received: "受領済のリクエストはありません",
        accepted: "承諾済のリクエストはありません",
        customFilter: "一致するものが見つかりません。 もう一度やり直してください。 "
    },

    clientRequestPrefixes: {
        draft: "ドラフト",
        returned: "返却済",
        recalled: "引戻し済",
        withdrawn: "引戻済"
    },

    clientRequestsTabHeader: {
        all: "すべて",
        draft: "ドラフト",
        pending: "保留中",
        received: "受領済",
        accepted: "承諾済"
    },

    clientRequestsPriorityFilters: {
        all: "すべて",
        normal: "標準",
        high: "高",
        critical: "クリティカル",
        highAndCritical: "高＋クリティカル"
    },

    requestTableHeader: {
        requestId: "リクエストID",
        title: "タイトル",
        receivedDate: "受信日",
        dueDate: "期日",
        sentDate: "送信日",
        acceptedDate: "受領日",
        assignedTo: "割当て先",
        group: "グループ",
        status: "ステータス",
        priorityType: "優先度",
        tags: "タグ"
    },

    dropdownColumnsFilter: {
        1: "割当て先",
        2: "グループ",
        3: "期日",
        4: "送信日",
        5: "受領日",
        6: "承認日",
        7: "ステータス",
        8: "優先度",
        9: "タグ"
    },

    requestTableDropdownFilter: {
        customizeTable: "表のカスタマイズ",
        selectInfo: "オプションを4つまで選択してください。",
        selectInfoTooltip: "カラムを4つまで選択してください。1つ以上のオプションの選択を解除し続行してください。"
    },

    ClientStatus: {
        1: "ドラフト",
        2: "ドラフト－連絡先がありません",
        3: "送信済",
        4: "システムエラー",
        5: "無効なクライアント担当者",
        6: "回答待ち",
        7: "受領済",
        8: "承諾済",
        9: "返却済",
        10: "引戻済",
        11: "送信中",
        12: "承認中",
        13: "引戻中",
        14: "削除中",
        15: "差戻中",
        16: "応答中",
        17: "削除済",
        18: "無効なクライアント担当者",
        19: "転送中の引戻し",
        20: "引戻し済",
        21: "完了処理中",
        22: "引戻し中"
    },

    analyticStatus: {
        1: "作成中",
        2: "承認未了",
        3: "承認済",
        4: "期限切れ"
    },

    paginationControl: {
        firstPage: "最初のページ",
        lastPage: "最後のページ",
        previousPage: "前のページ",
        nextPage: "次のページ",
        show: "表示"
    },

    auditPlanFilterLabels: {
        showMore: "さらに表示",
        filterTypeOfScots: "SCOT",
        noScotsAvailable: "利用可能なSCOTsがありません",
        filterTypeOfITProcess: "ITプロセス",
        noITProcessAvailable: "利用可能なITプロセスはありません"
    },

    controlListBuildStep4FilterLabels: {
        scots: {
            filterTypeOfScots: "SCOTs",
            noScotsAvailable: "利用可能なSCOTsがありません"
        },
        testing: {
            filterTypeOfTesting: "テスト",
            noTestingAvailable: "利用可能なテストがありません"
        },
        designEffectiveness: {
            filterTypeOfDesignEffectiveness: "デザインの有効性",
            noDesignEffectivenessAvailable: "利用可能なデザインの有効性がありません"
        },
    },

    clientRequestsFilterLabels: {
        filterAssignedTo: "割当て先",
        filterAttachmentsLabel: "添付ファイルのタイプ",
        filterCreatedByLabel: "作成者",
        filterStatusLabel: "ステータス",
        filterDueAfterLabel: "期限後",
        filterDueBeforeLabel: "期限前",
        filterErrorsLabel: "エラー",
        filterOverdueLabel: "期限超過",
        filterTagLabel: "タグ",
        filterTimePhaseLabel: "タイムフェーズ",
        filterTypeLabel: "タイプ",
        filterPriorityLabel: "優先度",
        searchMembers: "メンバーを探す",
        noTags: "タグが作成されていません。",
        noTimephase: "タイムフェーズがありません。",
        clearAll: "全てクリア",
        clearHoverText: "クリア",
        noResultsFound: "結果が見つかりません",
        yes: "はい",
        no: "いいえ",
        showMore: "表示数を増やす",
        // Check this
        filterNoMatchesFound: "一致するものが見つかりません。 もう一度やり直してください。 ",
        filter: "フィルター",
        title: "フィルター",
        noRelatedTask: "関連付けられたタスクがありません"
    },
    //Dashboard - integration

    collaborationInstruction: "以下でステータス別のコラボレーションリクエストを確認することができます。 <br/> 件数をクリックすると、フィルタ処理されたリクエストリストに移動します。",
    noValidationsAvailable: "この監査フェーズの検証はありません。 ",
    individualView: "個別ビュー",
    engagementView: "エンゲージメントビュー",
    centralizedServiceInstruction: "下記のステータス別リクエストと集中化サービスを活用するタスクの割合を確認してください。<section ><b>サービスのリクエスト</b></section>を選択し新規リクエストを作成してください。",
    // Dashboard - todo list
    todoList: "To Do リスト",
    todoListInProgress: "現在",
    todoListOpen: "今後の予定",
    todoListClosed: "完了",
    todoListInstruction: "ステータス別の期限未到来の割当て及びレビューノートを確認してください。<br /> タイムフレーム又はカテゴリーを選択すると表示変更ができます。<br /> タスク又は文書名をクリックすると、アイテムを開くことができます。",
    noOpenAssignments: "割当先別未了タスクはありません。",
    noInProgressAssignments: "進行中の割当てはありません。",
    noClosedAssignments: "クローズ済の割当てはありません。",
    allLabel: "すべて",
    dueLabel: "期限",
    noAssignments: "割当てがありません。",
    executiveReview: "エグゼクティブレビュー",
    epTasksStatusSignOffWithoutDetails: "以下のPICのステータスサマリーを確認してください。",
    epTasksStatusSignOff: "以下のPICのステータスサマリーを確認してください。詳細は<b>詳細を表示</b>を選択してください。",
    epeqrTasksStatusSignOffWithoutDetails: "以下のPICとEQRのステータスサマリーを確認してください",
    epeqrTasksStatusSignOff: "以下のPICとEQR のステータスサマリーを確認してください。詳細は<b>詳細を表示</b>を選択してください。",
    eqrDefaultMessage: "このエンゲージメントでは本機能は利用しません",
    selectPartners: "業務執行社員を選択",
    noPartnersInEng: "エンゲージメントに業務執行社員がいません。",
    epTasks: "PICタスク",
    eqrTasks: "EQRタスク",
    viewDetails: "詳細を閲覧",
    picReview: "PICレビュー",
    eqrReview: "EQR レビュー",
    eqrtasksWithSignOff: "EQR <br/>サインオフが未了なタスク",
    eqrdocumentsWithSignOff: "EQR <br/>サインオフが未了な文書",
    pictasksWithSignOff: "PIC<br/>サインオフが未了なタスク",
    picdocumentsWithSignOff: "PIC<br/>サインオフが未了な文書",
    partnerSignoffs: "業務執行社員のサインオフ",
    epTaskswithpartnersignoffs: "件数をクリックし、フィルタ処理されたタスクリストに進んでください。",
    allDocssignedoff: " <br/>すべての文書がサインオフ済",
    someDocssignedoff: " <br/>一部の文書がサインオフ済",
    noDocssignedoff: " <br/>サインオフ済の文書なし",
    partnernotinvited: "業務執行社員がインバイトされていません。",
    noEQRsinyourengagement: "エンゲージメントにEQRが選定されていません。",
    selectEQRs: "EQRを選択してください。",
    eqrNotinvited: "EQRがインバイトされていません。",
    eqrsignoffs: "EQRのサインオフ",
    eqrtaskswithpartnersignoffs: "件数をクリックし、フィルタ処理されたタスクリストに進んでください。",
    allpartners: "全ての業務執行社員",
    allEQRs: "全てのEQR",
    reviewComments: "レビューノート",
    noOpenReviewComments: "オープン レビューノートはありません。",
    noClearedReviewComments: "クリア済みのレビューノートはありません。",
    noClosedReviewComments: "クローズ済みのレビューノートはありません。",
    noReviewCommentsForSelectedTime: "選択されたタイムフレームに関するレビューノートはありません。別のタイムフレームを選択し続行します。",
    picTasksSomeDocSignOff: "PICのサインオフが一部の文書に実施されているタスク",
    picTasksNoDocSignOff: "PICのサインオフがすべての文書に実施されていないタスク",
    eqrTasksSomeDocSignOff: "EQRのサインオフが一部の文書に実施されているタスク",
    eqrTasksNoDocSignOff: "EQRのサインオフがすべての文書に実施されていないタスク",
    picNotIdentified: "PICが識別されませんでした",
    eqrNotIndentified: "EQRが識別されませんでした",
    todoReviewNote: "レビューノート",

    // Dashboard - Executive Tasks
    executiveTasks: "フォーカスエリア",
    executiveTasksInstruction: "リスク又は勘定科目別タスクの表示を選択してください。 <br/> 選択後は、件数にカーソルを合わせて詳細を表示するか又はタスクを選択し特定の詳細ページに進んでください。",
    byRisk: "リスク別",
    byAccount: "勘定科目別",
    responsiveTasks: "関連するタスク",
    openNotes: "オープンノート",
    lowLabel: "低",
    mediumLabel: "中",
    highLabel: "高",
    criticalLabel: "重要",
    epRequired: "PICは必須",
    eqrRequired: "EQR必須",
    noDocumentsSignedOff: "サインオフ済の文書なし",
    someDocumentsSignedOff: "サインオフ済の文書",
    allDocumentsSignedOff: "サインオフ済の全ての文書",
    completedAssignments: "割当て完了済",
    designation: "指定",
    significantAccount: "重要な勘定科目",
    epSignOff: "PICサインオフ",
    eqrSignOff: "EQRサインオフ",
    someLabel: "いくつか",
    riskNoDataLabel: "このリスクに関連するタスクはありません。",
    accountNoDataLabel: "この勘定科目及びアサーションに関連するタスクはありません。",
    NoDataLabel: "選択されたアコーディオンについて利用可能なデータなし",
    // Manage tags
    manageTagsInstructionalText: "ここに新規タグを作成してください。既存のタグを編集や削除も可能です。リクエストをタグ付けすると、エンゲージメントの体系やプロジェクト管理の改善に役立ちます。",
    noTagsAdded: "追加されたタグがありません。タグを作成し開始してください。",

    // Client Request Comments
    noCommentsCreatedYet: "コメントが作成されていません。",
    addCommentTitleTip: "コメントの追加",
    addReplyTitleTip: "返信の追加",
    addAComment: "コメントを残してください...",
    addAReply: "返信を追加",
    deleteCommentConfirmationModalTitle: "コメントの削除",
    deleteCommentConfirmationModalMessage: "このコメントを削除しますか？このコメントへの全ての回答が削除されます。",

    // Client Request Voice Note Comment Labels
    voiceNoteCommentRecordLabel: "ボイスノート",
    voiceNoteCommentStopLabel: "停止",
    voiceNoteCommentPlayLabel: "再生",
    voiceNoteCommentDeleteLabel: "削除",

    //Client Request Status/Tooltip messages
    SendRequestSuccess: "リクエストが正常に送信されました。",
    BulkSendRequestSuccess: "{0}のリクエストは正常に送信されました。",
    BulkSendOneRequestSuccess: "1つのリクエストの送信に成功しました。",
    SendInProgress: "送付中",
    AcceptInProgress: "承諾中",
    CompleteInProgress: "完了処理中",
    HasErrorState: "リクエストは送信できませんでした。再試行してください。",
    WithdrawRequestSuccess: "リクエストは引戻されました。",
    WithdrawInProgress: "引戻中",
    WithdrawRequestError: "リクエストは引戻しができませんせした。再試行してください。",
    DeleteRequestError: "リクエストは削除できませんでした。ページを更新し再試行してください。",
    AcceptRequestError: "リクエストは承諾できませんでした。再試行してください。",
    CompleteRequestError: "リクエストは完了できませんでした。再試行してください。",
    InvalidClientContact: "無効なクライアント担当者",
    BulkSendInvalid: "1つ以上の選択されたリクエストの送信には追加アクションが必要です。確認して再試行してください。",
    returnInProgress: "返却中",
    returnRequestError: "リクエスト返却不可。再試行してください。",

    //Client Withdraw Request
    WithdrawRequest: "リクエストの引戻し",
    WithdrawReuestConfirmMsg: "このリクエストを引戻してよろしいですか？引戻し後は、クライアントは確認できなくなります。また、チーム側では引戻されたリクエストはドラフトリストに移行します。",
    WithdrawMenuOption: "引戻し",
    MoreOptions: "オプションの表示数を増やす",
    Complete: "完了",
    WithdrawLabel: "引戻済",
    CompleteInstructionalText: "クライアントから情報が既に提供されている場合は、完了としてください。",

    //Client Complete Request
    CompleteRequestConfirmMsg: "リクエストを完了すると、クライアントのTo Doリストからリクエストが削除され、クライアントのステータスが「送信済」に更新されます。このリクエストはEY Canvasの「受領済」リストに移動します。例えば、リクエストされた情報が別の方法で既に受領されている場合に使用できます。",
    CompleteRequest: "リクエストの完了",
    CompleteRequestSuccess: "リクエストは完了しました。",

    //Client Accept Return Request
    AcceptLabel: "承諾",
    ReturnLabel: "返却",
    ReturnRequest: "リクエストの返却",
    acceptRequest: "リクエストの承諾",
    acceptRequestWithoutTask: "選択されたリクエストを承諾してもよろしいですか？",
    acceptRequestWithTask: "<b>選択されたリクエストを承諾してもよろしいですか？</b> 添付された文書は {0}  関連タスクの外部文書タブから利用可能です。",
    acceptRequestSuccess: "リクエストは承諾されました。",
    returnedRequestSuccess: "リクエスト返却済",

    // Client Request Relate Files modal
    noRecordsFound: "記録なし",
    relateSelected: "選択された関連付け",
    relateFilesModalHeader: "文書を選択し選択された関連付けのクリックにより、既存文書をこのリクエストに関連付けできます。",
    relateAnalyticModalHeader: "既存のアナリティクスをこのリクエストに関連付けるには、選択されたアナリティクスのボックスにチェックを入れてください。他の利用可能なアナリティクスのプレビューを確認するにはクリックしてください",
    relateAnalyticHereModalHeader: "こちら",
    noAnalyticsRecordsFound: "共有可能なアナリティクスがありません。クリックして",
    noAnalyticsRecordsFoundGetStarted: "開始。",
    associateExistingDocumentsSelected: "文書が追加されました",
    associateExistingDocumentSelected: "文書が追加されました",

    // Client Request Details Header
    timePhaseLabel: "タイムフェーズ:",
    receivedDateLabel: "受領済:",
    dueDateLabel: "期限:",
    sentDateLabel: "送信済:",
    acceptedDateLabel: "承諾済:",
    clientRequestSyncLabel: "アップデートがEY Canvas Client Portalに送信されています。",
    editDescriptionLabel: "説明の編集",
    createdDateLabel: "作成済:",

    //Client Advance Search
    advancedSearch: "高度な検索",
    advancedSearchRefereceNumberCheck: "参照番号",
    advancedSearchTitleCheck: "タイトル",
    advancedSearchDocumentsCheck: "文書",
    advancedSearchCommentsCheck: "コメント",
    advancedSearchApplyButton: "適用",
    searchRequest: "検索する",
    clearSearch: "検索のクリア",

    //Adjustment Topup module
    adjustmentModule: {
        currencyType: "通貨タイプ",
        currencyCode: "通貨コード",
        businessUnit: "ビジネスユニット",
        all: "すべて",
        moduleName: "調整モジュール",
        financialStatement: "財務諸表",
        viewByTrialBalanceType: "試算表タイプ別表示",
        multiEntry: "マルチエンティティ",
        balanceSheet: "貸借対照表",
        incomeStatement: "損益計算書",
        currentperiodUnadjusted: "Analysis date ",
        unadjusted: "（未調整）",
        currentperiodAdjusted: "Analysis date ",
        adjusted: "（調整済）",
        adjustment: "調整",
        newAdjustment: "新しい調整",
        noRecordsFound: "レコードがありません",
        periodEnded: "期末日",
        periodsEnded: "期末日",
        noResultsFound: "結果が見つかりません。",
        notApplicableAbbreviation: "N/A",
        noAdjustmentCreated: "調整は作成されていません。",
        createAdjustment: "{0}を作成する",
        next: "次のページ",
        previous: "前のページ",
        reclassification: "組替",
        manageAdjustment: "調整の管理",
        lastPage: "最後のページ",
        firstPage: "最初のページ",
        filterYes: "はい",
        filterNo: "いいえ",
        showOnlyAdjustedAccountClasses: "調整がある勘定科目クラスのみ表示",
        noneAvailable: "利用できません",
        noImportedTrialbalanceAvailable: "インポート済の試算表がありません。",
        trialBalanceRequired: "試算表",
        comparativeperiodUnadjusted: "比較日付",
        comparativeperiodAdjusted: "比較日付",
        multityEntityRequired: "マルチエンティティ",
        placeHolderMessageWhenHelixMappingIsTrue: "インポート済の試算表がありません。{0}をクリックし新しいアナライザーを関連付けてください。",
        placeHolderMessageWhenHelixMappingIsFalse: "EY Helixとの統合は利用できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
        eyHelixIntegrationLinkText: "EY Helix接続",
        noEntitiesAvailablePlaceholder: "エンティティが作成されていません。エンティティを作成し開始してください。",
        search: "検索",
        viewAdjustmentWithValidations: "バリデーション有の調整を表示 ({0})",
    },

    misstatementLabels: {
        name: "名前",
        notes: "ノート",
        signOffs: "サインオフ",
        open: "オープン",
        openReadOnly: "読み取り専用で開く",
        delete: "削除",
        rename: "名前の変更",
        signOffRequirements: "サインオフの要求",
        confidentiality: "機密性",
        unlink: "リンク解除",
        removeFromAdjustment: "調整から削除"
    },

    allControls: "すべてのコントロール",
    //Client Request Document labels
    clientRequestDocuments: {
        externalDocuments: "外部",
        taskDocuments: "文書",
        deletedDocuments: "削除済",
        priorPeriodDocuments: "前年度",
        priorPeriodInfoMessage: "これらの文書はダウンロードできません",
        uploadedBy: "作成者",
        deletedBy: "削除者",
        lastModifiedBy: "最終更新者",
        eyBadge: "文書から削除済",
        externalBadge: "外部から削除済",
        uploadInProgress: "アップロード中",
        refreshdocuments: "文書の更新",
        disabledDocument: "一括操作はこのタイプの文書では使用できません。",
        menuOptions: {
            delete: "削除",
            open: "開く",
            openr: "読み取り専用で開く",
            restore: "リストア",
            remove: "削除",
            rename: "名前の変更",
            editInHelix: "EY Helixで編集"
        },
        externalPriorPeriod: "クライアント",
        eyPriorPeriod: "EY",
        uploadedByEY: "EY"
    },

    //Client Request Assigned To Errors
    clientRequestAssignedToErrorLabel: "割当てユーザー又はグループは無効です。割当てを更新し続行してください。",
    clientRequestAssignedToErrorLabelEnd: "外部チームメンバーを編集するにはこちらをクリックしてください。",
    clickHereLabel: "リンク：",
    clientRequestAssignedToIconErrorLabel: "割当てグループにはアクティブなメンバーはいません。リクエストをアクティブユーザー/グループに割当てるかメンバーをグループに追加し続行してください。",
    clientRequestDueDateErrorLabel: "期日は必須です。期日をアップデートして続けてください。",

    clientRequestDocumentsNoDocsFound: [{
            id: 'externalDocuments',
            label: "追加された外部文書なし"
        },
        {
            id: 'taskDocuments',
            label: "1つ以上の文書をドラッグアンドドロップするか文書の追加をクリックしてください。"
        },
        {
            id: 'deletedDocuments',
            label: "削除された文書なし"
        },
        {
            id: 'searchRequestDocuments',
            label: "一致したものはありません。再試行してください。"
        },
        {
            id: 'priorPeriodDocuments',
            label: "利用可能な前期の文書がありません"
        }
    ],

    liveNotifications: {
        "ey.at.hercules.annotation.created": "作成済の注釈",
        "ey.at.hercules.annotation.edited": "編集済の注釈",
        "ey.at.hercules.annotation.replied": "回答済の注釈",
        "ey.at.hercules.contentupdate.updated": "更新済コンテンツ",
        "ey.at.hercules.contentupdate.failed": "コンテンツ更新ができませんでした。"
    },

    //Assign to
    usersOption: "ユーザー",
    externalUsersOption: "外部ユーザー",
    groupsOption: "グループ",
    lblassignedto: "割当て先",
    searchGroup: "グループの検索",
    requiredAssignedTo: "割当てが必要です",
    rdSubmitRequest: "リクエストの提出",

    closeDrawer: "閉じて全ての選択を解除",
    requestSelected: "選択済リクエスト",
    requestsSelected: "選択済リクエスト",
    //GA Scopes labels
    engagementScopesAndCustomSubScopes: "エンゲージメントスコープ及びカスタマイズされたサブスコープ",
    defineGroupScopes: "グループスコープの決定",
    gaScopeIntro: "EY GAM上のエンゲージメントスコープがデフォルト設定となっています。同一スコープを共有する複数チームへのグループタスク及びインストラクションのカスタマイズが必要な場合、サブスコープの作成を検討してください。インストラクション送信の際は、各サブスコープに異なるバージョンの送信が可能です。",
    addSubScope: "サブスコープの追加",
    customSubScope: "サブスコープのカスタマイズ",
    noCustomSubscopes1: "このエンゲージメントスコープについてカスタマイズされたサブスコープはありません。",
    noCustomSubscopes2: "<b>サブスコープの追加<b>を選択し開始してください。",
    subScopeName: "サブスコープ名",
    addDescription: "説明の追加",
    textExceedsLength500: "文字数を500字超とすることはできません。",
    manageGroupPermission: "このアクションの実行には<b>グループ管理</b>権限が必要です。エンゲージメント管理者に権限のリクエストについて相談してください。",
    deleteCustomSubScope: "カスタムサブスコープの削除",
    areYouSureDeleteCustomSubScope: "カスタムサブスコープを削除してよろしいですか？",

    //GA Component labels
    newTeam: "新規チーム",
    teamName: "チーム名",
    legalEntityName: "法人名",
    parentTeam: "親会社監査チーム",
    isReferenceOnly: "参照専用",
    isNotUsingCanvas: "EY Canvasを利用していないチーム",

    referenceOnlyTooltip: "<b>参照専用</b>に指定されたチームではリンクリクエスト、インストラクション又はタスクを受領できません。これらは組織的な目的でのみ使用されます。",

    canvasFormNotOwnedByEng: "このエンゲージメントによって所有されていない共有CanvasフォームはEY Canvas Client Portalに送信できません。このフォームを送信する必要がある、或いはソースエンゲージメントから送信する必要がある場合、このエンゲージメント上でフォームのコピーを作成してください。",
    canvasFormNotAllowedInCtry: "所在国ではクライアントとのCanvasフォームの共有は利用可能ではありません。",
    on: "on",
    sendRequest: "リクエストの送信",
    selectUserOrGroup: "ユーザー又はグループの選択",
    canvasFormShowAttachments: "{0} 添付文書を表示",
    canvasFormShowOneAttachment: "1添付文書を表示",
    canvasFormHideAttachments: "{0} 添付文書を非表示",
    canvasFormHideOneAttachment: "1添付文書を非表示",

    //GA Components
    createGroupStructure: "グループ構造の作成",
    componentText: "EY Canvas経由でのデリバラブルズ授受を行う各エンゲージメントチームについてリージョン及び構成単位を作成してください。  EY Canvas経由でのデリバラブルズ授受を行わない場合、<b>EY Canvasを利用しない</b>にチームを指定できます。また、組織上の目的でのみチームを作成し<b>参照のみ</b>へのチーム指定もできます。 このような指定先チームにはリンクリクエスト、インストラクションまたはタスクは送付されません。対応後、<b>リンクリクエストの送信</b>を選択します。",
    addTeam: "チームの追加",
    sendLinkRequests: "リンクリクエストの送信",
    noComponents: "チームが作成されていません。<b> チームの追加 <b> を選択し開始してください。",
    editTeam: "チームの編集",
    deleteTeam: "チームの削除",
    deleteInstructional: "このチームを削除してよろしいですか？<br/><br/> このチームへのリンクが解除されエンゲージメントを通して文書のやり取りができなくなります。さらに、このチームに割当てられた全てのカスタムインストラクション及びタスクが削除されます。",
    linkRequestHasBeenSent: "リンクリクエストが既に送信済みである、または指定が既に設定済みであるため、このチームのスコープまたは指定を編集できません。",
    selectScopes: "スコープの選択",
    searchScopes: "スコープの検索",
    selectTeams: "チームの選択",
    sendLinkRequestsDescription: "エンゲージメントを関連付けたいスコープまたはチームを選択してください。<br> リンクリクエストが各チームの担当者に送信されます。担当者がリンクリクエストを承諾すると、EY Canvasを通してグループインストラクションとタスクを受け取ります。",
    sendVersionsDescription: "グループインストラクション及びタスクの最新バージョンを送付したいスコープ又はチームを選択してください。<br>送付先チームがあなたのエンゲージメントに関連付けされると、グループインストラクション及びタスクが受領できるようになります。チームが最新バージョンを承諾すると、エンゲージメントで利用可能となります。",
    notSentYet: "送信済バージョンなし",
    notLinkedYet: "リンクリクエストの送信未了",
    cardView: "カード表示",
    noItemsPlaceholder: "バージョンは未発行です。グループインストラクション及びグループタスクのバージョンを発行しこちらにあるデータを確認してください。",

    //GA Instructions
    customizeGroupInstructions: "グループインストラクションのカスタマイズ",
    gaInstructionsIntro: "EY GAMに従ったグループインストラクションがデフォルトで含まれおり、本質的に情報提供機能です。リージョナルチーム及び構成単位チームに主要な情報、作業スコープ及び一元的に実施される手続の通知を目的としています。このため、インストラクションのEY GAMからのカスタマイズを行い、必要な場合追加インストラクションを織込み、各インストラクションのスコープまたはチームへの割当て要否を決定してください。対応後、インストラクションを発行し割当てスコープまたはチームへ送信してください。",
    addInstruction: "インストラクションの追加",
    instruction: "インストラクション",
    groupTaskSelected: "グループタスク",
    assignScopes: "スコープへの割当て",
    assignTeams: "チームへの割当て",
    maxLengthMessage: "文字数は<b>500<b>字以内にしてください。",
    addScope: "スコープの追加",
    editInstruction: "カスタムインストラクションの編集",
    editKnowledgeInstruction: "ナレッジインストラクションの編集",
    editKnowledgeTask: "ナレッジタスクの編集",
    editCustomTask: "カスタムタスクの編集",
    saveChangesInstruction: "変更の保存",
    updatedOnInstruction: "最終更新日：",
    knowledgeDescriptionInstruction: "ナレッジの説明",
    editDisabledTitle: "このアクションの実行には <b>グループの管理</b> 権限が必要です。エンゲージメント管理者に相談し権限を取得してください。",
    deleteCustomInstruction: "インストラクションの削除",
    deleteGroupTask: "続行すると失われる未保存の変更があります。<br/> 続行するには <b>確認</b>を選択してください。または<b>キャンセル</b> を選択して、元のページに戻り、変更を保存してください。",
    areYouSureDeleteCustomInstruction: "このカスタムインストラクションを削除してもよろしいですか?",
    areYouSureDeleteCustomTask: "このカスタムタスクを削除してもよろしいですか?",
    publishAfterDelete: "このインストラクションを削除した場合は、変更を反映し、新しく発行したインストラクションのセットを、割当てられたスコープまたはチームに再送信する必要があります。",
    publishAfterDeleteGroupTask: "プロジェクトIDを入力してプロジェクトを検索してください。",
    resendPublishInformation: "このステップで変更を反映できます。新しく発行したインストラクションのセットをサマリーから再送信できます。",
    resendPublishInformationGroupTask: "このステップで変更を反映できます。新しく発行したタスクのセットをサマリーから再送信できます。",
    compareVersionsNoVersionSelectedTitle: "比較するバージョンが選択されていません！",
    compareVersionsNoVersionSelectedSubtitle: "最新バージョンと比較するバージョンをドロップダウンから選択してください",

    //Add Section
    addSection: "セクションの追加",
    addSectionInstructionalText: "セクションを追加し、カスタムインストラクションを生成してください。",
    addSectionPlaceholder: "セクション名",

    //Edit Section
    editSection: "セクション名の編集",
    editSectionInstructionalText: "このカスタムセクション名を変更してください。<br> 対応後、この変更を発行し選択したスコープまたはチームに更新バージョンを送付して下さい。",
    editSectionSave: "変更の保存",

    //Delete Section
    deleteCustomSection: "セクションの削除",
    areYouSureDeleteCustomSection: "このセクションを削除しますか？<br> このセクションの全てのインストラクションが削除されます。対応後、この変更を発行し選択したスコープまたはチームに更新バージョンを送付して下さい。",
    customSection: "セクション",

    //Publish Changes
    publishChanges: "変更を反映",
    publishChangesInstructional: "現在のインストラクション及びタスクのセットに対する変更を反映しますか? <br><br>前のインストラクション及びタスクのセットは上書きされます。変更を反映すると、更新されたインストラクション及びタスクのセットをサマリーから送信できます。",
    publishChangesNotAvailable: "まだ利用できません",

    //GA Tasks
    costomizeGroupTasks: "グループタスクのカスタマイズ",
    gaTasksIntro: "EY GAM上のグループタスクがデフォルトで含まれており、リンク済エンゲージメントに送信されます。EY GAMからのカスタマイズを行い、必要な場合追加タスクを織込み、各タスクのスコープまたはチームへの割当て要否を決定してください。対応後、タスクを発行し割当てスコープまたはチームへ送信してください。",
    addCustomTask: "カスタムタスクの追加",
    groupTask: "グループタスク",
    gaTasks: "タスク",
    attachments: "添付文書",
    notAvailable: "利用不可",
    gaDocument: "文書",
    gaDocuments: "文書",
    gaScope: "スコープ",
    gaScopes: "スコープ",
    gaScopesCapitalized: "スコープ",
    gaTeam: "チーム",
    gaTeams: "チーム",
    gaUnassignedScopeTeam: "未割当て",
    hideDetails: "詳細の非表示",
    gaAssignedScopes: "割当てられたスコープ",
    gaAssignedTeams: "割当てられたチーム",
    addTask: "新しいタスク",
    due: "期限",
    noAttachments: "添付ファイルが追加されていません。",

    // Chip component
    chipMore: "さらに表示",

    // GS Group Summary labels
    assignedTeam: "割当てられたチーム",
    lastPublished: "最終公開",
    versionStatus: "バージョンステータス",
    lastSent: "最終送信",
    lastSentTooltip: "インストラクションとタスクのバージョンが各チームに最後に送信された日付です。日付をクリックすると、チームに送信されたバージョンが表示されます。",
    lastSentBeforeTooltip: " <b><<スコープ名>><b>では、新しいバージョンのインストラクションとタスクが用意されています。このチームに最新バージョンを送信するかどうかを検討してください。",
    groupSummary: "グループサマリー",
    summarySubTitle: "下記の各スコープとチームに割当て済のインストラクション及びタスクの直近バージョンをレビューしてください。<b>バーションを送信</b>を選択し、割当て済スコープとチームにこのバージョンを送信します。<br/>関連する送信日を選択し特定チームへの送信済バージョンのレビューもできます。",
    compareVersions: "バージョンを比較",
    sendVersion: "バージョンを送信",
    compareVersionsInstructional: "差異を識別するために、発行済のインストラクション及びタスクの最新バージョンをチームに送信されたバージョンと比較します。バージョン間に差異がある場合は、新しいバージョンをチームに送信する必要があるかどうかを評価します。",
    publishedVersion: "発行済バージョン",
    sentVersion: "送信済バージョン",
    emptyPublishedVersion: "利用可能なスコープはありません。<br/>コンポーネントチームに割当てられたスコープのリストはこちらです。",
    emptySentVersion: "利用可能なチームがありません。",
    selectPublishedVersion: "発行済のバージョンを選択すると、ここにデータが表示されます。",
    selectSentVersion: "送信済のバージョンを選択すると、ここにデータが表示されます。",
    dueDate: "期限",
    emptyPublishedSnapshot: "選択されたスコープで利用できる発行済インストラクション及びタスクはありません。<br/>ここでデータを表示するには、バージョンを発行してください。",
    emptySentSnapshot: "インストラクション及びタスクは選択されたチームに送信されていません。<br/>ここでデータを表示するには、このストリームにインストラクションとタスクを発行し、送信してください。",
    update: "アップデート",
    updates: "アップデート",
    noTeamsPlaceholder: "チームPlaceholderなし",
    noTeamSelected: "1つ以上のスコープまたはチームを選択し続行します。",
    latestVersionAlreadySent: "チームが未だ作成されていません。1つ以上のチームを作成するとインストラクション及びタスクのバージョンを発行できます。",
    latestHasBeenSended: "インストラクション及びタスクの直近バージョンはこのチームに送付済みです。",
    noNewVersionToSend: "選択されたスコープ又はチームは既にインストラクション及びタスクの最新バージョンを受領済です。送付すべきアップデートはありません。",
    notSelectedTask: "選択されていません。",
    assignedTeams: "割当て先チーム",
    noTeamsCreatedYet: "チームが未だ作成されていません。1つ以上のチームを作成するとインストラクション及びタスクのバージョンを発行できます。",
    newersTeamsSended: "インストラクション及びタスクの直近バージョンは関連するスコープ／チームに送付済みです。",
    LinkRequestNotSent: "リンクリクエストの送信未了",
    lastVersionSentInstructionalText: "<b>{sentDate}</b>に<b>{teamName}</b>へ送信済みのタスク及びインストラクションのバージョンは以下のとおりです。このバージョンはこのチームに送信済みの直近バージョンです。",

    // ReceiveInstructions labels
    receiveInstructionsTitle: "{versionType} グループインストラクション及びタスクのバージョン",
    receiveInstructionsInstructional: "{primaryEng} はグループインストラクション及びタスクの {versionType} バージョンを {sentDate}に送信済みです.このバージョンをレビューし承諾又は差戻しのいずれかを選択して下さい。 <b>バージョンの比較</b>を使用すると、このバージョンと従前のバージョンとの比較ができます。",
    fromLabel: "From",
    assignedScope: "割当てスコープ",
    dateSent: "送付日",
    acceptVersion: "バージョンの承諾",
    returnVersion: "バージョンの差戻し",
    returnPrimaryButton: "返却",
    returnVersionDescription: "プライマリーチームにインストラクション及びタスクのこのバージョンを差戻してよろしいですか？ <br>このバージョンはエンゲージメントにはインポートされません。プライマリーチームへの理由を説明したコメントを残してください。",
    noContent: "現在利用可能なインストラクションはありません。後で再試行するかヘルプデスクに連絡してください。",
    editorPlaceHolder: "コメント",
    receiveCompareVersionInstructional: "{primaryEng} から受領した最新バージョンのインストラクションとタスクを以前に受領したバージョンとの差を確認するため比較する。",
    latestReceiveCompareVersionInstructional: "{primaryEng} から受領した最新バージョンのインストラクションとタスクを以前に受領したバージョンとの差を確認するため比較する。",
    latestVersion: "直近バージョン",
    earlierVersion: "従前のバージョン",
    earlierVersionEmpty: "比較可能な従前のバージョンはありません。",
    selectEarlierVersion: "従前のバージョンを選択しこちらにあるデータを確認してください。",
    pstName: "グループエンゲージメントインストラクションのレビュー",
    pstDescription: "グループ監査インストラクションをレビューして下さい。実施-全般のグループタスクを完了させてください。これらのタスクはグループ監査インストラクションの承諾時にタスクリストに追加されました。",
    selectedVersion: "選択したバージョン",
    issuingEngagement: "エンゲージメントの発行",
    accountsAndDisclosureLink: "勘定科目及び開示",
    openRiskAssessmentDocuments: "リスク評価文書を開く",
    openRiskAssessmentDocument: "リスク評価文書を開く",

    //Client engagement name labels
    successQueueMessage: "エンゲージメント表示名はEY Canvas Client Portal上で適切に更新されました。",
    clientEngagementInstructionalText: "こちらでカスタマイズされたエンゲージメント表示名の追加又は編集をしてください。この名称はEY Canvas Client Portal上のこのエンゲージメントにアクセスする外部チームメンバーが閲覧可能です。",
    clientEngagementPlaceholder: "エンゲージメント表示名",
    clientEngagementModalTitle: "EY Canvas Client Portal上のエンゲージメント表示名",
    clientDisplayName: "クライアント表示名",
    textExceedsLength: "文字数を100字超とすることはできません。",

    // Manage client access locations
    location: "ロケーション",
    locationName: "ロケーション名",
    accessLocations: "アクセスロケーション",
    inputType: "インプットタイプ",
    ipAddress: "IPアドレス",
    ipAddresses: "IPアドレス",
    startOfIpRange: "IPレンジの開始",
    endOfIpRange: "IPレンジの終了",
    cidrNotation: "CIDR表記",
    manageClientAccessLocationsLink: "ロケーションの追加",
    manageClientAccessLocationsModalTitle: "クライアントアクセスロケーションの管理",
    manageClientAccessLocationsInstructionalText: "IPアドレスを下記リストに追加すると、ロケーションベースでEY Canvas Client Portalへのアクセスが有効になります。<br>クライアントアクセスロケーションが有効の場合、ここにリストされたIPアドレスを有する外部のチームメンバーのみがこのエンゲージメントにアクセスできます。追加されたIPアドレスがない場合、外部のチームメンバーはどのロケーションからでもアクセスできます。 <br>詳細については <b>こちら<b>をクリックしてください。",
    manageClientAccessLocationsNoResultFound: "このエンゲージメントに追加されたIPアドレスはありません。内部及び外部チームメンバーはどのロケーションからでもエンゲージメントにアクセスできます。",
    deleteAccessLocations: "アクセスロケーションの削除",
    deleteAccessLocationsInstructionalText: "選択されたアクセスロケーションを削除してよろしいですか？<b>外部チームメンバーがこちらのロケーションからEY Canvas Client Portalにアクセスを試行する場合、このエンゲージメントにはもはやアクセスできなくなります。",
    locationLengthError: "ロケーションは100字を超えることはできません。",
    oneOrMoreIpAddressFormatError: "入力されたIPアドレスの１つ以上が無効です。",
    ipAddressFormatError: "入力されたIPアドレスは無効です。",
    ipSuffixError: "IPアドレスのCIDRサフィックスは、1～32の10進数である必要があります。 ",
    ipRangeStartSmallerThanEnd: "開始IPは終了IP未満である必要があります。",
    ipInputTypeInfo: "IPアドレスを選択し個別IPアドレス又はIPアドレスリストを入力します。IPv4アドレスのみサポートしています。<br>IPレンジを選択し同じネットワークプレフィックスを共有するIPアドレスレンジを入力します (i.e. アドレスの最初の3セグメント) 。<br>CIDRブロックを選択しCIDR表記付きIPアドレスレンジを入力します。CIDRアドレスのみサポートしています。",
    ipAddressInfo: "IPアドレスについては、各アドレスをカンマ区切りしたリスト又は各アドレスを別々の行で表示したリストのいずれによっても入力できます。 <br>有効なIPv4アドレスにはピリオドで区切られた0〜255の範囲の4つの整数が含まれます。",
    ipCidrInfo: "このエンゲージメントにアクセス可能とする必要があるIPアドレスレンジを表すCIDR表記を入力してください。 <br>有効なCIDR表記には、有効なIPv4アドレス、スラッシュ/文字、及び1～32の10進サフィックスが含まれます。",
    ipAddressEg: "e.g. 192.XXX.X.1 192.XXX.X.2",
    ipRangeStartEg: "e.g. 192.XXX.X.1",
    ipRangeEndEg: "e.g. 192.XXX.X.2",
    ipCidrEg: "e.g. 192.XXX.X.1/22",
    searchIpPlaceholder: "IPアドレスのチェック",
    ipNotAddedMessage: "許可されたリストに追加されていません。",
    ipIsAllowedMessage: "IPアドレスが許可されます。",
    importAccessLocationsLink: "アクセスロケーションのインポート",
    importAccessLocationsInstructionalText: "アクセスロケーションは従前のエンゲージメントからインポートできます。 <br>アクセスロケーションをインポートしてもよろしいですか？",
    importAccessLocationsCloseButton: "閉じる",
    importAccessLocationsCancelButton: "キャンセル",

    // Export Requests
    exportRequests: "リクエストの出力",

    // Add custom request labels
    addCustomRequestModal: {
        titleTip: "新しいリクエスト",
        titleTipAddButton: "新規作成",
        closeTitleTip: "閉じる",
        modalTitle: "新しいリクエスト",
        returnModalTitle: "リクエストの返却",
        modalHeader: "EY Canvas Client Portalに送信する新しいリクエストを追加",
        requiredAssignedTo: "(必須)",
        assignToError: "割当て先は必須です。",
        dueDate: "期日 (必須)",
        dueDateError: "期日は必須です。",
        titlePlaceholder: "タイトル（必須）",
        titleError: "タイトルは必須です",
        description: "説明",
        descriptionplaceholder: "説明の入力",
        descriptionError: "リクエストの説明が最大文字数 (4,000字)を超えています。",
        associateDocuments: "文書の関連付け",
        emptyAssociatedDocumentsList: "1つ以上の文書をドラッグ・アンド・ドロップするか、又は文書の追加をクリックしてください。",
        addDocumentButton: "文書の追加",
        signOffCheckbox: "EY Canvas Client Portalにアップロードされた文書はサインオフが必須です。",
        sendRequest: "リクエストの送信",
        returnRequest: "リクエストの返却",
        saveAsDraft: "ドラフトとして保存",
        cancel: "キャンセル",
        copyTitleAndDescription: "タスクからのタイトル及び説明のコピー",
        copyAssociatedDocuments: "タスクからの文書のコピー",
        priority: "リクエストの優先度",
        addNewRequestButton: "新しいリクエストを追加",
        addExistingRequestButton: "既存のリクエストを追加"
    },
    addCustomEventModal: {
        titleTip: "新しいイベント",
        closeTitleTip: "閉じる",
        modalTitle: "新しいイベント",
        eventDate: "イベントの日付",
        eventDateError: "日付が必須です",
        titlePlaceholder: "タイトル",
        titleError: "タイトルは必須です",
        description: "説明（任意）",
        descriptionplaceholder: "説明の入力",
        descriptionError: "イベントの説明が最大文字数 (4,000文字)を超えています",
        sendEvent: "イベントの送信",
        saveAsDraft: "イベントをドラフトとして保存",
        cancel: "キャンセル",
        eyParticipantsCollaborationError: "少なくとも1名のEY参加者が必要です",
        externalParticipantsCollaborationError: "少なくとも1名の外部参加者が必要です"
    },
    eyHelixInstructionText: "下記のリンクされたEY Helixプロジェクト及び推奨アナライザーを確認してください。 <br/> いずれかのプロジェクト又はアナライザーをクリックし特定のEY Helixのページに進んでください。",
    smartAutomationInstrText: "下記の現在使用中のSmart Automationソリューションを確認してください。 <br/> ソリューションをクリックしSmart Automation Hubに進んでください。",
    smartAutomationSolutionsNotAvailable: "現在エンゲージメントではスマート・オートメーション・ソリューションは利用できません。",
    noSmartAutomationAvailable: "エンゲージメントで利用可能なスマートオートメーションソリューションはありません。",
    availableSolutions: "利用可能なソリューション",
    useOfSuggestedSolutions: "提案されたソリューションの使用",
    useOfOtherSolutions: "他のソリューションの使用",
    suggestedSolutions: "提案されたソリューション",
    otherSolutions: "他のソリューション",
    currentlyusing: "現在使用中",
    suggested: "推奨",
    primaryProject: "プライマリープロジェクト",
    noLinkedProjects: "エンゲージメントにリンクされたプロジェクトはありません。",
    noSuggestedAnalyzers: "エンゲージメントに推奨されるアナライザーはありません。",
    eyHelixNotAvailable: "EY Helix利用不可",
    helixNotAvailableMessage: "現在このエンゲージメントではEY Helixを利用できません。",

    noGroupTaskCreatedYet: "作成されたグループタスクはありません。",
    noInstructionsCreatedYet: "インストラクションはまだ作成されていません",
    documentsReceived: "受領済文書",
    documentsPending: "受領前の文書",

    teamLabel: "チーム",
    scopeLabel: "スコープ",

    documentSignOffby: "文書サインオフ者",
    documentAddedBy: "文書追加者",
    documentModifiedBy: "文書編集者",
    documentDeletedBy: "文書削除者",
    commentAddedBy: "ノートを追加した者",
    commentClearedBy: "ノートをクリアした者",
    commentClosedBy: "ノートをクローズした者",
    commentReopenedBy: "ノートを再オープン化した者",

    documentAssignedTo: "文書割当て先",
    draftDocReceivedFrom: "ドラフト文書送信者",
    finalDocReceivedFrom: "最終文書送信者",
    documentReturnedBy: "文書返却者",
    returnedDocumentClearedBy: "返却済文書クリア者",
    documentConflictResolvedBy: "競合文書解消者",
    draftDocumentSentBy: "ドラフト文書送信者",
    documentReturnedFrom: "文書返却者",
    finalDocumentSentBy: "最終文書送信者",
    noActivityAvailable: "利用可能なアクティビティはありません。",
    allEngagementFilterLabel: "その他のすべてのエンゲージメント",
    otherEngagementComments: "他のエンゲージメントノート",
    engagements: "エンゲージメント",
    engagement: "エンゲージメント",
    view: "表示",
    notesModalInstructionalText: "下記の選択された{0}に関するノートを確認し回答してください。",

    //New collaboration Related Labels
    searchRelateFileNoMatchesFound: "一致するものが見つかりませんでした。再試行してください。",

    //New collaboration Related tasks
    relatedTasksLabel: "関連タスク",
    selectRelatedTasks: "タスクの選択",
    searchAndPressEnter: "検索及びEnterを押す",
    noRelatedTasksSelected: "選択された関連タスクなし",
    relatedTasksCount: "関連タスク",
    notFoundTasks: "タスクが見つかりません",
    dueDateDetailLabel: "期日",
    requestType2MessageTitle: "このリクエストは新規タブで開きます。",
    requestType2MessageSubtitle: "ページを更新すると更新箇所を表示できます。",
    requestType2InTrnasitMessageTitle: "このリクエストは転送中のため開くことができません。",
    requestType2InTrnasitMessageSubtitle: "同期が完了するのを待ってページを更新し、再試行してください。",

    //New collaboration Time Phase
    selectTimePhase: "タイムフェーズの選択",
    timePhaseNotFound: "タイムフェーズが見つかりません。",

    understandITProcess: "ITプロセスの理解",

    //New collaboration Access Location
    accessLocationLabel: "アクセスロケーションは有効です",
    accessLocationTitle: "許可されたネットワークロケーションから接続しているユーザのみがEY Canvas Client Portalにアクセスできます。許可されたロケーションは、オプションメニューのアクセスロケーションから管理できます。",

    // Reporting Labels
    summaryScreenLabel: "サマリー画面",
    dataExportLabel: "データエクスポート",
    projectManagementLabel: "プロジェクトマネジメント",
    reportingHeaderName: "レポーティング",
    repAllTasks: "全てのタスク",
    repDeletedTasks: "削除されたタスク",
    repMultiEntityTasks: "マルチエンティティタスク",
    repAllAuditPlan: "監査計画",
    repITAppSOSummary: "IT App/SOサマリー",
    repITProcessScotControls: "ITプロセス、SCOT及び統制",
    repTaskAssignments: "タスクの割当て",
    repTaskDetails: "タスク詳細",
    repTaskAnalysis: "タスク分析",
    repTaskSummary: "タスクサマリー（パイロット）",
    repExportToExcel: "データを出力",
    repExportDate: "日付を出力",
    repEngInfo: "エンゲージメント情報",
    repNoRecordMessage: "表示する記録なし",
    dateInUTC: "UTC",
    repSCOTsControls: "SCOTs及び統制",
    repITProcessSummary: "ITプロセスサマリー",
    repCanvasForms: "Canvasフォーム",
    repControlForms: "統制フォーム",
    projectInsight: "プロジェクトインサイト",
    archiveForm: "アーカイブフォーム",
    archive: "アーカイブ",
    repCanvasFormResponse: "Canvasフォームの回答",
    repCanvasFormRelatedComments: "関連するコメント",
    repControlFormResponse: "統制フォームの回答",
    repNoRecordFound: "レコードがありません",
    repCanvasFormsIncomplete: "不完全な回答",
    repCanvasFormRelatedObjects: "関連するオブジェクト",
    voiceNoteLabel: "ボイスノート",
    repComponentTeamGroup: "構成単位チーム",
    componentTeamCanvasFormExport: "Canvasフォームのエクスポート",

    // Reporting Tasks
    repTaskTitle: "タスクタイトル",
    repTaskDescription: "タスクの説明",
    repTaskSource: "タスクソース",
    repTaskNature: "タスクの性質",
    repTaskCloseEarly: "前倒し",
    repTaskCloseLate: "遅延",

    // Reporting Documents
    repAllDocuments: "全ての文書",
    repSignOffs: "サインオフ",
    repDocumentsModified: "報告書日後に編集された文書",

    //Reporting Collaboration
    repRequestsAndTasks: "リクエスト及びタスク",
    repRequestsTasksComments: "リクエスト/タスクコメント",

    SCOTSummaryReportHeader: "SCOTサマリー",
    GroupReportHeader: "グループレポート",
    SCOTSummaryEffective: "有効",
    GroupInstructionSummary: "グループインストラクションサマリー",
    GroupActivity: "構成単位の勘定科目マッピング履歴",
    SEMReportHeader: "SEM",
    GroupComponentAccountReportHeader: "グループコンポーネント勘定科目マッピング",
    AccountDisclosuresReportHeader: "勘定科目及び開示",

    //Reporting Collaboation Details
    collaborationDetails: "コラボレーションの詳細",
    collaborationSummary: "サマリー",
    collaborationActivity: "アクティビティの詳細",
    ReviewNotesReportHeader: "レビューノート",

    GroupStructureSummary: "グループストラクチャーサマリー",

    //Reporting CRT Summary
    wcgwSummary: "WCGWサマリー",
    crtlabel: "コントロールレビューツール（CRT）",
    assertionSummary: "アサーションサマリー",
    scotSummary: "SCOTサマリー",
    noRecordsToExport: "出力する記録がありません",
    statisticsSummary: "統計",
    qualityChecks: "品質チェック",
    controlSummary: "統制サマリー",
    filterBySCOT: "SCOTによるフィルター",

    //Reporting manage team
    independenceSummaryReportTabName: "独立性サマリー",

    //MEST dashboard
    viewAllRiskTypesAndAssertions: "全てのリスクタイプ及びアサーションを表示する",
    riskRelatedToAssertion: "アサーションに関連付けられたリスク",
    higherRiskRelatedToAssertion: "アサーションに関連付けられた高リスク項目",
    noRisksAvailable: "利用できるリスクがない",
    relatedEstimates: "関連付けられた見積り",
    viewAllAssertions: "すべてのアサーションを表示",
    wcgwRelatedToAssertion: "アサーションに関連するWCGW",
    noWcgwsAvailable: "利用可能なWCGWがありません",
    goTo: "Go to",
    allItems: "全ての項目",

    // Create TimePhase Labels
    createTimePhaseLabels: {
        modalTitle: "タイムフェーズの追加",
        modalDescription: "属性を追加し「保存して閉じる」又は「保存して追加」をクリックしてください。",
        timephaseNameLabel: "タイムフェーズ名",
        milestoneSelectLabel: "マイルストーン",
        timephaseLabel: "タイムフェーズ",
        startDateLabel: "開始日",
        endDateLabel: "終了日",
        startDateErrorMessage: "開始日は必須です",
        endDateErrorMessage: "終了日は必須です",
        timephaseNameErrorMessage: "名称は必須です。",
        milestoneErrorMessage: "マイルストーンは必須です",
        isKeyEvent: "キーイベント",
        timephaseDescription: "説明 (任意)",
        addSuccessMessage: "タイムフェーズが追加されました。"
    },

    AccountListHeaderLabels: {
        pspAndosp: "PSPs/OSPs",
        limitRiskAssertionLabel: "リスクが限定的な勘定科目",
        heading: "勘定科目及び表示と関連付け",
        accountsOrDisclosure: "勘定科目及び開示",
        psps: "PSPs",
        rejected: "差戻済",
        remove: "削除",
        risks: "リスク",
        assertions: "アサーション",
        noRecordsFound: "利用可能な勘定科目又は開示がありません",
        noResultsFound: "結果が見つかりません",
        responsiveHeading: "対応",
        rejectedPspsHeading: "差し戻されたPSP",
        importPsps: "PSPのインポート",
        importOsps: "OSPのインポート",
        addOsps: "OSPの追加",
        pspEnded: "して開始",
        noPspsandOsps: "{0}は利用できません",
        allAreRejected: "すべてのPSPが差し戻されました",
        rejectButton: "差戻",
        acceptButton: "承諾",
        additionalInfo: "根拠：",
        noAssertionsAvailableLabel: "利用可能なアサーションがありません",
        noAssertionAvailableTooltip: "利用可能なアサーションがありません。<strong>勘定科目及び開示の管理</strong>をクリックしてアサーションを追加してください。",
        importFromKnowledge: "ナレッジからのインポート",
        disabledAddOspTooltip: "実証タスクを追加するには少なくとも1つのアサーションが利用可能である必要があります。<strong>勘定科目及び開示の管理</strong>をクリックして、アサーションを追加してください。",
        noPsps: "利用可能なPSPがありません。{0}から始めてください。",
        noOspsPsps: "利用可能なPSP/OSPがありません。{0} 、{1}もしくは {2}から始めてください。",
        acceptErrorMsg: "差し戻されたタスクを承諾することができません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
        build7NoPspOrOspAttachedToAssertion: "各アサーションには少なくとも1つの対応する実証手続が必要です。以下のアサーションは対応するPSPs/OSPsがありません: <b>{orphanAssertions}</b>。 {0}, {1}, もしくは {2} を追加して、この勘定科目に対するすべてのアサーションに対応するか、この勘定科目に対応する既存のPSPs/OSPsの編集アイコンをクリックして、他のアサーションに関連付けてください。",
        build7NoPspOrOsp: "各アサーションは少なくとも1つの対応する実証手続が必要です。いずれのアサーションにも対応するPSPs/OSPsがありません。この勘定科目のすべてのアサーションに対応するため、{0}, {1}, もしくは {2} を作成してください。",
        build7NoOspsAndAllPspAreRejected: "各アサーションは少なくとも1つの対応する実証手続が必要です。すべてのPSPsが差し戻しされており、いずれのアサーションにも対応するPSPs/OSPsがありません。この勘定科目のすべてのアサーションに対応するため、{0} もしくは {1} を作成してください。",
        build6And7NoAssertions: "各重要な勘定科目又は開示に実証手続を追加するためには、少なくとも1つの関連するアサーションが必要です。{0}をクリックしてアサーションを追加してください。",
        build7LimitedAccountNoPspOsp: "それぞれのリスクが限定的な勘定科目には少なくとも1つの対応する実証手続が必要です。{0} するか {1} を作成しこの勘定科目のリスクに対応してください。",
        manageAccountAndDisclosures: "勘定科目及び開示の管理"
    },

    AddTaskLabels: {
        accountLabel: "勘定科目：",
        taskSectionLabel: "タスクセクション",
        ospModelTitle: "新しいOSP",
        ostModelTitle: "新しいOST",
        saveAndClose: "保存",
        saveAndCreate: "保存して別のものを作成",
        cancel: "キャンセル",
        prefix: "プレフィックス",
        title: "タイトル",
        suffix: "サフィックス",
        timePhase: "タイムフェーズ",
        description: "カスタマイズされた説明",
        descriptionPlaceholder: "カスタマイズされたタスクの詳細（必須）",
        assertions: "アサーション",
        optional: "(任意)",
        required: "必須",
        noResultFound: "結果が見つかりません",
        of: "／",
        characters: "文字",
        descriptionMaxLengthError: "説明の文字数が最大許容数を超えました。",
        noteDiscriptionErrorMessage: "回答が{0}文字であり上限の{1}文字を超過しています。文字数を減らすか形式の変更を行い説明を見直しの上、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
        customizeDescription: "カスタマイズされたタスクの詳細（必須）",
        errorMsg: "OSPの追加に失敗しました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
        customizeTaskDescription: "カスタマイズされたタスクの説明"
    },

    RemoveTaskLabels: {
        modelOspTitle: "OSPを削除",
        modelOstTitle: "OSTを削除",
        deleteBtn: "削除",
        cancel: "キャンセル",
        confimationOspMsg: "選択したOSPを削除してよろしいですか？",
        confimationOstMsg: "選択したOSTを削除してよろしいですか？",
        warning1Msg: "このエンゲージメントにおけるどのタスクにも関連付けられていない関連するエビデンスは一時ファイルに移動されます。",
        warning2Msg: "どのエビデンスにも関連付けられていない発見事項及び対応タスクは削除されます。"
    },

    TaskReportHeaderLabels: {
        Tasktype: "タスクタイプ",
        Taskstatus: "タスクステータス",
        Taskassignedto: "タスクの割当て先",
        Tasktitleprefix: "タスクタイトルのプレフィックス",
        Tasktitle: "タスクタイトル",
        Tasktitlesuffix: "タスクタイトルのサフィックス",
        Taskdescription: "タスクの説明",
        Knowledgetasktitle: "ナレッジタスクタイトル",
        Knowledgetaskdescription: "ナレッジタスクの説明",
        Oldtaskname: "古い文書名",
        Oldtaskdetail: "古い文書の詳細",
        Rejected: "差戻済",
        Rationalforrejection: "差戻し理由",
        Auditphase: "監査フェーズ",
        Timephasetype: "マイルストーン",
        Timephase: "タイムフェーズ",
        Timephasestartdate: "タイムフェーズ開始日",
        Timephaseduedate: "タイムフェーズ完了日",
        Keyevent: "キーイベント",
        Tasksource: "タスクソース",
        Tasknature: "タスク性質",
        Lasttaskstatuschangedate: "タスクステータス最終更新日",
        Taggroup: "タググループ",
        Tags: "タグ",
        RelatedMESTentities: "関連するMESTエンティティ",
        Schedulednextwaveservices: "予定済みのNextWaveサービス",
        Priority: "優先度",
        Taskid: "タスクID",
        Roleid: "ロールID",
        Tasktypeid: "タスクタイプID",
        Taskstatusid: "タスクステータスID",
        Auditphaseid: "監査フェーズID",
        Timephasetypeid: "マイルストーンID",
        Tasksourceid: "タスクソースID",
        Tasknatureid: "タスクの性質ID"
    },

    glAccountDocumentLabels: {
        modelTitle: "GL勘定科目",
        modelName: "エビデンスの関連付け",
        documentName: "文書名",
        documentCounter: "{0} 文書",
        documentsCounter: "{0} 文書",
        btnCancel: "キャンセル",
        btnSave: "保存",
        errorMessage: "文書を選択して続ける",
        noResultsFound: "結果が見つかりません",
        newTickMark: "新しいチェックマーク",
        bulkModePlaceholder: "エビデンスを選択して関連付けを行い、<strong>\'保存\'</strong> を選択して終了する。"
    },

    // Edit TimePhase Labels
    editTimePhaseLabels: {
        modalTitle: "タイムフェーズの編集",
        modalDescription: "属性を編集し <b>保存</b>をクリックしてください。",
        editSuccessMessage: "タイムフェーズが更新されました。"
    },

    // Delete TimePhase Labels
    deleteTimePhaseLabels: {
        deleteTimePhaseModalTitle: "タイムフェーズの削除",
        deleteDescription: "このタイムフェーズを削除してよろしいですか？",
        showTimePhaseName: "タイムフェーズ",
        showMileStone: "マイルストーン",
        showStartDate: "開始日",
        showEndDate: "終了日",
        showDescription: "説明:",
        showAssignedTasks: "割当てられたタスク数",
        showAssignedAssignments: "割当て数",
        deleteSuccessMessage: "タイムフェーズが削除されました。"
    },

    // Create Tag Labels
    createTagGrouplabels: {
        modalTitle: "タググループの追加",
        modalDescription: "名称を入力し「保存して閉じる」又は「保存して続行」（続行する場合）をクリックしてください。",
        tagGroupNameLabel: "タググループ",
        tagGroupNameErrorMessage: "タググループは必須です",
        saveAndClose: "保存して閉じる",
        saveAndAdd: "保存して追加",
        addSuccessMessage: "タググループが追加されました。"
    },

    // Bulk Tags
    tags: {
        noTagsAvailabel: "利用可能なタグなし",
        deleteTag: "タグの削除",
        deleteDescription: "タグの削除は取消しできません。続行してよろしいでしょうか？",
        showDeleteTagName: "タグ",
        showDeleteTagGroupName: "タググループ",
        showAssignedTasks: "割当て済タスク",
        deleteSuccessMessage: "タグが削除されました。",
        task: "タスク",
        tasks: "タスク",
        addTagGrouplabels: "タググループの追加",
        addTag: "タグの追加",
        action: "アクション",
        addTagDesc: "<h3>タグの追加</h3><p>‘タググループの追加’をクリックしタグの追加に利用可能な新規タググループを作成してください。</p>",
        assignTagDesc: "<h3>タグの割当て</h3><p>選択項目をタググループ下のタグにドラッグアンドドロップしてください。</p>",
        editTagDesc: "<h3>タグの編集</h3><p>３点リーダーを選択の上、'編集'を選択しタグプロパティを編集してください。</p>",
        deleteTagDesc: "<h3>タグの削除</h3><p>３点リーダーを選択の上、'削除'を選択しタグを削除してください。</p>",
        removeTagDesc: "<h3>タグのリムーブ</h3><p>既存タグ付きの１つ以上の項目をタググループ下の関連タグ名称にドラッグアンドドロップしタグをリムーブしてください。</p>",
        expand: "展開",
        collapse: "折りたたむ",
        TagName: "タグ名称",
        TagGroupName: "タググループ名称",
        addTagSuccessMessage: "タグが追加されました。",
        editTagSuccessMessage: "タグが更新されました。",
        addTagModalTitle: "タグの追加先",
        editTagModalTitle: "タグの編集",
        addTagModalDescription: "新規タグを作成し「保存して閉じる」又は「保存して続行」（続行する場合）をクリックしてください。",
        editTagModalDescription: "属性を編集し <b>保存</b>をクリックしてください。",
        tagSetSuccessMessage: "タグが設定されました。",
        tagsSetSuccessMessage: "タグが設定されました。",
        tagRemoveSuccessMessage: "タグがリムーブされました。",
        tagsRemoveSuccessMessage: "タグがリムーブされました。",
        tagRemovedSuccessfully: "タグがリムーブされました。"
    },

    relateEvidenceHeader: "修正に関する情報を提供するエビデンスを関連付けてください。",
    relatedDocumentCounter: "{0} 文書",
    relatedDocumentsCounter: "{0} 文書",
    documentsLocationLabel: "文書のロケーション",
    relateTemporaryFilesHeader: "このエンゲージメントから一時文書を関連付ける。",

    // Create Assignment Labels
    addAssignmentlabels: {
        modalTitle: "割当ての追加",
        modalDescription: "名称を入力し、対応後保存をクリックしてください。",
        assignmentNameLabel: "割当て名称",
        assignmentNameErrorMessage: "割当て名称は空欄にできません。",
        saveAndClose: "保存して閉じる",
        saveAndAdd: "保存して追加",
        addSuccessMessage: "割当てが追加されました。"
    },
    addUserOrRoleLabelto: "ユーザー又はロールの追加先",
    addUserOrRoleheader: "追加したいチームメンバー又は役割を検索してください。",
    saveAndAdd: "保存して追加",

    // Bulk Assignment
    BulkActionsLabel: "一括操作",
    BulkAssignmentAction: "アクション",
    BulkShow: "表示",
    BulkActionsInstructionalText: "タスクグループに対して、ドラッグ&ドロップで一括操作を行うことができます。タスクグループ内の個々のタスクを表示するには、タスクグループにマウスを合わせて矢印アイコンをクリックしてください。",
    bulkOperationsModalDescription: "タスクに対し一括処理を実行します。タスクグルーピングに関する個別タスクを閲覧するには、タスクグループにマウスを合わせ、矢印のアイコンをクリックしてください。",
    selectRequest: "リクエストを選択して送付",
    replaceLabel: "入れ替え",
    labelStaff: "スタッフ-",
    addModeLabel: "追加",
    replaceModeLabel: "置換え",
    dueDateModeLabel: "期日までの日数の更新",
    searchByAssignmentName: "検索",
    addTeamMemberLabel: "チームメンバーの追加",
    noTeamMembersFound: "利用可能なチームメンバーがありません。",
    addMemberSuccessMessage: "チームメンバーの追加に成功しました",
    addAssignmentLabel: "割当ての追加",
    addAssignmentNameLabel: "割当て名称の追加",
    noAvailableAssignmentsMessage: "利用可能な割当てなし",
    showDuplicateError: "選択したチームメンバー又は役割は、選択したタスクに重複した割当てを行うことができません。続行するには異なる割当て、チームメンバー又は役割を選択してください。",
    infoBulkAssignments: "一括割当て",
    infoBulkAssignmentDesc: "1つ以上のタスクグループを選択すると、新規割当ての作成又は既存割当ての置換えができます。割当ての作成又は編集を行う場合、チームメンバーに割当てた現時点が最短期日の割当てを有するチームメンバーとして再計算されます。",
    infoAssignmentsDueDate: "割当て期日の設定",
    infoAssignmentsDueDateDesc: "「日付の選択/日数の計算」トグルを使用して期日の割当てを設定してください。トグルの使用により、タスクの特定の期日、又はタイムフェーズ期日までの日数のいずれかを設定できます。",
    infoAddAssignmentExisting: "既存のチームメンバーに割当てを追加してください。",
    infoAddAssignmentExistingDesc: "割当てを設定するには期日までの日数を設定する必要があります。または、カレンダーコントロールを利用して期日を指定することもできます。一度、設定すると設定されたアイテムをドラッグアンドドロップして新しい割当てを設定することもできます。",
    infoAddAssignmentNew: "割当てを新規チームメンバーに追加",
    infoAddAssignmentNewDesc: "付与した割当てに対してチームメンバー又は役割が表示されない場合、チームメンバーの追加をクリックすると利用可能なチームメンバー又は役割のリストが表示されます。選択すると、そのチームメンバーはリスト末尾に追加され、ドラッグアンドドロップの割当てを使用できるようになります。",
    infoRemove: "割当てのリムーブ",
    infoRemoveDesc: "１つ以上の項目をアサイン名称下のチームメンバーにドラッグアンドドロップし割当てをリムーブしてください。そのチームメンバーへの未了の割当ては削除されます。完了済割当てはリムーブされません。",
    infoReplace: "割当ての置換え",
    infoReplaceDesc: "割当てを置き換える場合、1つ以上のアイテムを割当て名称の下にあるチームメンバーにドラッグします。同じ割当て名称を持つ既存割当てがある場合、選択されたチームメンバーに再割当てが行われます。複数のチームメンバーがそのアサイン名称に関する割当てを有する場合、選択されたユーザーに取込まれます。割当ての置換えの使用の際に期日前の設定は任意です。その設定を行わない場合、既存の設定が使用されます。",
    infoUpdateDueDate: "期日の更新",
    infoUpdateDueDateDesc: "「日付の選択」又は「日付の計算」を使用して「期日」を設定し、期日変更したいチームメンバーにドラッグアンドドロップしてください。そのチームメンバーへのオープン又は進行中の割当てには更新された期日が付されます。完了済の割当ては変更されません。",
    infoDelete: "割当ての削除",
    infoDeleteDesc: "右側の割当てをクリックし、その割当て一式を削除するか否かを選択してください。",
    infoExecutive: "エグゼクティブの割当て",
    infoExecutiveDesc: "フィルタリングや検索機能の使用により、エグゼクティブに適用可能なタスクのフィルタリングができることで、速やかな割当てができるようになります。",
    infoSpecificTask: "特定のタスクへの割当て",
    infoSpecificTaskDesc: "割当てをタスクレベルで行う必要がある場合、左側のグループにカーソルを合わせ個別タスクを表示するオプションを選択します。これにより、このグループに関する個別タスクの表示及びきめ細やかな割当てができるようになります。",
    unassignedLabel: "割当て未了",
    replaceSignleSuccessMessage: "タスクが更新されました。",
    replaceMultipleSuccessMessage: "タスクが更新されました。",
    dueDateSingleSuccessMessage: "割当てが更新されました。",
    dueDateMultipleSuccessMessage: "割当てが更新されました。",
    invalidAssignmentUpdate: "同じ人物にタスクを割当て期日を更新してください。",
    removeSuccessMessage: "割当てが更新されました。",
    colorCode: "カラーコード",
    removeSuccessSingleMessage: "割当てが更新されました。",
    removeSuccessMultipleMessage: "割当てが更新されました。",
    assignmentRemovedSuccessfully: "割当てがリムーブされました。",

    // Bulk Task
    itemsSelected: "選択されたタスク",
    itemSelected: "選択されたタスク",
    dragAndDrop: "ドラッグアンドドロップ",
    currentApplication: "現時点の適用",
    allAssignmentsClosed: "全ての割当てはクローズ済みです。",
    allAssignmentsCompleted: "すべての割当てが完了しました",

    onOrBeforeCurrentDate: "現時点以前",
    withInCurrentWeek: "今週",
    quickFilter: "クイックフィルタ",
    suggestedFilters: "推奨されたフィルタ",
    showXMore: "{0}の詳細表示",

    // Task due date Events
    addEventlabels: {
        modalTitle: "イベントの追加",
        startDateLabel: "開始日",
        modalDescription: "属性を追加し「保存して閉じる」又は「保存して追加」をクリックしてください。",
        eventNameLabel: "イベント名",
        eventType: "イベントタイプ",
        singleDay: "1日",
        dateRange: "日付の範囲",
        eventDate: "イベントの日付",
        eventDescription: "説明 (任意)",
        isEvent: "クライアントとのイベントの共有",
        EventNameErrorMessage: "イベント名は必須です",
        eventDateErrorMessage: "イベント日は必須です。",
        addSuccessMessage: "イベントが追加されました。"
    },

    // Bulk Notes
    DeleteSomeNotesAreClosed: "<b>選択したノートの一部のみクローズ済であり、削除できます。</b> <br /> 続行する場合、下記ノートが削除されます。",
    DeleteSomeNotesAreNotClosed: "下記ノートはクローズ済でないため削除できません。",
    DeleteDontHaveClosedNotes: "下記ノートはクローズ済でないため削除できません。",
    someNotesAreOpen: "<b>選択したノートの一部のみオープンステータスとなっています。</b> <br/> 続行する場合、下記ノートは更新されます。",
    someNotesAreNotOpen: "下記ノートはクリア済またはクローズ済のため更新されません。",
    dontHaveOpenNotes: "下記ノートはクリア済またはクローズ済のため更新できません。",
    ShowNumberMore: "{0}の詳細表示",

    // Drag and Drop
    assignmentLabel: "割当て",
    assignmentsLabel: "割当て",
    singleAssignmentCreatedMessage: "割当てが作成されました。",
    multipleAssignmentCreatedMessage: "割当てが作成されました。",
    daysPriorWarning: "割当て作成前に期限の設定",



    // Related Tasks - Engagement selector
    selectEngagement: "エンゲージメントの選択",
    thisEngagement: "このエンゲージメント",
    noResultsFoundLabel: "結果が見つかりませんでした。",
    taskLocationLabel: "タスクロケーション",

    // Delete Assginment
    deleteDescription: "割当ての削除が実行できません。続行しますか？",
    deleteAssignmentModalTitle: "割当ての削除",
    deleteSingleSuccessMessage: "割当てが削除されました。",
    deleteMultipleSuccessMessage: "割当てが削除されました。",
    teamMemberLabel: "チームメンバー",
    assignedTasksCountLable: "割当てられたタスク",
    deleteAssignmentLabel: "割当て",
    selectengagement: "エンゲージメントの選択",

    //Due Days
    dueDateTitle: "期日の入力",
    dueDatedescription: "タイムフェーズ期日の何日前までに割り当てを完了する必要があるかを入力してください。",
    dueDateAssign: "割当て",
    dueDateSelect: "選択",
    dueDateCalculate: "計算",

    // Tasklist - bulk markcomplete
    markComplete: "完了のマーク",
    markCompleteMessgae1: "<b>選択されたタスクを完了</b>してよろしいですか? <br />選択されたタスクについて未完了の割当てがある場合、それらはクローズされます。",
    markCompleteMessgae2: "選択したタスクのうち、一部のみ完了とマークされます。<br /> 続行する場合、 <b>下記にリストされたタスクは完了とマークされます</b>。 未完了の割当てがある場合、それらはクローズされます。",
    markCompleteMessgae3: "関連エビデンスがない又は関連エビデンスにサインオフがないため、<b>下記にリストされたタスクには完了マークは付されません</b>。 ",
    markCompleteMessgae4: "関連エビデンスがない又は関連エビデンスにサインオフがないため、<b>下記にリストされたタスクには完了マークは付されません</b>。 ",

    // Tasklist - bulk handoff
    handOffLabel: "ハンドオフ",
    confirmHandOff: "ハンドオフの確認",
    handOffMessgae1: "<b>選択されたタスクのハンドオフ</b>を次の割当てメンバーに対して実施してもよろしいですか? <br />選択されたタスクについて未完了の割当てがある場合、それらはクローズされます。",
    handOffMessgae2: "選択したタスクの一部に別のチームメンバーが割り当てられているものがあります。<br /> 続行する場合、 <b>下記にリストされたタスクはハンドオフされます</b>。 選択されたタスクについて未完了の割当てがある場合、それらはクローズされます。",
    handOffMessgae3: "未完了の割当てがないため、<b>下記にリストされたタスクはハンドオフされません</b>。 ",
    handOffMessgae4: "未完了の割当てがないため、<b>下記にリストされたタスクはハンドオフできません</b>。 ",
    closeMyAssignments: "私の割当てのクローズ",

    saveQuickFilter: "クイックフィルターの保存",
    saveQuickFilterModalHeader: "クイックフィルターとして適用したフィルタークリップを保存する。",
    saveQuickFilterModalText: "保存されたもしくは推奨されたフィルターを選択することにより、このエンゲージメントに再度アクセスする際に時間を節約できます。エンゲージメントごとに5つまで保存されたクイックフィルターを新規作成ができます。",
    quickfiltername: "クイックフィルタの名称",
    taskCategory: "タスクカテゴリー",

    cannotsavefilter: "カスタムクイックフィルタの保存はできません。",
    cannotsavefiltermodalheadertext: "<b>エンゲージメントにつき保存クイックフィルタは5つまで作成できます。</b> <br /> 続行する場合、既存のクイックフィルタの1つを削除し再試行してください。",
    savedFilters: "保存されたフィルタ",
    taskassignedto: "タスクの割当て先",
    noteassignedto: "ノートの割当て先",
    taskPrefix: "タスクのプレフィックス",
    taskSuffix: "タスクのサフィックス",

    // Mark complete/HandOff Evidences category
    noSignOffs: "サインオフなし",
    noSignOffsByMe: "自身のサインオフなし",
    myPreparerSignOffs: "作成者としてのサインオフ",
    myReviewerSignOffs: "レビュアーとしてのサインオフ",
    myPreparerAndReviewerSignOffs: "作成者及びレビューアーとしてのサインオフ",

    notificationDownErrorMessage: "通知機能は一時的に利用できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    notificationUpbutSomeLoadingErrorMessage: "通知センターは一時的に利用できません。ページを更新し再試行してください。 - まもなく利用可能になります。",

    timeTrackerErrorFallBackMessage: "タイムトラッキング機能は一時的に利用できません。ページを更新し再試行してください。このメッセージが続く場合は、ヘルプデスクに連絡してください。",
    timeTrackerLoadingFallbackMessage: "タイムトラッキング機能は一時的に利用できません。まもなく利用可能になります。",

    signOffOnAllAs: "全てサインオフ",
    accountType: "勘定科目タイプ",

    openDocumentInstructionalText: "この文書は自動的にオープンされます。<b>オープンするためにクリックする必要はありません</b> <br>文書のオープン後、このタブはクローズできます。",
    closeTab: "タブのクローズ",

    // Build Step - Add Due Date
    milestones: "マイルストーン",
    events: "イベント",
    noTimePhasesHaveBeenIdentified: "識別されたタイムフェーズなし",

    wcgws: "WCGWs",
    relatedControls: "関連する統制,",
    relatedControlsWCGWsRatio: "関連付けられた統制/WCGW",
    wcgwsToControlsRatio: "統制に対するWCGWsの割合",
    controlsToWCGWsRatio: "WCGWsに対する統制の割合",
    testedControls: "テストされた統制",

    // Collaboration request to Task relation
    CollaborationModalTitle: "タスクにリクエストを関連付ける",
    CollaborationModalDescription: "タスクにリクエストを関連付ける場合には、1つ以上のリクエストを以下のタスクにドラッグアンドドロップしてください。",
    noDataFound: "データがありません",
    taskName: "タスク",
    showMessage: "カテゴリーとタスクグループを選択して開始する",
    showCategory: "カテゴリー",
    showTaskGroup: "タスクグループ",
    optionITProcesses: "ITプロセス",
    optionExecutionGeneral: "全般手続",
    relatedRequestsLabel: "関連付けられたリクエスト",
    relatedRequestsFormatted: "{0}関連付けられたリクエスト",
    relatedRequestFormatted: "{0}関連付けられたリクエスト",
    relatedRequests: "関連付けられたリクエスト",
    relatedTasks: "関連付けられたタスク",
    relatedSuccessSingleMessage: "{0}リクエストのタスクへの関連付けに成功しました。",
    relatedSuccessMultipleMessage: "{0}リクエストのタスクへの関連付けに成功しました。",
    showUnrelated: "関連付けられていない{0}を表示する",
    unrelate: "未関連",
    noRequestsMessage: "利用可能なリクエストがありません",
    requestNumber: "リクエスト番号",
    sortAscending: "昇順で並べ替え",
    sortDescending: "降順で並べ替え",
    removeSorting: 'Remove sorting',

    // PIC Dashboard
    groupBy: "グループ化",
    allTasks: "全てのタスク",
    iTSOs: "IT/サービス受託会社",
    generalExecution: "実施全般",
    PICSignOff: "PICサインオフ",
    EQRSignOff: "EQR サインオフ",
    completed: "完了",
    allAssigned: "すべての割当て",
    picTaskAssignmentLabel: "あなたの割当て",
    assignReadyForReview: "現在",
    assignUpcomingForReview: "今後の予定",
    assignReadyForReviewTasks: "現在の割当て",
    assignUpcomingForReviewTasks: "今後の割当て",
    picTaskSignoffInComplete: "<b>PIC</b>のサインオフが未了であるタスク",
    picDocSignoffInComplete: "<b>PIC</b>のサインオフが未了である文書",
    eqrTaskSignoffInComplete: "<b>EQR </b>のサインオフが未了であるタスク",
    eqrDocSignoffInComplete: "<b>EQR </b>のサインオフが未了である文書",
    collapseCards: "カードを折りたたむ",
    expandCards: "カードの拡張",
    noUserSelectedPlaceholder1: " {0} はこのエンゲージメントに識別またはインバイトされていません。",
    noUserSelectedPlaceholder2: "ここをクリックすると",
    noUserSelectedPlaceholder3: " {0} を識別またはインバイトできます",
    notInvitedLabel: "インバイトされていない",
    noTasksPlaceholder: "この監査フェーズの <br/>マイルストーンに関連付けられたタスクはありません。",
    noTasksTilesPlaceholder: "選択されたユーザーに割当てられたタスクはありません",
    noAssignmentPlaceholder: "割当てが見つかりません",
    dueDateAssignmentPlaceholder: "期日ごとの割当",
    countAssignmentPlaceholder: "割当数",
    OverduetPlaceholder: "期限超過",
    TodayPlaceholder: "今日",
    tasksView: "タスク画面",
    documentsView: "文書画面",
    picAndEqr: "PIC & EQR",
    ResponsiveToSR: "⚡SRに関連付けられた",
    responsiveToFR: "⚡FRに関連付けられた",
    relatedTasksFormatted: "{0} の関連するタスク",
    relatedTaskFormatted: "{0} の関連するタスク",
    autoAssignWarning2: "ここをクリック",
    toAssign: "アサイン先",
    taskAssignWarning: " {0}のサインオフが必要な割当てられていないタスク",
    tasksAssignWarning: " {0}のサインオフが必要な割当てられていないタスク",
    taskAdditionalFuncText1: "<b>このタスクには追加機能があります。 </b>",
    taskAdditionalFuncText2: "<b>移動してください。</b><p>PIC/EQRレビューが必須のタスクではない限り、ビルドタスクではタスクを完了とマークする際にエビデンスの関連付けは不要です。</p>",
    taskadditionalfunctionality: "<b>このタスクは追加の機能を有します。</b> {0} </b>してそちらに進みます。</b><p>タスクにPIC/EQRレビューが必要でない限り、ビルドタスクでは関連付けるべきエビデンスに完了マークを付す必要はありません。</p>",
    taskclickhere: "ここをクリック",
    taskAutoAssignModalTitle: "自動割当て",
	taskAutoAssignModalDescription: 'EQR のサインオフが必要なタスクのうち｛1｝に割当てられていないものが｛0｝個あります。"割当て"をクリックし｛1｝に対するEQR の割当てを作成してください。',
	tasksAutoAssignModalDescription: 'EQR のサインオフが必要なタスクのうち｛1｝に割当てられていないものが｛0｝個あります。"割当て"をクリックし｛1｝に対するEQR の割当てを作成してください。',
    picTaskAutoAssignSuccessMessage: "PICサインオフが必要なタスクの割当て先：",
    picTasksAutoAssignSuccessMessage: "PICサインオフが必要なタスクの割当て先：",
    eqrTaskAutoAssignSuccessMessage: "EQR サインオフが必要なタスクの割当て先：",
    eqrTasksAutoAssignSuccessMessage: "EQR サインオフが必要なタスクの割当て先：",
    taskEntityDocumentValidationMsg: "このタスクには、対応するエビデンスがないエンティティがあります。エンティティ別表示に切り替えて、追加の文書化が必要なエンティティを確認してください。",
    // PIC/EQR Sign-Off validation message
    picSignOffValidationMsg: "このタスクはPICのサインオフが必要ですが、PIC文書が関連付けられていません。この要求事項には少なくとも一つの文書が必要です。",
    eqrSignOffValidationMsg: "このタスクはEQR のサインオフが必要ですが、EQR 文書が関連付けられていません。この要求事項には少なくとも一つの文書が必要です。",
    picAndEQRSignOffValidationMsg: "このタスクはPIC/EQR のサインオフが必要ですが、PIC/EQR 文書が関連付けられていません。この要求事項には少なくとも一つの文書が必要です。",
    updateDataOnPicEqrDashboardBannerMessage: "以下の変更はアップデートされていません。 {0} からページを更新してください。",
    showMissingSignOffByLabel: "{0}のサインオフがない文書を表示",

    FindingsReportName: "発見事項",
    FindingsDeficiencyReportTabName: "不備",
    FindingsMisstatementReportTabName: "虚偽表示",
    FindingsDeficiencyITReportTabName: "不備-IT",
    auditPlanRelatedEvidenceReporLabel: "関連するエビデンスを含む監査計画",
    groupStructureSummaryReportReportLabel: "グループストラクチャーサマリー",
    auditPlanReportLabel: "監査計画レポート",
    itAppSOSummaryReportLabel: "ITApp&SOサマリー",
    craSummaryReportLabel: "CRAサマリー",
    teamMembersLabel: "チームメンバー",
    ipeLabel: 'Information produced by the entity (IPE)',
    validationChecksReportLabel: "検証チェック",
    trialBalanceReportLabel: "試算表",
    trialBalanceReportTabLabel: "試算表レポート",
    reportLabelYes: "はい",
    reportLabelNo: "いいえ",
    assignedBy: "割当て者",
    openInReviewNotesHub: "レビューノートハブで開く",
    nextNote: "次",
    previousNote: "前",

    //component team group tab names
    accountInfoCanvasFormExport: "勘定科目情報",

    //project insight tab names
    projectInsightCanvasFormExport: "Canvasフォームの出力",
    projectInsightSCOTToWCGWToControl: "SCOT→WCGW→統制",
    projectInsightControlToITApplication: "ITアプリケーションに対する統制",
    projectInsightControlToAssertion: "アサーションに対する統制",
    projectInsightRiskToWCGW: "WCGWsに対するリスク",

    //IPE Report
    ipeControlsReport: 'Controls',
    ipeSubstantiveReport: 'Substantive',
    ipeITGCReport: 'ITGC',

    // Milestone tab names
    milestonesReport: "マイルストーンレポート",
    unmappedTasks: "マッピングされていないタスク",

    // Effective
    isEffective: "有効",
    inEffective: "非有効",
    nonEffective: "非有効",

    clientRequests: "クライアントリクエスト",
    externalTasks: "外部タスク",
    requestPriority: "リクエストの優先度",
    scot: "SCOT",
    assertionR: "アサーション",
    wcgwToControlMappingTotal: "WCGWから統制へのマッピング合計",

    //CRA build step
    buildStep2EntityHeaderText: "重要な勘定科目及び開示、アサーション、関連するWCGW及び統制",
    buildStep4EntityHeaderText: "重要な勘定科目、開示及び関連するアサーション",
    accountNameHeader: "重要な勘定科目及び開示",
    noAssertionsLabel: "関連するアサーションがありません。〈a〉勘定科目と開示の管理</a>をクリックし開始してください。",
    noAssertionsBuildStep2text1: "少なくとも1つのアサーションがこの勘定科目に関連付けられる必要があります。以下をクリックしてください",
    accountWithoutAssertionsBuildStep2text1: "それぞれの重要な勘定科目又は開示に少なくとも1つのアサーションが必要です。以下をクリックしてください。",
    noAssertionsBuildStep2text2: "勘定科目及び開示の管理",
	noAccountsLabel: '重要な勘定科目又は開示は作成されていません。 <span class="bold-text">勘定科目及び開示の管理</span> をクリックして開始します。',
	noAccountsLabelPlaceHolder: '重要な勘定科目又は開示が作成されていません。 <span class="bold-text">勘定科目又は開示の管理</span>から開始してください。',
    noAccountsOrDiscloserPreText: "重要な勘定科目または開示が作成されていません。",
    noAccountsOrDiscloserText: "勘定科目及び開示の管理",
    noAccountsOrDiscloserPostText: "開始してください",
    noAssertionsBuildStep1text1: "少なくとも1つのアサーションがこのリスクに関連付けられる必要があります。以下をクリックしてください",
    noAssertionsBuildStep1text1Msg: "各リスクには、少なくとも一つの関連するアサーションが必要です。",
    noAssertionsBuildStep1text2: "アサーションの関連付け",
    noAssertionsBuildStep1text3: "して開始",
    editRisk: "リスクの編集",
    deleteRisk: "リスクの削除",
    noControlsRelatedWWCGW: "関連する統制がありません。",
    noControlsRelatedWCGW: "統制依拠戦略のアサーションに関連付けられた各WCGWについて、少なくとも１つの統制をテスト対象とする必要があります。以下を作成してください：",
    noControlsRelatedWCGWNewCont: "新しい統制",
    noControlsRelatedWCGWor: "または",
    noControlsRelatedWCGWRelateCont: "既存の統制を関連付ける",
    noControlsForWCGW: "統制依拠戦略ではないアサーションは、統制を識別する必要はありません。",
    noControlsRelatedWCGWFooter: "から始めてください。",
    relateWCGWs: "<a>WCGWｓを関連付ける</a>",
    noWCGWs: "関連するWCGWsがありません",
    noWCGWsClick: " クリック",
    noWCGWsFooter: " して開始。",
    showOnlyRisksWithNoAssertion: "アサーションが関連付けられていないリスクのみを表示",
    showIncomplete: "未完了のCRAのアサーションのみを表示する",
    showOnlyInvalidBuildStep2: "必須の詳細が入力されてない勘定科目のみを表示",
    noTestedControlsWithRelyAssertion: "統制依拠戦略のアサーションに関連付けられた各WCGWについて、少なくとも１つの統制をテスト対象とする必要があります。",

    // Account build step
    accountOrDisclosure: "勘定科目/開示",
    relatedAssertions: "関連するアサーション",
    relatedAccountsAndAssertions: "関連する勘定科目及びアサーション",
    pspIndexTitle: "PSPインデックス",
    statementTypeTitle: "文書タイプ",
    significantAccountLabel: "重要な",
    limitedRiskLabel: "リスクが限定的な",
    insignificant: "軽微",
    significantDiscloure: "重要な開示",
	accountAddedMessage: '勘定科目 "##"の作成が成功しました',
    accounHeaderText: "勘定科目及び開示",

    // Add accounts / disclosures Modal labels
    accountsListTitle: "勘定科目 / 開示および関連するアサーション",
    addAccountsDisclosures: "勘定科目 / 開示の追加",
    editAccountsDisclosures: "勘定科目/開示を編集する",
    accountNameLabel: "勘定科目名称（必須）",
    accountDesignationLabel: "指定（必須）",
    accountEstimateLabel: "見積勘定科目である",
    accountStatementTypeLabel: "文書タイプ（必須）",
    pspIndexDropdownLabel: "PSPインデックス（必須）",
    removePSPIndexLabel: "PSPインデックスの削除",
    assertionsLabel: "アサーション（必須）",
    noAccounsMessage: "勘定科目が見つかりません。開始するには勘定科目を追加してください。",

    //Delete account / disclosure modal labels
    deleteAccountDisclosure: "勘定科目/開示を削除する",
    deleteAcConfirmMessage: "勘定科目/開示 {0} を削除してよろしいですか？すべての関連するアサーションは削除されます。選択された勘定科目/開示にのみ関連したタスクも削除されます。",

    true: "True",
    false: "False",
    taskSummaryReportEngagementInfo: "複数エンゲージメント",
    viewPriority: "優先度の確認",
    priorityRequestsSent: "送信された優先リクエスト",

    //reactive frame
    maxTabsLocked: "タブの上限に達しました。タブの1つのピン留めを解除し閉じてから新しいタブを開いてください。",
    openInNewTab: "新しいタブで開く",
    copyLink: "リンクのコピー",
    copySuccess: "リンクがクリップボードにコピーされました",
    copyFailure: "リンクのクリップボードへのコピーが失敗しました",
    minimize: "最小化",

    //Risk status for account cards
    riskStatusLabels: {
        NoAssertionsAvailableLabel: "利用可能なアサーションがありません",
        SignificanceNotSelectedLabel: "重要性が選択されていません",
        InsignificantLabel: "軽微"
    },

    lockTab: "タブのピン留め",
    keyDocuments: "主要な文書",
    suggestedDocuments: "提案された文書",
    noSuggestedDocuments: "提案された文書がありません",
    exitBulkMode: "一括処理モードの終了",
    bulkLabel: "一括処理",

    me: "私",
    viewByUser: "ユーザー別表示",
    unsentDraftCapitalized: "未送信ドラフト",
    picSignoffInComplete: "PICサインオフ未完了",
    eqrSignOffIncomplete: "EQRサインオフ未完了",

    tableView: "テーブルビュー",
    noRelatedAssertions: "関連するアサーションはありません。クリック",

    multiEntityTileMessage1: "クリック",
    multiEntityTileMessage2: "here",
    multiEntityTileMessage3: "エンティティごとのステータスを表示するため",
    allItemsMessage: "すべてのアイテムを表示する",

    EntitySelector: "エンティティを選択して開始",
    allEntities: "全てのエンティティー",
    multiEntity: "複数のエンティティー",
    ungrouped: "グルーピングされていない",
    numberSelected: "{0}　選択済",
    allTimePhases: "すべて",
    timePhases: "タイムフェーズ",
    noTimePhaseFound: "タイムフェーズが見つかりません",
    unrelatedAssignments: "関連付けられていない割当て",
    unrelatedRequests: "関連付けられていないリクエスト",
    relateRequests: "リクエストの関連付け",
    taskWithoutAnyAssignments: "割当てがないタスク",
    privacyNotice: "プライバシー通知",
    lastPublishedAndSent: "最終発行日及び送信日",
    drafts: "ドラフト",
    allEntitiesTask: "これはすべてのエンティティに関連するエンゲージメント全体のタスクです",
    noRelatedEntities: "関連するエンティティがありません",
    clickNewRisk: "して開始",
    relatedAccountsDisclosuresAndAssertions: "関連する重要な勘定科目、開示及びアサーション",
    relateAssertion: "アサーションの関連付け",
    taskByEntity: "エンティティ別タスク",
    engagementWideTask: "エンゲージメント全般タスク",
    componentEngagementPill: "CT",
    primaryAndComponentEngagementPill: "PT/CT",
    // Scot build steps
    scotHeader: "SCOTs",
    searchScot: "検索する",
    manageScots: "SCOTsの管理",
    superModelStep1ScotMessage: "重要な勘定科目及び開示並びに関連するSCOTs",
    scotRelatedITApplicationServiceOrg: "SCOTs並びに関連するITアプリケーション及びサービス受託会社",
    noScotsAvailable: "結果が見つかりません",
    searchScotPlaceholder: "検索する",
    searchScotClearHoverText: "クリア",
    showOnlyUnrelatedScotToggleSwitch: "関連していないもののみ表示",
    newScot: "新しいSCOT",
    importFromKnowledgeScot: "SCOTsのインポート",
    importAccountsAndDisclosures: "勘定科目及び開示のインポート",
    showOnlyAccountRelatedScot: "関連する重要な勘定科目及び開示がないSCOTsのみを表示",
    warningMessageEstimateScotNotAssociatedWithEstimatedAccount: "各見積SCOTは、少なくとも１つの見積りを含む重要な勘定科目又は重要な開示に関連付けられる必要があります。このSCOTを関連する重要な勘定科目又は重要な開示にドラッグアンドドロップしてください。",
    warningMessageScotNotAssociatedWithAccount: "各SCOTは、少なくとも１つの重要な勘定科目又は重要な開示に関連付けられる必要があります。このSCOTを関連する重要な勘定科目又は重要な開示にドラッグアンドドロップしてください。",
    showvalidations: "バリデーションを表示",

    scotRelatedWCGWandControls: "SCOT並びに関連するWCGW及び統制",
    newWcgw: "新しいWCGW",
    manageWCGWs: "WCGWの管理",
    manageControl: "統制の管理",
    importWCGWs: "WCGWのインポート",
    relateWCGWs: "WCGWsの関連付け",
    newControl: "新しい統制",
    importControl: "統制のインポート",
    importControls: "統制のインポート",
    relateControl: "統制の関連付け",
    scotStrategyIsControlMessage: "このWCGWには統制が識別されていません。SCOT戦略は定義されていません。",
    scotStrategyIsWCGWMessage: "このSCOTにはWCGWが識別されていません。SCOT戦略は定義されていません。",
    controlsPlaceholderWithNoRelatedWCGWsMessage: "各SCOTは少なくとも1つのWCGWが関連付けられる必要があります。以下を作成してください：",
    controlsPlaceholderWithNoRelatedControlsMessage: "各WCGWは少なくとも1つの統制が関連付けられる必要があります。以下を作成してください：",
    noITApplicationSOMessage: "このSCOTにはITアプリケーション又はサービス受託会社が識別されていません。クリックしてください。",
    relatedItAppSOHeaderMessage: "関連するITアプリケーション及びサービス受託会社",
    substantivePlaceholderWithNoRelatedControlsMessage: "このSCOTには統制が識別されていません。実証単独戦略を採用しているSCOTsについては、統制を識別する必要はありません。",
    substantivePlaceholderWithNoRelatedWCGWsMessage: "このSCOTにはWCGWが識別されていません。実証単独戦略を採用しているSCOTsについては、WCGWsを識別してください。",
    noITApplicationSOMessageText: "必要に応じて関連付けます。",
    notSelected: "選択されていません",
    or: "または",

    //WCGWControls
    showOnlyWCGWRelatedControls: "関連付けのあるもののみを表示",

    createorRelateControl: "新しい統制を作成する又は既存の統制を関連付ける",

    //Accounts Scot build steps
    accountHeader: "勘定科目",
    searchAccount: "勘定科目の検索",
    searchAccountPlaceholder: "検索",
    manageAccounts: "勘定科目と開示の管理",
    showOnlyUnrelatedAccountToggleSwitch: "関連しないもののみを表示",
    searchAccountClearHoverText: "クリア",
    noAccountsAvailable: "結果が見つかりません",
    showOnlyScotRelatedAccount: "関連するSCOTがない重要な勘定科目及び開示のみを表示",
    warningMessageEstimateAccountNotAssociatedWithEstimatedScot: "見積りを含む重要な勘定科目又は開示は、少なくとも１つの見積SCOTに関連付けられる必要があります。既存の関連するSCOTをこの重要な勘定科目又は重要な開示にドラッグアンドドロップしてください。",
    warningMessageAccountNotAssociatedWithScot: "重要な勘定科目又は開示は、少なくとも１つのSCOTに関連付けられる必要があります。既存の関連するSCOTをこの重要な勘定科目又は重要な開示にドラッグアンドドロップしてください。",
    significantAccountsAndDisclosures: "重要な勘定科目及び開示",
    // Independence Only

    independenceOnlyStatus: "独立性のみ",

    //Controls
    controlDesignEffectivenessWarningValidation: "統制はデザインの有効性を選択する必要があります",
    controlHeader: "SCOTs及び関連する統制",
    manageControls: "統制の管理",
    manageITApplications: "ITアプリケーションの管理",
    searchControlClearHoverText: "クリア",
    searchControlPlaceholder: "検索",
    noControlsAvailable: "結果が見つかりません",
    controlName: "統制名",
    frequency: "頻度",
    type: "タイプ",
    newSO: "新しいSO（サービス受託会社）",
    designEffectiveness: "デザインの有効性",
    testing: "テスト",
    strategyTypeName: "SCOT戦略",
    controlTestingYes: "はい",
    controlTestingNo: "いいえ",
    effective: "有効",
    ineffective: "非有効",
    noControlsResult: "結果が見つかりません。",
    noControlsLabel: "結果が見つかりません。",
    relatedControl: "関連する統制",
    relateControls: "統制の関連付け",
    controlTypeValues: {
        itApplication: "ITアプリケーション統制",
        itDependentManual: "IT依存手作業統制",
        manualPrevent: "手作業防止",
        manualDetect: "手作業発見"
    },
    controlFrequencyTypes: {
        manyTimesPerDay: "毎日何度も",
        daily: "日次",
        weekly: "週次",
        monthly: "月次",
        quarterly: "四半期毎",
        annually: "年次",
        iTApplicationControl: "IT アプリケーション統制",
        other: "その他"
    },
    filterTypeOfScots: "SCOTs",
    noScotsAvailable: "結果が見つかりません",


    onlyShowControlsWithNoDesignEffectiveness: "選択されたデザインの有効性がない統制のみを表示する",

    // control Tasks
    controlCount: "{0} 統制",

    //Create and Edit WCGW
    wcgwInputName: "WCGW名",
    editWCGW: "WCGWの編集",
    createNewWCGW: "新しいWCGWを作成",
    editTheWCGW: "WCGWを編集",
    createEditWCGWSave: "保存",
    createEditWCGWClose: "キャンセル",
    createEditWCGWModelScot: "SCOT",
    newWCGWTitel: "新しいWCGW",
    wcgwNameIsRequired: "WCGWには名前が必要です",
    deleteWCGW: "WCGWを削除",


    //Audit Plan
    importPSPButtonText: "PSPsのインポート",
    commonContentUpdateSuccessMessage: "コンテンツ更新中です。 完了するまでに最大15分かかる場合があります。ページを更新し新しくインポートされたPSPを確認してください。",
    responsivetoRisks: "リスクへの対応",
    procedures: "手続",
    toc: "TOC",
    significantandFraudRisksHeading: "特別な検討を必要とするリスク及び不正リスク並びに対応する手続及び統制",
    risksBeingRespondedToByComponentTeam: "リスクには構成単位チームが対応しています。",
    responsivecontrolsandTOCs: "対応する統制及びTOCs",
    ResponsivePSPOSP: "対応するPSP/OSP",
    responsivePSPsOSPs: "対応するPSPs/OSPs",
    responsiveTOC: "対応するTOC",
    responsiveControl: "対応する統制",
    responsivePSPOPSMessage: "このリスクのアサーションに対応する実証手続を少なくとも1つ識別する必要があります。 {0} をクリックして対応する実証手続を識別してください。",
    responsiveControlMessage: "このリスクのアサーションに対応する統制（デザインの有効性評価が完了したもの) を少なくとも1つ識別する必要があります。{0}をクリックして対応する統制を識別してください。{1}をクリックしてデザインの有効性又はテスト戦略を設定してください。",
    responsiveTOCMessage: "統制依拠戦略のアサーションには(1)低リスクとされておらず、かつ、(2)デザインの有効性評価が完了している統制のリスクに対応するTOCが少なくとも1つ必要です。対応するTOCsを特定するには、 <b>「対応するTOC」</b>をクリックしてください。",
    notcompleted: "未完了",
    noResponsiveTOCAvailable: "この統制に対応するTOCが識別されていません。",
    refresh: "データの更新",
    tocHoverOverWhenControlTestingHasNoorNotCompleted: "この統制はテスト対象として選択されていません。<b>統制の管理</b>を使用しテストの選択を変更してください。",
    noresponsiveTOCIdentified: "識別された対応するTOCはありませんでした。",
    taskAssertionnotModified: "タスクのアサーションが編集されていません。アサーションの関係を編集し続行するか、キャンセルをクリックし終了してください。",
    failedToEditRelatedAssertions: "このタスクに関連するアサーションの編集に失敗しました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    assertionCannotEdited: "利用できないチェックボックスが付いたアサーションがEYメソドロジーによって設定されており、編集できません。",
    editAssertionInfoMessage: "このタスクに対するアサーションを追加又は削除してください。少なくとも1つの選択されたアサーションが必要です。",
    editRelatedAssertions: "関連するアサーションの編集",
    loweRiskHeader: "低リスク",
    placeholderWhenControlTestingHasNotCompleted: "この統制はテスト対象として選定されていません。{0} を使用してテストの選択を変更してください。",
    pspandOSP: "PSPs/OSPs",
    tocs: "統制テスト",
    norelatedAssertionPlaceHolder: "特別な検討を必要とするリスク又は不正リスクには、このリスクに関連するアサーションを少なくとも１つ識別する必要があります。{0}をクリックして関連するアサーションを識別してください。",
    assertionMustHaveOneControlWithCompleteDesignEffectiveness: "各アサーションには、リスクに対応して識別され、デザインの有効性評価が完了した統制が少なくとも１つ必要です。{0}をクリックして対応する統制を識別してください。",
    controlRiskRelyNotLowerRisk: "統制依拠戦略の各アサーションには、(1)低リスクとされておらず、(2)デザインが有効であり、かつ、(3)テスト対象とされた統制が少なくとも１つ必要です。{0}をクリックして対応する統制を識別してください。",
    controlRiskRelyWithDesignEffectively: "統制依拠戦略の各アサーションには、(1)デザインが有効であり、かつ、(2)テスト対象とされた統制が少なくとも１つ必要です。{0}をクリックして対応する統制を識別してください。",

    assertionWithControlRiskNotRely: "統制依拠戦略ではないアサーションには、統制テストを識別する必要はありません。",
    thisControlNotSelectedForTesting: "この統制はテスト対象として選定されていません。{0}をクリックしてテストの選択を変更してください。",
    testControlRelatedToControlAsLowerRisk: "低リスクとされた統制に関連付けられた統制テストでは、このアサーションのリスクには対応できません。",
    testControlWithoutCompleteDE: "デザインの有効性評価が完了していない統制に関連付けられた統制テストでは、このアサーションのリスクには対応できません。{0}をクリックしてデザインの有効性を設定してください。",
    testControlrelatedToineffective: "デザインの有効性評価が非有効の統制に関連付けられた統制テストでは、このアサーションのリスクには対応できません。{0}をクリックしてデザインの有効性を変更してください。",
    anotherTestControlIdentified: "このアサーションのリスクに対応する別の統制テストが識別されており、これ以上の統制テストを識別する必要はありません。この統制に対応するTOCが識別されていません。",
    eachControlMustHaveOneToc: "統制依拠戦略の各アサーションには、(1)低リスクとされておらず、(2)デザインが有効であり、かつ、(3)テスト対象とされた統制のリスクに対応するTOCが少なくとも１つ必要です。この統制に対応するTOCが識別されていません。{0}をクリックして対応するTOCを識別してください。",
    eachAssertionControlHaveAtleasetOneTOC: "統制依拠戦略の各アサーションには、(1)デザインが有効であり、かつ、(2)テスト対象とされた統制のリスクに対応するTOCが少なくとも１つ必要です。この統制に対応するTOCが識別されていません。{0}をクリックして対応するTOCを識別してください。",
    norepsonsivePSPOSPplaceholder: "各アサーションには、このリスクに対応した実証手続が少なくとも1つ必要です。{0}をクリックして対応する実証手続を識別してください。",

    //Reject Task
    rejectPspModalTitle: "PSPを差し戻す",
    rationaleRequired: "必須",
    rationaleTextEditorLabel: "PSPを差し戻す理由",
    rejectTaskErrorMessage: "タスクの差戻ができません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    rejectTaskModalHeader: "本当に選択されたPSPを差し戻しますか？",
    rejectTaskModaWarningText: "このエンゲージメントにおいて他のどのタスクにも関連付けられていない関連するエビデンスは一時ファイルに移動します。",
    rejectTaskRationaleLabel: "根拠（必須）",

    // Adobe Analytics
    aaCookieConsentTitle: "ようこそ",
    aaCookieContentPrompt: "クッキーを許可しますか？",
	aaCookieConsentExplanation: '<p>このウェブサイト運営上必要なクッキーに加え、エクスペリエンス及びサービス向上のため以下のタイプのクッキーを使用します:  <strong> 機能性クッキー <strong> (設定の記憶等エクスペリエンス向上目的)、 <strong>パフォーマンスクッキー <strong> (ウェブサイトパフォーマンス測定及びエクスペリエンス向上目的)、 <strong>広告/ターゲティングクッキー <strong> (広告キャンペーン実施先を対象に第三者により設定され、かつ、関連する広告を提供する目的)、 <strong></p><p> 詳細については<a target="_blank" href="https://www.ey.com/en_us/cookie-policy">クッキーポリシー</a>を参照してください。</p>',
	aaCookieConsentExplanationWithDoNotTrack: "<p>このウェブサイト運営上必要なクッキーに加え、エクスペリエンス及びサービス向上のため以下のタイプのクッキーを使用します:  <strong> 機能性クッキー </strong> (設定の記憶等エクスペリエンス向上目的)、 <strong>パフォーマンスクッキー </strong> (ウェブサイトパフォーマンス測定及びエクスペリエンス向上目的)、 <strong>広告/ターゲティングクッキー </strong> (広告キャンペーン実施先を対象に第三者により設定され、かつ、関連する広告を提供する目的)、 </p><p>ブラウザで「追跡しない」設定が有効になっていることを検出しました。その結果、広告/ターゲティングクッキーは自動的に無効になります。</p><p> 詳細については<a target='_blank' href='https://www.ey.com/en_us/cookie-policy'>クッキーポリシー</a>を参照してください。</p>",
    aaCookieConsentDeclineOptionalAction: "任意のクッキーを拒否します",
    aaCookieConsentAcceptAllAction: "全てのクッキーを承諾します",
    aaCookieConsentCustomizeAction: "クッキーのカスタマイズ",
	aaCookieConsentCustomizeURL: "https://www.ey.com/en_us/cookie-settings",

    //Task Sections
    taskSectionLabels: {
        taskSectionHeader: "タスクグループ及び関連タスク",
        manageTaskSections: "タスクグループの管理",
        taskSectionsAccordionHeader: "タスクグループ",
        phaseAccordionHeader: "フェーズ",
        tasksAccordionHeader: "タスク",
        rejectedAccordionHeader: "差戻済",
        noRelatedTasksMessage: "利用可能なPSTs/OSTsはありません。{0}を作成して開始してください。",
        taskSectionTaskHeader: "タスク",
        newOSTButtonText: "新しいOST",
        cutomTaskSectionBadgeText: "カスタム",
        rejectedTasksLabel: "差し戻されたPSTｓ",
        additionalInfo: "根拠",
        rejectButton: "差戻",
        acceptButton: "承諾",
        removeButton: "除外",
        addButton: "追加",
        allPSTsRejectedMessage: "すべてのPSTsが差し戻されました。",
        rejectModalTitle: "PSTを差し戻す",
        rationaleTextEditorLabel: "PSTを差し戻す根拠",
        rejectTaskModalHeader: "選択したPSTを差し戻してよろしいですか？",
        noResultsMessage: "結果が見つかりません",
        noTaskSetionsAvailableMessage: "利用可能なタスクセクションがありません",
        rejectTaskModaWarningText: "このエンゲージメントにおけるどのタスクにも関連付けられていない関連するエビデンスは一時ファイルに移動されます。EY Canvasから配信された文書を含むPSTsは差戻しできません。",
        rejectTaskRationaleLabel: "根拠（必須）"
    },

    // Cookie Settings
    cookieSettings: {
        title: "クッキーの設定",
        explanation: "ey.com及びMy EYプラットフォームでのクッキーの使用に同意してください。以下にリストされているクッキーの種類から1つ以上を選択し、選択内容を保存します。クッキーの種類及びその目的の詳細については、以下のリストを参照してください。",
        emptyCookieListNotice: "このカテゴリのクッキーはこのアプリでは使用されていません",
        nameTableHeader: "クッキーの名称",
        providerTableHeader: "クッキープロバイダー",
        purposeTableHeader: "クッキーの目的",
        typeTableHeader: "クッキーの種類",
        durationTableHeader: "クッキーの有効期間",
        formSubmit: "選択の保存",
        requiredCookieListTitle: "必須クッキー",
        functionalCookieListTitle: "機能性クッキー",
        functionalCookieAcceptance: "以下の機能性クッキーを受け入れます",
        functionalCookieExplanation: "機能性クッキーによりエクスペリエンスを向上させることができます (たとえば選択した設定を記憶するなど)。",
        performanceCookieListTitle: "パフォーマンスクッキー",
        performanceCookieAcceptance: "以下のパフォーマンスクッキーを受け入れます",
        performanceCookieExplanation: "パフォーマンスクッキーはWebサイトのパフォーマンスを測定し、エクスペリエンスを向上させるのに役立ちます。パフォーマンスクッキーを使用する場合、我々は個人データを保存せず、クッキーを通じて集約され匿名化された形式で収集された情報のみ使用します。",
        advertisingCookieListTitle: "ターゲッティングクッキー",
        advertisingCookieAcceptance: "以下の広告/ターゲッティングクッキーを受け入れます",
        advertisingCookieExplanation: "ユーザーのアクティビティとセッションを追跡するために使用する広告/ターゲティングクッキーにより、また広告クッキーの場合、広告キャンペーン実施先を対象に第三者により設定され、かつ、関連する広告を提供する目的で、よりパーソナライズされたサービスを提供できるようにします。",
        doNotTrackNotice: "ブラウザで「追跡しない」設定が有効になっていることを検出しました。その結果、広告/ターゲティングクッキーは自動的に無効になります。",
    },

    //Task Sections and related Tasks
    taskSectionAndRelatedTask: "タスクセクション及び関連するタスク",
    manageTaskSections: "タスクセクションの管理",

    // Financial Statments
    financialStatementLabels: {
        financialStatements: "財務諸表",
        trialBalance: "試算表",
        okButton: "OK",
        leadSheet: "リードシート",
        balanceSheet: "貸借対照表",
        incomeStatement: "損益計算書",
        eyreferences: "リファレンス",
        currenPeriod: "分析日",
        comparativePeriod: "比較日付",
        changeFrom: "変更元",
        percentageChangeFrom: "％変動 対",
        notesColumn: "ノート",
        viewTrialBalanceType: "試算表タイプ別表示",
        multiEntity: "マルチエンティティ",
        placeHolderText: "アカウントクラスの検索",
        currencyType: "通貨タイプ",
        currencyCode: "通貨コード",
        businessUnit: "ビジネスユニット",
        periodEnded: "期末日",
        periodsEnded: "期末日",
        searchGLAccountPlaceholder: "GL勘定科目の検索",
        eyReferenceDocuments: " {0} 文書",
        relatedNotes: "関連するノート",
        notAvailable: "利用不可",
        significantDisclosures: "重要な開示",
        noResultFound: "結果が見つかりません",
        openEYHelixProjects: "EY Helixプロジェクトを開く",
        openAdjustmentModule: "調整モジュールを開く",
        goToSubstantiveProcedureLink: "実証手続へ進む",
        cancel: "キャンセル",
        remove: "削除"
    },

    financialStatementsClassView: {
        bulk: "一括処理",
        eyAccount: "EY勘定科目",
        placeHolderText: "GL勘定科目の検索",
        noAccountDesignation: "勘定科目指定が設定されていません",
        insignificantLeadSheetMessage: "軽微な勘定科目のリードシートは表示されません",
        unmappedGLAccounts: "マッピングされていない勘定科目のリードシートは表示されません",
        unmappedAccountText: 'Unmapped'
    },
    financialStatementTypeIds: [{
            id: 1,
            label: "資産"
        },
        {
            id: 4,
            label: "負債"
        },
        {
            id: 7,
            label: "純資産"
        },
        {
            id: 8,
            label: "収益"
        },
        {
            id: 9,
            label: "費用"
        },
        {
            id: 17,
            label: "純利益"
        }
    ],
    copyrightMessage: "Copyright © <year> all rights reserved",
    createNotes: {
        notesPlaceholderText: "{0}または{1}をクリックしてノートを追加する",
        newNote: "ノートの追加",
        relateNote: "ノートの関連付け",
        addNewNotesHeader: "ノートの詳細を以下に入力し <b>\'Save and close\'</b>を選択し終了する。別のノートを作成するには、<b>\'Save and create another\'</b>を選択してください。",
        noteIndex: "インデックス",
        noteIndexRequired: "インデックス（必須）",
        noteDescription: "説明",
        noteDescriptionRequired: "説明（必須）",
        saveAndClose: "保存して閉じる",
        newTickmarkDescription: "このGL勘定科目にリファレンスされたエビデンスがない理由を選択してください。",
        newTickmarkBulkModalDescription: "選択されたGL勘定科目にリファレンスされたエビデンスがない理由を選択してください。"
    },
    deleteNotes: {
        deleteNote: "ノートの削除",
        deleteNoteTitle: "選択されたノートを削除してよろしいですか？",
        delete: "削除",
        cancel: "キャンセル"
    },
    editNotes: {
        editNote: "ノートの編集",
        editNotesHeader: "以下のノートの詳細を編集し<b>\'保存して閉じる\'</b>を選択して終了する。",
        edit: "編集",
        cancel: "キャンセル"
    },
    notesListLabels: {
        actions: "アクション",
        noteCount: "{0} ノート",
        notesCount: "{0} ノート"
    },
    relateNotes: {
        relateNoteLabel: "ノートの関連付け",
        searchPlaceholder: "検索",
        accountLabel: "勘定科目",
        indexLabel: "インデックス",
        descriptionLabel: "説明",
        addedLabel: "追加済",
        showOnlyRelatedLabel: "関連付けのあるもののみを表示",
        noResultsFoundMessage: "結果が見つかりません。",
        noteCount: "{0} ノート",
        notesCount: "{0} ノート",
        closeBtnTitle: "閉じる"
    },
    uploadEvidenceDocuments: {
        addnewEvidencesPlaceholderandLinks: "{0}または{1}をクリックしてエビデンスを追加するか、{2}をクリックしてエビデンス不要と指定してください。",
        newEvidence: "新しいエビデンス",
        relateEvidence: "エビデンスの関連付け",
        newTickMark: "新しいチェックマーク",
        relateTasks: 'Relate task',
        noTasksSeleted: "タスクを選択して続ける。",
        relateTaskPlaceholder: "新しいリファレンスは少なくとも1つのタスクに関連付ける必要があります。タスクを選択してこの文書がエビデンスとして追加されている必要があります。",
        confirmButtonTitle: "続行",
        closeButtonTitle: "キャンセル",
        noResultsFound: "結果が見つかりません",
        taskType: "タイプ",
        taskName: "タスク名",
        taskCount: "{0}タスク",
        tasksCount: "{0}タスク",
        title: "リファレンス",
        removeReference: "リファレンスを削除する"
    },
    glAccountAssociatedNotes: {
        aggregatedNotesPlaceholder: "利用可能なノートはありません。GL勘定科目を選択してノートを作成してください。",
        notes: "ノート",
        relatedGlAccountPlaceholder: "関連するGL勘定科目"

    },
    finacialStatementsBulkOperations: {
        relateEvidenceLabel: "エビデンスの関連付け",
        selectedCountGLAccount: "選択された {0} GL勘定科目",
        selectedCountGLAccounts: "選択された {0} GL勘定科目",
        selectAll: "全て選択",
        deselectAll: "全てを選択解除する",
        exitBulkMode: "一括処理モードの終了",
        noGLAccountsSelectedValidationMessageEvidence: "少なくとも1つのGL勘定科目を選択し、エビデンスを関連付けるか、一括処理モードの終了をクリックしてください。",
        noGLAccountsSelectedValidationMessageTickmark: "少なくとも1つのGL勘定科目を選択し、新しいチェックマークを付すか、一括処理モードの終了をクリックしてください。",
        noGLAccountsSelectedValidationMessageRemoveReference: "少なくとも1つのGL勘定科目を選択し、リファレンスを削除するか、一括処理モードの終了をクリックしてください。",
        relateTickmarkLabel: "新しいチェックマーク",
        removeReferenceLabel: "リファレンスの削除",
        removeReferenceConfirmationMsg: "選択したすべてのGL勘定科目へのリファレンスを削除するかどうか確認してください。"

    },
    financialStatementsFilters: {
        referenceFilterKey: "リファレンスがないGL勘定科目",
        accountFilterKey: "マッピングされていないGL勘定科目",
        noResultsPlaceholder: "結果が見つかりません。",
        trialBalance: "試算表",
        noneAvailable: "利用できません",
        search: "検索",
        multityEntity: "マルチエンティティ",
        placeHolderMessageWhenHelixMappingIsTrue: "インポート済の試算表がありません。{0}をクリックし新しいアナライザーを関連付けてください。",
        placeHolderMessageWhenHelixMappingIsFalse: "EY Helixとの統合は利用できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
        eyHelixIntegrationLinkText: 'EY Helix integration',
        noEntitiesAvailablePlaceholder: "エンティティが作成されていません。エンティティを作成し開始してください。"
    },
    //Group instructions
    assertionTabButton: "アサーション",
    inherentRiskFactorButton: "固有リスク要因",
    accountsAndDisclosure: "勘定科目/開示",
    assertions: "アサーション",
    assertionC: "C",
    assertionEO: "E/O",
    assertionMV: "M/V",
    assertionRO: "R&O",
    assertionPO: "P&D",

    complexity: "複雑性",
    subjUncertainty: "主観性　不確実性",
    fraudOrError: "不正又は誤謬",
    change: "変更",
    natureOfAccount: "勘定科目の性質",
    relatedParties: "関連当事者",
    higherInherentRiskLabel: "［高(higher)］の固有リスク",
    lowerInherentRiskLabel: "［低(lower)］の固有リスク",
    relevantLabel: "リスクに関連する",
    relevantContributeLabel: "リスクに関連し、「高」の固有リスクに寄与する",
    incompleteInherentRiskTooltip: "未完了の固有リスク",
    estimateLabel: "見積り",
    riskAssociatedLabel: "リスクに関連する",
    greaterExtentLabel: "広範囲",
    lesserExtentLabel: "狭い範囲",
    accordionNoRiskLabel: "この勘定科目アサーションに関連するリスクはありません。",
    accordionNoRiskAccountLabel: "この勘定科目に関連するリスクはありません",
    accordionNoAssertionsLabel: "この勘定科目に関連付けられたアサーションはありません。",
    accordionLimitedRiskLabel: "勘定科目がリスクが限定的な勘定科目と識別されています。",

    maps: "マッピング",
    financialStatements: "財務諸表",
    serviceGatewayAutomation: "サービスゲートウェイ＆オートメーション",
    manageTaskGroups: "タスクグループの管理",
    openAssignmentsLabel: "割当てを開く",
    inProgressAssignmentsLabel: "進行中の割当て",
    // My Progress collaboration view.
	calendarDays: [
		"日",
		"月",
		"火",
		"水",
		"木",
		"金",
		"土"
	],
	calendarMonths: [
		"1月",
		"2月",
		"3月",
		"4月",
		"5月",
		"6月",
		"7月",
		"8月",
		"9月",
		"10月",
		"11月",
		"12月"
	],
    myProgressToday: "今日",
    noDueDateAssignedGroup: "期日が割当てられていません",
    myProgressStatusTile: {
        yourRequests: "あなたのリクエスト",
        totalCount: "合計数",
        requestStatus: "リクエストステータス",
        draft: "ドラフト",
        pending: "保留中",
        received: "受領済",
        accepted: "承諾済",
        overdue: "期限超過",
        noRelatedTasks: "関連するタスクのない{0}",
        oneNoRelatedTask: "関連するタスクがない1",
        addRequest: "新しいリクエスト",

        //Requests dues tile 2
        pendingRequestsByDueDate: "期日別回答待ちリクエスト",
        requestsYAxisLabel: "リクエスト",
        requestsXAxisLabel: "日",
        tooltipDaysLabel: "日",
        tooltipTotalLabel: "合計:",
        normalLabel: "標準",
        highLabel: "高",
        criticalLabel: "クリティカル",
        overdueLabel: "期限超過",
        overDueCatFirst: "期限超過 >90",
        overDueCatSecond: "期日超過 31～90",
        overDueCatThird: "期日超過 10～30",
        overDueCatFourth: 'Overdue 1-9',
        catFifth: '1-9',
        catSixth: '10-30',
        catSeventh: '31-90',
        catEighth: '> 90',
        noRequestsFound: "リクエストが見つかりません",
        daysOverdue: 'Days overdue',
		daysComingDue: 'Days coming due'
    },
    documentAttributeReference: {
        name: "名前",
        notes: "ノート",
        signOffs: "サインオフ",
        tasks: "関連タスク",
        open: "オープン",
        openReadOnly: "読み取り専用で開く",
        delete: "削除",
        rename: "名前の変更",
        signOffRequirements: "サインオフの要求",
        confidentiality: "機密性",
        unlink: "リンク解除",
        relateTasks: "関連タスク"
    },
    aiChatbot: 'EYQ Assurance Knowledge',
    selectDueDate: "期日の選択",
    daysOverdue: 'Days overdue',
    daysComingdue: 'Days coming due',
    loadingDataMessage: 'Loading data... this may take a few seconds'
};

/*RBAC Errors*/
export const RbacErrors = {
    106: "コンテンツを編集する役割がありません。エンゲージメント管理者と連携して、十分な権限を取得してください。"
};

/*Errors*/
export const Errors = {
    /*Doc Helper Custom Messages */
    0: "接続が切断されました。再接続してもう一度再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    101: "無効なエンゲージメントステータス。",
    102: "有効なエンゲージメントユーザーが見つかりません。",
    103: "エンゲージメントのユーザーに係る独立性遵守が欠けています。",
    104: "Missing required Azure AD Scopes",
    105: "エンゲージメント権限の取得中にエラーが発生しました。ページを更新して再試行してください。問題が続く場合は、ヘルプデスクに連絡してください。",
    106: "このアクションを実行する権限がありません",
    107: "有効なエンゲージメントユーザーが見つかりません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    108: "エンゲージメントプロファイルが未了です。ランディングページに進みプロファイルを完了してください。",
    303: "同じ名前のドキュメントが現在アップロードされています。",
    401: "操作を完了できません。ぺージを更新し再試行してください。問題が解消しない場合は、ヘルプデスクに連絡してください。",
    403: "サポートされていないファイル形式であり、アップロードされていません。文書を有効なファイル形式で再保存して、再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    410: "この文書は削除済のため開くことができません。",
    411: "空白の文書は認められません。",
    412: "同じ名前のドキュメントがこのエンゲージメントにすでに存在しています。",
    413: "文書ファイルが許容サイズ(250MB)を超えているため、アップロードできません。ファイルサイズを小さくして、再試行してください。",
    500: "接続が切断されました。再接続してもう一度再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    414: "名前が最大文字数（ {0} 文字）を超えています。",
    600: "今回の操作が完了しませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    601: "同じ名前の文書が存在します。",
    602: "文書が既にコラボレーションにあります",
    603: "文書が見つかりません。",
    'zip': "サポートされていないファイルタイプが1つ以上含まれているか、.zipファイル内に上限を超えるファイル数が圧縮されているため、.zipファイルをアップロードできません。",
    401000: "ネットワークの変更が検出されました。続行するにはページを再読み込みしてください",

    /*Accounts*/
    1001: "勘定科目作成の呼び出しに失敗しました。",
    1002: "勘定科目名がありません。",
    1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1004: "結果が見つかりません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    1005: "無効なエンゲージメントIDです。",
    1006: "無効なアカウントタイプです。",
    1007: "無効なステートメントタイプです。",
    1008: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1009: "IDによる勘定科目取得の呼び出しに失敗しました。",
    1010: "エンゲージメントIDによる勘定科目取得の呼び出しに失敗しました。",
    1011: "無効なリクエストによって、勘定科目IDに対するSWEサマリ取得の呼び出しに失敗しました。",
    1012: "無効なサマリータイプです。",
    1013: "アカウントレビュー作成のコールが失敗しました。",
    1014: "アカウントレビュー削除のコールが失敗しました。",
    1015: "無効なアカウントレビュー作成リクエスト。",
    1016: "無効なアカウントレビューID。",
    1017: "アカウントはこのエンゲージメントの一部ではないか、削除されています。",
    1018: "アカウントレビューが別のユーザーによって作成されました。",
    1019: "勘定科目は別のユーザーによって削除されました。ページを更新し再試行してください。",
    1020: "更新のためには勘定科目にPSPが必要です",
    1024: "勘定科目名が500文字を超えています。",
    1025: "リスクが限定的又は軽微な勘定科目は想定されていません",
    1026: "勘定科目に重複するアサーションを含めることはできません",
    1027: "無効なアサーションID",
    1037: "PSPインデックスは重複できません",
    1039: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1048: "勘定科目の実施タイプが無効です。",
    1053: "勘定科目にはリスク又は見積りが関連付けられており、リスクが限定的な勘定科目又は軽微な勘定科目には設定できません。",
    1054: "削除されるアサーションにリスク又は見積りが関連付けられています",
    1065: "特別な検討を必要とするリスク、不正リスク又は重要な虚偽表示リスク又は見積りに関連付けられたアサーションを変更することはできません。まずこれらの関連付けを削除する必要があります。",

    1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk.',
    1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
    1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
    1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

    /*Assertions*/
    2001: "無効な作成リクエストです。",
    2002: "アサーション名がありません。",
    2003: "アサーションがありません。",
    2004: "アサーション取得の呼び出しができませんでした。",
    2005: "無効なエンゲージメントIDです。",
    2006: "IDによるアサーション取得の呼び出しに失敗しました。",
    2007: "アサーションWCGW取得の呼び出しに失敗しました。",
    2050: "アサーションが見つかりません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    /*Tags*/
    5120: "タグ ID が見つかりません",
    5121: "タグ ID がありません",
    5123: "タグの関連付けが重複しています",
    5124: "タグの関連付けが見つかりません",


    /*Risks*/
    4001: "この操作を完了することができません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    4002: "リスク名がありません。",
    4003: "リスクがありません。",
    4004: "リスク取得の呼び出しができませんでした。",
    4005: "無効なエンゲージメントIDです。",
    4006: "IDによるリスク取得の呼び出しに失敗しました。",
    4007: "無効なクエリリクエストです。",
    4008: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4009: "無効な更新リクエストです。",
    4010: "リスクには既に特定のWCGWが割り当てられています",
    4011: "WCGWリストはNull値にできません。",
    4012: "タスクタイプの取得ができませんでした",
    4013: "無効な作成リクエストです。",
    4014: "関連するアサーションが無効です。ページを更新してもう一度やり直してください。エラーが解決しない場合は、ヘルプデスクに連絡してください。",
    4015: "そのWCGWは無効です。ページを更新してもう一度やり直してください。エラーが解決しない場合は、ヘルプデスクに連絡してください。",
    4016: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4017: "アサーションがリスクに対して無効です。ページを更新してもう一度やり直してください。エラーが解決しない場合は、ヘルプデスクに連絡してください。",
    4018: "パスされたリスクタイプIDが無効です。",
    4019: "リスク名が無効です。",
    4020: "無効な文書ID",
    4021: "リスク名は500文字以上にすることはできません。",
    4023: "アサーションIdリストは空白にできません。",
    4024: "リスクが限定的な勘定科目の監査調書フォームはエラーのため作成できませんでした。ページを更新し再試行してください。問題が続く場合は、ヘルプデスクに連絡してください。",
    4025: "アカウントIDが無効です。",
    4026: "無効なアサーションID。",
    4027: "アサーションリスクモデルを空白にすることはできません",
    4031: "リスク又はフォーム本文のオプションが無効です。",

    4035: "特別な検討を必要とするリスク又は不正リスクの高リスクは編集できません。",
    4036: "アサーションIDが渡されない場合、ナレッジアサーションIDを空にすることはできません。ナレッジアサーションIDは列挙型にする必要があります",
    4037: "この勘定科目のナレッジアサーションIDは既に存在します。",
    4038: "リスクタイプIDが許容されるオプションと一致しません。",
    4040: "この操作を行うことはできません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /*TASK*/
    5001: "全ての取得に失敗しました。",
    5002: "このエンゲージメントではこのタスクは利用できなくなりました",
    5003: "タスクについての文書の取得に失敗しました。リクエストパラメーターが無効です。",
    5004: "タスクに関連する文書の取得に失敗しました。リクエストパラメーターが無効です。",
    5005: "IDによるタスク取得に失敗しました。",
    5006: "タスクのカテゴリ取得の呼び出しに失敗しました。",
    5007: "タスクのサブカテゴリ取得の呼び出しに失敗しました。",
    5008: "タスクの内容取得の呼び出しに失敗しました。",
    5009: "タスクのクライアントリクエスト取得の呼び出しに失敗しました。",
    5010: "タスクのクライアントリクエスト保存の呼び出しに失敗しました。",
    5011: "あなたがアイテムを関連付けようとしているタスクは削除または却下されています。",
    5012: "あなたが関連付けようとしているアイテムは削除または却下されています。",
    5013: "あなたがアイテムを関連付けようとしているタスクは削除または却下されています。",
    5014: "あなたが関連付けようとしている文書は削除されています。",
    5015: "タスクの証拠取得の呼び出しに失敗しました。",
    5016: "WCGWのタスク取得の呼び出しに失敗しました。",
    5017: "エンゲージメントIDはゼロより大きい必要があります。",
    5018: "この操作はできません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5019: "タスクの内容が空欄です",
    5020: "選択したタスクは消去または却下されています。そのため、今回はアクションを完了させることができませんでした。",
    5021: "ソース文書IDが見つかりません。",
    5022: "注釈の保存に失敗しました",
    5023: "エンゲージメントのユーザーが見つかりません。",
    5024: "タスク削除の呼び出しに失敗しました。",
    5025: "タスク削除の呼び出しに失敗しました。",
    5026: "タスクリストが空欄です",
    5027: "レビューが見つかりません。",
    5028: "ファイル名は必須です。",
    5029: "ファイル拡張子は必須です。",
	5030: 'ファイル名は次の文字を使用できません：: */:<>\\?|\"',
    5031: "文書名更新中のエラー。",
    5032: "文書IDが無効です。",
    5033: "オペレーションタイプが見つかりません",
    5034: "タスクステータスの変更に失敗しました。",
    5035: "実行しようとしている操作は完了できませんでした。後ほど再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    5036: "この呼び出しでは本文はNull値又は空欄にできません。",
    5037: "この呼び出しではリクエストはNull値にできません。",
    5038: "一意のファイル名を入力して次に進む。",
    5039: "ファイル名は必須です。",
    5040: "ファイル名は半角100文字（全角50文字）を超えることができません。",
	5041: 'ファイル名には次の文字を使用できません：: */:<>\\?|\"',
    5042: "選択したタスクは却下されます。",
    5043: "タスクはビルドステップタスクです。",
    5044: "タスクはマイルストーンタスクです。",
    5045: "タスクの種類はPSP又はOSPのいずれでもありません。",
    5046: "文字数が上限を超えています。",
    5047: "文字数が上限を超えています。",
    5048: "必須フィールド。",
    5049: "選択した文書をこのタスクから取り除くことはできません。ページを更新してもう一度やり直してください。問題が解決しない場合は、ヘルプデスクまでお問い合わせください。",
    5050: "タスクグループIDはゼロ又は無効でない必要があります",
    5051: "タスクセクションIDはゼロ又は無効でない必要があります",
    5052: "文書を現在のタスクに追加中のエラー。呼び出しができませんでした。",
    5053: "現在のタスクでの文書更新中のエラー。呼び出しができませんでした。",
    5054: "現在のタスクでの文書のコピーを追加中のエラー。呼び出しができませんでした。",
    5055: "文書の名前変更中のエラー。呼び出しができませんでした。",
    5056: "ナレッジに関するタスクタイトル又はグループタスクを編集することはできません。",
    5057: "タスクタイプの種類はOSTである必要があります",
    5058: "この文書はシステムに関連付けられているためタスクから除外できません。",
    5059: "タイムフェーズの値は無効です。",
    5060: "エビデンス追加時のエラー。呼び出しができませんでした。",
    5061: "別のユーザーによって表示されている情報が更新されました。ページを更新してもう一度やり直してください。エラーが解決しない場合は、ヘルプデスクに連絡してください。",
    5062: "リクエストされた文書はエンゲージメントに関連付けられているEY Atlasのチャネルからは入手できません。今後追加を検討できるようにするため、ヘルプデスクにご連絡ください。",
    5063: "パッチオペレーションは無効です。",
    5064: "選択したタスクは削除または却下されています。そのため、今回はアクションを完了させることができませんでした。",
    5065: "タスクソースタイプの更新ができませんでした。無効なリクエストです。",
    5066: "ガイダンスの取得エラー。呼び出しに失敗しました。",
    5067: "タスクネイチャータイプの更新ができませんでした。無効なリクエストです。",
    5068: "タスクネイチャータイプの更新ができませんでした。無効なリクエストです。",
    5069: "タスクの割当て削除の呼び出しに失敗しました。",
    5070: "選択した1つ以上のタスクが削除されました。問題が解決しない場合は、再試行するかヘルプデスクまでお問い合わせください。",
    5071: "割当てを更新することができませんでした。無効なリクエストです。",
    5072: "作成者が見つかりません。無効なリクエストです。",
    5073: "割当てが見つかりません。",
    5074: "タスクの割当ての保存に失敗しました",
    5075: "選択したチームメンバーまたは役割は、選択したタスクに対して複数の割当てを有することはできません。続行するには、他の割当て、チームメンバー、または役割を選択してください。 エラーが続く場合は、ヘルプデスクに連絡してください。 ",
    5076: "選択されたチームメンバーは、このエンゲージメントではアクティブなメンバーではありません。問題が解決しない場合は、再試行するかヘルプデスクまでお問い合わせください。",
    5077: "1つ以上のタスクが消去されました。問題が解決しない場合は、再試行するかヘルプデスクまでお問い合わせください。",
    5078: "選択されたタスク割当ては削除されています。再試行しエラーが続く場合は、ヘルプデスクに連絡してください。",
    5079: "選択した1つ以上のタスクが削除されました。問題が解決しない場合は、再試行するかヘルプデスクまでお問い合わせください。",
    5080: "文書のバージョンの記録がありません",
    5081: "このタスクに現在割り当てられているユーザーを作成者として再割り当てすることはできません。問題が解決しない場合は、再試行するかヘルプデスクまでお問い合わせください。",
    5082: "更新ができませんでした。文書の名称は、エンゲージメントに対して固有である必要があります。ページを更新してこのメッセージを削除します。",
    5083: "タスクの詳細の最大文字数を超過しました。",
    5084: "タスクの文書の作成の呼び出しができませんでした。",
    5085: "タスクの文書の削除の呼び出しができませんでした。",
    5086: "タスクのハンドオフ作成の呼び出しができませんでした。",
    5087: "タスクのパッチの呼び出しができませんでした。",
    5088: "このタスクにはハンドオフするためのエビデンスが含まれる必要があります。再試行するかヘルプデスクに連絡してください。",
    5089: "このタスクに関連する全てのエビデンス（ペーパープロファイルを除く）には完了とマークするために少なくとも1人の実施者と査閲者が必要です。再試行し、問題が解決しない場合は、ヘルプデスクまでお問い合わせください。",
    5091: "エンゲージメントにはこのペーパープロファイル名が既に存在します。",
    5092: "名前に次の文字を含めることはできません：*/:<>\\?|\\",
    5093: "ペーパープロファイル名が最大文字数（全角60字、半角100字）を超えています。",
    5101: "タスクの作成に失敗しました。",
    5102: "タスクの説明がありません。",
    5103: "タスクのタイトルがありません。",
    5104: "タスクのタイムフェーズがありません。",
    5105: "タスクの関連付けを編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5106: "監査フェーズが無効です。",
    5107: "監査フェーズは「スコープ及び戦略」、「実施」のどちらかである必要があります。",
    5108: "タスクの説明が長すぎます。",
    5109: "ロールタイプパラメーターが無効です。",
    5110: "割当てIDはゼロより大きい必要があります。",
    5111: "タスクに関連付けようとしている項目は削除されています。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5112: "タスクに関連付けようとしている項目は削除されています。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5113: "タスクに関連付けようとしている項目は削除されています。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5116: "ドキュメントタイプが無効です。",
    5119: "選択された1つ以上のタスクのステータスがアップデートされませんでした。ページを更新して、再試行してください。エラーが継続する場合はヘルプデスクにご連絡ください。",
    5127: "関連付けが完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5129: "関連付けが完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5133: "関連付けが完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5137: "タスクの関連付けを編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5138: "タスクの関連付けを編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5140: "タスクの関連付けを編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5146: "タスクに完了マークを付すには、全ての関連エビデンス（ペーパープロファイルは除く）に1人以上の作成者及び査閲者のサインオフが必要です。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5150: "1つ以上のオートメーションは選択したタスクに関連付けることができません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5156: "タスクの関連付けを編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5157: "タスクの関連付けを編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5159: "共有文書タイプが無効です。",
    5160: "文書をリンクする際にエラーが発生しました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5174: "タスクは1つ以上のエンティティに関連付ける必要があります。エンゲージメント全体のタスクとするには、エンティティトグルでタスクを変更してください。",
    5184: "タスクタイプは主要標準タスク又は主要実証手続タスクではありません。",
    5185: "EY Canvasから配信された文書を含むPSTsは差戻しできません。",
    5188: "無効な文書又はリンク解除中",
    5189: "タスクにはリンクされたエビデンス又はリンクされた回答が添付されています。",
    5190: "タスクには少なくとも1つのアサーションが必要です。",
    5191: "関連付けを完了できません。ページを更新して再試行してください。問題が解消しない場合には、ヘルプデスクに連絡してください。",
    5192: "タスクに関連付けようとしている項目は削除されています。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    5193: "選択された項目は削除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",


    /*WCGW*/
    6001: "WCGWの作成の呼び出しに失敗しました。",
    6002: "WCGW名がありません。",
    6003: "WCGWがありません。",
    6004: "WCGW取得の呼び出しができませんでした。",
    6005: "無効なエンゲージメントIDです。",
    6006: "アサーションIDが無効又は削除されているため、リクエストされたアクションが完了できませんでした。ページを更新し再試行してください。",
    6007: "IDによるWCGW取得の呼び出しに失敗しました。",
    6008: "無効なリクエストです。",
    6009: "WCGW IDが無効又は削除されているため、リクエストされたアクションを完了できませんでした。ページを更新し再試行してください。",
    6010: "タスクをWCGWに関連付けできませんでした。",
    6011: "選択されたWCGWは削除されました。",
    6012: "タスク及びWCGWは同じアサーションと関連していません。",
    6013: "選択されたタスクは同じエンゲージメントに属していません。",
    6014: "WCGWよりタスクの関連付けを解除できませんでした。",
    6015: "タスクをWCGWに関連付けできませんでした。",
    6016: "タスクは差戻しされたため、WCGWに関連付けできません。",
    6017: "タスクはマイルストーンタスクではないため、WCGWに関連付けできません。",
    6018: "タスクがビルドステップタスクではないため、WCGWに関連づけることができません。",
    6019: "タスクはPSP又はOSPではないため、WCGWに関連付けできません。",
    6020: "タスクとWCGWは同じアサーションに関連付けられており、WCGWに関連付けることはできません。",
    6027: "無効なWCGW ID又は統制IDです。",
    6028: "関連付けを完了できません。ページを更新して再試行してください。問題が解消しない場合には、ヘルプデスクに連絡してください。",
    6029: "削除を完了できません。ページを更新して再試行してください。問題が解消しない場合には、ヘルプデスクに連絡してください。",

    /*Engagement*/
    7001: "IDによる取得が見つかりませんでした。",
    7002: "ワークスペースIDによるエンゲージメントの取得の呼び出しができませんでした。",
    7003: "全てのエンゲージメントの企業の取得の呼び出しができませんでした。",
    7004: "IDによるエンゲージメントの取得の呼び出しができませんでした。",
    7005: "全てのユーザーの取得の呼び出しができませんでした。",
    7006: "姓は250文字を超えてはなりません。",
    7007: "無効なユーザータイプエラー。",
    7008: "名は250文字を超えてはなりません。",
    7009: "ユーザーGUIは空白にできません。",
    7010: "無効なユーザーステータスエラー。",
    7011: "エンゲージメントユーザー作成のコールが失敗しました。",
    7012: "{0} {1} 既にアクティブまたは保留中のチームメンバーであるためインバイトすることができません。",
    7013: "イニシャルは3文字を超えてはなりません。",
    7014: "EY Canvasのランディングページにアクセスできません。再試行しても問題が解決しない場合は、ヘルプデスクに連絡してください。",
    7015: "{0} {1}は以下のアクセスグループであるため、インバイトできません：{2}はエンゲージメントから削除されています。更新して、再試行してください。",
    7016: "{0} {1}は、ユーザーが既に次のアクセスグループのアクティブなチームメンバーであるためインバイトできません：{2}",
    7017: "選択したグループにはドメインは許可されていません：{0}",
    7018: "Eメールアドレスを空白にすることはできません。",
    7019: "名（First Name）を空白にすることはできません。",
    7020: "姓（Last Name）を空白にすることはできません。",
    7021: "ユーザーのイニシャルを空白にすることはできません。",
    7022: "ユーザーのプライマリーオフィスを空白にすることはできません。",
    7023: "ユーザーのログイン名を空白にすることはできません。",
    7024: "ユーザーのEYロールを空白にすることはできません。",
    7025: "ユーザーのエンゲージメントロールを空白にすることはできません。",
    7026: "操作を完了できません。再試行しても問題が解消しない場合は、ITサービスデスクにご連絡ください。",
    7027: "無効なEメールアドレス",
    7028: "パッチエンゲージメントユーザーのコールが失敗しました。",
    7029: "エンゲージメントユーザー - 無効なエンゲージメントユーザーステータスID。",
    7030: "エンゲージメントユーザー - 無効なエンゲージメントユーザーロールID。",
    7031: "1つ以上のエンゲージメントユーザーIDが見つかりません。",
    7032: "Eメールアドレスは250文字以下にする必要があります。",
    7033: "要求されたユーザーを空白にすることはできません。",
    7034: "ユニバーサルメッセージプロセッサーキューが失敗しました。",
    7035: "イニシャルは3文字を超えてはなりません。",
    7036: "名は250文字を超えてはなりません。",
    7037: "姓は250文字を超えてはなりません。",
    7038: "外部ユーザー作成のコールが失敗しました。",
    7039: "1人以上のユーザーが既にアクティブまたは保留中のチームメンバーであるためインバイトできません。ページを更新し再試行してください。問題が解消しない場合には、ヘルプデスクに連絡してください。",
    7040: "名は250文字を超えてはなりません。",
    7041: "姓は250文字を超えてはなりません。",
    7042: "イニシャルは3文字を超えてはなりません。",
    7043: "GPNは250文字以下にする必要があります。",
    7044: "GUIは250文字以下にする必要があります。",
    7045: "IDによる外部ユーザーの取得に失敗しました。",
    7046: "ユーザー名を空白にすることはできません。",
    7047: "変更を保存できません。再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    7048: "EY Canvas Landing Pageは現在アクセスできず、編集する必要があります。もう一度お試しください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    7049: "エンゲージメントユーザー更新のコールが失敗しました。",
    7050: "メンバーを非アクティブ化することはできません。エンゲージメントには、エンゲージメントを管理する権限を持つメンバーが少なくとも1人必要です。選択内容を更新して、再試行してください。問題が解決しない場合は、ITサービスデスクにご連絡ください。",
    7051: "IDによる内部ユーザーの取得に失敗しました。",
    7052: "ユーザーが見つかりません。",
    7053: "IDで取得できません。",
    7054: "エンゲージメントIDによるクイックリンクの取得に失敗しました。",
    7055: "以前のメンバーを追加する権限がありません。このアクションを実行する適切な権限を持つエンゲージメントチームメンバーに連絡してください。",
    7056: "EY Canvasで変更を保存できませんでした。再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    7057: "新しいメンバーを追加する権限がありません。このアクションを実行する適切な権限を持つエンゲージメントチームメンバーに連絡してください。",
    7058: "ユーザーのステータスが変更されました。ページを更新して、もう一度お試しください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",
    7062: "EY Canvas Client Portalは現在利用できず、既存のメンバーの情報を更新する必要があります。再試行しても問題が解決しない場合は、ヘルプデスクに連絡してください。",
    7063: "外部メンバーを非アクティブ化できません。ページを更新して再試行してください。問題が解決しない場合は、ヘルプデスクに連絡してください。",
    7064: "無効なパッチ操作。",
    7065: "{0} {1}は1つ以上のアクセスグループでアクティブ化できません。選択したグループではドメインは許可されていません：{2}。",
    7066: "{0} は有効なユーザーではありません。",
    7067: "外部ユーザーの呼び出しに失敗しました。",
    7068: "EY Canvas Client Portalは現在利用できず、既存のメンバーの情報を更新する必要があります。再試行しても問題が解決しない場合は、ヘルプデスクに連絡してください。",
    7069: "選択したアクセスグループはアクティブではありません：{0}。削除してもう一度お試しください。",
    7072: "エンゲージメント解除中にエラーが発生しました。ページを更新して、再試行してください。エラーが解決しない場合は、ヘルプデスクにお問い合わせください。",
    7074: "変更は保存できません。エンゲージメント管理権限を有し独立性を完了しているアクティブ・メンバーが最低１名必要です。問題が解決しない場合、ヘルプデスクに連絡してください。",
    7075: "{0} {1} はインバイトできません。既にチームメンバーとしてアクティブです。",
    7077: "1名以上のユーザーを非アクティブ化できません。ページを更新して再試行してください。問題が継続する場合はヘルプデスクに連絡してください。",
    7079: "ドメインが許可されていません。エラーが解消しない場合には、ヘルプデスクに連絡してください。",
    7080: "第三者をインバイトする権限がありません。ページを更新して、再試行してください。問題が解決しない場合は、ヘルプデスクに連絡して、権限を取得してください（適切な場合）。 ",
    7094: "選択したチームメンバーはこのエンゲージメントの文書にサインオフしており、削除できません。",
    7100: "制限されたフィールドへの編集処理ができません。ページを更新し再試行してください。",

    /*SCOT*/
    8001: "SCOTの作成の呼び出しに失敗しました。",
    8002: "SCOT名がありません。",
    8003: "SCOTがありません。",
    8004: "SCOT取得の呼び出しができませんでした。",
    8005: "無効なエンゲージメントIDです。",
    8006: "無効なアサーションIDです。",
    8007: "IDによるSCOT取得の呼び出しに失敗しました。",
    8008: "無効なリクエストです。",
    8009: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
    8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',

    /*User*/
    10001: "ログインしているユーザー設定が見つかりません。",
    10002: "ユーザーの全ての取得の呼び出しができませんでした。",
    10003: "ユーザーの存在の取得の呼び出しができませんでした。",

    /*Risk Type*/
    11001: "無効な作成リクエストです。",
    11002: "リスクタイプ名がありません。",
    11003: "リスクタイプがありません。",
    11004: "リスクタイプの呼び出しができませんでした。",
    11005: "無効なエンゲージメントIDです。",

    /* Annotation Errors*/
    12001: "無効なリクエストのパラメーターです。",
    12002: "注釈の作成の呼び出しができませんでした。",
    12003: "注釈の取得ができませんでした。",
    12004: "無効なエンゲージメントID",
    12005: "コレクション内のIDはゼロよりも大きい必要があります。",
    12006: "コレクション内のIDはゼロよりも大きい必要があります。",
    12007: "無効なタスクID",
    12008: "無効な文書ID",
    12009: "有効な文書ID、タスクIDまたは財務諸表IDが必要です。",
    12010: "返信には親が必要です。",
    12011: "無効なステータスID",
    12012: "ドキュメントタイプは440GLである必要があります。",
    12013: "無効な注釈タイプです。",
    12014: "無効なエンゲージメントユーザーです。",
    12015: "この文書は別のユーザーによって削除されました。",
    12016: "注釈の更新の呼び出しができませんでした。",
    12017: "回答しようとしているノートは別のチームメンバーにより削除済みです。ページを更新し再試行してください。",
    12018: "注釈変更アクションタイプはNullであってはなりません。",
    12019: "レビューノートが削除されました。",
    12020: "無効なアクションです。",
    12021: "ユーザーは注釈の作成者ではありません。",
    12022: "作成者のユーザーが見つかりません。",
    12023: "作成者のユーザーがいないかエンゲージメントに含まれていません。",
    12024: "割り当てられたユーザーが必要です。",
    12025: "作成者のユーザーがいないかエンゲージメントに含まれていません。",
    12026: "無効なノート",
    12027: "ノートは空欄にできません。",
    12028: "期日は必須です。",
    12029: "有効な優先度が必須です。",
    12030: "ノートのステータスは変更されており編集や返答は実施できません。ウィンドウを一旦閉じて再度開くことで更新されたデータの閲覧および編集を実施してください",
    12031: "注釈は一番上である必要があります。",
    12032: "注釈は一番上であってはなりません。",
    12033: "次の値の少なくとも１つ以上が空の優先タイプ、期日、ステータス又は割当てユーザーであってはなりません。",
    12034: "ノートの文字数は4,000字以内となります。",
    12035: "検索文字が最大文字数（半角500文字、全角250文字）を超えています。",
    12036: "タスクIDか文書IDを受け入れる必要があり、両方は認められていません。",
    12037: "パッチオペレーションは無効です。",
    12038: "編集したいノートは存在しません。ページを更新し再試行してください。",
    12039: "他のチームメンバーと同じノートを編集しようとしています。ページを更新して再試行してください。",
    12040: "注釈ユーザー取得の呼び出しができませんでした。",
    12041: "注釈ユーザー取得ができませんでした。無効なクエリ値です。",
    12042: "文書タイプは注釈を作成するには有効ではありません。",
    12043: "既に存在しないタスク又は文書に関するノートを追加しようとしています。ページを更新して再試行してください。",
    12044: "編集したい返答は存在しません。ページを更新し再試行してください。",
    12045: "レビューノートが見つかりません。",
    12046: "削除したいノートは他のチームメンバーにより既に削除されています。ページを更新し再試行してください。",
    12047: "オープンステータスのノートに対する返答のみ削除できます。ページを更新し再試行してください。",
    12048: "ステータスを変更したい返答は存在しません。ページを更新し再試行してください。",
    12049: "他のチームメンバーにより削除済みのノートについて返答を削除しようとしています。ページを更新し、再試行してください。",
    12050: "ステータスが「クローズ済」となっているノートしか削除できません。",
    12059: "レビューノートは作成者のみが削除できます。",
    12066: "オープンノートのみ返答できます。",
    12067: "別のチームメンバーにより削除済みのコメントへの返答を削除しようとしています。ページを更新し再試行してください。",
    12068: "コメントを追加することができません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    12070: "財務諸表ごとに1つのコメントのみ追加可能です。既存のコメントを編集してください。",
    12071: "情報を削除するのに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /*Configuration*/
    13001: "構成は見つかりません。",
    13002: "構成の取得のAPIコールが失敗しました。",

    /*Documents*/
    14001: "リクエストがNull値であるため呼び出しができません。",
    14002: "文書が見つかりません。呼び出しができませんでした。",
    14003: "エンゲージメントIDはゼロより大きい必要があります。",
    14004: "ドキュメントIDはNull値または空にすることはできません。",
    14005: "関連するタスクの取得中にエラーが発生しました。コールが失敗しました。",
    14006: "選択した文書は削除できません。後でもう一度試してみてください。問題が解決しない場合は、ヘルプデスクまでお問い合わせください。",
    14007: "予期しないエラーが発生しました。",
    14008: "サインオフ中に予期しない問題が発生しました。",
    14009: "サインオフの追加中にエラーが発生しました。",
    14010: "承認IDはゼロより大きい必要があります。",
    14011: "サインオフの削除中にエラーが発生しました。",
    14012: "本文は空欄にできません。",
    14013: "選択した文書はリンクを解除できません。後で再試行してください。問題が解決しない場合は、ヘルプデスクに連絡してください。",
    14014: "文書IDによるアカウントの取得に失敗しました。",
    14015: "無効な関連エンティティ。",
    14016: "文書の承認の取得の呼び出しができませんでした。",
    14017: "全ての文書の検出事項の取得の呼び出しができませんでした。",
    14018: "全ての文書の取得の呼び出しができませんでした。",
    14019: "サインオフが見つかりません。",
    14020: "無効なアクション値です。",
    14021: "無効な発見事項タイプです。",
    14022: "文書はエンゲージメントに含まれません。",
    14023: "文書変更タイプが有効ではありません。",
    14024: "全ての文書の取得の呼び出しに失敗しました。パラメーターは有効ではありません。",
    14025: "文書レビューの作成中にエラーが発生しました。 APIコールが失敗しました。",
    14026: "文書レビューの削除中にエラーが発生しました。 APIコールが失敗しました。",
    14027: "エンゲージメントIDは空白にすることはできません。",
    14028: "ユーザーIDが無効です。",
    14029: "ユーザーはこのアクションをするための認証が行われていません。",
    14030: "渡されたIDの文書はこのエンゲージメントで見つかりませんでした。",
    14031: "ドキュメントレビューIDが無効です。",
    14032: "文書レビューが見つかりません。",
    14033: "文書は既に承認されています。",
    14034: "ワークスペースにある他のエンゲージメントとのリンク解除中であるか、この文書は既にリンク解除されています。ページを更新し再試行してください。問題が解消しない場合には、ヘルプデスクに連絡してください。",
    14035: "その文書は指定されたエンゲージメントには共有されていません。",
    14036: "バージョン番号をゼロより大きい必要があります。",
    14037: "操作を完了できません。ページを更新して、再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください",
    14038: "文書の変更理由を取得できませんでした。",
    14039: "IDによる文書変更理由の取得に失敗しました。",
    14040: "変更理由の更新に失敗しました。",
    14041: "無効な変更理由。",
    14042: "変更理由の更新に失敗しました。",
    14043: "変更理由の作成に失敗しました。",
    14044: "変更理由の削除に失敗しました。",
    14045: "無効な変更理由ID。",
    14046: "文書は利用できません。ページを更新して、再試行してください。問題が解決しない場合は、ITサービスデスクにご連絡ください。",
    14047: "文書には既に変更理由が割当てられています。",
    14048: "文書に競合が生じています。続行する前に解消してください。",
    14049: "文書がチームまたはユーザに追加されたかをチェックするための無効なデータ。",
    14050: "参照文書の削除中にエラーが発生しました。",
    14051: "すべての共有エビデンスのリンク解除チェックリストが見つかりません。",
    14052: "検索テキストが最大長（500文字）を超えています。",
    14053: "リクエストがNull値であるため、呼び出しを実行できません。",
    14054: "無効なパッチ操作。",
    14055: "文書履歴の呼び出し復旧に失敗しました。",
    14056: "メッセージをキューに入れようとしたときにエラーが発生しました。",
    14057: "このエンゲージメントには、同じ名前の文書が既に存在します。",
    14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
    14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
    14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
    14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
    14062: 'The document confidentiality type id is not valid.',
    14063: 'Cannot change confidentiality type of this document type.',
    14064: 'User doesnt have permission.',
    14065: 'Invalid custom description.',
    14066: 'Failed to update extension.',
    14067: 'Invalid extension.',
    14068: 'Failed to get document extensions.',
    14069: "この文書は別のチームメンバーによりリンク解除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    14070: "無効なファイルタイプ",
    14071: "選択した文書バージョンは利用できません。文書の最新の履歴のバージョンを表示するには、このウィンドウを閉じてから再度開いてください。",
    14072: 'Source document Id should not be null or empty.',
    14073: 'Canvas form ids should not be null or empty.',
    14074: "Canvas form ID's should not be duplicates.",
    14075: 'Failed to associate document to canvas forms.',
    14076: "関連ソース文書付きのCanvasフォームがありません。",
    14077: 'Source document not found. Call failed.',
    14078: 'Current document is already associated with given canvas forms.',
    14079: "この文書は削除済のため開くことができません。",
    14080: 'The source approval user id is invalid.',
    14081: 'The source approval user id should valid GUID and must not be empty GUID.',
    14082: 'The modify user id is invalid.',
    14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
    14084: 'File name cannot include: */:<>\\?|""',
    14085: 'The document name exceeded maximum length allowed.',
    14086: 'DocService failed while updating document details.',
    14087: 'The input is not valid.',
    14088: 'A input has duplicate document names.',
    14089: "ブックマーク所見が無効です。",
    14090: "リクエストステータスが変更されました。必要な場合には、ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    14091: "このリクエストが削除されました。ページを更新し、アップデートされたデータを表示してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

    /*SEM*/
    15001: "無効なリクエストによって、勘定科目IDに対するSEMサマリー取得の呼び出しに失敗しました",
    15002: "無効な勘定科目IDです。",
    15003: "無効なエンゲージメントIDです。",
    15004: "無効なサマリータイプです。",
    15005: "関連する勘定科目が見つけられませんでした。ページを更新して再試行してください。問題が解決しない場合は、ヘルプデスクにお問い合わせください。",

    /*Timephase*/
    16001: "タイムフェーズの取得ができませんでした。",
    16002: "エンゲージメントはゼロよりも大きい必要があります。",
    16003: "タイムフェーズはゼロよりも大きい必要があります。",
    16004: "無効なタスクID値です。",
    16005: "無効なタイムフェーズ値です。",

    /*Validations*/
    17001: "ビルドステップIDまたは文書タイプIDがありません。",

    /*TaskGroupSection*/
    18001: "全てのタスクグループグループの呼び出しに失敗しました。",
    18005: "このタスクグループはこのエンゲージメントで使用できなくなりました。",
    18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    18016: "タスクグループは関連付けられたタスクがない場合のみ削除できます。関連付けられたタスクを削除、もしくは変更して再試行してください。",
    18019: "アップデートしようとしているタスクグループはすでに削除されています。",

    /*Assignments*/
    19001: "割当ての作成の呼び出しができませんでした。",
    19002: "割当ての取得の呼び出しができませんでした。",
    19003: "割当て名は一意である必要があります。",
    19004: "無効な割当て名",
    19005: "割当て名が100文字を超えています",
    19006: "無効な割当てタイプ",
    19007: "割当ての検索テキストが500文字を超えています。 ",
    19008: "この割当て名は、他のチームメンバーによって削除されました。ページを更新して、再試行してください。 ",

    19012: "タスクIDは繰返しができません。",
    19013: "役割IDフィールドとユーザーIDフィールドに同時に値を設定することはできません。",
    19014: "ユーザーIDをデフォルト値にすることはできません。",
    19016: "PICユーザーが無効であるかPICユーザーがインバイトされていません。",
    19017: "EQR ユーザーが無効であるかEQR ユーザーがインバイトされていません。",
    19018: "期日の値は0より大きく1000未満で入力してください。",
    19019: "タスクの自動割当ての作成に失敗しました。",

    /*Client Request*/
    21001: "リクエストはEY Canvas Client Portalに送信できませんせした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    21002: "このリクエストは削除済です。ページを更新し更新データを確認します。エラーが続く場合は、ヘルプデスクに連絡してください。",
    21009: "クライアントリクエストの文書削除の呼び出しに失敗しました。",
    21010: "返信しようとしているコメントは他のチームメンバーにより削除されています。ページを更新して、再試行してください。",
    21011: "クライアントリクエストの文書は削除されました。",
    21012: "クライアントリクエストの文書が見つかりません。",
    21013: "文書リクエストが空です。",
    21014: "文書idが空です。",
    21015: "クライアントリクエストidが空です。",
    21016: "クライアントリクエストの文書作成の呼び出しに失敗しました。",
    21017: "1つ以上の関連付けられた文書がエンゲージメントから削除されました。このリクエストから削除された文書を取除くか、ページを更新し再試行してください。",
    21018: "文書が見つかりません。",
    21019: "クライアントリクエストのステータスが 変更されました。",
    21030: "クライアントグループIDが一致しません。",
    21031: "リクエストステータスが変更されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    21032: "クライアントグループ担当ユーザーはアクティブでありません。",
    21033: "クライアントグループはアクティブでありません。",
    21034: "クライアントグループにアクティブなユーザーはいません。",
    21045: "リクエストステータスが変更されました。ページを更新し最新の変更を確認してください。",
    21046: "リクエストはEY Canvas Client Portalに送信できませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    21050: "リクエストは削除できませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    21053: "エンゲージメントで利用可能なタスクはありません。ページを更新しリストを更新してください。",
    21057: "EY担当者の割当てができませんでした。ページを更新し再試行してください。",
    21028: "期日は必須です。",
    21036: "タイムフェーズは見つかりませんでした。",
    21064: "タスクのリクエストへの関連付けはできません。リクエストは最大25件のタスクへの割当てができます。1つ以上の関連タスクをリムーブし新規のものを関連付けてください。",
    21065: "1つ以上の機密文書がリクエストに追加されました。EY Canvas Client Portalに1つ以上のこれらの文書を送信するための適切な機密性レベルを有していません。続行するには、アクセス権のない機密文書を全て削除してください。",
    21066: "データ取得中にエラーが発生しました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    21067: "優先度が更新できませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    21035: "クライアントリクエストが見つかりません。",
    21074: "受領したリクエストについてはタイトル、説明、優先度を変更することはできません。",
    21075: "承認されたリクエストについてはタイトル、説明、割当て（グループ）、割当て（ユーザー）、期日、優先度を変更することはできません。",
    21077: "受領済み又は未受領のクライアントリクエストは期日が必須です。",
    21039: "クライアントグループIDが見つかりません。",
    21078: "グループへの割当て又はユーザーへの割当ての更新の際は、グループ名及びユーザー名が必須です。",
    21079: "日付フォーマットが無効です。",
    21027: "リクエストタイトルは必須です。",
    21041: "リクエストタイトルの長さが最大文字数を超えています。",
    21042: "リクエストの説明の長さが最大文字数を超えています。",
    21060: "クライアントユーザーIDが空欄です。",
    21076: "優先度タイプは許可されていません。",

    /* Group Components*/
    22001: "関連する構成単位取得の呼び出しができませんでした。",
    22002: "グループ構成単位の取得の呼び出しに失敗しました。",
    22003: "グループ構成単位の作成の呼び出しに失敗しました。",
    22004: "無効な親構成単位ID。特定された親構成単位は存在しません。",
    22005: "チーム名は最大文字数を超えています。",
    22006: "チーム法人名は最大文字数を超えています。",
    22008: "特定されたスコープは存在しません。",
    22009: "無効な構成単位略称",
    22010: "無効な構成単位法人名",
    22011: "無効な構成単位スコープID",
    22012: "連絡先のEメールアドレスが入力された場合、担当者のGUIDはNull値または空欄にできません。",
    22013: "連絡先のEメールアドレスが入力された場合、担当者名はNull値または空欄にできません。",
    22016: "このチームは別のチームメンバーにより削除されました。ページを更新し再試行してください。",
    22022: "このエンゲージメントのチーム名は既に存在します。",
    22043: "インストラクションの送信要求ができませんでした。",

    /*User Presence*/
    23001: "ログインしているユーザーの存在が見つかりません。",
    23002: "ユーザープロファイル取得の呼び出しができませんでした。",
    23003: "ユーザーの存在の文書の検証ができませんでした。",
    23004: "ユーザーの存在の削除の呼び出しができませんでした。",
    23005: "文書は他のユーザーによって利用されていません。ページを更新し再試行してください。問題が解決しない場合には、ヘルプデスクにお問い合わせください。",

    /* Forms */
    24001: "フォーム取得の呼び出しができませんでした。",
    24002: "無効なエンゲージメントIDです。",
    24003: "ドキュメントIDはNull値または空にすることはできません。",
    24004: "無効な文書IDです。",
    24005: "無効なフォームのヘッダーIDです。",
    24006: "無効なフォームのセクションIDです。",
    24007: "無効なリクエストのパラメーターです。",
    24008: "ヘッダーIDはNull値または空にすることはできません。",
    24009: "セクションIDはNull値または空にすることはできません。",
    24010: "フォーム本文の回答更新オペレーションに失敗しました。",
    24011: "フォーム本文の回答更新についての無効なリクエストです。",
    24012: "無効な本文IDです。",
    24013: "無効なフォーム本文のオプションIDです。",
    24014: "無効なフォーム本文のタイプIDです。",
    24015: "所与の本文タイプIDに対して無効なリクエストの本文です。",
    24016: "所与の本文タイプIDに対して無効な自由テキストです。",
    24017: "最大文字数を超過しています（リッチテキスト形式のタグを含む）。文字列を短くするか、不要な形式を削除し、再試行してください。",
    24018: "本文IDへの返答は許可されていません。",
    24019: "本文IDはNull値または空にすることはできません。",
    24020: "リクエスト本文か無効です",
    24021: "本文は必須です",
    24038: "文書が無効か存在していません。",
    24049: "選択されたオブジェクトは削除されています。ページを更新し、再試行してください。エラーが解消しない場合には、ヘルプデスクに連絡してください。",
    24057: "文書フォームプロファイルの検証ができません。",
    24063: "国IDが無効です。",
    24064: "言語IDが無効です。",

    /*Document Change Types*/
    25001: "文書変更タイプの取得のコールが失敗しました。",
    25002: "無効なエンゲージメントID。",
    25003: "無効なリクエスト。",

    /* Manage team */
    26001: "クライアントユーザーグループの全取得のコールが失敗しました。",
    26002: "新しいクライアントグループの作成/メールドメインのコールが失敗しました。",
    26003: "グループ名を空白にすることはできません。",
    26004: "メールドメインを空白にすることはできません。",
    26005: "{0}メールドメインラベルは263文字を超えてはなりません。",
    26006: "{0}メールドメインは263文字を超えてはなりません。",
    26007: "{0}メールドメインの最初の部分は*または英数字にすることができますが、その他の特殊文字は使用できません。",
    26008: "{0} 冒頭部分がワイルドカードである場合、2つ以上のラベル構成となる必要があります。",
    26009: "{0} 冒頭部分は*または英数字にすることができますが、他のドメイン部分には特殊文字を使用できません。",
    26010: "メールドメインは一意である必要があります。",
    26011: "指定されたクライアントアクセスグループIDは無効です。",
    26012: "アクセスグループの削除中にエラーが発生しました。このグループまたはこのグループのメンバーに割当てられているリクエスト/外部タスクがないことを確認して、再試行してください。",
    26013: "アクセスグループは既に削除されています。ページを更新して最新のデータを取得してください。",
    26014: "1つ以上のEメールドメインが必要です。",
    26015: "EY Canvas Client Portalは現在利用できず、既存のメンバーの情報を更新する必要があります。再試行しても問題が解決しない場合は、ヘルプデスクに連絡してください。",
    26016: "削除中にエラーが発生しました。",
    26017: "データ取得に失敗しました。",
    26018: "同時実行のため問題が生じました。アクセスグループは既にアクティブではありません。ページを更新して、再試行してください。",
    26019: "保存に失敗しました。",
    26020: "アクティブなユーザーが割当てられているEメールのドメインを削除することはできません。変更は保存されませんでした。",


    /* TimePhaseTypes - Milestones */
    27001: "マイルストーンの内容の取得ができませんでした。",

    /*Client Request Counts*/
    28001: "クライアントリクエスト情報の取得のコールからは何も見つかりませんでした。",

    /*Content updates Error messages*/
    29001: "IDで取得できません。",
    29002: "アクションタイプが見つかりません。",
    29003: "コンテンツIDが見つかりません。",
    29004: "コンテンツ更新APIコールが失敗しました。",
    29005: "コンテンツを更新しています。後ほど再試行してください。それでも問題が解消しない場合には、ヘルプデスクに連絡してください。",
    29006: "無効なリクエストパラメーター。",
    29010: "コンテンツを更新しています。後で再試行してください。長時間問題が継続する場合は、ITヘルプデスクに連絡してください。",
    29012: "エンゲージメントに、該当する標準プロファイルの質問がありません。ヘルプデスクに連絡してください。",
    29013: "EY Canvas FITイネーブルメントアクティビティが共有されている場合、主要標準タスク（PST）とプロファイルのコンテンツ更新は利用できません。PSTまたはプロファイルのコンテンツを更新するにはこれらのアクティビティのリンクを解除してください。複数のコンテンツ更新タイプが選択された場合、主要標準タスク（PST）及び/又はプロファイルの選択を解除し、更新を再度実施してください。",
    /*IT Process*/
    30001: "すべてのITプロセスの取得に失敗しました。",
    30002: "すべてのITプロセスを取得-無効なエンゲージメントID。",
    30003: "ITプロセス名は空にできません。",
    30004: "ITプロセス名の最大文字数は500字としてください。",
    30005: "ITプロセスIDは無効です。",
    30006: "IDごとのITプロセスの取得の呼び出しに失敗しました。",
    30007: "無効なリクエスト",
    30008: "ITプロセスが無効です。",
    30009: "文書が見つかりませんでした。",
    30010: "ITプロセスの削除に失敗しました。",
    30012: "無効なITリスク",

    /*Checklist*/
    31001: "すべてのチェックリストの取得のコールが失敗しました。",
    31002: "チェックリストのコールが失敗しました。",
    31003: "無効なチェックリストパラメーター。",
    31004: "無効なエンゲージメントエラー。",
    31005: "無効なリクエストパラメーターエラー。",
    31006: "無効なチェックリクエストパラメーターエラー。",

    /*Archive*/
    32001: "エンゲージメントステータスが無効です。バリデーションを解決しアーカイブプロセスを再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32002: "フォーム本文の表示ステータスの更新中にアーカイブに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32003: "エンゲージメントステータスの更新中にアーカイブに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32004: "エンゲージメントキャッシュの無効化中にアーカイブに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32005: "コンテンツ更新中です。更新完了までこのエンゲージメントはアーカイブできません。後ほど再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32006: "このエンゲージメントに未解決のバリデーションがあります。ページを更新しバリデーションを解決しアーカイプロセスを再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32007: "ARCリクエストモデル構築中にアーカイブに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32008: "Arc API URL取得中にアーカイブに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32009: "Arc API 呼び出しの実行中にアーカイブに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32010: "Arc API レスポンスにデータがないためアーカイブに失敗しました。再試行してください。エラーが続く場合はヘルプデスクに連絡してください。",
    32011: "Arc フォームの詳細の保存中にアーカイブに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32012: "再試行のためのエンゲージメントステータス更新中にアーカイブに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32013: "アーカイブメッセージのキューイング中にアーカイブに失敗しました。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32014: "アーカイブは成功しましたが、 Universal status update messageのキューイング中にエラーが発生しました。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32015: "アーカイブは成功しましたが、  CCP status update messageのキューイング中にエラーが発生しました。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32016: "アーカイブ処理を再試行するには、エンゲージメントステータスがアーカイブエラーである必要があります。",
    32017: "エンゲージメントは見つかりませんでした。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32019: "現在あなたのリクエストを処理することができません。再試行し、エラーが続く場合は、EYサポートに連絡してください。",
    32020: "ARC URLが構成されていません。再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32200: "エンゲージメントに未解消のバリデーションがあります。レポーティングハブからバリデーションチェックを実施してください。更なる詳細についてはMoreメニューのバリデーションヘルプ機能を参照してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    32400: "ARCシステムとのコミュニケーション中に下記エラーが発生しました。ヘルプデスクに連絡しこのエラーを報告し続行してください。",

    /*RBAC*/
    33001: "エンゲージメントIDが見つかりません。",
    33002: "ユーザーIDが見つかりません。",

    /*Helix Linked Projects*/
    34001: "EY Helix Projectはリンク解除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    34002: "エンゲージメントIDはNull値や空にできません。",
    34003: "コールで本文を空白にすることはできません。",
    34004: "プロジェクトIDをNull値または空にすることはできません。",
    34005: "プロジェクト名をNull値または空にすることはできません。",
    34006: "EY Helix Projectはリンク解除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    34007: "すべてのHelixプロジェクト取得のコールが失敗しました。",
    34008: "エンゲージメントIDはゼロより大きい必要があります。",
    34009: "操作が完了できませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    34020: "Helixプロジェクトにリンクすることができませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    34024: "Helixに通知を送付できませんでした。プロジェクトのリージョン情報がありません。",
    34029: "プロジェクトのロケーションがEY Canvasエンゲージメントのロケーションと一致しないため、プロジェクトがリンクされていません。",
    34030: "アナライザーはリンクできません。選択されたアナライザーへチームメンバーとしてのアクセス権がありません。EY Helixプロジェクト管理者へ連絡し再試行してください。 ",
    34031: "EY Helixアプリケーションにアクセスしたことがないようです。",
    34038: "選択したアナリティクスは利用できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    34043: "`選択したEY Helixプロジェクトは利用できなくなりました。 'Link project'をクリックし別のプロジェクトをリンクします。",
    34044: "選択したEY Helixプロジェクトは削除対象とマークされています。「プロジェクトのリンク付け」をクリックして別のプロジェクトにリンク付けしてください。",
    34045: "選択したEY Helixプロジェクトは保存対象とマークされています。「プロジェクトのリンク付け」をクリックして別のプロジェクトにリンク付けしてください。",
    34046: "`EY Helixのアナライザーが無効または欠落しています。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    34047: "`選択したアナライザーはEY Helixでは利用できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    34048: "`リンクされたプロジェクトではアナリティクスは利用できません。 EY Helixに移動し、データと分析の処理手順を完了して続行します。",
    34080: "エンゲージメントのHelix接続の最大数を超過しています。",

    /* PAANS */
    35001: "現在EYポリシーの作成、承認、通知サービスは利用できません。関連するすべてのポリシーが完了したかどうかを確認できません。関連ポリシーをまだレビューしていない場合は、ページを更新して再試行してください。問題が継続する場合はヘルプデスクにご連絡ください。",

    /*Engagement Comments*/
    38001: "エンゲージメントコメントの作成に失敗しました。",
    38002: "全てのエンゲージメントコメントの取得に失敗しました。",
    38003: "このアクションを完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    38004: "このアクションを完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    38005: "このアクションを完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    38006: "このアクションを完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    38007: "このアクションを完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    38008: "このアクションを完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    38009: "このアクションを完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    38010: "本文をNull値にできません。",
    38011: "コメント文書をNull値または空欄にできません。",
    38012: "このエンゲージメントにおいてエンティティが存在しません。",
    38013: "エンゲージメントコメントステータスIDは0より大きな値にする必要があります。",
    38014: "親エンゲージメントコメントIDは0より大きな値にする必要があります。",
    38015: "特定の基準に一致するCanvasフォーム本文はありませんでした。",
    38016: "回答しようとしているノートは別のチームメンバーにより削除済みです。ページを更新し再試行してください。",
    38017: "親エンゲージメントのコメントがクリアされました。",
    38018: "提供された親エンゲージメントコメント自体が返信です",
    38019: "コメント文字数は1字以上4,000 字以内にしてください。",
    38020: "提供されたエンティティUIDは無効です。",
    38021: "提供された親エンティティUIDは無効です。",
    38022: "エンゲージメントコメントの削除に失敗しました。",
    38023: "コメントIDは空欄にできません。",
    38024: "このアクションは有効なアクションである必要があります。",
    38025: "ノートのステータスが変更されました。ページを更新し再試行してください。",
    38026: "レビューノートは作成者のみが削除できます。",
    38027: "既に存在しないコメントを編集しようとしています。ページを更新し再試行してください。",
    38028: "クリア済コメントは更新できません。",
    38029: "コメント\のテキストを変更できるのは作成者だけです",
    38030: "エンゲージメントコメントIDが無効です",
    38031: "コメントステータスIDは空欄にできません。",
    38032: "リクエストされたユーザーとエンゲージメントの間に関係する記録はありませんでした。ページを更新し再試行してください。エラーが解消しない場合には、ヘルプデスクに連絡してください。",
    38033: "更新アクションが無効です。",
    38034: "リクエストされたコメントIDは既に他のコメントにより使用されています。",
    38035: "提供されたコメントIDは無効です",
    38036: "文書IDはNull値又は空欄にできません。",
    38037: "コメントが割当てられたユーザーのIDは空欄にできません。",
    38038: "コメントがオープン、クローズしている間はコメントを再割当てできません。",
    38039: "返信を削除しようとしているノートは既に削除されています。ページを更新し再試行してください。",
    38040: "返答には期日は不要です。",
    38041: "返答には優先度を設定できません。",
    38042: "コメントには期日が必要です。",
    38043: "コメントには優先度が必要です。",
    38044: "既に存在しないコメントに対する返信を編集しようとしています。ページを更新し再試行してください。",
    38045: "エンゲージメントステータスIDとユーザーまたは優先度に割当てられたコンテンツの両方を編集することはできません。",
    38046: "エンゲージメントコメントの更新が失敗しました。",
    38047: "オープンのコメントのみ回答できます",

    /*Tags*/
    39004: "編集しようとしているタググループは他のチームメンバーによって削除されました。ページを更新して再試行してください",
    40003: "選択したタググループは他のチームメンバーによって削除されました。続けるには他のタグのグループを選択してください",
    40007: "1つ以上の選択したノートが削除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    40011: 'Note index cannot exceed 5 characters.',
    40012: "タグカラーコードが無効です。ページを更新して、再試行してください。",
    40014: "編集しようとしているタグを含むタググループは他のチームメンバーによって削除されました。ページを更新して再試行してください",
    40016: "選択したタスクにタグを追加 (又はタスクからタグを削除)することはできません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    40019: "編集しようとしているタグは別のチームメンバーにより削除されました。ページを更新し再試行してください。",
    40020: "タグは現在同期できませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    40021: "選択した１つ以上のタグが削除されました。ページを更新して、再試行してください。",
    40022: "このエンゲージメントに1人以上の外部チームメンバーを追加してから、この操作を再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    40027: 'Description is too long.',

    // Scheduler request
    70022: "このサービスリクエストに関連付けられているタスクはありません。 続行するには、ページを更新し、削除されていない1つ以上のタスクを選択してください。 エラーが解消しない場合には、ヘルプデスクに連絡してください。 ",
    70024: "集中化サービスはこのエンゲージメントでは利用できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    70025: "集中化サービスは現在あなたの国では利用できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /* TaskDocumnet */
    80001: "タスクへの文書関連付けの作成に失敗しました。",
    80002: "リクエストには最低1つのタスクを含める必要があります。",
    80003: "文書IDが存在する必要があります。",
    80004: "選択済タスクが削除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    80005: "文書Idが無効です。",
    80006: "ユーザーには、操作を実行するための十分な権限がありません。 ",
    80007: "タスクへの文書関連付けに失敗しました。",
    80008: "タスクへの文書関連付けの後、タスクのステータスの変更に失敗しました。",
    80011: "機密文書は共有できません。",
    80012: "リクエストペイロードが無効または空です。",
    80013: "タスクが制限値を超えています。一度に300以下のタスクを選択してください。",
    80014: "文書をリンクする際にエラーが発生しました。ページを更新し再試行してください。問題が解消しない場合には、ヘルプデスクに連絡してください。",

    /* ITApplication / SO */
    81001: "全てのITアプリケーションの取得に失敗しました。",
    81002: "全てのITアプリケーションの取得 - 無効なエンゲージメントID",
    81003: "選択されたITアプリケーションは削除されています。このモーダルを削除しアップデートされたリストを閲覧してください。",
    81004: "名称は空にできません。",
    81005: "名称の最大文字数は500字としてください。",
    81006: "無効な戦略タイプID",
    81007: "無効な文書ID",
    81008: "IDごとのITアプリケーションの取得に失敗しました。",
    81009: "無効な分類",
    81010: "無効なSCOT",
    81011: "無効な統制",
    81012: "ITアプリケーションIDをnullまたは空にできません。",
    81013: "ITアプリケーションが見つかりませんでした。",
    81014: "ITアプリケーション ITプロセスの削除の呼び出しに失敗しました。",
    81015: "ITアプリケーション ITプロセスIDは空にできません。",
    81016: "無効なITアプリケーション ITプロセスID",
    81017: "ITアプリケーション ITプロセスが見つかりませんでした。",
    81018: "ITアプリケーション ITプロセス作成の呼び出しに失敗しました。",
    81019: "ITアプリケーションにとって代わるサービス受託会社",

    /* Controls */
    83001: "統制の取得に失敗しました。",
    83002: "この操作はできません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    83003: "コントロールIDがNull値又は空です。",
    83004: 'The selected Control has been deleted. Close this modal to see the updated list.',
    83005: "文書IDが無効です。",
    83006: "統制名がありません。",
    83007: "統制名の長さが無効です。",
    83008: "リクエストが無効です。",
    83009: "統制頻度IDが無効です。",
    83010: "統制タイプIDが無効です。",
    83011: "統制ITアプリケーションが無効です。",
    83012: "統制デザイン有効性タイプIDが無効です。",
    83013: "無効なITアプリケーション",
    83014: "統制のタイプが手作業防止または手作業発見タイプの場合、サービス受託会社タイプのITアプリケーションのみが許可されます。",
    83015: "IT依存手作業統制のみが手作業IPEテストを選択できます。",
    83016: "このプロファイルのエンゲージメントには低リスク統制は許可されていません。",
    83017: "フィルタされたSCOTsを複製します。",
    83018: "統制名が500文字を超えています。",
    83019: "WCGW IDが無効です。",
    83020: "重複したWCGW IDは許可されていません。",
    83021: "重複したITアプリケーションIDは許可されていません。",
    83023: "現在のページは無効です。",
    83024: "ページサイズが無効です。",
    83025: "検索文字数は最大100字としてください。",
    83026: "サービス受託会社がないIT APPはIT依存手作業統制又はITアプリケーション統制の統制タイプにのみ関連付けられます。",
    83027: "フィルタされたWCGWsを複製します。",
    83028: "ナレッジ統制IDが無効です。",

    /* ITControl */
    84001: "IT統制の取得に失敗しました。",
    84002: "IDごとのIT統制の取得に失敗しました。",
    84003: "IT統制IDがnullまたは空です。",
    84004: "無効なIT統制Id.",
    84005: "文書Idが無効です。",
    84006: "IT統制名がありません。",
    84007: "IT統制名の文字数が無効です",
    84008: "IT統制の頻度Idが無効です。",
    84009: "IT統制アプローチIdが無効です。",
    84010: "IT統制のデザインの有効性タイプIdが無効です。",
    84011: "IT統制テストの値が無効です。",
    84012: "IT統制運用状況の有効性タイプIdが無効です。",
    84013: "IT統制の頻度がありません。",
    84014: "IT統制の削除に失敗しました。",
    84015: "検索文字数は最大100字としてください。",

    /*GroupTasks*/
    85001: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85002: "選択した操作は完了できませんでした。ページを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。 ",
    85003: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85004: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85005: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85006: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85007: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85008: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85009: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85010: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85011: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85012: "選択された文書は他のリージョンまたは構成単位に既に割当てられています。このため、割当てることができません。ページを更新し再試行してください。",
    85013: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85014: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85015: "選択された操作は現在完了できません。 ぺージを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85016: "エンゲージメントIDは空欄にできません。",
    85017: "このタスクはこのエンゲージメントで利用できなくなりました。",
    85018: "無効な文書ID",
    85019: "これらの文書を送付するための適切な機密性レベルを有していません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85020: "送信しようとしている１つ以上の文書は送信できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    85021: "プライマリーチームへ送信できないフォーム",
    85022: "１つ以上の文書は送信できませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /* ITRisk */
    86001: "ITリスク名は空にできません。",
    86002: "ITリスク名の最大文字数は500字としてください。",
    86003: "無効なITリスクId.",
    86004: "IDごとのITリスク取得の呼び出しに失敗しました。",
    86005: "ITリスクが見つかりませんでした。",
    86006: "ITリスク IT統制の作成の呼び出しに失敗しました。",
    86007: "無効なIT統制Id.",
    86008: "ITリスク IT統制の削除の呼び出しに失敗しました。",
    86009: "無効なITリスク IT統制Id",
    86010: "ITリスクの削除に失敗しました。",


    /*Copyhub*/
    88017: "エクスポートプロセスのサービスがダウンしました - パッケージ作成が部分的にしか成功していません",
    88018: "パッケージ送信に選択されたユーザーが有効ではありません(無効なEメール、GUI、またはフルネーム)",
    88033: "インポートするコピーパッケージのステータスが無効です",
    88042: "一括エクスポートの権限がありません。",
    88045: "テンプレートエンゲージメントの作成権限がありません。",
    88048: "パッケージは別のユーザーによって現在インポート中です。後で再試行してください。",
    88049: "パッケージは存在しません。タブを更新してください。",
    88050: "現在別のエンゲージメントコピーが進行中です。",
    88051: "このエンゲージメントについて多くのコピーが進行中です。別のものを開始する前に、コピーが完了するのをお待ちください。",
    88056: "アクションが完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    88057: "選択された文書はアクティブなマルチユーザー編集モードの関連するエビデンスを含んでいます。関連するエビデンスを確認の上、手続を進めてください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /* Group Scopes */
    92001: "全てのグループスコープ取得のコールに失敗しました。",
    92002: "グループスコープ作成のコールに失敗しました。",
    92003: "無効なグループスコープ更新リクエスト",
    92004: "無効なスコープ名",
    92005: "無効な親スコープID",
    92006: "親スコープが存在しません。",
    92007: "無効なスコープ説明",
    92008: "グループスコープ名の文字数を100字超とすることはできません。",
    92009: "グループスコープ説明の文字数を500字超とすることはできません。",
    92010: "グループスコープの削除の呼び出しに失敗しました。",
    92011: "編集中のカスタムサブスコープは他のチームメンバーによって削除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    92012: "特定されたスコープIDは有効ではありません。",
    92013: "このカスタムサブスコープはチームに割り当てられているため削除できません。",
    92014: "削除しようとしているカスタムサブスコープは既に他のチームメンバーによって削除されています。ページを更新し再試行してください。",
    92015: "ユーザーは操作の実行が許可されていません。",
    92016: "スコープ名は既にこのエンゲージメントに存在します。",
    92017: "IDグループ別スコープの取得要求ができませんでした。",

    /* Group Sections */
    101001: "グループセクションの作成に失敗しました",
    101002: "グループ名が空欄もしくは無効です",
    101003: "グループセクション名の長さが100文字を超えています",
    101004: "セクション名が既にエンゲージメントに存在します",
    101005: "グループセクションの編集に失敗しました",
    101006: "無効なセクションID",
    101007: "グループセクションが存在しません",
    101008: "無効なエンゲージメントID",
    101009: "無効なグループナレッジセクション",

    /* Group Documents */
    110001: "無効なエンゲージメントID",
    110002: "無効なインストラクションステータス",
    110003: "IDによるエンゲージメントの取得に失敗しました",

    /* ClientEngagement */
    93001: "クライアントエンゲージメント説明が見つかりません。",
    93002: "クライアントエンゲージメント説明の文字数を100字超とすることはできません。",
    93003: "クライアントエンゲージメントリクエストが空欄です。",
    93004: "クライアントエンゲージメント取得のコールに失敗しました。",
    93005: "クライアントエンゲージメント更新のコールに失敗しました。",
    93006: "エンゲージメント表示名は現在更新できませんでした。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /*IP FIltering */
    96005: "{0}が許可リストに追加されていません。",
    96015: "ソースエンゲージメントからインポートできるアクセスロケーションはありません。",
    96016: "ソースエンゲージメントからインポートできるアクセスロケーションはありません。",

    /*RBAC SchedulerRequests */
    'permissionIssueForScheduler': "サービスをリクエストする権限がありません。エンゲージメント管理者に連絡してこのアクションを実行する権限をリクエストしてください。",

    /* GroupInstructions */
    98001: "グループインストラクションの取得の呼び出しに失敗しました。",
    98002: "1つ以上のナレッジインストラクションのセクションIDが無効です。",
    98003: "グループインストラクションの作成の呼び出しに失敗しました。",
    98004: "インストラクション名は空にできません。",
    98005: "インストラクション名は500字を超えることはできません。",
    98006: "インストラクションの説明は空にできません。",
    98007: "インストラクションの説明は4,000字以内にしてください。",
    98008: "インストラクションはスコープまたはチームに割当てる必要があります。",
    98009: "インストラクション名は既にこのエンゲージメントに存在します。",
    98011: "このグループインストラクションは別のチームメンバーによって既に削除されています。 ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    98012: "このグループインストラクションは別のチームメンバーによって削除されました。 ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    98016: "編集しようとしているグループインストラクションは別のチームメンバーによって削除されました。 ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    98017: "このグループタスクは別のチームメンバーによって既に削除されています。 ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    98018: "このグループタスクは別のチームメンバーによって削除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    98019: "エンティティが見つかりません。",

    /* Group Snapshots */
    102001: "グループインストラクションのスナップショットの作成要求ができませんでした。",
    102002: "無効なリクエストパラメータによるエラー",
    102003: "無効なエンゲージメントエラー",
    102004: "全てのグループのスナップショットの取得要求ができませんでした。",
    102005: "IDグループ別スナップショットの取得要求ができませんでした。",
    102006: "スナップショットが見つかりませんでした。",
    102007: "無効なスナップショットが選択されました。",

    /* Group Links - Send link request */
    106001: "グループリンク送付要求ができませんでした。",
    106002: "チームリストは空欄にできません。",
    106003: "1つ以上の選択されたチームは無効です。",
    106004: "グループリンクメッセージのキューイングに失敗しました。",
    106005: "チームは繰返しができません。",
    106006: "同時トークンは繰返しができません。",

    /* GroupInstructions - Send Version request */
    22019: "チームは削除されました。",
    22023: "インストラクション送付要求ができませんでした。",
    22024: "インストラクションを送付しようとしている先の構成単位は利用可能でないか削除されました。",
    22025: "エンゲージメントIDは空欄にできません。",
    22026: "構成単位IDは空欄にできません。",
    22027: "期日のないグループインストラクションが見つかりました。",
    22028: "構成単位へのスコープインストラクションはまだ発行されていません。",
    22029: "構成単位に送付すべき新規インストラクションは発行されていません。",
    22030: "インストラクション及びタスクのこのバージョンは別のチームメンバーにより承諾済みです。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    22031: "グループバージョンの呼び出しに失敗しました。",

    /* GroupVersion */
    22032: "インストラクションは存在しません。",

    22034: "Idによるグループバージョンの取得の呼び出しに失敗しました。",
    22035: "インストラクション設定IDは空欄にできません。",

    /* Return instruction concurrency scenario*/
    22036: "インストラクション及びタスクの新規バージョンが利用可能です。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    22037: "インストラクション及びタスクのこのバージョンは別のチームメンバーにより承諾済みです。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    22038: "インストラクション及びタスクのこのバージョンは別のチームメンバーにより返却済みです。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    37018: "このGL勘定科目は利用できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    37019: "文書の関連付けは編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    37030: "このGL勘定科目は利用できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    37032: "文書の関連付けは編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    37033: "文書の関連付けは編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    37034: "文書の関連付けは編集できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    37037: "この調整は利用できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /* EngagementReports */
    111001: "レポートタイプによるレポート取得コールに失敗しました。",
    113015: "試算表が利用できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    113025: "勘定科目クラスID又は勘定科目IDのフィルタリングが必須であり、続行できません。",
    113050: "試算表または財務諸表がこのエンゲージメントに添付されていないまたは削除されているため続行できません。",

    /*Information Security */
    200001: "実行されたアクションはEY情報セキュリティによって禁止されています。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /*GL account concurrency scenario*/
    113043: "この調整勘定科目は利用できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    113019: "この調整勘定科目は利用できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    113022: "アクションが完了できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    113039: "このGL勘定科目には既にリファレンスが関連付けられています。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
    113035: "このGL勘定科目には既にリファレンスが関連付けられています。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    113020: "このエビデンスは利用できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    113037: "このGL勘定科目は利用できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    40029: "このGL勘定科目は利用できなくなりました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    /*Trial balance*/
    113060: "MESTエンゲージメントにはMultiEntityが必須です。",
    113061: "MESTエンゲージメント以外にはMultiEntityが必須ではありません。",
    113057: "エンゲージメントHelixが見つかりません。",
    113094: "アップデートする試算表はPlannning及びIstrial Balanceがtrueである必要があります。",
    113095: "アップデートする試算表はfinancialタイプが試算表のとき、Plannning及びIstrial Balanceがtrueでない必要があります。",
    113069: "エンゲージメントにはスコープ及び戦略が既に存在します。",
    113009: "無効な試算表IDです、進めません。",
    113092: "試算表はPlannningおよびFinancial Statementsです。ソフトデリートに進めません。",
    114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."

};

export const controlRiskTypeStep2 = [{
        id: 1,
        name: "依拠する"
    },
    {
        id: 2,
        name: "依拠しない"
    },
    {
        id: 3,
        name: "MPをテストする"
    }
];

/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
        id: 1,
        value: "更新中"
    },
    {
        id: 3,
        value: "エラー"
    },
    {
        id: 5,
        value: "更新中"
    },
    {
        id: 6,
        value: "エラー"
    }
];

export const riskTypes = [{
        id: 1,
        name: "特別な検討を必要とするリスク",
        abbrev: "SR",
        title: "特別な検討を必要とするリスク"
    },
    {
        id: 2,
        name: "不正リスク",
        abbrev: "FR",
        title: "不正リスク"
    },
    {
        id: 3,
        name: "重要な虚偽表示リスク",
        abbrev: "R",
        title: "ROMM/固有リスク"
    }
];

export const riskTypesToolTip = [{
        id: 1,
        name: "特別な検討を必要とするリスク",
        abbrev: 'SR',
        label: "SR",
        title: "特別な検討を必要とするリスク"
    },
    {
        id: 2,
        name: "不正リスク",
        abbrev: "FR",
        label: "不正",
        title: "不正リスク"
    },
    {
        id: 3,
        name: "重要な虚偽表示リスク",
        abbrev: "R",
        label: "重要な虚偽表示リスク",
        title: "重要な虚偽表示リスク"
    }
];

export const risksTypes = [{
        id: 1,
        name: "特別な検討を必要とするリスク",
        abbrev: "SR",
        title: "特別な検討を必要とするリスク"
    },
    {
        id: 2,
        name: "不正リスク",
        abbrev: "FR",
        title: "不正リスク"
    },
    {
        id: 3,
        name: "重要な虚偽表示リスク",
        abbrev: "R",
        title: "重要な虚偽表示リスク"
    }
];

export const emptyRiskTypes = [{
        id: 1,
        label: "重要な虚偽表示リスクが識別されていません"
    },
    {
        id: 2,
        label: "不正リスクが識別されていません"
    },
    {
        id: 3,
        label: "重要な虚偽表示リスクが識別されていません"
    }
];

export const controlRiskType = [{
        id: 1,
        name: "依拠する"
    },
    {
        id: 2,
        name: "依拠しない"
    },
    {
        id: 3,
        name: "MPをテストする"
    }
];
export const inherentRiskType = [{
        id: 1,
        name: "高"
    },
    {
        id: 2,
        name: "低"
    }
];
export const CRAStrings = {
    Minimal: "最低",
    Low: "低",
    'Low +SC': "低 +特別な検討",
    Moderate: "中",
    High: "高",
    'High +SC': "高 +特別な検討"
};
export const priorityType = [{
        id: 1,
        name: "低（low)",
        className: 'Low',
        label: "L"
    },
    {
        id: 2,
        name: "中（medium)",
        className: 'Medium',
        label: "M"
    },
    {
        id: 3,
        name: "高（high)",
        className: 'High',
        label: "H"
    },
    {
        id: 4,
        name: "クリティカル",
        className: 'Critical',
        label: "C"
    }
];
export const reviewNoteFilterTypes = [{
        value: 0,
        label: "すべて"
    },
    {
        value: 1,
        label: "オープン"
    },
    {
        value: 2,
        label: "クリア済"
    },
    {
        value: 3,
        label: "クローズ済"
    }
];
export const reviewStatus = [{
        id: 1,
        name: "オープン"
    },
    {
        id: 2,
        name: "クリア済"
    },
    {
        id: 3,
        name: "クローズ済"
    }
];
export const reviewNoteOpenStatusOption = [{
        value: 2,
        label: "クリア"
    },
    {
        value: 3,
        label: "クローズ"
    }
];
export const reviewNoteClearedStatusOption = [{
        value: 1,
        label: "再オープン"
    },
    {
        value: 3,
        label: "クローズ"
    }
];
export const reviewNoteBulkClearedStatusOption = [{
        value: 1,
        label: "再オープン"
    },
    {
        value: 2,
        label: "クリア"
    },
    {
        value: 3,
        label: "クローズ"
    }
];
export const reviewNoteClosedStatusOption = [{
    value: 1,
    label: "再オープン"
}];
export const signOffTypes = [{
        value: 0,
        label: "実施者"
    },
    {
        value: 1,
        label: "査閲者"
    },
    {
        value: 2,
        label: "なし"
    }
];
export const RNHNoteStatusOptions = [{
        value: 1,
        label: "オープン"
    },
    {
        value: 2,
        label: "クローズ済"
    },
    {
        value: 3,
        label: "クリア済"
    }
];
export const assertions = [{
        id: 1,
        assertionname: "網羅性",
        assertionabbreviation: "C",
        statementtypeid: 2,
        displayorder: 1
    },
    {
        id: 2,
        assertionname: "実在性",
        assertionabbreviation: "E",
        statementtypeid: 2,
        displayorder: 2
    },
    {
        id: 3,
        assertionname: "評価",
        assertionabbreviation: "V",
        statementtypeid: 2,
        displayorder: 3
    },
    {
        id: 4,
        assertionname: "権利と義務",
        assertionabbreviation: "R&O",
        statementtypeid: 2,
        displayorder: 4
    },
    {
        id: 5,
        assertionname: "表示及び開示",
        assertionabbreviation: "P&D",
        statementtypeid: 2,
        displayorder: 5
    },
    {
        id: 6,
        assertionname: "網羅性",
        assertionabbreviation: "C",
        statementtypeid: 1,
        displayorder: 6
    },
    {
        id: 7,
        assertionname: "発生",
        assertionabbreviation: "O",
        statementtypeid: 1,
        displayorder: 7
    },
    {
        id: 8,
        assertionname: "測定",
        assertionabbreviation: "M",
        statementtypeid: 1,
        displayorder: 8
    },
    {
        id: 9,
        assertionname: "表示及び開示",
        assertionabbreviation: "P&D",
        statementtypeid: 1,
        displayorder: 9
    },
    {
        id: 10,
        assertionname: "網羅性",
        assertionabbreviation: "C",
        statementtypeid: 3,
        displayorder: 10
    },
    {
        id: 11,
        assertionname: "実在性/発生",
        assertionabbreviation: "E/O",
        statementtypeid: 3,
        displayorder: 11
    },
    {
        id: 12,
        assertionname: "測定/評価",
        assertionabbreviation: "M/V",
        statementtypeid: 3,
        displayorder: 12
    },
    {
        id: 13,
        assertionname: "権利と義務",
        assertionabbreviation: "R&O",
        statementtypeid: 3,
        displayorder: 13
    },
    {
        id: 14,
        assertionname: "表示及び開示",
        assertionabbreviation: "P&D",
        statementtypeid: 3,
        displayorder: 14
    }
];
//Add Review Note
export const priorityTypes = [{
        value: 1,
        label: "低（low)"
    },
    {
        value: 2,
        label: "中（Medium)"
    },
    {
        value: 3,
        label: "高（high)"
    },
    {
        value: 4,
        label: "クリティカル"
    }
];
/*Cog Menu*/
export const cogMenuOptions = {
    Open: "オープン",
    'Start Co-edit mode': "マルチユーザー編集を開始",
    'End Co-edit mode': "マルチユーザー編集を終了",
    'Open read-only': "読み取り専用で開く",
    'View history': "履歴の表示",
    CopyLink: "リンクのコピー",
    Rename: "名前の変更",
    Delete: "削除",
    'Remove from task': "タスクから削除",
    Remove: "リムーブ",
    Unlink: "リンク解除",
    RelateTasks: "タスクに関連付け",
    RelateEntities: "エンティティの関連付け",
    Restore: "リストア",
    PermanentlyDelete: "完全に削除",
    ChangeReason: "理由の編集",
    Confidentiality: "機密性",
    SignoffRequirements: "サインオフ要件",
    AssignRegionComponent: "リージョン又は構成単位への割当て",
    UnassignRegionComponent: "リージョン又は構成単位への割当てが未了",
    ReturnToRegionComponent: "リージョン又は構成単位へ差戻し",
    ClearReturnToRegionComponent: "リージョン又は構成単位へ差戻しのクリア",
    OverwriteForm: "フォームの上書き",
    Finalize: "調書の完了"
};

export const pagingSvgHoverText = {
    first: "最初のページ",
    previous: "前のページ",
    next: "次のページ",
    last: "最後のページ"
};
export const controlFrequencyType = {
    1: "毎日何度も",
    2: "日次",
    3: "週次",
    4: "月次",
    5: "四半期ごと",
    6: "年次",
    7: "ITアプリケーション統制",
    8: "その他"
};
export const itApproachType = {
    1: "統制",
    2: "実証"
};
export const controlType = {
    1: "ITアプリケーション",
    2: "ITDM統制",
    3: "手作業による防止的統制",
    4: "手作業による発見的統制"
};
export const aggregateITEvaluationType = {
    1: "サポートする",
    2: "サポートしない",
    3: "FS&ICFRサポート",
    4: "FSのみサポート"
};
export const entityType = {
    'ENTITY3': "勘定科目",
    'ENTITY4': "SCOT",
    'ENTITY5': "ITプロセス",
    'ENTITY7': "リスク",
    'ENTITY18': "WCGW",
    'ENTITY19': "統制",
    'ENTITY20': "IT/サービス受託会社 アプリケーション",
    'ENTITY24': "アサーション",
    'ENTITY34': "IT統制",
    'ENTITY35': "ITリスク"
};
export const trueFalseToYesNo = {
    'true': "はい",
    'false': "いいえ"
}
export const trueFalseToYesOnly = {
    'true': "はい"
}
export const yesNoLocalized = {
    'Yes': "はい",
    'No': "いいえ"
}
export const iTProcessEvaluationType = {
    1: "有効",
    2: "非有効",
    3: "依拠可能",
    4: "テストされていない"
};

export const strategyType = {
    1: "統制",
    2: "実証",
    3: "依存する",
    4: "依拠しない"
};
export const accountType = {
    1: "重要な勘定科目",
    2: "リスクが限定的な勘定科目"
};

export const scotTypes = {
    1: "経常",
    2: "非経常",
    3: "見積"
};
export const taskNavigation = {
    1: "私のタスク",
    2: "すべてのタスク",
    3: "スコープ及び戦略",
    4: "SCOT",
    5: "IT/サービス受託会社",
    6: "勘定科目",
    7: "実施全般",
    8: "総括",
    9: "チームサマリー",
    10: "リスク"
};
export const subCategoty = {
    1: "全て表示",
    2: "作成",
    3: "レビュー"
};
export const subCategoryType = {
    AllTasks: {
        id: 1,
        title: "全て表示",
        label: "全て表示"
    },
    ToPrepare: {
        id: 2,
        title: "作成へ",
        label: "作成へ"
    },
    ToReview: {
        id: 3,
        title: "レビューへ",
        label: "レビューへ"
    },
    Preparers: {
        id: 2,
        title: "実施者",
        label: "実施者"
    },
    Reviewers: {
        id: 3,
        title: "査閲者",
        label: "査閲者"
    }
};
/*Task Types*/
export const taskType = {
    1: "標準タスク",
    2: "主要標準タスク",
    3: "ウォークスルータスク",
    4: "統制タスク",
    5: "実証タスク",
    6: "PSPタスク",
    7: "対応タスク",
    8: "グループタスク"
};

export const taskTypesForAddTask = {
    importfromknowledge: "ナレッジからインポート",
    custom: "カスタム",
    account: "勘定科目",
    itsubstantive: "IT実証手続",
    scotwalkthroughtask: "SCOTウォークスルー",
    scotcontroltask: "SCOT統制",
    itwalkthroughtask: "ITウォークスルー",
    itcontroltask: "IT統制"
};

export const taskTypeBadge = {
    1: "OST",
    2: "PST",
    3: "WT",
    4: "TOC",
    5: "OSP",
    6: "PSP",
    7: "RT",
    8: "GT",
    9: "PIC",
    10: "EQR",
    11: "PIC/EQR",
    22: "ACT",
    23: "UDP"
};
/*Task Types*/
export const taskTypeAbbreviation = {
    1: "TOC",
    2: "TOC",
    3: "TOC",
    4: "TOC",
    5: "TOC",
    6: "TOC",
    7: "RT",
    8: "RT",
    9: "RT",
    10: "RT",
    11: "RT",
    13: "OST",
    14: "PST",
    16: "OSP",
    17: "PSP",
    18: "WT",
    19: "UDP",
    20: "WT",
    22: "ACT",
    23: "GT",
    24: "GT",
    25: "GT",
    26: "OSP",
    27: "GT"
};
export const auditPhase = {
    1: "スコープ及び戦略",
    2: "実施",
    3: "総括"
};
export const ProfileActionType = {
    1: "プロファイル送信 - 初回",
    2: "プロファイル送信 - ロールフォワード",
    3: "プロファイル編集",
    4: "グローバルコンテンツの更新",
    5: "PSPsのインポート",
    6: "PSTsのインポート",
    7: "Canvasフォームのコンテンツの更新",
    8: "グループ監査インストラクションのインポート",
    9: "マニュアルフォームの追加",
    10: "プロファイルの送信",
    11: "コンテンツアップデート（必須）",
    12: "Canvasフォーム プロファイルの同期"
};

export const taskGroup = {
    1: "計画時における全般手続の実施",
    2: "勘定科目フロー",
    3: "SCOTフロー",
    4: "ＩＴアプリケーション&サービス受託会社フロー",
    5: "結合リスク評価（CRA）フロー",
    6: "監査計画フロー",
    7: "エンゲージメント手続の総括",
    8: "監査差異要約表（SAD）",
    9: "監査結果の評価",
    10: "その他監査手続の実施",
    11: "グループ構造",
    12: "グループインストラクション",
    13: "プライマリグループタスク",
    14: "構成単位グループタスク",
    15: "監査計画",
    16: "Accounts Flow - MEST",
    17: "レビュー手続の実施",
    18: "新規受嘱及び継続手続の結果の考慮",
    19: "エンゲージメントチームの編成",
    20: "データの入手に関する全般的な計画の策定",
    21: "リスク評価のための分析的手続の実施及び重要性の決定",
    22: "Identify significant accounts - MEST",
    23: "リスク評価における追加手続の実施",
    24: "ソース（情報源）の識別",
    25: "重要な勘定科目の識別",
    26: "SCOTsの識別及び理解",
    27: "ITプロセス/サービス受託会社の識別及び理解",
    28: "監査戦略及びCRAの決定",
    29: "追加的に要求されるリスクの識別手続",
    30: "内部監査部門の利用に関する検討",
    31: "リスク評価への対応",
    32: "監査戦略の確定",
    33: "独立審査担当社員による手続（スコープ&戦略フェーズ）",
    34: "監査手続の立案",
    35: "監査証拠の評価及び総括",
    36: "コミュニケーション及びデリバラブルズの発行",
    37: "独立審査担当社員による手続（総括フェーズ）",
    38: " 監査報告書の作成及び発行",
    39: "調書の最終化及びアーカイブ",
    40: "企業レベルでの内部統制のテストの実施",
    41: "オートメーテッド・テクニックに使用されたデータの評価",
    42: "必須の不正対応手続の実施",
    43: "内部監査部門の利用及び専門家の利用に関する検討",
    44: "ITプロセスの評価",
    45: "議事録及び契約書並びに訴訟等のレビュー",
    46: "財務諸表関連手続の実施",
    47: "関連当事者、継続企業及び法令規則に関する手続の実施",
    48: "監査戦略の変更に関する討議",
    49: " 実施に関する結論",
    50: "独立審査担当社員による手続（実施フェーズ）",
    51: "スコープ及び戦略 - 品質活動の完了",
    52: "初年度監査にかかる手続の実施",
    53: "リスク評価手続の実施",
    54: "サービス受託会社の識別",
    55: "Digital - タスクグループ 5",
    56: "ITプロセスの識別及び理解",
    57: "計画手続の実施",
    58: "グループ構造、インストラクション及び関与",
    59: "重要な開示の識別",
    60: "重要な財務報告プロセスの識別及び理解",
    61: "Digital - タスクグループ 11",
    62: "Digital - タスクグループ 12",
    63: "Digital - タスクグループ 13",
    64: "Digital - タスクグループ 14",
    65: "Digital - タスクグループ 15",
    66: "Digital - タスクグループ 16",
    67: "Digital - タスクグループ 17",
    68: "期末手続に係るプロジェクトマネジメント活動の実施",
    69: 'Execute substantive procedures - Governance',
    70: 'Execute substantive procedures - Strategy',
    71: 'Execute substantive procedures - Risk Management',
    72: 'Execute substantive procedures - Metrics and Targets',
    73: "実証手続の実施 - その他",
    74: "他の者の作業の評価",
    75: "Digital - タスクグループ 25",
    76: "Digital - タスクグループ 26",
    77: "Digital - タスクグループ 27",
    78: "Digital - タスクグループ 28",
    79: "Digital - タスクグループ 29",
    80: "Digital - タスクグループ 30",
    81: "Digital - タスクグループ 31",
    82: "Digital - タスクグループ 32",
    83: "Digital - タスクグループ 33",
    84: "Digital - タスクグループ 34",
    85: "レビュー証拠の評価及び総括",
    86: "全般的保証手続の実施",
    87: "証拠の評価及び結論",
    88: "Digital - タスクグループ 38",
    89: "Digital - タスクグループ 39",
    90: "Digital - タスクグループ 40",
    91: "Digital - タスクグループ 41",
    92: "Digital - タスクグループ 42",
    93: "Digital - タスクグループ 43",
    94: "Digital - タスクグループ 44",
    95: "Digital - タスクグループ 45",
    96: "Digital - タスクグループ 46",
    97: "Digital - タスクグループ 47",
    98: "Digital - タスクグループ 48",
    99: "Digital - タスクグループ 49",
    100: "Digital - タスクグループ 50"
};
export const AutomationHubRequestStatus = {
    Draft: "ドラフト",
    Submitted: "提出済",
    Sent: "送信中",
    InProgress: "処理",
    Failed: "処理エラー",
    Completed: "完了済",
    FailedToSendToBP: "処理エラー",
    QueueingFailed: "送信失敗",
    ActionRequired: "要対応"
};
export const milestonesLabels = {
    1: "スコープ",
    2: "戦略",
    3: "ウォークスルー",
    4: "期中統制テスト",
    5: "期中実証テスト",
    6: "ウォークスルー（期末プロセス）",
    7: "期末統制テスト",
    8: "期末実証テスト",
    9: "総括",
    10: "該当無し",
    11: "実施",
    12: "スコープ及び戦略 - 品質活動",
    13: "その他のスコープ及び戦略",
    14: "CRA",
    15: "リスク評価及び重要性",
    16: "スコープ及び戦略の確定",
    17: "ポスト・インテリム - プロジェクトマネジメント"
};

export const TasksFilterGroups = {
    Tasks: "タスク",
    Assignments: "割当て",
    ReviewNotes: "レビューノート",
    ProjectManagement: "プロジェクト管理",
    Other: "その他"
};

export const TasksFilterTypes = {
    TaskStatus: "タスクのステータス",
    TaskType: "タスクの種類",
    AssignedTo: "割当者",
    OpenAssignments: "割当者別未了タスク",
    ReviewNotesStatus: "レビューノートのステータス",
    ReviewNotesAssignedTo: "割当てられたレビューノート",
    ReviewNotesCreatedBy: "レビューノート作成者",
    TimePhase: "タイムフェーズ",
    Milestone: "マイルストーン",
    AuditPhase: "監査フェーズ",
    DocumentConflict: "文書の競合",
    Findings: "発見事項",
    Entity: "企業",
    IsBookmarked: "オフライン用にダウンロード済"
};

export const quickFilterTaskStatus = [{
        value: '1',
        label: "オープン"
    },
    {
        value: '2',
        label: "進行中"
    },
    {
        value: '3',
        label: "レビュー中"
    },
    {
        value: '4',
        label: "完了"
    }
];

export const quickFilterAssignmentStatus = [{
        value: '1',
        label: "オープン"
    },
    {
        value: '2',
        label: "進行中"
    },
    {
        value: '3',
        label: "クローズ済"
    },
    {
        value: '4',
        label: "未割当て"
    }
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	"コラボレーション",
	// 'Control Forms',
	"文書",
	"タスク",
	"SCOTサマリー",
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
    'Archive Form': "アーカイブフォーム",
    'Canvas Forms': "Canvasフォームレポート",
    'Collaboration': "コラボレーション",
    'Control Forms': "統制レポート",
    'Documents': "文書レポート",
    'Tasks': "タスクレポート",
    'Team Members': "チームメンバー",
    'Trial Balance': "ナンバーズレポート"
};
export const projectManagement = [
	"コラボレーションの詳細",
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];

export const projectManagementReportNames = {
    'Collaboration Details': "クライアントコラボレーションダッシュボード",
    'Milestones': "マイルストーンレポート",
    'Review Notes': "レビューノートレポート",
    'Validation Checks': "バリデーションチェックレポート"
};

export const taskQuickFilterOptions = [{
        id: 'taskToPreparer',
        label: "実施すべきタスク",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'tasksReadyForReview',
        label: "レビュー可能なタスク",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allAssignedTasks',
        label: "全ての割当てタスク",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allOverdueTasks',
        label: "期限超過タスク",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allTasksDueThisWeek',
        label: "今週に期限が到来するタスク",
        uiViewId: uiViews.taskSystemSuggestedFilter
    }
];

export const noDefaultFilter = {
    id: 'noDefaultFilter',
    label: "デフォルトのフィルタなし"
};

export const taskTypes = [{
        id: '1',
        label: "統制タスク"
    },
    {
        id: '2',
        label: "統制タスク - 統制"
    },
    {
        id: '3',
        label: "統制タスク - ELC"
    },
    {
        id: '4',
        label: "統制タスク - IT/SO"
    },
    {
        id: '5',
        label: "統制タスク - MP"
    },
    {
        id: '6',
        label: "統制タスク - SO"
    },
    {
        id: '7',
        label: "対応タスク"
    },
    {
        id: '8',
        label: "キャッシュ・フローに関する虚偽表示 対応タスク"
    },
    {
        id: '9',
        label: "不備対応タスク"
    },
    {
        id: '10',
        label: "開示に関する虚偽表示 対応タスク"
    },
    {
        id: '11',
        label: "虚偽表示対応タスク"
    },
    {
        id: '12',
        label: "標準タスク"
    },
    {
        id: '13',
        label: "その他の標準タスク"
    },
    {
        id: '14',
        label: "主要標準タスク"
    },
    {
        id: '15',
        label: "実証タスク"
    },
    {
        id: '16',
        label: "その他の実証手続タスク"
    },
    {
        id: '17',
        label: "主要実証手続タスク"
    },
    {
        id: '18',
        label: "ウォークスルータスク"
    },
    {
        id: '19',
        label: "ウォークスルータスク - IT/SO"
    },
    {
        id: '20',
        label: "ウォークスルータスク - SCOT"
    },
    {
        id: '21',
        label: "To Do"
    },
    {
        id: '22',
        label: "勘定科目結論タスク"
    },
    {
        id: '23',
        label: "グループタスク"
    },
    {
        id: '24',
        label: "プライマリーグループタスク"
    },
    {
        id: '25',
        label: "構成単位グループタスク"
    },
    {
        id: '26',
        label: "IT/SO その他の実証手続タスク"
    },
    {
        id: '27',
        label: "リンク解除された構成単位グループタスク"
    }
];

export const filterAssignmentType = [{
        value: '1',
        label: "作成者"
    },
    {
        value: '2',
        label: "詳細レビューアー"
    },
    {
        value: '3',
        label: "一般レビューアー"
    },
    {
        value: '4',
        label: "パートナー"
    },
    {
        value: '5',
        label: "EQR"
    },
    {
        value: '6',
        label: "その他"
    }
];

export const filterTaskStatus = [{
        value: '1',
        label: "オープン"
    },
    {
        value: '2',
        label: "進行中"
    },
    {
        value: '3',
        label: "レビュー中"
    },
    {
        value: '4',
        label: "完了"
    },
    {
        value: '5',
        label: "エビデンスなし"
    }
];

export const filterAssignmentStatus = [{
        value: '1',
        label: "オープン"
    },
    {
        value: '2',
        label: "進行中"
    },
    {
        value: '3',
        label: "クローズ済"
    },
    {
        value: '4',
        label: "割当て未了"
    }
];

export const filterTaskType = [{
        value: '1',
        label: "統制タスク"
    },
    {
        value: '7',
        label: "対応タスク"
    },
    {
        value: '13',
        label: "その他の標準タスク"
    },
    {
        value: '14',
        label: "主要標準タスク"
    },
    {
        value: '16',
        label: "その他の実証手続タスク"
    },
    {
        value: '17',
        label: "主要実証手続タスク"
    },
    {
        value: '18',
        label: "ウォークスルー/ UDPタスク"
    },
    {
        value: '22',
        label: "勘定科目結論タスク"
    },
    {
        value: '999',
        label: "PICサインオフは必須です"
    },
    {
        value: '1000',
        label: "EQRサインオフ必須"
    }
];

export const filterTaskTypeGroupEngagement = [{
        value: '1',
        label: "統制タスク"
    },
    {
        value: '7',
        label: "対応タスク"
    },
    {
        value: '13',
        label: "その他の標準タスク"
    },
    {
        value: '14',
        label: "主要標準タスク"
    },
    {
        value: '16',
        label: "その他の実証手続タスク"
    },
    {
        value: '17',
        label: "主要実証手続タスク"
    },
    {
        value: '18',
        label: "ウォークスルー/UDPタスク"
    },
    {
        value: '22',
        label: "勘定科目結論タスク"
    },
    {
        value: '23',
        label: "グループタスク"
    },
    {
        value: '999',
        label: "PICサインオフは必須です"
    },
    {
        value: '1000',
        label: "EQRサインオフ必須"
    }
];

export const filterTaskTypeInterimEngagement = [{
        value: '14',
        label: "主要標準タスク"
    },
    {
        value: '13',
        label: "その他の標準タスク"
    },
    {
        value: '23',
        label: "グループタスク"
    },
    {
        value: '999',
        label: "PICサインオフは必須です"
    },
    {
        value: '1000',
        label: "EQRサインオフ必須"
    }
];

export const filterMilestones = [{
        value: '1',
        label: "スコープ",
        hideFromMenu: true
    },
    {
        value: '2',
        label: "戦略",
        hideFromMenu: true
    },
    {
        value: '12',
        label: "スコープ及び戦略 - 品質活動"
    },
    {
        value: '13',
        label: "その他のスコープ及び戦略"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "リスク評価及び重要性"
    },
    {
        value: '16',
        label: "スコープ及び戦略の最終化"
    },
    {
        value: '17',
        label: "ポストインテリム プロジェクトマネジメント"
    },
    {
        value: '3',
        label: "ウォークスルー"
    },
    {
        value: '4',
        label: "期中統制テスト"
    },
    {
        value: '5',
        label: "期中実証テスト"
    },
    {
        value: '6',
        label: "ウォークスルー (期末プロセス)"
    },
    {
        value: '7',
        label: "期末統制テスト"
    },
    {
        value: '8',
        label: "期末実証テスト"
    },
    {
        value: '11',
        label: "実施"
    },
    {
        value: '9',
        label: "総括"
    },
    {
        value: '10',
        label: "N/A"
    },
    {
        value: '0',
        label: "マイルストーンなし"
    }
];

export const documentListMilestones = [{
        value: '1',
        label: "スコープ"
    },
    {
        value: '12',
        label: "スコープ及び戦略プロジェクトマネジメント"
    },
    {
        value: '13',
        label: "その他のスコープ及び戦略"
    },
    {
        value: '2',
        label: "戦略"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "リスク評価と重要性"
    },
    {
        value: '16',
        label: "スコープと戦略の完了"
    },
    {
        value: '17',
        label: "ポストインテリムプロジェクトマネジメント"
    },
    {
        value: '3',
        label: "ウォークスルー"
    },
    {
        value: '4',
        label: "期中統制テスト"
    },
    {
        value: '5',
        label: "期中実証テスト"
    },
    {
        value: '6',
        label: "ウォークスルー（期末プロセス）"
    },
    {
        value: '7',
        label: "期末統制テスト"
    },
    {
        value: '8',
        label: "期末実証テスト"
    },
    {
        value: '11',
        label: "実施"
    },
    {
        value: '9',
        label: "総括"
    },
    {
        value: '10',
        label: "N/A"
    }
];

export const filterAuditPhases = [{
        value: '1',
        label: "スコープ及び戦略"
    },
    {
        value: '2',
        label: "実施"
    },
    {
        value: '3',
        label: "総括"
    }
];


export const filterDocListReviewNoteStatus = [{
        value: 1,
        label: "オープン"
    },
    {
        value: 5,
        label: "クリア済"
    },
    {
        value: 2,
        label: "クローズ済"
    }
];

export const filterDocumentConflicts = [{
    value: '1',
    label: "Yes"
}, {
    value: '0',
    label: "No"
}];
export const filterDownloadedForOffline = [{
    value: '1',
    label: "Yes"
}, {
    value: '2',
    label: "No"
}];

export const missingEntityDocuments = [{
    value: 10034,
    label: "はい"
}]


export const filterTaskFindings = [{
        value: '1',
        label: "不備"
    },
    {
        value: '2',
        label: "虚偽表示"
    }
];

export const ConfidentialityTypes = [{
        id: 1,
        Name: "デフォルト"
    },
    {
        id: 2,
        Name: "低"
    },
    {
        id: 3,
        Name: "中"
    },
    {
        id: 4,
        Name: "高"
    },
    {
        id: 5,
        Name: "極秘"
    }
];

export const RoleForMember = [{
        id: 1,
        role: "筆頭業務執行社員",
        roleAbbreviation: "PIC",
        displayOrder: 9
    },
    {
        id: 2,
        role: "業務執行社員",
        roleAbbreviation: "EP",
        displayOrder: 8
    },
    {
        id: 3,
        role: "エグゼクティブディレクター",
        roleAbbreviation: "ED",
        displayOrder: 5
    },
    {
        id: 4,
        role: "プリンシパル",
        roleAbbreviation: "プリンシパル",
        displayOrder: 6
    },
    {
        id: 5,
        role: "シニアマネージャー",
        roleAbbreviation: "シニアマネージャー",
        displayOrder: 4
    },
    {
        id: 6,
        role: "マネージャー",
        roleAbbreviation: "マネージャー",
        displayOrder: 3
    },
    {
        id: 7,
        role: "シニア",
        roleAbbreviation: "シニア",
        displayOrder: 2
    },
    {
        id: 8,
        role: "スタッフ",
        roleAbbreviation: "スタッフ",
        displayOrder: 1
    },
    {
        id: 9,
        role: "Intern",
        roleAbbreviation: "Intrn"
    },
    {
        id: 10,
        role: "独立審査担当社員",
        roleAbbreviation: "EQR",
        displayOrder: 10
    },
    {
        id: 11,
        role: "その他のパートナー",
        roleAbbreviation: "その他のパートナー",
        displayOrder: 7
    },
    {
        id: 12,
        role: "GDS - スタッフ",
        roleAbbreviation: "GDSスタッフ",
        displayOrder: 13
    },
    {
        id: 13,
        role: "Advisory (ITRA,TAS,Human Capital or Other)",
        roleAbbreviation: "ADV"
    },
    {
        id: 14,
        role: "Tax",
        roleAbbreviation: "Tax"
    },
    {
        id: 15,
        role: "Executive Support Services",
        roleAbbreviation: "ESS"
    },
    {
        id: 16,
        role: "General Counsel",
        roleAbbreviation: "GCO",
        displayOrder: 12
    },
    {
        id: 17,
        role: "Audit Quality Reviewer",
        roleAbbreviation: "AQR",
        displayOrder: 11
    },
    {
        id: 18,
        role: "ML Component Team",
        roleAbbreviation: "MCT"
    },
    {
        id: 19,
        role: "Client Supervisor",
        roleAbbreviation: "C.スーパーバイザー"
    },
    {
        id: 20,
        role: "Client Staff",
        roleAbbreviation: "C. スタッフ"
    },
    {
        id: 21,
        role: "Internal Audit Supervisor",
        roleAbbreviation: "IAスーパーバイザー"
    },
    {
        id: 22,
        role: "Internal Audit Staff",
        roleAbbreviation: "IAスタッフ"
    },
    {
        id: 23,
        role: "Regulator",
        roleAbbreviation: "規制当局"
    },
    {
        id: 24,
        role: "Other (e.g. due diligence review)",
        roleAbbreviation: "その他"
    },
    {
        id: 25,
        role: "Office",
        roleAbbreviation: "オフィス"
    },
    {
        id: 26,
        role: "Area",
        roleAbbreviation: "Area"
    },
    {
        id: 27,
        role: "Industry",
        roleAbbreviation: "IND"
    },
    {
        id: 28,
        role: "National",
        roleAbbreviation: "NAT"
    },
    {
        id: 29,
        role: "Global",
        roleAbbreviation: "GBL"
    },
    {
        id: 30,
        role: "GDS - シニア",
        roleAbbreviation: "GDSシニア",
        displayOrder: 14
    },
    {
        id: 31,
        role: "GDS - マネージャー",
        roleAbbreviation: "GDSマネージャー",
        displayOrder: 15
    }
];

export const SubServiceLines = [{
        subServiceLineId: 1,
        subServiceLineName: "Audit",
        displayOrder: 1
    },
    {
        subServiceLineId: 2,
        subServiceLineName: "FIDS",
        displayOrder: 2
    },
    {
        subServiceLineId: 9,
        subServiceLineName: "FAAS",
        displayOrder: 3
    },
    {
        subServiceLineId: 11,
        subServiceLineName: "CCaSS",
        displayOrder: 4
    },
    {
        subServiceLineId: 12,
        subServiceLineName: "BTS",
        displayOrder: 5
    },
    {
        subServiceLineId: 13,
        subServiceLineName: "Human Capital",
        displayOrder: 6
    },
    {
        subServiceLineId: 14,
        subServiceLineName: "Law",
        displayOrder: 7
    },
    {
        subServiceLineId: 15,
        subServiceLineName: "Indirect Tax",
        displayOrder: 8
    },
    {
        subServiceLineId: 16,
        subServiceLineName: "GCR",
        displayOrder: 9
    },
    {
        subServiceLineId: 17,
        subServiceLineName: "Transaction Tax",
        displayOrder: 10
    },
    {
        subServiceLineId: 18,
        subServiceLineName: "ITS",
        displayOrder: 11
    },
    {
        subServiceLineId: 19,
        subServiceLineName: "GCO",
        displayOrder: 12
    },
    {
        subServiceLineId: 20,
        subServiceLineName: "Business Consulting",
        displayOrder: 13
    },
    {
        subServiceLineId: 21,
        subServiceLineName: "Technology Consulting",
        displayOrder: 14
    },
    {
        subServiceLineId: 22,
        subServiceLineName: "Transactions and Corporate Finance",
        displayOrder: 15
    },
    {
        subServiceLineId: 23,
        subServiceLineName: "EY Parthenon",
        displayOrder: 16
    },
    {
        subServiceLineId: 24,
        subServiceLineName: "Other",
        displayOrder: 17
    },
    {
        subServiceLineId: 25,
        subServiceLineName: "Technology Risk",
        displayOrder: 18
    }
];

export const SchedulerRequestRole = [{
        id: 31,
        userTypeId: 4,
        label: "GDSマネージャー"
    },
    {
        id: 31,
        userTypeId: 3,
        label: "リクエストマネージャー"
    }
];

/* Task Status */
export const TaskStatus = [{
        id: 1,
        label: "オープン"
    },
    {
        id: 2,
        label: "進行中"
    },
    {
        id: 3,
        label: "レビュー中"
    },
    {
        id: 4,
        label: "完了"
    },
    {
        id: 5,
        label: "解除済"
    },
    {
        id: 6,
        label: "PIC/EQRサインオフの完了"
    }
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
        id: 1,
        label: "未送信"
    },
    {
        id: 2,
        label: "進行中"
    },
    {
        id: 3,
        label: "送信済"
    },
    {
        id: 4,
        label: "差戻済"
    }
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
        id: GAComponentDocumentStatus.Open,
        label: "オープン"
    },
    {
        id: GAComponentDocumentStatus.InProgress,
        label: "受領済"
    },
    {
        id: GAComponentDocumentStatus.Submitted,
        label: "提出済"
    },
    {
        id: GAComponentDocumentStatus.Returned,
        label: "差戻済"
    },
    {
        id: GAComponentDocumentStatus.InReview,
        label: "作成済"
    },
    {
        id: GAComponentDocumentStatus.Complete,
        label: "レビュー済"
    },
    {
        id: GAComponentDocumentStatus.Dismissed,
        label: "取下済"
    },
    {
        id: GAComponentDocumentStatus.RejectInTransit,
        label: "差戻中"
    },
    {
        id: GAComponentDocumentStatus.ReturnError,
        label: "差戻しエラー"
    }
];
export const TeamSummaryPreparerTaskStatus = [{
        id: 1,
        label: "オープン"
    },
    {
        id: 2,
        label: "進行中"
    },
    {
        id: 3,
        label: "完了"
    }
];
export const TeamSummaryReviewerTaskStatus = [{
        id: 1,
        label: "オープン"
    },
    {
        id: 2,
        label: "進行中"
    },
    {
        id: 3,
        label: "完了"
    }
];

export const DocumentHelper = {
    401: "操作を完了できません。ぺージを更新して、再試行してください。問題が解消しない場合には、ヘルプデスクに連絡してください。",
    413: "ファイルは最大許容ファイルサイズ（250MB）を超えており、アップロードできません。ファイルサイズを小さくしてから再試行してください。",
    412: "同じ名前の文書がこのエンゲージメントにすでに存在します",
    414: "文字数が最大値を超えています（{0}文字）",
    410: "この文書は削除済のため開くことができません。",
    411: "空白の文書は認められません。"
};

export const reviewNoteCategories = [{
        value: reviewNoteRoutes.path.all.id,
        path: reviewNoteRoutes.path.all.path,
        label: "全てのノート"
    },
    {
        value: reviewNoteRoutes.path.document.id,
        path: reviewNoteRoutes.path.document.path,
        label: "文書ノート"
    },
    {
        value: reviewNoteRoutes.path.task.id,
        path: reviewNoteRoutes.path.task.path,
        label: "タスクノート"
    },
    {
        value: reviewNoteRoutes.path.form.id,
        path: reviewNoteRoutes.path.form.path,
        label: "Canvasフォームコメント"
    }
];

export const reviewNoteStatus = [{
        value: '1',
        label: "オープン"
    },
    {
        value: '2',
        label: "クリア済"
    },
    {
        value: '3',
        label: "クローズ済"
    }
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
        id: 1,
        type: 'document',
        label: "文書ノート"
    },
    {
        id: 2,
        type: 'task',
        label: "タスクノート"
    }
];

export const accountConclusionTabs = {
    details: "詳細",
    conclusions: "結論"
};


export const rnhFilterType = [{
        id: 0,
        filterType: rnhFilterTypeQuery.annotationStatusIds,
        name: "ノートのステータスID",
        inDropDown: false
    },
    {
        id: 1,
        filterType: rnhFilterTypeQuery.authoredBy,
        name: "作成者",
        inDropDown: true
    },
    {
        id: 2,
        filterType: rnhFilterTypeQuery.assignedTo,
        name: "割当て先",
        inDropDown: true
    },
    {
        id: 3,
        filterType: rnhFilterTypeQuery.priority,
        name: "優先度",
        inDropDown: true,
        filterOptions: [{
            id: "1",
            label: "低"
        }, {
            id: "2",
            label: "中"
        }, {
            id: "3",
            label: "高"
        }, {
            id: "4",
            label: "重要"
        }]
    },
    {
        id: 4,
        filterType: rnhFilterTypeQuery.dueBefore,
        name: "期限前",
        inDropDown: true,
        isDateTime: true
    },
    {
        id: 5,
        filterType: rnhFilterTypeQuery.dueAfter,
        name: "期限後",
        inDropDown: true,
        isDateTime: true
    }
];

export const rnhSortingOptions = [{
        id: 'Number',
        label: '#'
    },
    {
        id: 'DueDate',
        label: "期日"
    },
    {
        id: 'Priority',
        label: "優先度"
    },
    {
        id: 'Status',
        label: "ステータス"
    }
];

export const userConfidentiality = [{
        id: 1,
        value: "全般"
    },
    {
        id: 2,
        value: "低"
    },
    {
        id: 3,
        value: "中"
    },
    {
        id: 4,
        value: "高"
    },
    {
        id: 5,
        value: "制限あり"
    },
    {
        id: 6,
        value: "機密事項"
    }
];

export const externalUserStatus = {
    active: "アクティブ",
    inactive: "アクティブではない"
};

export const engagementStatus = {
    1: "アクティブ",
    2: "ペンディング",
    3: "リジェクト済",
    4: "非アクティブ",
    13: "予定済 - 非アクティブ"
};

export const copyRequestStatus = {
    0: "期限切れ",
    1: "準備",
    2: "送信済",
    3: "受領済",
    4: "エクスポート実行中",
    5: "エクスポート成功",
    6: "エクスポート失敗",
    7: "インポート実行中",
    8: "インポート成功",
    9: "インポート失敗",
    10: "拒否",
    11: "コピー実行中",
    13: "ドラフト",
    14: "送信実行中",
    15: "配信実行中",
    16: "配信失敗"
}

export const copyObjectGrouptype = {
    21: "エンゲージメント",
    22: "勘定科目",
    23: "SCOTs",
    20: "エビデンス",
    24: "既存からのロールフォワード",
    25: "テンプレート",
    26: "一括エクスポート",
    27: "外部文書",
    28: "ガイド付きワークフロー",
    29: "エンティティごとのエンゲージメント"
}

export const independenceStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.overriden,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
        value: 3,
        label: labels.matteridentifiedpendingaction
    },
    {
        value: 4,
        label: labels.matterresolveddeniedaccess
    },
    {
        value: 5,
        label: labels.matterresolvedgrantedaccess
    },
    {
        value: 8,
        label: labels.override
    },
    {
        value: 1,
        label: labels.incomplete
    },
    {
        value: 2,
        label: labels.nomattersidentified
    },
    {
        value: 7,
        label: labels.restored
    },
    {
        value: 6,
        label: labels.notapplicable
    }
];

export const independenceConfirmationStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.override,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
    1: "スコープ",
    2: "戦略",
    3: "ウォークスルー",
    4: "期中統制テスト",
    5: "期中実証テスト",
    6: "ウォークスルー（期末プロセス）",
    7: "期末統制テスト",
    8: "期末実証テスト",
    9: "総括",
    10: "該当なし",
    11: "実施",
    12: "スコープ及び戦略 - 品質活動",
    13: "その他のスコープ及び戦略",
    14: "CRA",
    15: "リスク評価及び重要性",
    16: "スコープ及び戦略の確定",
    17: "ポスト・インテリム - プロジェクトマネジメント"
};

export const engagementMetricsComingDueOptions = [{
        value: 1,
        label: "明日"
    },
    {
        value: 3,
        label: "3日以内"
    },
    {
        value: 5,
        label: "5日以内",
        isDefault: true
    },
    {
        value: 10,
        label: "10日以内"
    },
    {
        value: 30,
        label: "30日以内",
        isMax: true
    }
];

export const engagementMetricsWhatsNewOptions = [{
        value: 1,
        label: "昨日"
    },
    {
        value: 3,
        label: "過去3日間"
    },
    {
        value: 5,
        label: "過去5日間",
        isDefault: true
    },
    {
        value: 10,
        label: "過去10日間",
        isMax: true
    }
];

export const engagementMetricsDisplayedAttributes = {
    preparer: "作成へ",
    forMyReview: "レビューへ",
    upcomingReview: "今後のレビュー",
    reviewNotesAssigned: "私に対するノート",
    reviewNotesAuthored: "私が作成したノート",
    partnerTasks: "パートナータスク",
    eqrTasks: "EQRタスク",
    timephases: "タイムフェーズ",
    groupTasks: "グループタスク",
    groupDeliverables: "グループデリバラブルズ",
    automation: "オートメーション",
    requests: "リクエスト"
};

export const quickLinks = {
    linkAccountSummary: "勘定科目サマリー",
    linkScotSummary: "SCOTサマリー",
    linkITSummary: "ITサマリー",
    linkCRASummary: "CRAサマリー",
    linkGAStructureSummary: "グループ構造サマリー",
    linkGAInstrcutionSummary: "グループインストラクションサマリー",
    linkSEM: "Substantive Evaluation Matrix",
    linkAuditPlan: "監査計画",
    linkWorkPlan: "作業計画",
    linkITProcessEvaluation: "ＩＴ評価",

    linkGeneral: "全般",
    linkScots: "SCOTs",
    linkITSO: "IT/SO",
    linkAccounts: "勘定科目",
    linkResponseTask: "対応タスク",
    linkWrapupEngagement: "エンゲージメントの総括",
    linkArchive: "アーカイブチェックリスト"
};

export const customKeyEvents = {
    reportDate: "報告書日",
    endDatePeriodCovered: "終了日",
    archiveDeadlineDate: "アーカイブ期日"
};

export const filterReviewNoteStatus = [{
        value: filters.reviewNoteStatus.open,
        label: "オープン"
    },
    {
        value: filters.reviewNoteStatus.cleared,
        label: "クリア済"
    },
    {
        value: filters.reviewNoteStatus.closed,
        label: "クローズ済"
    }
];

export const filterFileExtension = [{
        value: filters.fileExtension.canvasForm,
        label: "Canvasフォーム"
    },
    {
        value: filters.fileExtension.email,
        label: "Eメール"
    },
    {
        value: filters.fileExtension.excel,
        label: "Excel"
    },
    {
        value: filters.fileExtension.paperProfile,
        label: "ペーパープロファイル"
    },
    {
        value: filters.fileExtension.pdf,
        label: "PDF"
    },
    {
        value: filters.fileExtension.powerPoint,
        label: 'PowerPoint'
    },
    {
        value: filters.fileExtension.smartAutomation,
		label: "スマートオートメーション"
    },
    {
        value: filters.fileExtension.visio,
        label: "Visio"
    },
    {
        value: filters.fileExtension.word,
        label: "Word"
    },
    {
        value: filters.fileExtension.zip,
        label: "Zip"
    },
    {
        value: filters.fileExtension.other,
        label: "その他"
    }
];

export const filterDocumentContent = [{
        value: filters.documentContent.trackedChanges,
        label: "変更履歴"
    },
    {
        value: filters.documentContent.comments,
        label: "コメント"
    },
    {
        value: filters.documentContent.formulaError,
        label: "数式エラー (Excelファイルのみ)"
    },
    {
        value: filters.documentContent.highlightsWordFilesOnly,
        label: "ハイライト (Wordファイルのみ)"
    },
    {
        value: filters.documentContent.hiddenSheets,
        label: "非表示されたシート"
    },
    {
        value: filters.documentContent.embeddedFiles,
        label: "埋め込みファイル"
    },
    {
        value: filters.documentContent.ProtectedFiles,
        label: "保護された"
    },
    {
        value: filters.documentContent.DocumentContentNotAvailable,
        label: "利用できない文書コンテンツ"
    },
    {
        value: filters.documentContent.DocumentsInCollaborationMode,
        label: "マルチユーザー編集モードの文書"
    },
];

export const filterSharedEvidence = [{
        value: filters.sharedEvidence.source,
        label: "ソース"
    },
    {
        value: filters.sharedEvidence.target,
        label: "ターゲット"
    }
];

export const filterFindings = [{
        value: filters.findings.misstatement,
        label: "虚偽表示"
    },
    {
        value: filters.findings.deficiency,
        label: "不備"
    }
];

export const filterSignoffRequirements = [{
        value: filters.signoffRequirements.picMandatory,
        label: "PICは必須"
    },
    {
        value: filters.signoffRequirements.picTeamAssigned,
        label: "PICチームの割当て"
    },
    {
        value: filters.signoffRequirements.eqrMandatory,
        label: "EQR は必須"
    },
    {
        value: filters.signoffRequirements.eqrTeamAssigned,
        label: "EQR チームの割当て"
    }
];

export const filterResponsiveToRisks = [{
        value: filters.responsiveToRisk.responsiveToSignificantRisk,
        label: "特別な検討を必要とするリスク"
    },
    {
        value: filters.responsiveToRisk.responsiveToFraudRisk,
        label: "不正リスク"
    },
    {
        value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
        label: "固有リスク：高"
    }
];

export const filterMissingRelatedTask = [{
        value: filters.missingRelatedTask.picSignoffRequired,
        label: "PICのサインオフが必須"
    },
    {
        value: filters.missingRelatedTask.eqrSignoffRequired,
        label: "EQR のサインオフが必要"
    }
];

export const filterCanvasForms = [{
        value: filters.canvasForms.incompleteResponses,
        label: "対応未了事項"
    },
    {
        value: filters.canvasForms.unresolvedComments,
        label: "未解決コメント"
    }
];

export const documentChangeTypes = {
    0: "選択された変更に対する理由がありません",
    1: "事務的でない変更",
    2: "変更履歴が利用された場合変更を承諾する",
    3: "既存のエビデンスに対するクロスリファレンスの追加",
    4: "Faxもしくは電子メールで受領した確認に原本の返答を追加",
    5: "体裁整え",
    6: "フォームAPとSubstantial role評価の完了",
    7: "改訂前文書の削除もしくは解除",
    8: "マネージメントレターの準備",
    9: "アーカイブプロセスに関する完了チェックリストのサインオフ",
    10: "最終文書の整理及びクロスリファレンス",
    11: "現地時間への調整が行われた場合、当該変更は報告日以前に行われています（米国のみ）"
};

export const documentChangeTypesOptions = [{
        value: 1,
        label: "事務的でない変更"
    },
    {
        value: 2,
        label: "変更履歴が利用されている場合の変更の承諾"
    },
    {
        value: 3,
        label: "既存のエビデンスに対するクロスリファレンスの追加"
    },
    {
        value: 4,
        label: "Faxもしくは電子メールで受領した確認に原本の返答を追加"
    },
    {
        value: 5,
        label: "体裁整え"
    },
    {
        value: 6,
        label: "フォームAPとSubstantial role評価の完了"
    },
    {
        value: 7,
        label: "監査証拠を構成しない文書の削除又は破棄"
    },
    {
        value: 8,
        label: "監査意見をサポートしない文書の作成又は追加"
    },
    {
        value: 9,
        label: "アーカイブプロセスに関する完了チェックリストのサインオフ"
    },
    {
        value: 10,
        label: "最終文書の整理及びクロスリファレンス"
    },
    {
        value: 12,
        label: "MESTのみ：EY Canvasでの報告日よりも遅い報告日の企業に関連付けられたエビデンスの編集"
    },
    {
        value: 11,
        label: "現地時間への調整が行われた場合、当該変更は報告日以前に行われています（米国のみ）"
    }
];

export const FourFortyFilterTypes = [{
        id: 0,
        filterType: 'QuickFilter',
        name: "クイックフィルター",
        hasChild: false
    },
    {
        id: 1,
        filterType: 'TaskStatus',
        name: "タスクステータス",
        hasChild: false
    },
    {
        id: 2,
        filterType: 'TaskType',
        name: "タスク種類",
        hasChild: false
    },
    {
        id: 3,
        filterType: 'AssignedTo',
        name: "割当先",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 4,
        filterType: 'OpenAssignment',
        name: "割当未了",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 5,
        filterType: 'AssignmentsUsersEngagementRoles',
        name: "割当未了",
        hideDisplay: true,
        loadOptionsFromServer: true
    },
    {
        id: 6,
        filterType: 'ReviewNotesStatus',
        name: "レビューノートステータス",
        hasChild: false
    },
    {
        id: 7,
        filterType: 'ReviewNotesAssignedTo',
        name: "レビューノート割当先",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 8,
        filterType: 'ReviewNotesCreatedBy',
        name: "レビューノート作成者",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 9,
        filterType: 'TimePhase',
        name: "タイムフェーズ",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 10,
        filterType: 'Milestone',
        name: "マイルストーン",
        hasChild: false
    },
    {
        id: 11,
        filterType: 'AuditPhase',
        name: "実施フェーズ",
        altName: "エンゲージメントフェーズ",
        hasChild: false
    },
    {
        id: 12,
        filterType: 'DocumentConflict',
        name: "文書の競合",
        hasChild: false
    },
    {
        id: 13,
        filterType: 'Findings',
        name: "発見事項",
        hasChild: false,
        hideForNonAudit: true
    },
    {
        id: 14,
        filterType: 'Entity',
        name: "組織",
        hasChild: false,
        loadOptionsFromServer: true,
        hideForNonMest: true
    },
    {
        id: 15,
        filterType: 'IsBookmarked',
        name: "オフライン利用のためダウンロード",
        hasChild: false
    }
];

/* Arc Timeline */
export const arcValidationGroups = [{
        id: 1,
        label: "Build Step 30 ???"
    },
    {
        id: 2,
        label: "SEM (Evaluation Matrix) ???"
    },
    {
        id: 3,
        label: "エビデンスを完成させる"
    },
    {
        id: ArcTimelineGroups.FinalizeEvidence,
        label: "エビデンスを最終化する"
    },
    {
        id: ArcTimelineGroups.CompleteRemainingTasks,
        label: "残りのタスクを完了する"
    },
    {
        id: ArcTimelineGroups.ResolveValidations,
        label: "残りの検証チェックを解決する"
    },
    {
        id: 7,
        label: "アーカイブ準備をする"
    },
    {
        id: 8,
        label: "Canvas Form (個別)"
    },
    {
        id: 9,
        label: "Canvas Form　（すべて）"
    },
    {
        id: 10,
        label: "Canvas Form　（すべて）"
    }
];

export const checkListTypes = [{
        id: 7,
        label: "ハードコピーファイル及びバインダーの最終化"
    },
    {
        id: 13,
        label: "キーエンゲージメント日の確認"
    },
    {
        id: 14,
        label: "エンゲージメントコードの確認"
    },
    {
        id: 15,
        label: "クライアントコードの確認"
    },
    {
        id: 10,
        label: "エンゲージメントをグループからリンク解除"
    },
    {
        id: 16,
        label: "レポートタイプの検証"
    },
    {
        id: 17,
        label: "監査報告書日以降に変更された一時ファイルを確認する"
    },
    {
        id: 18,
        label: "監査報告書日以降に変更された削除済みファイルを確認する"
    },
    {
        id: 19,
        label: "エンゲージメントプロファイルの変更が提出されていることを確認してください。"
    },
    {
        id: 20,
        label: "保護された文書をレビューする"
    },
    {
        id: 95,
        label: "全般的な担当者の指定"
    }
];

export const arcValidationTypes = [{
        id: ArcTimeLineValidationTypes.DocumentConflict,
        label: "文書の競合状態を解消する"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
        label: "マルチユーザーにより編集中の文書"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
        label: "保護された文書をレビューする"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
        label: "利用できない文書コンテンツ"
    },
    {
        id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
        label: "未解決のレビューノートをクローズする"
    },
    {
        id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
        label: "変更履歴をエビデンスから削除する"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
        label: "スマートオートメーションエビデンスファイルを最終化"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
        label: "全てのPICサインオフの要求事項を完了"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
        label: "全てのEQR サインオフの要求事項を完了"
    },
    {
        id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
        label: "PICタスクにPIC文書を関連付ける"
    },
    {
        id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
        label: "EQR タスクにEQR 文書を関連付ける"
    },
    {
        id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
        label: "すべてのエビデンスにサインオフする"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormComment,
        label: "Canvasフォームのコメントを解決する"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
        label: "共有エビデンスのリンクを解除する"
    },
    {
        id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
        label: "未完了のタスクにエビデンスを追加する"
    },
    {
        id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
        label: "PIC文書が全てのPICタスクに含まれているか検証する。"
    },
    {
        id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
        label: "EQR 文書が全てのEQR タスクに含まれているか検証する。"
    },
    {
        id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
        label: "エビデンスのエンティティタスクへの関連付け"
    },
    {
        id: ArcTimeLineValidationTypes.MarkTasksComplete,
        label: "タスクを完了としてマークする"
    },
    {
        id: ArcTimeLineValidationTypes.AccountsSummary,
        label: "勘定科目サマリー"
    },
    {
        id: ArcTimeLineValidationTypes.ScotSummary,
        label: "SCOTsサマリー"
    },
    {
        id: ArcTimeLineValidationTypes.CraSummary,
        label: "CRAサマリー"
    },
    {
        id: ArcTimeLineValidationTypes.ITSummary,
        label: "ITサマリー"
    },
    {
        id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
        label: "監査報告書データの正確性を確認する"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveForm,
        label: "アーカイブフォームを完了する"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveTask,
        label: "アーカイブタスクを完了する"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
        label: "グループ共有エビデンスのリンクを解除する"
    },
    {
        id: ArcTimeLineValidationTypes.AuditPlan,
        label: "監査計画"
    },
    {
        id: ArcTimeLineValidationTypes.UnassociateFinding,
        label: "関連付けられていない発見事項"
    },
    {
        id: ArcTimeLineValidationTypes.IndependenceCompliance,
        label: "独立性遵守状況"
    },
    {
        id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
        label: "Canvasフォームの未対応項目を完了する"
    },
    {
        id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
        label: "Substantive evaluation matrix"
    },
    {
        id: ArcTimeLineValidationTypes.ITEvaluation,
        label: "IT評価"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
        label: "監査報告書日以降に変更された文書"
    },
    {
        id: ArcTimeLineValidationTypes.DuplicateFileNames,
        label: "重複するファイル名を持つエビデンスファイルの名称を変更してください。"
    },
    {
        id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
        label: "ITフロー"
    },
    {
        id: ArcTimeLineValidationTypes.AdjustmentsModule,
        label: "調整"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
        label: "コンテンツがないCanvasフォームのレビュー"
    },
    {
        id: ArcTimeLineValidationTypes.PersonInCharge,
        label: "担当者"
    },
    {
        id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
        label: ''
    },
    {
        id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
        label: "作成者と査閲者双方のサインオフのある一時ファイルについて、エビデンスに含める、又は、削除するのいずれとすべきかをレビューしてください。"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
        label: "PICタグのある一時ファイルをレビューして、エビデンスに移すべきかタグを削除すべきかを確認してください。"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
        label: "EQRタグのある一時ファイルをレビューして、エビデンスに移すべきかタグを削除すべきかを確認してください。"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
        label: "PICタグのある削除済ファイルをレビューして、エビデンスに移すべきかタグを削除すべきかを確認してください。"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
        label: "EQRタグのある削除済ファイルをレビューして、エビデンスに移すべきかタグを削除すべきかを確認してください。"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
        label: "エンゲージメントにおいて利用不可能となったオブジェクトに関連付けられた文書"
    }
];

export const ArchiveErrors = {
    32204: "エンゲージメントにエビデンスのないタスクがあります。",
    32209: "エンゲージメントに、回答が不完全な状態のCanvasフォームがあります。",
    32210: "エンゲージメントにオープンのレビューノートがあります。",
    32212: "エンゲージメントに未了タスクがあります。",

    32402: "アーカイブIDがnullまたは空です。",
    32403: "ファイルGUIDがnullまたは空です。",
    32404: "ARC FileStoreHostがnullまたは空です。",
    32424: "プライマリーエンゲージメントコードが未入力又は無効です。",
    32425: "報告書発行日は将来日付とすることはできません。",
    32426: "報告書発行日はエンゲージメント終了日後である必要があります。",
    32427: "パートナーをエンゲージメントにインバイトする必要があります。",
    32428: "ARCには調書タイプのデータがありません。",
    32429: "アーカイブフォーム上、報告タイプに関する選択が必須です。",
    32430: "限定付適正意見のアーカイブフォームに関する選択が必須です。",
    32431: "ARCとの統合によりアーカイブプロセス中にエラーが発生しました。ヘルプデスクに連絡しこのエラーを報告してください。"
};

export const validationTypes = [{
        id: 1,
        label: "未解決となっている独立性確認",
        altLabel: "Incomplete form",
        errorLabel: "未了の独立性遵守"
    },
    {
        id: 2,
        label: "独立性フォームのバージョンが最新ではありません",
        altLabel: "Out of date form",
        errorLabel: "現行バージョンでない独立性フォーム"
    },
    {
        id: 3,
        label: "不適切なロールによって付与されたアクセス",
        altLabel: "Not approved by PPEDD",
        errorLabel: "不適格な役割による付与されたアクセス"
    },
    {
        id: 4,
        label: "不適切なロールによる上書き",
        altLabel: "Not overridden by PPEDD",
        errorLabel: "不適格な役割によるオーバライド"
    },
    {
        id: 5,
        label: "関連付けが行われていないSCOT（勘定科目が不足）",
        errorLabel: "関連付いていないSCOTs"
    },
    {
        id: 6,
        label: "関連付けが行われていない統制（WCGWが不足）",
        errorLabel: "関連付いていない統制"
    },
    {
        id: 7,
        label: "統制依拠戦略が選択されているが関連するWCGWがありません",
        errorLabel: "WCGWが関連付いていない統制戦略の選択"
    },
    {
        id: 8,
        label: "統制依拠戦略が選択されているが関連する統制がありません",
        errorLabel: "統制が関連付いていない統制戦略の選択"
    },
    {
        id: 9,
        label: "統制依拠戦略が選択されていますが、テスト対象とされた統制が関連付けされていません",
        errorLabel: "テスト対象として選択された統制が関連付いていない統制戦略の選択"
    },
    {
        id: 10,
        label: "統制依拠戦略が選択されていますが、テスト対象とされた統制に紐づかないWCGWがあります。",
        errorLabel: "統制戦略が選択されています。テスト対象として選択された統制が関連付いていないWCGWがあります。"
    },
    {
        id: 11,
        label: "関連付けされていないリスク",
        errorLabel: "関連付いていないリスク"
    },
    {
        id: 12,
        label: "アサーションに関するCRAを完了してください",
        errorLabel: "このアサーションに関するCRAの完了"
    },
    {
        id: 13,
        label: "関連付けされていないWCGWs",
        errorLabel: "関連付いていないWCGW"
    },
    {
        id: 14,
        label: "重要な勘定科目に関連するSCOTsがありません",
        errorLabel: "重要な勘定科目にSCOTが関連付いていません"
    },
    {
        id: 15,
        label: "統制依拠戦略が選択されていますが、WCGWが関連付けされていません",
        errorLabel: "WCGWが関連付いていない依拠戦略の選択"
    },
    {
        id: 16,
        label: "統制依拠戦略が選択されていますが、統制が関連付けされていません",
        errorLabel: "統制が関連付いていない依拠戦略の選択"
    },
    {
        id: 17,
        label: "テスト対象とする関連する統制なしで選択された依拠戦略",
        errorLabel: "テスト対象として選択された統制が関連付いていない依拠戦略の選択"
    },
    {
        id: 18,
        label: "統制依拠戦略が選択されていますが、テストすべき統制に関連づけられていないWCGWがあります",
        errorLabel: "依拠戦略が選択されています。テスト対象として選択された統制が関連付いていないWCGWがあります。"
    },
    {
        id: 19,
        label: "関連付けられていないITアプリケーション/サービス受託会社",
        errorLabel: "関連付いていないIT App/So"
    },
    {
        id: 20,
        label: "関連付けられていない統制/IT実証手続",
        errorLabel: "関連付いていない統制/IT実証手続"
    },
    {
        id: 21,
        label: "関連づけられているITアプリケーション/サービス受託会社がありません",
        errorLabel: "関連するIT App/SOなし"
    },
    {
        id: 22,
        label: "関連するリスクがありません",
        errorLabel: "関連するリスクなし"
    },
    {
        id: 23,
        label: "関連する統制/IT実証手続がありません",
        errorLabel: "関連する統制/IT実証手続なし"
    },
    {
        id: 24,
        label: "テストのために選択された関連する統制/IT実証手続はありません",
        errorLabel: "テスト対象として選択された統制/IT実証手続が関連付いていない"
    },
    {
        id: 25,
        label: "テストのために選択された統制/IT実証手続に関連づけられていないリスクがあります",
        errorLabel: "テスト対象として選択された統制/IT実証手続が関連付いていないリスクがあります。"
    },
    {
        id: 26,
        label: "リスクが限定的な勘定科目に関連付けられた実証タスクがありません",
        errorLabel: "リスクが限定的な勘定科目は関連付いている実証タスクを1つも有していません。"
    },
    {
        id: 27,
        label: "アサーションに関連付けられた実証タスクがありません",
        errorLabel: "実証タスクはこのアサーションに1つも関連付いていません。"
    },
    {
        id: 28,
        label: "関連付けられていないTOC",
        errorLabel: "関連付いていないTOC"
    },
    {
        id: 29,
        label: "関連付けられていないウォークスルー",
        errorLabel: "関連付いていないウォークスルー"
    },
    {
        id: 30,
        label: "SCOTに関連付けられたウォークスルーがありません",
        errorLabel: "SCOTに関連付いているウォークスルータスクなし"
    },
    {
        id: 31,
        label: "テスト対象とされた統制に対し関連付けられた統制がありません。",
        errorLabel: "テスト対象として選択された統制に関連付いている統制タスクなし"
    },
    {
        id: 32,
        label: "関連付けられていないIT/サービス受託会社ウォークスルー",
        errorLabel: "関連付いていないIT/SOウォークスルー"
    },
    {
        id: 33,
        label: "関連付けられていないIT/サービス受託会社TOC",
        errorLabel: "関連付いていない IT/SO TOC"
    },
    {
        id: 34,
        label: "関連付けられていないIT/サービス受託会社OSP",
        errorLabel: "関連付いていない IT/SO OSP"
    },
    {
        id: 35,
        label: "IT/サービス受託会社プロセスには、関連付けられたウォークスルータスクがありません",
        errorLabel: "IT/SOプロセスはウォークスルータスクに関連付いていません"
    },
    {
        id: 36,
        label: "統制に対して関連付けられたTOCがありません",
        errorLabel: "統制はTOCに関連付いていません"
    },
    {
        id: 37,
        label: "IT実証手続に対して関連付けられたOSPがありません",
        errorLabel: "IT実証手続がOSPに関連付いていません"
    },
    {
        id: 38,
        label: "文書の競合",
        errorLabel: "未解決のコンフリクト"
    },
    {
        id: 39,
        label: "同期の競合 - 共有エビデンス - Canvas検証カウントに表示されません",
        errorLabel: "共有されたエビデンス - 同期のコンフリクト"
    },
    {
        id: 40,
        label: "サインオフがないエビデンス",
        errorLabel: "全てのエビデンスにサインオフ"
    },
    {
        id: 41,
        label: "エビデンスがないタスク",
        errorLabel: "開いているタスクにエビデンスを追加する"
    },
    {
        id: 42,
        label: "無効なエンゲージメントコード",
        errorLabel: "無効なエンゲージメントコード"
    },
    {
        id: 43,
        label: "無効なクライアントコード",
        errorLabel: "無効なクライアントコード"
    },
    {
        id: 44,
        label: "重複するファイル名",
        errorLabel: "ファイル名の複製"
    },
    {
        id: 45,
        label: "IT評価の不整合",
        errorLabel: "不完全なITプロセス評価"
    },
    {
        id: 46,
        label: "不完全なITプロセス評価",
        errorLabel: "不完全なITプロセス評価"
    },
    {
        id: 47,
        label: "IT総合評価の未了",
        errorLabel: "不完全なIT総合評価"
    },
    {
        id: 48,
        label: "未了のレスポンス",
        errorLabel: "裏付け根拠が不完全"
    },
    {
        id: 49,
        label: "関連付けられていない虚偽表示",
        errorLabel: "関連付いていない虚偽表示"
    },
    {
        id: 50,
        label: "関連付けられていない不備",
        errorLabel: "関連付いていない不備"
    },
    {
        id: 51,
        label: "実証タスクの関連付けられていないWCGW",
        errorLabel: "実証タスクが関連付いていないWCGW"
    },
    {
        id: 52,
        label: "WCGWの関連付けられていないリスク",
        errorLabel: "WCGWがないリスク"
    },
    {
        id: 53,
        label: "見積PSPインデックスがない見積勘定科目",
        errorLabel: "見積PSPインデックスがない見積勘定科目"
    },
    {
        id: 54,
        label: "見積SCOTがない見積勘定科目",
        errorLabel: "見積SCOTがない見積勘定科目"
    },
    {
        id: 55,
        label: "見積勘定科目が紐づけられていない見積SCOT",
        errorLabel: "見積勘定科目がない見積SCOT"
    },
    {
        id: 56,
        label: "対応TOCが紐づいていない統制リスクを有するアサーション",
        errorLabel: "対応するTOCがないが統制依拠とされているアサーション"
    },
    {
        id: 57,
        label: "低リスクではないリスクに対応して適切に整備された統制が１つも存在しないにも関わらず統制依拠戦略を採用しているアサーション",
        errorLabel: "統制に依拠するアサーションだが、低ではないリスクに対応する有効にデザインされた統制に関連付いているTOCがない"
    },
    {
        id: 58,
        label: "対応実証タスクが紐づけられていないアサーション",
        errorLabel: "対応する実証タスクがないアサーション"
    },
    {
        id: 59,
        label: "対応統制が紐づけられていないアサーション",
        errorLabel: "対応する統制がないアサーション"
    },
    {
        id: 60,
        label: "Canvasフォームコメント",
        errorLabel: "Canvasフォームコメント"
    },
    {
        id: 61,
        label: "Canvasフォームの不完全な回答",
        errorLabel: "Canvasフォームの不完全な回答"
    },
    {
        id: 62,
        label: "クローズ又は削除すべきオープン又はクリア済レビューノート",
        errorLabel: "クローズ又は削除すべきオープン又はクリア済レビューノート"
    },
    {
        id: 63,
        label: "変更履歴付きエビデンス",
        errorLabel: "変更履歴付きエビデンス"
    },
    {
        id: 64,
        label: "完了マークのないタスク",
        errorLabel: "タスクを完了とマークする"
    },
    {
        id: 65,
        label: "リンク解除が行われていない共有エビデンス",
        errorLabel: "共有エビデンスの共有解除"
    },
    {
        id: 66,
        label: "変更タイプが選択されていない文書",
        errorLabel: "修正タイプが選択されていない文書"
    },
    {
        id: 67,
        label: "変更理由（根拠）がない事務的でない変更",
        errorLabel: "変更理由（根拠）がない事務的でない変更"
    },
    {
        id: 68,
        label: "適切なロールによる事務的な変更以外の変更の未承認",
        errorLabel: "適切なロールによる事務的でない変更に対する未承認"
    },
    {
        id: 69,
        label: "エグゼクティブレビューアーのサインオフがない440GL",
        errorLabel: "440GLにエグゼクティブレビューアーのサインオフがありません"
    },
    {
        id: 70,
        label: "リンク解除が行われていないグループエンゲージメント",
        errorLabel: "グループからこのエンゲージメントのリンクを解除します"
    },
    {
        id: 71,
        label: "ヘッダーのないCanvasフォーム",
        altLabel: "ヘッダーのないCanvasフォーム",
        errorLabel: "ヘッダーのないCanvasフォーム"
    },
    {
        id: 72,
        label: "グループコンポーネントサマリー文書に内容がありません",
        errorLabel: "グループコンポーネントサマリー文書に内容がありません"
    },
    {
        id: 73,
        label: "Canvasフォームへの対応未了（承認ステータス考慮外）",
        errorLabel: "不完全なCanvasフォーム"
    },
    {
        id: 74,
        label: "プロファイルV2の変更未提出",
        errorLabel: "プロファイルの変更は提出されていません"
    },
    {
        id: 75,
        label: "0バイトの電子ファイル",
        errorLabel: "0バイトの電子ファイル"
    },
    {
        id: 76,
        label: "提出後に編集された独立性フォーム",
        altLabel: "未提出のフォーム",
        errorLabel: "提出後に編集された独立性フォーム"
    },
    {
        id: 77,
        label: "個人と異なる独立性テンプレート",
        altLabel: "個人と異なる独立性テンプレート",
        errorLabel: "個人と異なる独立性テンプレート"
    },
    {
        id: 78,
        label: "少なくとも1つのITプロセスが関連付いていない（SOではない）ITアプリケーション",
        errorLabel: "関連付いていないITアプリケーション"
    },
    {
        id: 79,
        label: "ITリスクが関連付いていないかITGCと関連しないITリスクが関連付いているITGC",
        errorLabel: "関連付いていないITGC"
    },
    {
        id: 80,
        label: "ITSPには関連するITリスクがありません",
        errorLabel: "Unrelated ITSP"
    },
    {
        id: 81,
        label: "ITプロセスには関連するITアプリケーションがありません",
        errorLabel: "関連付いていないITプロセス"
    },
    {
        id: 82,
        label: "ITアプリケーションを介して関連するITACまたはITDMがある（統制の逸脱なし）、ITリスクのないITプロセス",
        errorLabel: "ITリスクがありません"
    },
    {
        id: 83,
        label: "ITリスクには関連する ITGCがありません",
        errorLabel: "ITGCがない、またはマークが存在しません"
    },
    {
        id: 84,
        label: "ITアプリケーションが関連付いていないITDM/ITAC",
        errorLabel: "ITアプリケーションが関連付いていないApp/ITDM"
    },
    {
        id: 85,
        label: "対応する本文が表示されていない場合にはITSPは削除されません",
        errorLabel: "削除されるITSP"
    },
    {
        id: 86,
        label: "対応する本文が表示されていない場合にはITSPは削除されません",
        errorLabel: "削除されるITGC"
    },
    {
        id: 87,
        label: "対応する本文が表示されていない場合にはITリスクは削除されません",
        errorLabel: "削除されるITリスク"
    },
    {
        id: 88,
        label: "対象が表示されていない場合にはIT統制のテストが関連付いたITGCが存在します",
        errorLabel: "テスト戦略が無効であるITGC"
    },
    {
        id: 89,
        label: "デザインの有効性が選択されていないITGC",
        errorLabel: "ITGCのデザイン評価がありません"
    },
    {
        id: 90,
        label: "デザインの有効性が選択されていない統制",
        errorLabel: "デザインの有効性が選択されていない統制"
    },
    {
        id: 91,
        label: "ITアプリケーションが関連付いていないSCOT",
        errorLabel: "関連付いていないSCOT"
    },
    {
        id: 92,
        label: "特別な検討を必要するリスクに対応するがWCGWに関連するリスクには対応しない実証手続及び統制テスト",
        errorLabel: "リスクとタスクとの関連付けがリスク>WCGW>タスクの関係と整合していません"
    },
    {
        id: 93,
        label: "統制テストへの矛盾のある対応",
        errorLabel: "統制テストへの矛盾のある対応"
    },
    {
        id: 94,
        label: "ITアプリケーションに関連付いていないがITDMやITACに関連付いたSCOT",
        errorLabel: "SCOTのITアプリケーションがありません"
    },
    {
        id: 95,
        label: "全般的責任を割当てられたチームメンバーがいません",
        altLabel: "全般的責任を割当てられたチームメンバーがいません",
        errorLabel: "全般的責任を割当てられたチームメンバーがいません"
    },
    {
        id: 96,
        label: "リスク要因がリスクに関連していないもしくはROMMではないとマークされていない",
        errorLabel: "リスク要因がリスクに関連していないもしくはROMMではないとマークされていない"
    },
    {
        id: 97,
        label: "Risks unrelated to an Assertion",
        errorLabel: "Risks unrelated to an Assertion"
    },
    {
        id: 98,
        label: "見込基礎値の測定 - 未了",
        errorLabel: "見込基礎値の測定 - 未了"
    },
    {
        id: 99,
        label: "見込基礎値の根拠の測定 - 未了",
        errorLabel: "見込基礎値の根拠の測定 - 未了"
    },
    {
        id: 100,
        label: "調整後基礎値の測定 - 未了",
        errorLabel: "調整後基礎値の測定 - 未了"
    },
    {
        id: 101,
        label: "PM - 未了",
        errorLabel: "PM - 未了"
    },
    {
        id: 102,
        label: "PMが最大値を超えています",
        errorLabel: "PMが最大値を超えています"
    },
    {
        id: 103,
        label: "PMの根拠 - 未了",
        errorLabel: "PMの根拠 - 未了"
    },
    {
        id: 104,
        label: "TE - 未了",
        errorLabel: "TE - 未了"
    },
    {
        id: 105,
        label: "TEが認められた値の範囲外",
        errorLabel: "TEが認められた値の範囲外"
    },
    {
        id: 106,
        label: "TEの根拠 - 未了",
        errorLabel: "TEの根拠 - 未了"
    },
    {
        id: 107,
        label: "SAD - 未了",
        errorLabel: "SAD- 未了"
    },
    {
        id: 108,
        label: "SADが最大値を超えています",
        errorLabel: "SADが最大値を超えています"
    },
    {
        id: 109,
        label: "SADの根拠 - 未了",
        errorLabel: "SADの根拠 - 未了"
    },
    {
        id: 110,
        label: "PACE選択 - 未了",
        errorLabel: "PACE選択 - 未了"
    },
    {
        id: 111,
        label: "関連する文書はありません",
        errorLabel: "関連する文書はありません"
    },
    {
        id: 112,
        label: "PIC文書が1つも関連付いていないPICタスク",
        errorLabel: "PIC文書が1つも関連付いていないPICタスク"
    },
    {
        id: 113,
        label: "EQR文書が1つも関連付いていないEQRタスク",
        errorLabel: "EQR文書が1つも関連付いていないEQRタスク"
    },
    {
        id: 114,
        label: "PICタスクが1つも関連付いていないPIC文書",
        errorLabel: "PICタスクが1つも関連付いていないPIC文書"
    },
    {
        id: 115,
        label: "EQRタスクが1つも関連付いていないEQR文書",
        errorLabel: "EQRタスクが1つも関連付いていないEQR文書"
    },
    {
        id: 116,
        label: "PICサインオフが1つもないPIC文書",
        errorLabel: "PICサインオフが1つもないPIC文書"
    },
    {
        id: 117,
        label: "EQRサインオフが1つもないEQR文書",
        errorLabel: "EQRサインオフが1つもないEQR文書"
    },
    {
        id: 118,
        label: "アーカイブすべきでない文書がまだ存在します",
        errorLabel: "アーカイブすべきでない文書がまだ存在します"
    },
    {
        id: 119,
        label: "実施者と査閲者がサインオフしている一時ファイル",
        errorLabel: "実施者と査閲者がサインオフしている一時ファイル"
    },
    {
        id: 120,
        label: "全てのオープン又はクリア済Canvasフォームコメント",
        errorLabel: "全てのオープン又はクリア済Canvasフォームコメント"
    },
    {
        id: 121,
        label: "PICのサインオフ要件が設定されている一時ファイル",
        errorLabel: "PICのサインオフ要件が設定されている一時ファイル"
    },
    {
        id: 122,
        label: "EQRのサインオフ要件が設定されている一時ファイル",
        errorLabel: "EQRのサインオフ要件が設定されている一時ファイル"
    },
    {
        id: 123,
        label: "PICのサインオフ要件が設定されている削除済ファイル",
        errorLabel: "PICのサインオフ要件が設定されている削除済ファイル"
    },
    {
        id: 124,
        label: "EQRのサインオフ要件が設定されている削除済ファイル",
        errorLabel: "EQRのサインオフ要件が設定されている削除済ファイル"
    },
    {
        id: 125,
        label: "保護された文書をレビューする",
        errorLabel: "保護された文書をレビューする"
    },
    {
        id: 126,
        label: "利用できない文書コンテンツ",
        errorLabel: "利用できない文書コンテンツ"
    },
    {
        id: 127,
        label: "データのない損益計算書",
        errorLabel: "データのない損益計算書"
    },
    {
        id: 128,
        label: "データのない貸借対照表",
        errorLabel: "データのない貸借対照表"
    },
    {
        id: 129,
        label: "マルチエンティティ‐関連する勘定科目のすべてのPSP/ACTに関連づけられていないマルチエンティティ",
        errorLabel: "マルチエンティティ‐関連する勘定科目のすべてのPSP/ACTに関連づけられていないマルチエンティティ"
    },
    {
        id: 130,
        label: "個別のリスク評価フォームがない勘定科目",
        errorLabel: "個別のリスク評価フォームがない勘定科目"
    },
    {
        id: 131,
        label: "見積りの文書化のない見積り",
        errorLabel: "見積りの文書化のない見積り"
    },
    {
        id: 132,
        label: "個別の分析フォームがない勘定科目",
        errorLabel: "個別の分析フォームがない勘定科目"
    },
    {
        id: 133,
        label: "個別のプロファイルフォームがないマルチエンティティ",
        errorLabel: "個別のプロファイルフォームがないマルチエンティティ"
    },
    {
        id: 134,
        label: "勘定科目‐アクションに一致しない勘定科目タイプＩＤ",
        errorLabel: "勘定科目‐アクションに一致しない勘定科目タイプＩＤ"
    },
    {
        id: 135,
        label: "勘定科目‐アクションに一致しない会計上の見積りを含む勘定科目",
        errorLabel: "勘定科目‐アクションに一致しない会計上の見積りを含む勘定科目"
    },
    {
        id: 136,
        label: "勘定科目‐勘定科目に関連付けられていない関連するリスクのある勘定科目フォームオプション",
        errorLabel: "勘定科目‐勘定科目に関連付けられていない関連するリスクのある勘定科目フォームオプション"
    },
    {
        id: 137,
        label: "勘定科目‐関連する高リスクがない固有リスク「高」のアサーション",
        errorLabel: "勘定科目‐関連する高リスクがない固有リスク「高」のアサーション"
    },
    {
        id: 138,
        label: "マルチエンティティ‐関連する勘定科目に関連付けられた実証手続がないマルチエンティティ",
        errorLabel: "マルチエンティティ‐関連する勘定科目に関連付けられた実証手続がないマルチエンティティ"
    },
    {
        id: 139,
        label: "構成単位チームの作業に対する関与フォームのない構成単位 (参照専用の構成単位を除く)",
        errorLabel: "構成単位チームの作業に対する関与フォームのない構成単位 (参照専用の構成単位を除く)"
    },
    {
        id: 140,
        label: "関連するグループリスク評価インストラクションがない構成単位 (フル/スペシフィック)(参照専用の構成単位を除く)",
        errorLabel: "関連するグループリスク評価インストラクションがない構成単位 (フル/スペシフィック)(参照専用の構成単位を除く)"
    },
    {
        id: 141,
        label: "マルチエンティティ－関連するマルチエンティティのない勘定科目",
        errorLabel: "マルチエンティティ－関連するマルチエンティティのない勘定科目"
    },
    {
        id: 142,
        label: "文書.無効なオブジェクトに関連付けられたスマートエビデンスソースID",
        errorLabel: "文書.無効なオブジェクトに関連付けられたスマートエビデンスソースID"
    },
    {
        id: 143,
        label: "勘定科目‐関連する高リスクがない固有リスク「高」のアサーション",
        errorLabel: "勘定科目‐関連する高リスクがない固有リスク「高」のアサーション"
    },
    {
        id: 144,
        label: "グループ - 関連する構成単位のない勘定科目（他のエンゲージメントで実施済)",
        errorLabel: "グループ - 関連する構成単位のない勘定科目（他のエンゲージメントで実施済)"
    },
    {
        id: 145,
        label: "勘定科目－見積PSPインデックスのない見積勘定科目",
        errorLabel: "勘定科目－見積PSPインデックスのない見積勘定科目"
    },
    {
        id: 146,
        label: "マルチエンティティ - 個別のプロファイルの変更が提出されていないマルチエンティティ（個別の文書）",
        errorLabel: "マルチエンティティ - 個別のプロファイルの変更が提出されていないマルチエンティティ（個別の文書）"
    },
    {
        id: 147,
        label: "マルチエンティティ - 個別のプロファイルの変更が提出されていないマルチエンティティ（個別の文書）",
        errorLabel: "マルチエンティティ - 個別のプロファイルの変更が提出されていないマルチエンティティ（個別の文書）"
    },
    {
        id: 148,
        label: "勘定科目 - 不完全または無効な勘定科目のプロパティ",
        errorLabel: "勘定科目 - 不完全または無効な勘定科目のプロパティ"
    },
    {
        id: 149,
        label: "文書アップロード - 必須のPIC/EQRサインオフがない",
        errorLabel: "文書アップロード - 必須のPIC/EQRサインオフがない"
    },
    {
        id: 150,
        label: "文書アップロード - 必須のPIC/EQRサインオフ要求事項がない",
        errorLabel: "文書アップロード - 必須のPIC/EQRサインオフ要求事項がない"
    },
    {
        id: 151,
        label: "勘定科目 - 関連するアサーションがない重要な勘定科目/開示",
        errorLabel: "勘定科目 - 関連するアサーションがない重要な勘定科目/開示"
    },
    {
        id: 152,
        label: "文書アップロード - 実施者又は査閲者のサインオフがない",
        errorLabel: "文書アップロード - 実施者又は査閲者のサインオフがない"
    },
    {
        id: 153,
        label: "エビデンスがない調整",
        errorLabel: "エビデンスがない調整"
    },
    {
        id: 154,
        label: "勘定科目が関連付けられてない見積り",
        errorLabel: "勘定科目が関連付けられてない見積り"
    },
    {
        id: 155,
        label: "見積りではない勘定科目に関連する高/低リスク見積項目",
        errorLabel: "見積りではない勘定科目に関連する高/低リスク見積項目"
    },
    {
        id: 156,
        label: "見積りカテゴリの回答が「見積りの編集」の指定と一致していません",
        errorLabel: "見積りカテゴリの回答が「見積りの編集」の指定と一致していません"
    },
    {
        id: 157,
        label: "有効なSCOTがない見積り",
        errorLabel: "有効なSCOTがない見積り"
    },
    {
        id: 158,
        label: "Account without valid estimate",
        errorLabel: "Account without valid estimate"
    },
    {
        id: 159,
        label: "高/低リスク見積項目がない見積勘定科目",
        errorLabel: "高/低リスク見積項目がない見積勘定科目"
    },
    {
        id: 160,
        label: "高/低リスク見積項目がない見積SCOT",
        errorLabel: "高/低リスク見積項目がない見積SCOT"
    },
    {
        id: 161,
        label: "相殺しない調整",
        errorLabel: "相殺しない調整"
    },
    {
        id: 162,
        label: "有効なリスクが関連付けられていない高リスク見積項目",
        errorLabel: "有効なリスクが関連付けられていない高リスク見積項目"
    },
    {
        id: 163,
        label: "文書 - コラボレーションのためにチェックアウトされたか、またはチェックアウト中の文書",
        errorLabel: "文書 - コラボレーションのためにチェックアウトされたか、またはチェックアウト中の文書"
    },
    {
        id: 164,
        label: "エビデンスがないエンゲージメント非横断タスク",
        errorLabel: "エビデンスがないエンゲージメント非横断タスク"
    },
    {
        id: 165,
        label: "EPまたはEQRサインオフ要件が回答と一致しません",
        errorLabel: "EPまたはEQRサインオフ要件が回答と一致しません"
    },
    {
        id: 166,
        label: "特別な検討を必要とするリスク/不正リスクが、高リスクではない見積項目に関連付けられています",
        errorLabel: "特別な検討を必要とするリスク/不正リスクが、高リスクではない見積項目に関連付けられています"
    }
];

export const contentType = {
    1: "主要標準タスク（PSTs）",
    2: "主要実証手続のインデックス（PSPs）",
    3: "主要実証手続（PSPs）",
    4: "グループ監査インストラクション",
    5: "GAMで要求されるCanvasフォーム",
    6: "ユーザーが作成したCanvasフォーム（例：SCOTフォーム）",
    7: "独立性",
    9: "プロファイル",
    10: "Canvasマッピング"
};

export const contentTypeByName = {
    'PST': "主要標準タスク（PST）",
    'PSPIndex': "主要実証手続インデックス（PSPインデックス）",
    'PSP': "主要実証手続（PSP）",
    'GAInstructions': "グループ監査インストラクション",
    'CanvasFormKnowledge': "ナレッジから作成されたCanvasフォーム",
    'CanvasFormUserAdded': "ユーザーが作成したCanvasフォーム（例：SCOTフォーム）",
    'IndependenceForm': "独立性",
    'Profile': "プロファイル",
    'Maps': "Canvasマッピング"
};

export const reportTypes = {
    1: "無限定適正意見 - 強調事項あり",
    2: "無限定適正意見 - 強調事項なし",
    3: "限定付適正意見 - 強調事項あり",
    4: "限定付適正意見 - 強調事項なし",
    5: "不適正意見 - 強調事項あり",
    6: "不適正意見 - 強調事項なし",
    7: "意見不表明 - 強調事項あり",
    8: "意見不表明 - 強調事項なし",
    100: "いいえ",
    101: "該当なし",
    102: "未選択"
};

export const internalUserRoles = [{
        roleKey: 3,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "許可",
        roleNameUI: "エンゲージメントアーカイブ",
        displayName: "エンゲージメントアーカイブ",
        roleDisplayOrder: 2,
        tooltipText: "エンゲージメントのアーカイブの可否"
    },
    {
        roleKey: 4,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "許可",
        roleNameUI: "エンゲージメント管理",
        displayName: "エンゲージメントの管理",
        roleDisplayOrder: 1,
        tooltipText: "内部メンバーと外部メンバーをインバイトし、内部メンバーに権限を割当てる機能"
    },
    {
        roleKey: 5,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "許可",
        roleNameUI: "コンテンツ更新",
        displayName: "コンテンツアップデート",
        roleDisplayOrder: 6,
        tooltipText: "プロファイルの編集及びコンテンツ更新の受入の可否"
    },
    {
        roleKey: 7,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "許可",
        roleNameUI: "サービスリクエストの作成",
        displayName: "サービスリクエストの管理",
        roleDisplayOrder: 4,
        tooltipText: "サービスリクエストを作成及びサービスリクエストを完了する権限"
    },
    {
        roleKey: 8,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "許可",
        roleNameUI: "グループの管理",
        displayName: "グループの管理",
        roleDisplayOrder: 5,
        tooltipText: "プライマリーまたはリージョナルチームから受領したインストラクションを受諾または差戻する"
    },
    {
        roleKey: 9,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "許可",
        roleNameUI: "コピー、ロールフォワード、エンゲージメントのリストア",
        displayName: "エンゲージメントのコピー、ロールフォワード、リストア",
        roleDisplayOrder: 3,
        tooltipText: "エンゲージメントをコピー、ロールフォワード、アーカイブをリストアする権限",
    },
    {
        roleKey: 0,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "機密保持レベル",
        roleNameUI: "デフォルト",
        displayName: "なし(デフォルト)",
        roleDisplayOrder: 1,
        tooltipText: "既定の機密文書ロール"
    },
    {
        roleKey: 10,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "機密保持レベル",
        roleNameUI: "低",
        displayName: "低",
        roleDisplayOrder: 8,
        tooltipText: "低レベル機密文書のロール"
    },
    {
        roleKey: 11,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "機密保持レベル",
        roleNameUI: "高",
        displayName: "高",
        roleDisplayOrder: 10,
        tooltipText: "高レベル機密文書のロール"
    },
    {
        roleKey: 12,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "機密保持レベル",
        roleNameUI: "中",
        displayName: "中",
        roleDisplayOrder: 9,
        tooltipText: "中レベル機密文書のロール"
    },
    // {
    // roleKey: 13,
    // sectionId:1,
    // groupDisplayOrder: 200,
    // groupName: "守秘義務",
    // roleNameUI: "極秘",
    // displayName: "極秘",
    // roleDisplayOrder: 11,
    // tooltipText: "極秘文書のロール"
    // },
    {
        roleKey: 14,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "制限",
        roleNameUI: "読み取り専用",
        displayName: "読み取り専用",
        roleDisplayOrder: 12,
        tooltipText: "この機能は第三者レビューアーにCanvasエンゲージメントへのアクセス権限を付与する際にのみ使用します。プロフェッショナル・プラクティス（【日本】品質管理本部【日本】）から適切な承認を得てください。"
    },
    {
        roleKey: 16,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "制限",
        roleNameUI: "レビュー限定",
        displayName: "レビュー限定",
        roleDisplayOrder: 13,
        tooltipText: "レビュー限定権限では、ユーザーにEY Canvasエンゲージメントの情報閲覧、サインオフ、レビューノート機能の使用を許可するものです。これは、他のEYユーザーがこのエンゲージメントをレビューする必要があるが、編集の必要がない場合に使用します。"
    },
  {
        roleKey: 37,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "制限",
        roleNameUI: "独立性のみ",
        displayName: "独立性のみ",
        roleDisplayOrder: 14,
        tooltipText: "「独立性のみ」は、このユーザーにエンゲージメントの独立性フォームを完成させる権限を付与しますが、EY Canvasエンゲージメントに完全にアクセスすることはできません。これは、ユーザーがエンゲージメントの作業を実施したが、EY Canvasにアクセスする必要がない場合に使用されます。",
    },
    {
        roleKey: 6,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "許可",
        roleNameUI: "編集を戻す",
        displayName: "文書のロールバック／一括削除",
        roleDisplayOrder: 7,
        tooltipText: "報告書日後に誤って変更が加えられた場合に文書をロールバックし、440 Canvasフォームから削除する機能"
    },
    {
        roleKey: 35,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "許可",
        roleNameUI: "EY Canvas FITイネーブルメントの共有管理",
        displayName: "ガイド付きワークフローの管理",
        roleDisplayOrder: 14,
        tooltipText: "EY Canvasエンゲージメント間でガイド付きワークフローを共有する機能"
    },
    {
        roleKey: 36,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "許可",
        roleNameUI: "EY Helixデータのインポート",
        displayName: "EY Helixデータのインポート",
        roleDisplayOrder: 15,
        tooltipText: "EY Helixデータのインポート機能"
    }
];

export const ValidationSubGroups = [{
        id: 9008,
        label: "独立性遵守状況"
    },
    {
        id: 9001,
        label: "勘定科目サマリー"
    },
    {
        id: 9002,
        label: "SCOTサマリー"
    },
    {
        id: 9004,
        label: "ITサマリー"
    },
    {
        id: 9003,
        label: "CRAサマリー"
    },
    {
        id: 9005,
        label: "監査計画"
    },
    {
        id: 9011,
        label: "Substantive evaluation matrix"
    },
    {
        id: 9012,
        label: "Canvas formのバリデーション（検証）"
    },
    {
        id: 9009,
        label: "IT評価"
    },
    {
        id: 49,
        label: "関連付けが行われていない虚偽表示"
    },
    {
        id: 50,
        label: "関連付けが行われていない不備"
    },
    {
        id: 44,
        label: "重複するファイル名"
    },
    {
        id: 38,
        label: "未解決の競合"
    },
    {
        id: 9013,
        label: "監査報告書日以降の変更"
    },
    {
        id: 9014,
        label: "ITフロー"
    },
    {
        id: 9015,
        label: "EY Canvas FITイネーブルメント"
    },
    {
        id: 71,
        label: "コンテンツがないフォーム"
    },
    {
        id: 9016,
        label: 'Incomplete canvas form response'
    },
    {
        id: 9017,
        label: 'Adjustment module'
    },
];

export const engagementIndustry = {
    116: "Not Sector Specific 特定のセクターなし",
    61: "Aerospace and Defense – Aerospace Manufacturing 航空・防衛 - 航空関連製造",
    112: "Aerospace and Defense – Defense Contracts Manufacturing 航空・防衛 - 防衛関連請負製造",
    59: "Airlines – Air Transportation 航空運輸 - 航空輸送",
    92: "Asset Management – Commodity Funds アセットマネジメント - 商品ファンド",
    57: "Asset Management – Other Funds アセットマネジメント - その他のファンド",
    43: "Asset Management – Private Equity / Venture Capital アセットマネジメント - 未公開株式/ベンチャーキャピタル",
    85: "Asset Management – Registered / Listed Funds アセットマネジメント - 上場ファンド",
    53: "Asset Management – Structured Products アセットマネジメント - 仕組商品",
    60: "Asset Management – Unregulated Hedge Funds アセットマネジメント - 非規制ヘッジファンド",
    10: "Asset Management – Unregulated Segregated Accounts アセットマネジメント - 分別保管対象外の口座",
    90: "Audit of Compliance Management Systems コンプライアンスマネジメントシステム監査",
    51: "Automotive – Automotive Dealers and Repairs 自動車 - 自動車販売・整備",
    101: "Automotive – Automotive Manufacturing 自動車 - 自動車関連製造",
    5: "Automotive – Automotive Suppliers 自動車 - 自動車部品卸売",
    71: "Banking and Capital Markets – Banks 銀行・証券 - 銀行",
    89: "Banking and Capital Markets – Broker Dealers 銀行・証券 - 証券・商品先物取引",
    27: "Banking and Capital Markets – Credit Unions 銀行・証券 - 信用金庫・信用組合",
    54: "Banking and Capital Markets – Diversified and Other Financial Institutions 銀行・証券 - 総合その他の金融機関",
    32: "Banking and Capital Markets – Investment Banking 銀行・証券 - 証券取引所・商品取引所",
    4: "Biotechnology – Biotech – Emerging Growth Markets バイオ - バイオテクノロジー - 新興市場",
    109: "Biotechnology – Health Research and Testing バイオ - ヘルスリサーチ・検査",
    66: "Chemicals – Chemicals Manufacturing 化学 - 化学関連製造",
    41: "Cleantech クリーンテック",
    37: "Consolidations 連結",
    130: "Construction – Engineering and Architectural Services 建設 - エンジニアリング／建築サービス",
    68: "Construction – Highway and Heavy Construction 建設 - 土木工事",
    65: "Construction – Specialty Contractors 建設 - 特殊工事",
    82: "Consumer Products – Consumer Non– Durable Goods Manufacturing 消費者製品 - 非耐久消費財製造",
    17: "Consumer Products – Food and Beverages Manufacturing 消費者製品 - 飲食料品製造",
    35: "Consumer Products – Food Crops, Livestock, Fishing 消費者製品 - 農業、畜産業、漁業",
    33: "Consumer Products – Household Appliances and Electronics Manufacturing 消費者製品 - 家庭用電化製品・電子機器製造",
    75: "Consumer Products – Other Consumer Durable Goods Manufacturing 消費者製品 - その他の耐久消費財製造",
    39: "Consumer Products – Textiles and Apparel Manufacturing 消費者製品 - 繊維・衣服製造",
    21: "Diversified Industrial Products – Fabricated Metals 一般産業工業製品 - 金属製品製造",
    31: "Diversified Industrial Products – Forestry, Pulp, and Paper 一般産業工業製品 - 林業・パルプ紙加工品製造",
    29: "Diversified Industrial Products – Industrial Instruments Manufacturing 一般産業工業製品 - 工業用計測器製造",
    40: "Diversified Industrial Products – Industrial Machines Manufacturing 一般産業工業製品 - 産業用機械製造",
    26: "Diversified Industrial Products – Industrial Packaging 一般産業工業製品 - 工業梱包資材製造",
    42: "Diversified Industrial Products – Lumber and Wood Manufacturing 一般産業工業製品 - 木材・木製製品製造",
    105: "Diversified Industrial Products – Other Industrial Products 一般産業工業製品 - その他の工業製品",
    100: "Diversified Industrial Products – Primary Metals 一般産業工業製品 - 鉄鋼、非鉄金属製造",
    45: "Diversified Industrial Products – Printing 一般産業工業製品 - 印刷製本関連",
    1: "Diversified Industrial Products – Rubber and Plastics Manufacturing 一般産業工業製品 - ゴム製品・プラスティック製本製造",
    118: "Diversified Industrial Products – Stone, Clay, and Glass Manufacturing 一般産業工業製品 - 窯業、土石製品製造",
    76: "General または 一般",
    79: "Government and Public Sector – Education 政府及び公共セクター - 教育",
    78: "Government and Public Sector – Federal, National, and International Governments 政府及び公共セクター - 国立及び国際機関",
    131: "Government and Public Sector – Health Commissioner 政府及び公共セクター - 保健・衛生局",
    132: "Government and Public Sector – Health Provider 政府及び公共セクター - 医療供給",
    97: "Government and Public Sector – Local government, including State or other levels below National 政府及び公共セクター - 地方公共団体",
    2: "Health – Academic Medical Centers 公共医療 - 大学病院等",
    72: "Health – Government Hospitals 公共医療 - 政府系医療機関",
    74: "Health – Managed Health Care 公共医療 - 効率管理型医療",
    8: "Health – Multi Hospital Systems 公共医療 - マルチ・ホスピタル・システム",
    128: "Health – Non System Hospitals 公共医療 - 非システム（単立）ホスピタル",
    94: "Health – Other Health Care Entities 公共医療 - その他の医療機関",
    73: "Health – Physician Groups 公共医療 - 医師グループ",
    121: "Health – Post Acute Care 公共医療 - 急性期後治療",
    58: "Health – Specialty Hospitals 公共医療 - 専門医療機関",
    16: "Hospitality and Leisure – Gaming and Gambling レジャー - 娯楽・遊具施設",
    7: "Hospitality and Leisure – Hotels, Motels, and Lodging レジャー - 宿泊施設",
    126: "Hospitality – Restaurants / Eating and Drinking Establishments レジャー - 飲食店",
    84: "IFRS IFRS",
    55: "Insurance – Health Insurance 保険 - 健康保険",
    111: "Insurance – Insurance Agents and Brokers 保険 - 保険代理店業・保険外交員",
    69: "Insurance – Life Insurers 保険 - 生命保険",
    96: "Insurance – Other Insurance 保険 - その他の保険",
    11: "Insurance – Property and Casualty Insurers 保険 - 損害保険",
    117: "Insurance – Reinsurers 保険 - 再保険",
    23: "Life Sciences – Medical Technology 生命科学 - 医療テクノロジー",
    48: "Media and Entertainment – Advertising メディア・娯楽 - 広告代理店",
    14: "Media and Entertainment – Broadcast, Cable Network, Online Video メディア・娯楽 - 放送・ケーブルネットワーク・オンラインビデオ",
    18: "Media and Entertainment – Cable Provider, Satellite, MVPD メディア・娯楽 - ケーブルプロバイダー・衛星・MVPD",
    86: "Media and Entertainment – Film メディア・娯楽 - 映画",
    46: "Media and Entertainment – Integrated Media and Entertainment メディア・娯楽 - 総合メディア・娯楽",
    15: "Media and Entertainment – Music Industry メディア・娯楽 - 音楽興行関連",
    25: "Media and Entertainment – Other Media and Entertainment メディア・娯楽 - その他のメディア・娯楽業",
    20: "Media and Entertainment – Publishing メディア・娯楽 - 出版関連",
    30: "Media and Entertainment – Sports メディア・娯楽 - スポーツ関連",
    28: "Mining – Mining Operations 鉱業 - 採掘事業",
    3: "Non-complex SMEs 複雑でない中小企業(SMEs)",
    120: "Not for Profit – Foundations and Charitable Trusts 非営利団体 - 財団及び慈善信託",
    107: "Not for Profit – Other Not For Profit Organizations 非営利団体 - その他の非営利団体",
    70: "Oil and Gas – Energy Trading 石油・ガス - 油井・鉱山投資",
    22: "Oil and Gas – Exploration and Production 石油・ガス - 炭鉱及び生産",
    67: "Oil and Gas – Refining 石油・ガス - 精製",
    113: "Other Transportation – Local and Urban Transportation その他運輸 - 旅客運送",
    38: "Other Transportation – Other Transportation その他運輸 - その他の運営関連業",
    83: "Other Transportation – Rail Transportation その他運輸 - 鉄道関連",
    88: "Other Transportation – Road Transport and Warehousing その他運輸 - 自動車貨物運送・倉庫",
    6: "Other Transportation – Water Transportation その他運輸 - 海運・水上輸送・港湾運送",
    87: "Pension Funds / Benefit Plans ペンション・ファンド/ベネフィット・プラン",
    95: "Pharmaceutical – Medical Devices Manufacturing 医薬 - 医療器具製造",
    123: "Pharmaceutical – Pharmaceuticals Manufacturing and Wholesale 医薬 - 医療器具製造及び卸売",
    115: "Power and Utilities – Electricity パワー&ユーティリティ - 電気",
    119: "Power and Utilities – Natural Gas パワー&ユーティリティ - 天然ガス",
    110: "Power and Utilities – Other Utilities パワー&ユーティリティ - その他のユーティリティ",
    102: "Power and Utilities – Waste and Water パワー&ユーティリティ - 下水及び水道",
    125: "Professional Firms and Services – Business Services 専門家業務・サービス業 – 法人向けサービス",
    34: "Professional Firms and Services – Other Services 専門家業務・サービス業 – その他のサービス",
    47: "Professional Firms and Services – Personal Services 専門家業務・サービス業 – 個人向けサービス",
    124: "Professional Firms and Services – Professional Service Firms 専門家業務・サービス業 – 専門家サービス",
    127: "Professional Firms and Services – Rental and Leasing Services 専門家業務・サービス業 – レンタル・リースサービス",
    108: "Professional Firms and Services – Travel Services 専門家業務・サービス業 –旅行サービス",
    49: "Real Estate – Commercial Real Estate Owners/ Developers 不動産 - 商業不動産所有・開発",
    56: "Real Estate – Other Real Estate Owners/ Developers 不動産 - その他の不動産所有・開発",
    62: "Real Estate – Real Estate Investment Trusts 不動産 - 不動産信託",
    122: "Real Estate – Real Estate Investors 不動産 - 不動産投資",
    12: "Real Estate – Real Estate Service Companies 不動産 - 不動産仲介",
    91: "Real Estate – Residential Real Estate Owners/ Developers 不動産 - 住宅用不動産所有・開発",
    24: "Retail and Wholesale – Department Stores 小売・卸売 - 百貨店",
    93: "Retail and Wholesale – Internet Retail and Mail Order 小売・卸売 - 通信販売",
    80: "Retail and Wholesale – Mass Merchandisers / Discount Stores 小売・卸売 - 量販店・ディスカウントストア",
    9: "Retail and Wholesale – Other Specialty Retailers 小売・卸売 - その他の専門店小売業",
    77: "Retail and Wholesale – Retail Apparel and Accessory Stores 小売・卸売 - 衣料品小売",
    114: "Retail and Wholesale – Supermarkets, Grocery, and Convenience Stores 小売・卸売 - スーパーマーケット・食品小売",
    36: "Retail and Wholesale – Wholesale Durable Goods 小売・卸売 - 耐久消費財卸売",
    64: "Retail and Wholesale – Wholesale Non– Durable Goods 小売・卸売 - 非耐久消費財卸売",
    104: "Sustainability サステナビリティ",
    63: "Technology – Communication and Networking Equipment テクノロジー - コミュニケーション及びネットワーク機器",
    52: "Technology – Computers and Electronics テクノロジー - コンピュータ及び電子機器",
    138: "Technology – Internet and Social Commerce テクノロジー - インターネット及びソーシャルコーマース",
    103: "Technology – IT Services テクノロジー - ITサービス",
    19: "Technology – Other Technology テクノロジー - その他のテクノロジー",
    98: "Technology – Semiconductors テクノロジー - 半導体関連",
    13: "Technology – Software / SaaS / Apps テクノロジー - ソフトウェア/SaaS/アプリ",
    81: "Telecommunications – Cable Communications Services 通信 - 有線通信サービス",
    106: "Telecommunications – Integrated Communications Providers 通信 - 総合通信",
    129: "Telecommunications – Internet Service Providers 通信 - インターネット接続事業",
    99: "Telecommunications – Mobile Wireless Communications Services 通信 - 移動無線通信サービス",
    50: "Telecommunications – Other Communications 通信 - その他の通信業",
    44: "Telecommunications – Satellite Communications Services 通信 - 衛星通信サービス"
};

export const rnhQuickFilterLabel = [{
        id: rnhQuickFilter.all,
        label: "全て表示"
    },
    {
        id: rnhQuickFilter.assigned,
        filterType: rnhFilterTypeQuery.assignedTo,
        label: "割当者"
    },
    {
        id: rnhQuickFilter.authored,
        filterType: rnhFilterTypeQuery.authoredBy,
        label: "作成者"
    }
];

export const relatedItemStatus = [{
        id: 1,
        label: "ドラフト"
    },
    {
        id: 2,
        label: "クライアントの連絡先がありません"
    },
    {
        id: 3,
        label: "送信済"
    },
    {
        id: 4,
        label: "システムエラー"
    },
    {
        id: 5,
        label: "無効なクライアントの連絡先"
    },
    {
        id: 6,
        label: "回答待ち"
    },
    {
        id: 7,
        label: "受領済"
    },
    {
        id: 8,
        label: "承諾済"
    },
    {
        id: 9,
        label: "差戻済"
    },
    {
        id: 10,
        label: "引戻し済"
    },
    {
        id: 11,
        label: "送信中"
    },
    {
        id: 12,
        label: "受領中"
    },
    {
        id: 13,
        label: "引戻し中"
    },
    {
        id: 14,
        label: "削除中"
    },
    {
        id: 15,
        label: "差戻中"
    },
    {
        id: 16,
        label: "回答中"
    },
    {
        id: 17,
        label: "削除済"
    },
    {
        id: 18,
        label: "差し戻された無効なクライアント連絡先"
    },
    {
        id: 19,
        label: "取消中"
    },
    {
        id: 20,
        label: "取消済"
    },
    {
        id: 21,
        label: "完了処理中"
    },
    {
        id: 22,
        label: "取消中"
    }
];

export const GroupDocuments = [{
        id: 33,
        label: "プライマリーチームからのグループインストラクション"
    },
    {
        id: 37,
        label: "プライマリーチームから差し戻された文書"
    }
];

export const engagementUserStatus = {
    1: "アクティブ",
    2: "対応待ち",
    3: "差戻済",
    4: "非アクティブ",
    5: "アーカイブへのアクセス要求",
    6: "アーカイブへのアクセス権の差戻し",
    7: "コピーエンゲージメント - 非アクティブ",
    8: "リンク解除済 - 非アクティブ",
    9: "テンプレート - 非アクティブ",
    10: "ロールフォワード - 非アクティブ",
    11: "独立したユニバーサルへローカライズ",
    12: "インバイト進行中",
    13: "予定有り- 非アクティブ"
};
export const CGTTaskSendStatus = [{
        id: 1,
        label: "送信前"
    },
    {
        id: 2,
        label: "調書転送中"
    },
    {
        id: 3,
        label: "ドラフトバージョン送信済"
    },
    {
        id: 4,
        label: "返却済"
    },
    {
        id: 5,
        label: "レビュー中"
    },
    {
        id: 6,
        label: "完了"
    },
    {
        id: 7,
        label: "却下済"
    },
    {
        id: 8,
        label: "転送のリジェクト"
    },
    {
        id: 9,
        label: "最終バージョン送信済"
    },
    {
        id: 999,
        label: "送信に失敗しました"
    }
];

export const ServiceRequestStatus = [{
        id: 11,
        cssClass: 'accepted-text',
        statusLabel: "受領済"
    },
    {
        id: 12,
        cssClass: 'pending-text',
        statusLabel: "送信済"
    },
    {
        id: 13,
        cssClass: 'rejected-text',
        statusLabel: "キャンセル済"
    },
    {
        id: 14,
        statusLabel: "ドラフト"
    },
    {
        id: 15,
        cssClass: 'completed-text',
        statusLabel: "完了"
    },
    {
        id: 16,
        statusLabel: "過年度完了"
    },
    {
        id: 17,
        statusLabel: "提出エラー"
    },
    {
        id: 22,
        statusLabel: "N/A"
    },
    {
        id: 24,
        statusLabel: "アクションが必要です"
    }
];

export const assignmentsSectionLabels = [{
        id: bulkAssignment.assign,
        label: "割当て"
    },
    {
        id: bulkAssignment.timephase,
        label: "タイムフェーズ"
    },
    {
        id: bulkAssignment.tag,
        label: "タグ"
    }
];

export const assignmentsSectionLabelsNew = [{
        id: bulkAssignment.assign,
        label: "割当て"
    },
    {
        id: bulkAssignment.timephase,
        label: "タイムフェーズ"
    }
];

export const assignmentTypeLabels = [{
        id: assignmentTypes.preparer,
        label: "作成者"
    },
    {
        id: assignmentTypes.detailReviewer,
        label: "詳細レビューアー"
    },
    {
        id: assignmentTypes.generalReviewer,
        label: "一般レビューアー"
    },
    {
        id: assignmentTypes.partner,
        label: "パートナー"
    },
    {
        id: assignmentTypes.eqr,
        label: "EQR"
    },
    {
        id: assignmentTypes.other,
        label: "その他"
    }
];

export const assignmentActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "追加"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "リムーブ"
    },
    {
        id: bulkAssignmentConstants.actionIds.replace,
        label: "置換え"
    },
    {
        id: bulkAssignmentConstants.actionIds.updateDueDays,
        label: "期日の更新"
    }
];

export const tagActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "追加"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "リムーブ"
    }
];

export const manageAssigmentsActionTypeLabel = [{
        id: actionTypes.edit,
        label: "編集"
    },
    {
        id: actionTypes.delete,
        label: "削除"
    }
];

export const confidentialityLevels = {
    [confidentialityTypes.DEFAULT]: "デフォルト",
    [confidentialityTypes.LOW]: "低",
    [confidentialityTypes.MODERATE]: "中",
    [confidentialityTypes.HIGH]: "高"
};

export const milestoneTaskLabels = [{
        id: milestoneBuildTaskIds.accounts,
        label: "勘定科目フロータスク"
    },
    {
        id: milestoneBuildTaskIds.scots,
        label: "SCOTsフロータスク"
    },
    {
        id: milestoneBuildTaskIds.itso,
        label: "IT/SOフロータスク"
    },
    {
        id: milestoneBuildTaskIds.cra,
        label: "CRAフロータスク"
    },
    {
        id: milestoneBuildTaskIds.auditPlan,
        label: "監査計画フロータスク"
    },
    {
        id: milestoneBuildTaskIds.groupStructure,
        label: "グループ構造フロータスク"
    },
    {
        id: milestoneBuildTaskIds.groupInstructions,
        label: "グループインストラクションフロータスク"
    },
    {
        id: milestoneBuildTaskIds.review,
        label: "レビューフロータスク"
    }
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
    scope: "スコープ",
    teamName: "チーム名",
    groupStructure: "グループ構造",
    region: "リージョン",
    component: "構成単位"
};

export const filterSourceOfForm = [{
        value: '1',
        label: "カスタム"
    },
    {
        value: '2',
        label: "ナレッジ"
    },
    {
        value: '3',
        label: "独立性"
    }
];

export const independenceActions = [{
        id: independenceActionIds.createIndependenceForm,
        label: "独立性フォームの作成"
    },
    {
        id: independenceActionIds.removeTeamMember,
        label: "チームメンバーの削除"
    },
    {
        id: independenceActionIds.removeOverride,
        label: "上書きの削除"
    }
];


export const reviewNoteModalLabels = {
    /*Review Notes*/
    commentThread: "ノートスレッド",
    singleNoteInstructionalText: "下記の選択されたコメントを表示し回答してください。",
    emptyNoteDetailsMessage: "文章を選択すると、詳細が表示されます。まとめて編集するには、CtrlやShiftキーを使用して複数のレビューコメントを選択します。個々のコメントにおいて作業する場合はリストからコメントを選択してください。",
    documentReviewNotesLabel: "文書ノート",
    addNewReviewNoteButtonText: "新規のノート",
    noNotesAssociatedWithDocumentLabel: "以下のインプットを使用してノートを残してください。ユーザーにノートを割当て、優先度と期日を設定してください。",
    noNotesFound: "ノートが見つかりませんでした。",
    noNotesAssociatedWithTaskLabel: "このタスクに関連付けられた{0}ノートはありません。 ",
    allNotesLabel: "全てのノート",
    charactersLabel: "文字",
    myNotesLabel: "私のノート",
    showClearedLabel: "クリア済を表示",
    showClosedLabel: "クローズ済を表示",
    assignedToLabel: "割当て先",

    ofLabel: "of",
    enterNoteText: "ノートの入力",
    addNewNoteModalClose: "閉じる",
    addNewNoteModalTitleLabel: "新規ノートの追加",
    editNoteModalTitleLabel: "ノートの編集",
    deleteIconHoverText: "削除",
    deleteIconModalAcceptText: "削除",
    deleteIconModalConfirmMessage: "このコメントへの回答を削除してもよろしいですか？",
    deleteIconModalConfirmMessageParent: "選択したコメントへの回答を削除してもよろしいですか？",
    deleteIconModalTitleLabel: "ノートの削除",
    deleteReplyIconModalTitle: "返信の削除",
    emptyRepliesMessage: "返信未了",
    replyInputPlaceholder: "このノートへの返答",
    replyInputPlaceholderEdit: "レビューノートへの返信の編集",
    noteInputPlaceholderEdit: "レビューノートの編集",
    replyText: "テキストを返信",
    editReplyModelTitle: "返信を編集",
    editReplyPlaceholder: "返信を入力",
    noteDueDateLabel: "期限",

    priorityLabel: "優先度",
    dueDateLabel: "期日",
    dueLabel: "期限",
    status: "ステータス",
    noteModifiedDateLabel: "編集済",
    cancelLabel: "キャンセル",
    saveLabel: "保存",
    clearedBy: "作成者",
    closedBy: "完了者",
    reopenedBy: "再オープン実施者",
    reply: "返信",
    editIconHoverTextLabel: "編集",
    required: "必須",
    closeTitle: "閉じる",
    otherEngagementNotes: "他のエンゲージメントノート",
    closeLabel: "閉じる",
    showMore: "さらに表示",
    showLess: "表示を減らす",
    showMoreEllipsis: "さらに表示...",
    showLessEllipsis: "表示を減らす...",
    noResultFound: "結果が見つかりません",
    engagementNameLabel: "エンゲージメント名:",
    taskReviewNotesLabel: "タスクノート",
    fromUserLabel: labels.fromUserLabel,
    toUserLabel: labels.toUserLabel
};

//Copyhub create package
export const createPackageLabels = {
    packageType: "パッケージタイプ",
    categories: "カテゴリー",
    itemsToCopy: "コピーするアイテム",
    createPackage: "パッケージの作成",
    selectPackageType: "パッケージタイプの選択",
    selectPackageTypeTitle: "パッケージタイプの選択",
    selectCategoriesTitle: "カテゴリーの選択",
    selectEntitiesTitle: "エンティティの選択",
    relateCanvasFormsTitle: "文書の関連付け",
    relateAnObjectTitle: "オブジェクトの関連付け",
    step1InstructionalText: "パッケージタイプを選択し、名称を付し受領者を選択してください。データパッケージの作成又は送信前に、データプライバシー、法域間のデータ転送及び機密情報の保護に関して、適用されるすべての法令、規則及びEYポリシーへの準拠していることを確認してください。",
    packageTypes: [{
        value: 21,
        text: "エンゲージメント"
    }, {
        value: 20,
        text: "エビデンス"
    }, {
        value: 24,
        text: "既存からのロールフォワード"
    }, {
        value: 22,
        text: "勘定科目"
    }, {
        value: 23,
        text: "SCOTｓ"
    }, {
        value: 26,
        text: "一括エクスポート"
    }, {
        value: 25,
        text: "テンプレート"
    }, {
        value: 27,
        text: "外部文書"
    }, {
        value: 28,
        text: "ガイド付きワークフロー"
    }, {
        value: 29,
        text: "エンティティごとのエンゲージメント"
    }],

    packageName: "パッケージ名",
    packageDetailsText: "パッケージの詳細",
    required: "必須",
    sendTo: "送信先",
    nameOrEmail: "名前またはEメール",
    sendToName: "名前",
    sendToEmail: "Eメール",
    clearAllValues: "全ての値をクリア",
    engagementIdErrorMessage: "エンゲージメントIDが特定されていません。",
    emptyCategoriesStep2Text: '...',
    insufficientPermissionsMessage: "コピーパッケージを作成するための権限が不足しています。 エンゲージメント管理者に連絡して、コピーパッケージを作成する許可を要求してください。 ",
    CopyHubCanvasFormTooltip: "EY Canvasフォーム専用",
    CopyEngagementInProgress: "1度に実施できるエンゲージメントのコピーは1エンゲージメントのみです。",

    //Step 3 labels
    step3Header: "コピーする{0}を選択",
    selectAllText: "すべて選択",
    delectAllText: "全てを選択解除する",
    documentsSelectedText: "選択された文書",
    scotsSelectedText: "選択されたSCOTs",
    accountsSelectedText: "選択された勘定科目",
    entitiesSelectedText: "選択されたエンティティ",
    step3InstructionText: "データパッケージの作成又は送信前に、データプライバシー、法域間のデータ転送及び機密情報の保護に関して、適用されるすべての法令、規則及びEYポリシーへの準拠していることを確認してください。",
    step3InstructionTextEvidence: "エンゲージメントデータの送信前に、データプライバシー、法域間のデータ転送及び機密情報の保護に関して、適用されるすべての法令、規則及びEYポリシーに準拠していることを確認してください。",
    step3InstructionTextWarning: "EY Canvasフォームには関連するオブジェクト(例: SCOT、統制)は含まれません。",
    step3InstructionTextWarningFIT: "ガイド付きワークフローのコピーには、識別された関連する事象及び状況とそれに関連する説明を含めることができます。他の関連するオブジェクト（勘定科目、リスクなど）は含まれません。",
    availableCanvasFormsColumnName: "利用可能な文書",
    availableFITDocuments: "利用可能なガイド付きワークフロー",
    availableAccountsColumnName: "利用可能な勘定科目",
    availableSCOTsColumnName: "利用可能なSCOTs",
    availableExternalDocumentsColumnName: "利用可能な外部文書",
    step3NoItemeSelectedError: "続行するには少なくとも１つのアイテムを選択してください",
    searchPackagePlaceholder: "検索",
    searchPackageClearHoverText: "クリア",

    //step2:
    step2Header: "{0} パッケージのカテゴリーを選択",
    step2AccountsHdr: "コピーパッケージに含めるカテゴリーを選択してください。コアパッケージは全ての関連するアサーション、PSP、OSPを含みます。",
    step2scotshdr: "コピーパッケージに含めるカテゴリーを選択してください。コアパッケージは全ての関連するWCGWs、コントロール、タスクを含みます。",
    step2canformhdr: "コピーパッケージに含めるカテゴリーの選択",
    step2InstructionTextEngagementByEntity: "コピーパッケージに含めるエンティティの選択",
    availableEntitiesColumnName: "利用可能なエンティティ",
    step2HeaderEntities: "エンゲージメントパッケージに対する{0}を選択する",
    entitiesLabel: "エンティティ",

    scots: "SCOTs",
    itso: "IT/サービス受託会社",
    evidence: "エビデンス",
    realtedevidence: "関連するエビデンス",
    signoffs: "サインオフ",
    tempfiles: "一時ファイル",
    priorperiodevidence: "前期のエビデンス",
    recentlydeletedfiles: "最近削除されたファイル",
    historyfiles: "履歴ファイル",
    extgrp: "外部グループ及び外部チームメンバー",
    eydocument: "EY文書",
    extdoc: "外部文書",
    totalfilesize: "全ての選択のファイルサイズ合計",
    requestandexernaltasks: "リクエストおよび外部タスク",
    rollForwardFromExisting: "既存からのロールフォワード",
    template: "テンプレート",
    bulkExport: "一括エクスポート",

    fileSizeWaring: "選択されたカテゴリーは{0}のファイルを含みます。EY Canvasはこの制限を超えてコピーパッケージをサポートしません。",
    fileSizeWarningline2: "コピーパッケージの全ファイルサイズを削減するには文書カテゴリーの削除を検討してください",
    coloredExceedLable: "{0}GB超過",
    step2EngHdr: "コピーパッケージに含めるカテゴリーを選択してください。基本パッケージには以下が含まれます: エンゲージメントプロファイル、全てのナレッジ文書、主要標準タスク、その他の標準タスク、タイムフェーズ、勘定科目/開示(アサーション・関連するタスクを含む)、SCOTs、WCGWs、統制(関連するタスクを含む)、ITアプリケーション/サービス受託会社、リスク、ITGCs/ITSPs(関連するタスクを含む)。グループ監査エンゲージメントについては、グループ監査データも含まれます。",
    step2EngByEntityHdr: "コピーパッケージに含めるカテゴリーを選択してください。ベースパッケージにはエンゲージメントプロファイル、すべてのナレッジ文書、主要標準タスク、その他標準タスク、タイムフェーズ、勘定科目/開示、アサーション及び関連タスク、SCOTs、WCGWs、統制及び関連タスク、ITアプリケーション/サービス受託会社、リスク、ITGCs/ITSPs及び関連タスク、マッピングが含まれます。グループ監査エンゲージメントの場合、パッケージにグループ監査データも含まれます。",
    step2BulkExpHdr: "出力する文書種別を選択してください",
    gb: "GB",
    step2And: "及び",
    step2Files: "文書",
    lessThanMinGB: "0.01 GB未満",
    CategoryFileSizeCount: " {0} GB 及び {0} 文書",

    cancelLabel: "キャンセル",
    showSelected: "選択されたものを表示",
    showSelectedDocuments: "{0}選択済文書を表示",
    showSelectedEntities: "{0}選択済エンティティを表示",
    showSelectedGuidedWorflows: "{0}選択済ガイド付ワークフローを表示",
    showSelectedAccounts: "{0}選択済勘定科目を表示",
    showSelectedSCOTs: "{0}選択済SCOTsを表示",
    noDataFoundLabel: "データが見つかりません",
    copyPackageSuccessMessage: "{0} データエクスポートが開始されました。",
    copyPackageWarningLabel: "警告 : 無効な情報のため以下のメンバーにパッケージを送信できません :- {0}",
    noResultFound: "結果が見つかりません",
    canvasForms: "EY Canvasフォーム",
    canvasFormsInformationText: "EY Canvasフォームは、エビデンス及び/又は一時ファイルとしてのみエクスポートできます。<br/>EY Canvasフォームのダウンロードを有効にするには、これらのオプションのいずれかを選択してください。",
    coEditSelectAllWarningMessage: "一部の文書はマルチユーザー編集モードになっているためコピーパッケージに含めることができません。",
    coEditDocumentTooltip: "文書はマルチユーザー編集モードになっているためコピーできません。文書をチェックインして、このパッケージの一部としてコピーしてください。",
    coEditCopyWarningMessage: "{0} 文書が{1} カテゴリ内でマルチユーザー編集モードになっています。各カテゴリ内の全ての文書をチェックインしてこのパッケージの一部として含めてください。"
};

export const documentTypes = [{
        id: 1,
        label: "エビデンス"
    },
    {
        id: 2,
        label: "一時ファイル"
    },
    {
        id: 3,
        label: "前期のエビデンス"
    },
    {
        id: 4,
        label: "クライアントファイル"
    },
    {
        id: 5,
        label: "スナップショット"
    },
    {
        id: 6,
        label: "スマートフォーム"
    },
    {
        id: 29,
        label: "ペーパープロファイル"
    },
    {
        id: 47,
        label: "複数文書の出力"
    },
    {
        id: 48,
        label: "Canvasフォーム"
    },
    {
        id: 51,
        label: "オートメーションハブ"
    },
    {
        id: 59,
        label: "パッケージ"
    },
    {
        id: 72,
        label: "スマート調書"
    }
];

export const activityTypes = [{
        id: activityType.primaryLinkAccept,
        label: "リンクリクエスト承諾者 {0}"
    },
    {
        id: activityType.primaryLinkReject,
        label: "リンクリクエスト却下者 {0}"
    },
    {
        id: activityType.primaryUnlink,
        label: "{0}によってグループからリンク解除されたエンゲージメント"
    },
    {
        id: activityType.primaryComponentUnlink,
        label: "{0}によってグループからリンク解除されたエンゲージメント"
    },
    {
        id: activityType.componentPrimaryUnlink,
        label: "{0}によってグループからリンク解除されたエンゲージメント"
    },
    {
        id: activityType.primarySendLink,
        label: "{1}へのリンクリクエスト送信者{0}"
    },
    {
        id: activityType.documentsReceived,
        label: "文書受領者{0}"
    },
    {
        id: activityType.primarySendInstruction,
        label: "{0}から{1}に送信されたインストラクション"
    },
    {
        id: activityType.primaryRejectInstruction,
        label: "{0}に返信されたインストラクション"
    },
    {
        id: activityType.primaryAcceptInstruction,
        label: "{0}に承諾されたインストラクション"
    },
    {
        id: activityType.componentReceivedInstruction,
        label: "承諾済みのインストラクション"
    },
    {
        id: activityType.componentAcceptInstruction,
        label: "{0}に承諾されたインストラクション"
    },
    {
        id: activityType.componentRejectInstruction,
        label: "{0}に返信されたインストラクション"
    },
    {
        id: activityType.componentAcceptUpdatetInstruction,
        label: "{0}に承諾されたインストラクション"
    },
    {
        id: activityType.componentRejectUpdateInstruction,
        label: "{0}に返信されたインストラクション"
    },
    {
        id: activityType.primaryEvidenceReceived,
        label: "バージョン受領者 {0}"
    },
    {
        id: activityType.documentVersionConflictResolved,
        label: "コンフリクト解消者{0} "
    },
    {
        id: activityType.documentOverwrite,
        label: "{0}に上書きされた文書コンテンツ"
    },

    {
        id: activityType.primaryAssignComponent,
        label: "文書割当て先{0}"
    },
    {
        id: activityType.componentUnassigned,
        label: "文書未割当て者{0}"
    },
    {
        id: activityType.clearDocumentReturnedtoComponent,
        label: "バージョン最終更新者{0}"
    },
    {
        id: activityType.componentClearReturnedDocument,
        label: "バージョン解決者{0}"
    },
    {
        id: activityType.primaryReturnEvidence,
        label: "バージョン返信者{0}"
    },
    {
        id: activityType.componentEvidenceSent,
        label: "バージョン送信者{0}"
    },
    {
        id: activityType.componentReturnEvidence,
        label: "バージョン返信者{0}"
    },
    {
        id: activityType.createReviewNote,
        label: "ノートオープン者{0}"
    },
    {
        id: activityType.openReviewNote,
        label: "ノートオープン者{0}"
    },
    {
        id: activityType.clearReviewNote,
        label: "ノートクリア者{0}"
    },
    {
        id: activityType.closeReviewNote,
        label: "ノートクローズ者{0}"
    },
    {
        id: activityType.reviewerSignOff,
        label: "サインオフ者{0}"
    },
    {
        id: activityType.preparerSignOff,
        label: "サインオフ者{0}"
    },
    {
        id: activityType.canvasSendClientRequest,
        label: labels.sent
    },
    {
        id: activityType.clientRespondToClientRequest,
        label: "回答済"
    },
    {
        id: activityType.canvasRejectClientRequest,
        label: labels.rejected
    },
    {
        id: activityType.canvasWithdrawClientRequest,
        label: labels.WithdrawLabel
    },
    {
        id: activityType.canvasDeleteClientRequest,
        label: "削除済"
    },
    {
        id: activityType.canvasAcceptClientRequest,
        label: labels.accepted
    },
    {
        id: activityType.CEARecallClientRequest,
        label: "引戻し済"
    },
    {
        id: activityType.canvasCompleteClientRequest,
        label: labels.completed
    }
];


export const gaLinkStatus = [{
        id: GALinkStatus.Undefined,
        label: "未設定"
    },
    {
        id: GALinkStatus.NoPointOfContact,
        label: "連絡先なし"
    },
    {
        id: GALinkStatus.Pending,
        label: "未了"
    },
    {
        id: GALinkStatus.Accepted,
        label: "承諾済"
    },
    {
        id: GALinkStatus.Rejected,
        label: "却下済み"
    },
    {
        id: GALinkStatus.Expired,
        label: "期限切れ"
    },
    {
        id: GALinkStatus.Unlinked,
        label: "リンク解除"
    },
    {
        id: GALinkStatus.Delegated,
        label: "代理"
    },
    {
        id: GALinkStatus.SystemError,
        label: "システムエラー"
    },
    {
        id: GALinkStatus.Sent,
        label: "送信済"
    },
    {
        id: GALinkStatus.InvalidPointOfContact,
        label: "無効な連絡先"
    },
    {
        id: GALinkStatus.ComponentNotUsingCanvas,
        label: "Canvasを使用していない構成単位"
    }
];

export const gaInstructionStatus = [{
        id: 0,
        label: labels.notApplicable
    },
    {
        id: instructionStatus.notSent,
        label: "未送信"
    },
    {
        id: instructionStatus.pending,
        label: "未了"
    },
    {
        id: instructionStatus.accepted,
        label: "承諾済"
    },
    {
        id: instructionStatus.rejected,
        label: "返信済"
    },
    {
        id: instructionStatus.systemError,
        label: "システムエラー"
    },
    {
        id: instructionStatus.expired,
        label: "期限切れ"
    },
    {
        id: instructionStatus.sent,
        label: "送信済"
    },
    {
        id: instructionStatus.unlinked,
        label: "リンク解除"
    },
    {
        id: instructionStatus.queued,
        label: "キュー済"
    }
];

export const gsSnapshotComparisonStatus = [{
        id: snapshotComparisonIds.noChange,
        value: "null"
    },
    {
        id: snapshotComparisonIds.new,
        value: "新規"
    },
    {
        id: snapshotComparisonIds.added,
        value: "追加済"
    },
    {
        id: snapshotComparisonIds.modified,
        value: "修正済"
    },
    {
        id: snapshotComparisonIds.updated,
        value: "更新済"
    },
    {
        id: snapshotComparisonIds.removed,
        value: "削除済"
    },
    {
        id: snapshotComparisonIds.itemsRemoved,
        value: "リムーブ済項目"
    },
]

export const gaRoleType = [{
        id: GARoleTypeId.Primary,
        label: "プライマリー"
    },
    {
        id: GARoleTypeId.Region,
        label: "リージョン"
    },
    {
        id: GARoleTypeId.Component,
        label: "構成単位"
    }
];

export const linkRequestTypes = [{
        id: linkType.sent,
        label: "送信済"
    },
    {
        id: linkType.unlinked,
        label: "リンク解除"
    },
    {
        id: linkType.accepted,
        label: "承諾済"
    }
];

export const instructionTypes = [{
        id: instructionType.sent,
        label: "送信済"
    },
    {
        id: instructionType.rejected,
        label: "返信済"
    },
    {
        id: instructionType.received,
        label: "受信済"
    },
    {
        id: instructionType.accepted,
        label: "承諾済"
    }
];

export const syncStatusLabels = [{
        id: syncStatus.notSynchronized,
        label: "同期未了"
    },
    {
        id: syncStatus.syncInTransit,
        label: "転送して同期"
    },
    {
        id: syncStatus.syncInProcess,
        label: "同期中"
    },
    {
        id: syncStatus.synchronized,
        label: "同期済"
    },
    {
        id: syncStatus.deleteInTransit,
        label: "転送して削除"
    },
    {
        id: syncStatus.deleteInProcess,
        label: "削除中"
    },
    {
        id: syncStatus.deleted,
        label: "ス削除済"
    },
    {
        id: syncStatus.noHostEngagement,
        label: "ホストエンゲージメントなし"
    },
    {
        id: syncStatus.syncError,
        label: "同期エラー"
    }
];

export const colorOptionsLabels = {
    Red: "赤",
    Orange: "オレンジ",
    Teal: "青緑",
    Blue: "青",
    Purple: "紫",
    Green: "緑",
    Yellow: "黄色",
    Gray: "グレー"
};

export const todoListTimeFrameLabels = [{
        id: todoListTimeframeOptions.byDay,
        label: "日次"
    },
    {
        id: todoListTimeframeOptions.byWeek,
        label: "週次"
    },
    {
        id: todoListTimeframeOptions.byMonth,
        label: "月次"
    },
    {
        id: todoListTimeframeOptions.all,
        label: "全て"
    },
    {
        id: todoListTimeframeOptions.overdue,
        label: "期限超過"
    }
];

export const clientRequestsStatusFilter = [{
        value: 'Draft',
        label: "ドラフト"
    },
    {
        value: 'Pending',
        label: "対応待ち"
    },
    {
        value: 'Received',
        label: "受領済"
    },
    {
        value: 'Accepted',
        label: "承諾済"
    }
];

export const clientRequestsTypeFilter = [{
        value: 'Required',
        label: "サインオフ必須"
    },
    {
        value: 'NotRequired',
        label: "サインオフ不要"
    }
];

export const clientRequestsPriorityFilter = [{
        value: 'Normal',
        label: "標準"
    },
    {
        value: 'High',
        label: "高"
    },
    {
        value: 'Critical',
        label: "クリティカル"
    }
];

export const clientRequestsAttachmentsFilter = [{
        value: 'Analytics',
        label: "分析"
    },
    {
        value: 'ExternalAttachments',
        label: "外部の添付文書"
    },
    {
        value: 'EyAttachments',
        label: "EYの添付文書"
    },
    {
        value: 'None',
        label: "なし"
    }
];

export const clientRequestsCreatedByFilter = [{
        value: 'Client',
        label: "クライアント"
    },
    {
        value: 'EY',
        label: "EY"
    }
];

export const filterTimePhase = [{
    value: -1,
    label: "タイムフェーズなし"
}];

export const clientRequestsBooleanFilters = [{
        value: 1,
        label: "はい"
    },
    {
        value: 0,
        label: "いいえ"
    }
]

export const bulkClientRequestsNoRelatedTaskFilter = [{
        value: false,
        label: "はい"
    },
    {
        value: true,
        label: "いいえ"
    }
]

export const controlsTestingFilters = [{
        value: 'true',
        label: "有効"
    },
    {
        value: 'false',
        label: "非有効"
    },
    {
        value: 'null',
        label: "未選択"
    }
];

export const controlsDesignEffectivenessFilters = [{
        value: '1',
        label: "有効"
    },
    {
        value: '2',
        label: "非有効"
    },
    {
        value: '0',
        label: "未選択"
    }
];

export const clientRequestAnnotationTabs = [{
        id: clientRequestNoteTab.comments,
        label: "コメント"
    },
    {
        id: clientRequestNoteTab.history,
        label: "履歴"
    }
];

export const riskTypeOptions = [{
        id: 1,
        name: "特別な検討を必要とするリスク "
    },
    {
        id: 2,
        name: "不正リスク"
    },
    {
        id: 3,
        name: "重要な虚偽表示リスク"
    }
];

export const months = ['1月', '2月', '３月', '４月', '５月', '６月', '７月', '８月', '９月', '10月', '11月', '12月'];
export const longDays = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];
export const shortDays = ['日', '月', '火', '水', '木', '金', '土'];

// GA Scopes
export const gaScopesResource = [{
        id: gaScopes.full,
        label: "フル"
    },
    {
        id: gaScopes.specific,
        label: "スペシフィック"
    },
    {
        id: gaScopes.specificAuditProcedures,
        label: "特定の手続指定"
    },
    {
        id: gaScopes.review,
        label: "レビュー"
    }
]

// GA Instructions
export const gaRecommendationTypeResource = [{
        id: gaRecommendationType.required,
        label: "必須"
    },
    {
        id: gaRecommendationType.optional,
        label: "任意"
    },
    {
        id: gaRecommendationType.notApplicable,
        label: "該当なし"
    }
]

// GS Group Summary
export const gsTabsResource = [{
        id: groupSummaryTabs.assignedTeams,
        label: "割当てられたチーム"
    },
    {
        id: groupSummaryTabs.instructions,
        label: "インストラクション"
    },
    {
        id: groupSummaryTabs.tasks,
        label: "タスク"
    }
]

export const receiveInstructionsTypeResource = {
    true: {
        title: "新",
        instructional: "新"
    },
    false: {
        title: "更新済",
        instructional: "更新済"
    }
}

export const clientRequestSystemGeneratedMessages = {
    sent: "リクエスト送信先",
    accepted: "承諾済リクエスト",
    received: "受領済リクエスト",
    returned: "差戻し済リクエスト",
    withdrawn: "引戻し済リクエスト",
    complete: "リクエストはEYにより完了しました。",
    recalled: "引戻し済リクエスト",
    notification_submit: "オートメーションに提出されたリクエスト",
    notification_success: "リクエストはオートメーションに適切に提出されました。",
    notification_error: "オートメーションへの提出中にエラーが発生しました。オートメーションへの提出をクリックして再試行してください。",
    restore_document: "リストア済文書 - ",
    delete_document: "削除済文書 - ",
    assignedto: "項目の割当て先",
    editrequest: "編集されたリクエスト",
    prioritychange: "更新後のリクエスト優先度:"
};

export const externalTaskSystemGeneratedMessages = {
    sent: "外部タスク送信先",
    accepted: "承諾済外部タスク",
    received: "受領済回答",
    returned: "差戻し済外部タスク",
    withdrawn: "引戻し済外部タスク",
    complete: "外部タスクはEY Canvaｓから完了されました。",
    recalled: "引戻し済外部タスク",
    restore_document: "リストア済文書 - ",
    delete_document: "削除済文書 - ",
    assignedto: "項目の割当て先",
    editrequest: "編集された外部タスク",
    prioritychange: "更新後の外部タスク優先度:"
};

export const ipInputLabels = [{
        id: ipInputType.ipAddress,
        label: "IPアドレス"
    },
    {
        id: ipInputType.ipRange,
        label: "IPレンジ"
    },
    {
        id: ipInputType.cidrBlock,
        label: "CIDRブロック"
    }
];

export const ipFilterTypeLabels = {
    [ipFilterType.ipAddress]: "IPアドレス",
    [ipFilterType.ipRange]: "IPレンジ",
    [ipFilterType.cidrBlock]: "CIDRブロック"
};

export const gaLinkStatusObj = {
    [GALinkStatus.Undefined]: "未定義",
    [GALinkStatus.NoPointOfContact]: "連絡先なし",
    [GALinkStatus.NotSent]: "未送信",
    [GALinkStatus.Pending]: "リンクリクエスト保留中",
    [GALinkStatus.Accepted]: "リンクリクエスト承諾済",
    [GALinkStatus.Rejected]: "差戻済",
    [GALinkStatus.Expired]: "期限切れ",
    [GALinkStatus.Unlinked]: "リンクされていない",
    [GALinkStatus.Delegated]: "代理",
    [GALinkStatus.SystemError]: "システムエラー",
    [GALinkStatus.Sent]: "送信済み",
    [GALinkStatus.InvalidPointOfContact]: "無効な連絡先",
    [GALinkStatus.ComponentNotUsingCanvas]: "EY Canvas 未使用",
    [GALinkStatus.ComponentReferenceOnly]: "参照専用"
};

export const epTasksObj = [{
        value: '3',
        label: "サインオフされた文書なし"
    },
    {
        value: '2',
        label: "一部の文書のみサインオフあり"
    },
    {
        value: '1',
        label: "全ての文書にサインオフあり"
    }
];

export const eqrTasksObj = [{
        value: '6',
        label: "サインオフされた文書なし"
    },
    {
        value: '5',
        label: "一部の文書のみサインオフあり"
    },
    {
        value: '4',
        label: "全ての文書にサインオフあり"
    }
];

export const groupsFilterEntity = [{
        id: 1,
        label: "タスク"
    },
    {
        id: 2,
        label: "文書"
    }
];

export const scopesFilterEntity = [{
        id: 1,
        label: "フル"
    },
    {
        id: 2,
        label: "スペシフィック"
    },
    {
        id: 3,
        label: "特定の手続指定"
    },
    {
        id: 4,
        label: "レビュー"
    }
];

export const notesFilterLabels = [{
        id: notesFilter.allNotes,
        label: "全てのノート"
    },
    {
        id: notesFilter.myNotes,
        label: "私のノート"
    },
    {
        id: notesFilter.authoredByMeNotes,
        label: "私への割当"
    }
];

//Client Request Advanvce Search
export const advancedSearchValues = [{
        id: 1,
        value: labels.advancedSearchTitleCheck
    },
    {
        id: 2,
        value: labels.advancedSearchRefereceNumberCheck
    },
    {
        id: 3,
        value: labels.advancedSearchDocumentsCheck
    },
    {
        id: 4,
        value: labels.advancedSearchCommentsCheck
    }
];


export const TaskTypeLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy]
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs]
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs]
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts]
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution]
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion]
    }
];

export const TaskCategoryLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy],
        displayOrder: 1
    },
    {
        id: TaskListTypes.Risks,
        label: taskNavigation[TaskListTypes.Risks],
        displayOrder: 2
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs],
        displayOrder: 3
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs],
        displayOrder: 4
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts],
        displayOrder: 5
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution],
        displayOrder: 6
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion],
        displayOrder: 7
    },
];

export const kendoLabels = {
    alignLeft: "左揃え",
    alignRight: "右揃え",
    alignCenter: "中央揃え",
    alignFull: "両端揃え",
    addComment: "コメント追加",
    addColumnBefore: "左に列を挿入",
    addColumnAfter: "右に列を挿入",
    addRowAbove: "上に行を挿入",
    addRowBelow: "下に行を挿入",
    bulletList: "番号なしリストの挿入",
    bold: "太字",
    backColor: "ハイライト",
    createLink: "ハイパーリンクの挿入",
    createTable: "表の作成",
    cleanFormatting: "フォーマットのクリア",
    deleteRow: "行の削除",
    deleteColumn: "列の削除",
    deleteTable: "表の削除",
    fontSizeInherit: "フォントサイズ",
    foreColor: "色",
    format: "フォーマット",
    fontSize: "フォントサイズ",
    hyperlink: "webリンクの挿入",
    italic: "斜字体",
    indent: "インデント",
    insertTableHint: "{0} × {1} の表を作成",
    'hyperlink-dialog-content-address': "Webアドレス ",
    "hyperlink-dialog-title": "ハイパーリンクの挿入",
    "hyperlink-dialog-content-title": "タイトル",
    "hyperlink-dialog-content-newwindow": "新しいウィンドウでリンクを開く",
    "hyperlink-dialog-cancel": "中止",
    "hyperlink-dialog-insert": "挿入",
    outdent: "インデント解除",
    orderedList: "番号付きリストの挿入",
    print: "印刷",
    pdf: "pdfに出力",
    redo: "やり直し",
    strikethrough: "取り消し線",
    subscript: "下付き文字",
    superscript: "上付き文字",
    underline: "下線",
    undo: "元に戻す"
};

export const kendoFormatOptions = [{
        text: "段落",
        value: "p"
    },
    {
        text: "見出し1",
        value: "h1"
    },
    {
        text: "見出し2",
        value: "h2"
    },
    {
        text: "見出し3",
        value: "h3"
    },
    {
        text: "見出し4",
        value: "h4"
    },
    {
        text: "見出し5",
        value: "h5"
    },
    {
        text: "見出し6",
        value: "h6"
    }
];

export const kendoFontSize = [{
        text: '8',
        value: '8px'
    },
    {
        text: '9',
        value: '9px'
    },
    {
        text: '10',
        value: '10px'
    },
    {
        text: '11',
        value: '11px'
    },
    {
        text: '12',
        value: '12px'
    },
    {
        text: '14',
        value: '14px'
    },
    {
        text: '16',
        value: '16px'
    },
    {
        text: '18',
        value: '18px'
    },
    {
        text: '20',
        value: '20px'
    },
    {
        text: '22',
        value: '22px'
    },
    {
        text: '24',
        value: '24px'
    },
    {
        text: '26',
        value: '26px'
    },
    {
        text: '28',
        value: '28px'
    },
    {
        text: '36',
        value: '36px'
    },
    {
        text: '48',
        value: '48px'
    },
    {
        text: '72',
        value: '72px'
    }
];

export const monthsList = [
	"1月",
	"2月",
	"3月",
	"4月",
	"5月",
	"6月",
	"7月",
	"8月",
	"9月",
	"10月",
	"11月",
	"12月"
];

export const pspContentStatus = {
    1: "更新は必須です",
    2: "更新中",
    3: "更新完了",
    4: "更新エラー"
}

export const handOffLabels = {
    handoff: "ハンドオフ",
    handOffTitleTip: "レビューのためのハンドオフ",
    markCompleteTitleTip: "完了のマーク",
    handoffModalTitle: "次のチームメンバーにハンドオフ",
    handoffConfirmButtonText: "ハンドオフ",
    return: "返却",
    handModalDescription: "以下のオプションを選択してエビデンスファイルにサインオフしてください",
    markCompleteTextLine1: "このタスクを次のチームメンバーにハンドオフしてください。",
    markCompleteTextLine2: "以下のオプションを選択してエビデンスファイルにサインオフしてください。もしこのタスクに割当てられており完了した場合、<b>はい</b>を選択して閉じてしてください。このタスクにPIC又はEQR のサインオフが必要な場合、以下のオプションから選択してください。",
    closeLabel: "閉じる",
    handoffto: "ハンドオフ先",
    missingToUserError: "必須",
    markCompleteConfirm: "完了のマーク",
    markCompleteModalHeaderTextPart1: "このタスクに完了のマークをします。",
    markCompleteModalHeaderTextPart2: "以下のオプションを選択してエビデンスファイルにサインオフしてください。もしこのタスクに割当てられており完了した場合、<b>はい</b>を選択して閉じてください。このタスクにPIC又はEQR のサインオフが必要な場合、以下のオプションから選択してください。",
    signOffOnAllAs: "全てにサインオフする",
    preparer: "実施者",
    reviewer: "査閲者",
    none: "なし",
    noSignOffsByMe: "私がサインオフしていない",
    myPreparerSignOffs: "私の実施者サインオフ",
    myReviewerSignOffs: "私の査閲者サインオフ",
    myPreparerAndReviewerSignOffs: "私の実施者又は査閲者サインオフ",
    preparerTitle: "実施者サインオフ",
    reviewerTitle: "査閲者サインオフ",
    autoAssignmentMessage: "このチームメンバーは割当てがありません。 ​{1}期日の{0}の割当てが作成されます。 この割当て{2}を編集できます。",
    clickHere: "ここをクリック",
    noTaskEvidencesHandoffModal: "このタスクに関連付けられたエビデンスファイルはありません。",
    // Create Assignment
    createAssignment: "割当ての作成",
    create: "作成",
    cancelLabel: "キャンセル",
    createassignmentheader1: "選択したチームメンバーにはこのタスクへの割当てがありません。",
    createassignmentheader2: "ここに割当を作成してください。",
    dueDate: "期日",
    teamMemberAssigmentLabel: "チームメンバー",
    daysPriorToEndDate: "業務終了日までの日数",
    // Add Assignment
    addAssignmentTitle: "割当て名称の追加",
    confirmButtonLabel: "追加",
    cancelButtonLabel: "キャンセル",
    assignmentTypeInstructionalText: "割当てタイプを選択し以下に名称を入力してください。入力後<b>追加</b>をクリックしてください。",
    assignmentType: "割当てタイプ",
    required: "必須",
    clearHoverText: "クリア",
    unmarkcomplete: "完了マークの解除",
    markCompleteErrorMessage: "タスクを完了とすることができません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    // Assignment Dropdown
    noResultFound: "結果が見つかりません",
    addTaskGroupLabel: "タスクグループの追加",
    addAssignmentName: "割当て名称の追加",
    assignmentName: "割当て名称",
    additionalSignOff: "追加の必須サインオフ",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    closeMyAssignment: "私の割当てをクローズ",
    filterYes: "はい",
    filterNo: "いいえ",
    assignmentTypeLabels: [{
            id: assignmentTypes.preparer,
            label: "実施者"
        },
        {
            id: assignmentTypes.detailReviewer,
            label: "詳細レビューアー"
        },
        {
            id: assignmentTypes.generalReviewer,
            label: "全般レビューアー"
        },
        {
            id: assignmentTypes.partner,
            label: "パートナー"
        },
        {
            id: assignmentTypes.eqr,
            label: "EQR"
        },
        {
            id: assignmentTypes.other,
            label: "その他"
        }
    ]
};

export const displayedOn = {
    "Account": "勘定科目",
    "SCOT": "SCOT",
    "IT/SO": "IT/SO",
    "Scope & Strategy": "スコープ＆戦略",
    "Execution": "実施",
    "Conclusion": "総括"
}

export const auditPlanReportLabels = {
    adc: "関連するオブジェクト",
    secondaryObject: "第2関連オブジェクト",
    taskTypeColumn: "タスクタイプ",
    taskNamePrefix: "タスクのプレフィックス",
    taskName: "タスクタイトル",
    taskNameSuffix: "タスクのサフィックス",
    taskDescription: "タスク詳細",
    auditTaskStatus: "タスクステータス",
    rationaleForRejection: "差戻し理由",
    knowledgeTaskTitle: "ナレッジタスクタイトル",
    knowledgeTaskDescription: "ナレッジタスクの説明",
    assignedTo: "割当て先",
    engagementTagGroupName: "タググループ",
    engagementTagName: "タグ",
    prioritized: "優先",
    viewDisplayedOn: "表示する",
    engagementPhase: "エンゲージメントフェーズ",
    milestone: "マイルストーン",
    periodName: "タイムフェーズ",
    riskTypeAbbr: "関連するリスクタイプ",
    riskName: "関連するリスク名",
    relatedMESTEntityName: "関連するMESTエンティティ",
    scheduledNextWaveservices: "集中化サービス",
    taskID: "タスクID",
    timephaseID: "タイムフェーズID",
    taskTypeID: "タスクタイプID",
    timephaseTypeID: "タイムフェーズタイプID"
}

export const reportingTaskAll = {
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    taskAssignedTo: labels.taskassignedto,
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    knowledge_Task_Title: "ナレッジタスクタイトル",
    knowledge_Task_Description: "ナレッジタスクの説明",
    rejected: labels.rejected,
    rationale_for_Rejection: "差戻し理由",
    audit_Phase: labels.auditPhasesLabel,
    milestonename: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    timephasestartdateinutc: "タイムフェーズ開始日（UTC）",
    timephaseduedateinutc: "タイムフェーズ終了日（UTC）",
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    lastTaskChangeDateInUTC: "最終タスクステータス変更日（UTC）",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    mesT_Entity_Name: "関連するMESTエンティティ",
    multiEntityType: "マルチエンティティタイプ",
    taskID: "タスクID",
    taskTypeID: "タスクタイプID",
    taskStatusID: "タスクステータスID",
    auditPhaseID: "監査フェーズID",
    timephaseTypeID: "マイルストーンID",
    taskSourceTypeID: "タスクソースID",
    taskNatureTypeID: "タスク種類ID",
    cgTaskID: "ナレッジタスクID",
    knowledgeContentID: "ナレッジコンテンツID"
}

export const reportTaskAssignments = {
    taskNamePrefix: labels.taskPrefix,
    taskName: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    taskTypeName: labels.taskType,
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    auditPhaseName: labels.engagementPhase,
    milestones: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    PICSignoffRequired: "PICのサインオフが必須",
    EQRSignoffRequired: "EQRのサインオフが必須",
    taskStatusName: labels.taskStatusLabel,
    taskDueDateInUTC: "タスク期日（UTC）",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    completedAssignment: labels.completedAssignments,
    totalAssignment: "割当て総数",
    closedTaskAssignmentPercent: "クローズ済みタスク割当て %",
    assignmentOrder: "割当て順",
    firstNameVal: "タスクに割り当てられたチームメンバーの名前",
    lastNameVal: "タスクに割り当てられたチームメンバーの名字",
    assignmentName: labels.assignmentName,
    assignmentTypeName: labels.filterAssignmentTypeLabel,
    roleName: "エンゲージメントユーザーの役割",
    assignmentStatusVal: "タスク割当てステータス",
    dueDays: "期限",
    completedDateInUTC: "完了日（UTC）",
    assignmentDueDateInUTC: "割当て期限（UTC）",
    daysCompleteBeforeDueDate: "タスク割当て期限までの残日数",
    daysCompleteAfterDueDate: "タスク割当て期限超過日数",
    closedEarlyOrLate: "前倒し/遅延にて完了",
    closedDaysEarly: "完了前倒日数",
    closedDaysLate: "完了遅延日数",
    oldTaskName: "レガシータスクタイトル",
    oldTaskDetail: "レガシータスクの説明",
    taskID: "タスクID",
    assignmentID: "割当てID",
    roleID: "ロールID",
    userID: "ユーザーID"
}

export const reportingMultiEntityTask = {
    engagementID: "エンゲージメントID",
    taskID: "タスクID",
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    mesT_Entity_Name: "関連するエンティティ",
    multiEntityType: "マルチエンティティタイプ",
    taskTypeID: "タスクタイプID",
    taskStatusID: "タスクステータスID"
}

export const reportingManageteamInternal = {
        firstName: labels.firstnameLabel,
        lastName: labels.lastnameLabel,
        userInitials: labels.initialsLabel,
        emailAddress: labels.editExternalEmailLabel,
        gui: "GUI",
        engagementRole: labels.engagementrole,
        hasOverallResponsability: "全般的責任を有する",
        userStatus: "ステータス",
        independenceStatus: "独立性ステータス",
        grantedAccess: "アーカイブ後のアクセス許可",
        primaryOffice: "主たる事務所",
        preferredContactPhone: "電話番号",
        engagementUserStatusID: "エンゲージメントユーザーステータスID",
        engagementRoleID: "エンゲージメントロールID",
        independenceStatusID: "独立性ステータスID"
    }

export const reportingManageteamExternal = {
    clientGroupName: "グループ名",
    firstName: labels.firstnameLabel,
    lastName: labels.lastnameLabel,
    userInitials: labels.initialsLabel,
    emailAddress: labels.editExternalEmailLabel,
    domain: "ユーザードメイン",
    validDomainWithinGroup: "グループの有効なドメイン",
    userStatus: "ユーザーステータス",
    preferredContactPhone: "電話番号"
};

export const controlDesignEffectivenessType = {
    1: "有効",
    2: "非有効"
};

export const itAppSOSummaryReportLabels = {
    itApplicationName: "ITアプリケーション/サービス受託会社",
    strategyTypeName: "IT戦略",
    typeName: "タイプ",
    itProcessName: "ITプロセス",
    itRiskName: "ITリスク",
    itControlName: "ITGCs/ITSPs",
    natureOfTest: "テストの種類",
    controlFrequencyTypeNameColumn: "頻度",
    testing: "テスト",
    designEffectiveness: "デザインの有効性",
    evaluation: "ITプロセス評価"
};

export const ArchiveReportLabels = {
    engagementDescription: "エンゲージメントの説明",
    archiveReportQualifiedNameSection: "限定付レポート",
    archiveReportQualifiedTypeNameSection: "限定付レポートのタイプ",
    archiveFolderDescription: "アーカイブフォルダの説明",
    archiveFolderTypeNameSection: "フォルダーのタイプ",
    location: "ロケーション",
    archiveComments: "アーカイブコメント",
    engagementID: "エンゲージメントID",
    archiveCountryOfficeRegionID: "アーカイブする国のオフィスリージョンID",
    archiveReportQualifiedID: "アーカイブする限定付レポートID",
    archiveReportQualifiedTypeID: "アーカイブする限定付レポートのタイプID"
};

export const canvasFormRelatedCommentsLabels = {
    canvasFormName: "Canvasフォーム名",
    order1: "ヘッダー番号",
    formHeaderName: "ヘッダー",
    order2: "セクション番号",
    order3: "本文番号",
    formBodyResponseValue: "回答",
    commentNumber: "コメント番号",
    author: "作成者",
    assignedTo: "割当て先",
    createDateSection: "作成日",
    commentStatusSection: "ステータス",
    commentText: "コメント",
    commentVoiceNote: "ボイスノートあり",
    reply: "返信",
    replyVoiceNote: "ボイスノートあり"
};

export const canvasFormRelatedObjectsLabels = {
    canvasFormName: "Canvasフォーム名",
    order1: "ヘッダー番号",
    formHeaderName: "ヘッダー",
    formHeaderID: "フォームヘッダーID",
    order2: "セクション番号",
    formSectionID: "フォームセクションID",
    formSectionName: "セクション",
    firstLevelEntityColumn: "第1レベルのエンティティ",
    firstLevelRelatedObject: "第1レベルの関連オブジェクト",
    secondLevelEntityColumn: "第2レベルのエンティティ",
    secondLevelRelatedObject: "第2レベルの関連オブジェクト"
};

export const canvasFormResponseLabels = {
    canvasFormName: "Canvasフォーム名",
    order1: "ヘッダー番号",
    formHeaderName: "ヘッダー",
    knowledgeFormHeaderID: "ヘッダーナレッジID",
    headerKnowledgeContentID: "ヘッダーナレッジコンテンツID",
    order2: "セクション番号",
    formSectionName: "セクション",
    knowledgeFormSectionID: "セクションナレッジID",
    sectionKnowledgeContentID: "セクションナレッジコンテンツID",
    order3: "本文番号",
    formBody: "本文",
    knowledgeFormBodyID: "本文ナレッジID",
    bodyKnowledgeContentID: "本文ナレッジコンテンツID",
    formBodyResponse_Value: "回答"
};

export const CanvasFormsIncompleteLabels = {
    canvasFormName: "Canvasフォーム名",
    header: "ヘッダー",
    headerOrder: "ヘッダー番号",
    sectionOrder: "セクション番号",
    bodyOrder: "本文番号",
    body: "本文",
    formHeaderID: "フォームヘッダーID",
    formSectionID: "フォームセクションID",
    formBodyID: "フォーム本文ID"
};

export const controlFormResponseLabels = {
    controlName: "統制",
    documentName: "文書",
    engagementDescription: "エンゲージメントの説明",
    formHeader: "ヘッダー",
    headerKnowledgeDisplayOrder: "ヘッダーナレッジの表示順",
    formSection: "セクション",
    sectionKnowledgeDisplayOrder: "セクションナレッジの表示順",
    formBodyVal: "本文",
    bodyKnowledgeDisplayOrder: "本文ナレッジの表示順",
    ControlTesting: "統制テスト有無",
    controlFrequencyType: "統制の頻度",
    Effective: "有効か？",
    formBodyOptionVal: "フォームオプション本文の値",
    controlType: "統制タイプ",
    controlDesignEffectivenessType: "統制のデザインの有効性タイプ"
};

export const itProcessSummaryLabels = {
    itProcessName: "ITプロセス",
    itProcessEvaluation: "ITプロセスの評価",
    itProcesSupportingRationale: "サポートする根拠",
    itRiskName: "ITリスク",
    itControlName: "ITGCs/ITSPs",
    natureOfTest: "テストの種類",
    controlFrequencyTypeId: "頻度",
    testing: "テスト",
    designEffectiveness: "デザインの有効性",
    operatingEffectiveness: "運用状況の有効性"
}

export const itProcessScotControlsLabels = {
    itProcessName: "ITプロセス",
    scotName: "SCOT",
    controlName: "統制",
    controlDesignEffectivenessTypeName: "デザインの有効性",
    testing: "テスト",
    operatingEffectiveness: "運用状況の有効性",
    controlTypeName: "統制タイプ",
    isIPEManuallyTestedName: "IPEは手作業でテストされているか",
    itApplicationName: "ITアプリケーション",
    aggregateITEvaluationTypeName: "IT総合評価"
};

export const scotsControlsReportLabels = {
    scotName: "SCOT",
    controlName: "統制",
    operatingEffectiveness: "運用状況の有効性",
    itApplicationName: "ITアプリケーション統制",
    aggregateITEvaluation: "IT総合評価",
    supportingRationaleControlLabel: "サポートする根拠"
}

export const sCOTSummaryReportHeaderLabels = {
    scotName: "SCOT",
    scotTypeName: "取引タイプ",
    strategyTypeName: "SCOT戦略",
    itApplicationName: "IT App / SO SCOT",
    wcgwName: labels.wcgw,
    controlName: labels.control,
    controlFrequencyTypeName: labels.frequencyLabel,
    controlTypeName: "統制タイプ",
    testing: "テスト",
    operatingEffectiveness: "運用状況の有効性",
    controlITApplication: "IT App / SOによる統制",
    aggregateITEvaluationTypeName: "IT総合評価",
    supportingRationale: "サポートする根拠",
    scotId: "SCOT ID",
    strategyTypeID: "戦略タイプID",
    scotTypeID: "SCOTタイプID",
    wcgwid: "WCGW ID",
    controlID: "統制ID",
    controlFrequencyTypeID: "統制頻度タイプID",
    controlTypeID: "統制タイプID",
    aggregateITEvaluationTypeID: "IT総合評価タイプID"
};

export const findingsDeficiencyHeaderLabels = {
    description: "不備の説明",
    controls: "統制",
    controlsIsEffective: "統制の運用状況の有効性",
    type: "不備タイプ",
    magnitude: "影響度",
    responseText: "回答テキスト",
    remediatedAtYearEnd: "期末で解消済",
    mitigatingControls: "補完統制",
    mitigatingControlsIsEffective: "補完統制の運用状況の有効性",
    mitigatingTasks: "軽減タスク",
    foundIn: "発見事項の記載",
    accountsAndAssertions: "勘定科目とアサーション",
    scoTs: "SCOTs",
    deficiencyID: "不備ID",
    controlID: "統制ID",
    mitigatedControlID: "軽減統制ID",
    mitigatedTaskID: "軽減タスクID",
    documentID: "文書ID",
    accountID: "勘定科目ID",
    scotID: "SCOT ID"
};

export const findingsMisstatementHeaderLabels = {
    description: "虚偽表示の説明",
    type: "虚偽表示タイプ",
    trialBalance: "試算表",
    period: "期間",
    accountNumber: "勘定科目番号",
    accountName: "勘定科目名",
    accountType: "勘定科目タイプ",
    debit: "借方",
    credit: "貸方",
    responseText: "回答テキスト",
    correctedUncorrected: "修正済/未修正",
    mitigatingTasks: "軽減タスク",
    foundInDocument: "発見事項の記載",
    accountsAndAssertions: "勘定科目とアサーション",
    misstatementID: "虚偽表示ID",
    trialBalanceID: "試算表ID",
    misstatementAdjustmentID: "虚偽表示修正ID"
};

export const findingsDeficiencyITHeaderLabels = {
    itApplicationName: "ITアプリケーション名",
    itProcessName: "ITプロセス名",
    itControlName: "IT統制名",
    itApproachTypeName: "ITアプローチ名",
    isEffective: "統制の有効性",
    referenceNumber: "リファレンス番号",
    description: "不備の説明",
    deficiencyMagnitudeName: "不備の影響度",
    deficiencyTypeName: "不備タイプ"
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
    adc: "関連するオブジェクト",
    secondaryObject: "関連する統制 / 実証手続",
    taskName: "タスクタイトル",
    taskDescription: "タスクの説明",
    taskTypeColumn: "タスクタイプ",
    taskStatusValue: "タスクステータス",
    rationaleForRejection: "差戻し理由",
    engagementPhase: "エンゲージメントフェーズ",
    milestone: "マイルストーン",
    periodName: "タイムフェーズ",
    assignedTo: "割当て先",
    engagementTagGroupName: "タググループ",
    engagementTagName: "タグ",
    displayedOn: "表示する",
    documentName: "文書名",
    preparersValue: "実施者（UTC日付）",
    reviewersValue: "査閲者（UTC日付）",
    openReviewNotes: "レビューノートを開く",
    closedReviewNotes: "クリア済レビューノート",
    trackChangesValue: "変更履歴",
    lastModifiedBy: "最終編集者",
    lastModifiedDateValue: "最終編集日 (UTC)",
    taskID: "タスクID",
    timephaseID: "タイムフェーズID",
    taskTypeID: "タスクタイプID",
    documentTypeID: "文書タイプID",
    parentDocumentTypeID: "親文書タイプID",
    timePhaseTypeID: "タイムフェーズタイプID"
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
    sectionName: "セクション",
    gaInstructionName: "インストラクション名",
    gaInstructionDescription: "インストラクションの説明",
    documents: "文書名",
    knowledgeInstructionName: "ナレッジインストラクションタイトル",
    knowledgeInstructionDescription: "ナレッジインストラクションの説明",
    gaScopeName: "関連するスコープ / サブスコープ",
    componentOnly: "スコープ / 個別インストラクション",
    shortName: "リージョン / 構成単位名",
    cSection: "カスタムセクション",
    customInstruction: "カスタムインストラクション",
    gAinstructionID: "GAインストラクションID"
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
    primaryEngagementID: "エンゲージメントID",
    gaScopeID: "GAスコープID",
    gaScopeName: "スコープ",
    gaComponentID: "GA構成単位ID",
    shortName: "構成単位名",
    lastPublishedDateInUTC: "最終公開日",
    lastSentDateInUTC: "最終送信日",
    gaLinkStatusId: "リンクステータス",
    gaInstructionStatusId: "インストラクションステータス"
};

// Group Activity
export const groupActivityReportHeaderLabels = {
    engagementID: "エンゲージメントID",
    gaScopeID: "GAスコープID",
    gaScopeName: "スコープ",
    gaComponentID: "GA構成単位ID",
    shortName: "構成単位名",
    gaLinkStatusId: "リンクステータス",
    accountID: "勘定科目ID",
    accountName: "勘定科目名",
    accountType: "勘定科目の指定",
    activityTypeID: "アクティビティタイプID",
    activityTypeText: "アクティビティタイプ",
    modifyDateInUTC: "日付の変更",
    modifyUser: "ユーザーの変更",
};

export const AccountDisclosuresReportHeadeLabels = {
    engagementID: "エンゲージメントID",
    accountID: "勘定科目ID",
    accountName: "勘定科目名",
    accountTypeID: "勘定科目タイプID",
    accountTypeId: "勘定科目の指定",
    knowledgeAssertionId: "アサーション略称",
    inherentRiskTypeId: "固有リスク評価",
    controlRiskTypeId: "統制リスク評価",
    craValue: "CRA",
    riskID: "リスクID",
    riskTypeID: "リスクタイプID",
    riskType: "リスクタイプ",
    riskName: "リスク名",
    isHigherRiskValue: "高リスク",
};

// CRA summary
export const craSummaryReportHeaderLabels = {
    accountName: "勘定科目",
    accountTypeName: "勘定科目タイプ",
    rationale: "根拠",
    pspIndex: "PSPインデックス",
    conclusionStatement: "勘定科目の結論",
    scotName: "SCOTs",
    transactionType: "取引タイプ",
    strategyTypeName: "SCOT戦略",
    wcgwName: "WCGW",
    controlName: "統制",
    controlFrequencyTypeName: "頻度",
    controlTypeName: "統制タイプ",
    testing: "テスト",
    operatingEffectiveness: "運用状況の有効性",
    itApplicationName: "IT App/ SO SCOT",
    controlITApplication: "IT App/ SOによる統制"
};

export const craSummaryAssertionReportHeaderLabels = {
    accountName: "勘定科目",
    accountTypeName: "勘定科目タイプ",
    rationale: "根拠",
    pspIndex: "PSPインデックス",
    assertionAbbreviation: "アサーション",
    riskName: "リスク",
    inherentRiskTypeName: "固有リスクの評価",
    controlRiskTypeName: "統制リスクの評価",
    craValue: "CRA",
    wcgwName: "WCGW",
    controlName: "統制",
    controLFrequencyTypeName: "頻度",
    controlTypeName: "統制タイプ",
    testing: "テスト",
    isLowerR: "IsLowerRisk",
    operatingEffectiveness: "運用状況の有効性",
    itApplicationName: "IT App/ SO"
};

export const craSummaryDataReportHeaderLabels = {
    wcgwName: "WCGW",
    controlName: "統制",
    controLFrequencyTypeName: "統制の頻度",
    controlTypeName: "統制タイプ",
    itApplicationName: "ITアプリケーション",
    assertionName: "アサーション",
    statementTypeName: "文書タイプ",
    accountTypeName: "勘定科目タイプ",
    assertionAbbreviation: "アサーションの略称",
    inherentRiskTypeName: "固有リスク",
    controlRiskTypeName: "統制リスク",
    craValue: "CRA",
    riskTypeAbbreviation: "リスクの略称",
    frequency: "頻度",
    accountName: "勘定科目",
    riskName: "リスク",
    pspIndex: "PSPインデックス",
    testing: "テスト",
    operatingEffectiveness: "運用状況の有効性",
    isLowerRiskColumn: "低リスクか？",
    scotName: "SCOT",
    controlitApplicationName: "統制のITアプリケーション",
    rationale: "根拠",
    accountID: "勘定科目ID",
    riskID: "リスクID",
    scotid: "SCOT ID",
    wcgwid: "WCGW ID",
    controlID: "統制ID",
    itApplicationID: "ITアプリケーションID",
    knowledgeAssertionID: "ナレッジアサーションID",
    controlTypeID: "統制タイプID",
    controlFrequencyTypeID: "統制の頻度タイプID",
    accountTypeID: "勘定科目のタイプID",
    riskTypeID: "リスクタイプID",
    inherentRiskTypeID: "固有リスクのタイプID",
    controlRiskTypeID: "統制リスクのタイプID",
    statementTypeID: "文書タイプID",
    conclusionStatement: "勘定科目の結論"
};

export const reportingRequestsAndTasks = {
    requestTitle: "リクエスト/タスクタイトル",
    request_Description: "リクエスト/タスクの説明",
    type: "タイプ",
    tasks: "タスクタイトル",
    engagementTagName: "タグ",
    eyAssigned: "EY担当者",
    clientGroupName: "外部グループ",
    externalAssignedUser: "外部担当者",
    periodName: "タイムフェーズ",
    dueDateInUTC: "期日（UTC）",
    requestStatus: "リクエスト/タスクステータス",
    documentType: "文書タイプ",
    documentName: "当年度の文書名",
    priorYearDocumentName: "前年度の文書名",
    externalDocumentSignOffInUTC: "外部文書のサインオフ（UTC）",
    clientRequestReferenceNumber: "クライアントリクエスト番号"
};

export const reportingRequestComment = {
    requestTitle: "リクエスト/タスクタイトル",
    request_Description: "リクエスト/タスクの説明",
    type: "タイプ",
    tasks: "タスクタイトル",
    engagementTagName: "タグ",
    eyAssigned: "EY担当者",
    clientGroupName: "外部グループ",
    externalAssignedUser: "外部担当者",
    periodName: "タイムフェーズ",
    dueDateInUTC: "期日（UTC）",
    requestStatus: "リクエスト/タスクステータス",
    externalDocumentSignOffInUTC: "外部文書のサインオフ（UTC）",
    annotationTextData: "コメント",
    createDateInUTC: "コメント記入日（UTC）",
    annotationUserInitials: "コメント記入者"
};

export const reportingAllDocuments = {
    documentName: "文書名",
    fileExt: "ファイル拡張子",
    canvasFormType: "Canvasフォームタイプ",
    docType: "文書タイプ",
    confidentiality: "機密性",
    docFileSize: "ファイルサイズ（KB）",
    preparers: "実施者（UTC）",
    reviewers: "査閲者（UTC）",
    relatedTask: "関連タスク",
    openReviewNote: "オープンのレビューノート",
    clearedReviewNote: "クリア済レビューノート",
    trackChanges: "変更履歴",
    hiddenSheets: "非表示のシート",
    comments: "コメント",
    highlighted: "ハイライト",
    conflicted: "コンフリクト",
    docModifyUser: "最終編集者",
    docModifyDateInUTC: "最終編集日 (UTC)",
    documentID: "文書ID"
};

export const signOffDocuments = {
    documentName: "文書名",
    fileExt: "ファイル拡張子",
    canvasFormType: "Canvasフォームタイプ",
    docType: "文書タイプ",
    confidentiality: "機密性",
    docFileSize: "ファイルサイズ（KB）",
    docModifyUser: "最終編集者",
    docModifyDateInUTC: "最終編集日 (UTC)",
    signOffDate: "サインオフ日(UTC)",
    signedOffBy: "サインオフ者",
    role: "役割",
    preparerReviewer: "実施者/査閲者"
};

export const reportingDocumentsModified = {
    documentName: "文書名",
    lastModifiedDateInUTC: "最終編集日 (UTC)",
    lastModifiedUser: "最終編集ユーザー",
    reason: "理由",
    documentChangeComment: "根拠",
    preparersInUTC: "実施者（UTC）",
    reviewersInUTC: "査閲者（UTC）",
    approver: "承認（UTC）"
};

export const reportingDeletedTaskReport = {
    taskNamePrefix: labels.taskPrefix,
    taskName: "タスクタイトル",
    taskNameSuffix: labels.taskSuffix,
    taskDescription: "タスクの説明",
    taskTypeAbbreviation: "タスクタイプ",
    taskSourceType: "タスクソース",
    taskNatureType: "タスク性質",
    last_Modified_By: "最終更新者",
    modifyDateInUTC: "最終編集日 (UTC)",
    oldTaskName: "レガシータスクタイトル",
    oldTaskDetail: "レガシータスクの説明"
};

export const SEMReportHeaderLabel = {
    accountAssertion: "勘定科目/アサーション",
    craValue: "CRA",
    riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
    relatedRisks: "関連するリスク",
    taskType: "タスクタイプ",
    taskTitle: "タスク名称",
    taskSource: labels.source,
    taskNature: labels.nature,
    taskTypeID: "タスクタイプID",
    taskSourceTypeID: "タスクソースタイプID",
    taskNatureTypeID: "タスク性質タイプID"
}

export const MilestonesReportHeaderLabels = {
    taskName: labels.repTaskTitle,
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    auditPhase: labels.auditPhasesLabel,
    periodName: labels.timephase,
    timephase: "現在のマイルストーン",
    correctTimephase: "修正マイルストーン"
}

export const MilestonesReportHeader = {
    milestone: "マイルストーン",
    status: "マイルストーンステータス",
    taskStatus: "タスクステータス",
    taskTitle: "タスクタイトル",
    taskTypeAbbreviationColumn: "タスクタイプの略称",
    taskType: "タスクタイプ",
    timePhase: "タイムフェーズ",
    assignedTo: "割当て先",
    taskName: "タスク名",
    task_Detail: "タスク詳細",
    due_Date: "期日",
    documentName: "文書名",
    preparers: "作成者",
    reviewers: "査閲者",
    tagGroup: "タググループ",
    tags: "タグ",
    engagementID: "エンゲージメントID",
    taskID: "タスクID",
    taskTypeID: "タスクタイプID",
    taskStatusID: "タスクステータスID",
    timephaseID: "タイムフェーズID",
    timephaseTypeID: "タイムフェーズのタイプID",
    documentID: "文書ID"
}

export const groupStructureSummaryReportHeaderLabels = {
    gaScopeName: "スコープの説明",
    gaScopeDescription: "スコープ / サブスコープ名",
    shortName: "リージョン / 構成単位名",
    legalName: "法人名",
    gaRoleTypeName: "グループロール",
    relatedRegion: "関連するリージョン",
    pocText: "連絡先",
    gaLinkStatusName: "リンクステータス",
    gaInstructionStatusName: "インストラクションステータス",
    engagementID: "エンゲージメントID",
    gaRoleTypeID: "GAロールタイプID",
    gaLinkStatusID: "GAリンクステータスID",
    gaInstructionStatusID: "GAインストラクションステータスID"
}

export const collaborationSummary = {
    clientRequestID: "リクエスト番号",
    requestTitle: "タイトル",
    requestType: "タイプ",
    engagementTagName: "タグ",
    clientUser: "割当先",
    clientEmail: "クライアントEメール",
    clientStatusName: "ステータス",
    isOverDue: "期限超過",
    dueDateInUTC: "期日 (UTC)",
    eySentDateInUTC: "EY送信日 (UTC)",
    eyReceivedDateInUTC: "受領日 (UTC)",
    deliveredLate: "納期遅延",
    daysLate: "遅延日数",
    timesReturned: "差戻回数"
}

export const collaborationActivity = {
    clientRequestID: "リクエスト番号",
    requestTitle: "タイトル",
    requestType: "タイプ",
    engagementTagName: "タグ",
    clientUser: "割当先",
    clientEmail: "クライアントEメール",
    clientStatusName: "ステータス",
    isOverDue: "期限超過",
    dueDateInUTC: "期日 (UTC)",
    eySentDateInUTC: "EY送信日 (UTC)",
    eyReceivedDateInUTC: "受領日 (UTC)",
    deliveredLate: "納期遅延",
    daysLate: "遅延日数",
    timesReturned: "差戻回数",
    activity: "アクティビティ",
    activityDateInUTC: "アクティビティの日付(UTC)",
    historicalDueDateInUTC: "過去の期日(UTC)"
}

export const groupReportHeaderLabels = {
    gaInstructionName: "インストラクション名",
    gascopeTypeIDName: labels.scope,
    componentName: "構成単位名",
    pointOfContact: labels.pointOfContact,
    dueDateValue: "期日(UTC)",
    overdueValue: labels.overdueLabel,
    gaStatusIdName: labels.status,
    documentName: labels.documents,
    createDateValue: "サインオフ日(UTC)",
    signoffBy: labels.signedOffBy,
    engagementRoleIDName: labels.role,
    isPreparerText: "作成者/査閲者",
    documentID: "文書ID",
    gaStatusID: "GAステータスID",
    engagementRoleID: "エンゲージメントロールID"
}

export const wcgwSummaryHeaders = {
    wcgwName: "WCGW",
    scotName: "SCOT",
    controlName: "関連する統制",
    itApplications: "関連する IT App/SO",
    testing: "テスト対象の選択",
    isLowerR: "低リスク統制",
    controlFrequencyTypeName: "統制の頻度",
    controlTypeName: "統制タイプ",
    wcgwCount: "その他の関連するWCGWsの数"
}

export const allControlsHeaders = {
    engagementID: "エンゲージメントID",
    scotid: "SCOT ID",
    controlID: "統制ID",
    scotName: "SCOT名",
    controlName: "統制の説明",
    hasControlTesting: "テストの選択",
    isLowerRisk: "低リスク",
    controlTypeID: "統制タイプ",
    relatedITApplicationNames: "関連するIT App/SO",
    responsiveToSR: "特別な検討を必要とするリスクへの対応",
    IPE: "IPE"
}


export const qualityChecksHeaders = {
    itemID: "項目ID",
    itemName: "項目名",
    qualityChecks: "品質チェック",
    validationDescription: "検証の説明",
    buildGroup: "ビルドグループ",
    impactedItem: "影響を受ける項目",
    type: "タイプ"
}

export const statisticsHeaders = {
    scotname: "SCOT",
    strategyTypeId: "SCOT戦略",
    wcgwName: "WCGW",
    controlName: "統制",
    operatingEvaluation: "運用状況の評価",
    itApplicationName: "関連するIT app / SO",
    assertions: "アサーション",
    controlTypeId: "統制タイプ",
    testingSelection: "テストの選択",
    controlFrequencyTypeId: "頻度",
    itApplications: "ITアプリケーション",
    scotTypeId: "SCOTタイプ",
    itType: "ITアプリケーションのタイプ",
    isLowerR: "低リスクか？",
    engagementID: "エンゲージメントID",
    workspaceID: "ワークスペースID",
    scotID: "SCOT ID",
    scotTypeID: "SCOTタイプID",
    wcgwid: "WCGW ID",
    controlID: "統制ID"
}

export const CRTAssertionCountSummaryHeaders = {
    accountName: "勘定科目",
    assertion: "アサーション",
    controlName: "統制",
    ControlTypeName: "統制タイプ",
    ControlFrequencyTypeName: "頻度",
    Testing: "テスト",
    OperatingEvaluation: "運用状況の評価",
    assertionControlCount: "アサーション統制数",
    assertionAbbreviation: "アサーションの略称",
    wcgwName: "WCGW",
    engagementID: "エンゲージメントID",
    workspaceID: "ワークスペースID",
    assertionID: "アサーションID",
    wcgwid: "WCGW ID",
    controlID: "統制ID"
}

export const crtlistcontrolTypeName = {
    'IT Application Control': "ITアプリケーション統制",
    'IT Dependent Manual Control': "IT依存手作業統制",
    'Manual Prevent': "手作業防止",
    'Manual Detect': "手作業発見"
}

export const controlFrequencyNameTypes = {
    'Many times per day': "毎日何度も",
    'Daily': "日次",
    'Weekly': "週次",
    'Monthly': "月次",
    'Quarterly': "四半期毎",
    'Annually': "年次",
    'IT Application Control': "ITアプリケーション統制",
    'Other': "その他"
};

// Folder types
export const archiveFolderTypeNameTypes = {
    'Working Papers': "調書",
    'Perm File Active': "永久調書アクティブ",
    'Perm File Superseded': "差し替えられた永久調書",
    'Working Papers - CD/DVD': "調書 - CD/DVD",
    'Perm File Active - CD/DVD': "永久調書アクティブ - CD/DVD",
    'Perm File Superseded - CD/DVD': "差し替えられた永久調書 - CD/DVD",
    'Data Storage Devices': "データストレージデバイス"
};

export const operatingEvaluationType = {
    'Effective': "有効",
    'Ineffective': "非有効",
    'Not Selected': "未選択"
};

export const CRTSCOTCountSummaryHeaders = {
    scotname: "SCOT",
    strategyTypeName: "SCOT戦略",
    wcgwName: "関連するWCGWs",
    controlName: "関連する統制",
    operatingEvaluation: "運用状況の評価",
    itApplicationName: "関連するIT app / SO",
    assertions: "アサーション",
    controlTypeName: "統制タイプ",
    testing: "テストの選択",
    controlFrequencyTypeName: "頻度",
    itApplications: "ITアプリケーション",
    itAppType: "ITアプリケーションタイプ",
    scotTypeName: "SCOTタイプ",
    soctisLowerRisk: "低リスクの統制",
    engagementID: "エンゲージメントID",
    workspaceID: "ワークスペースID",
    scotID: "SCOT ID",
    scottypeid: "SCOTタイプID",
    wcgwid: "WCGW ID",
    controlID: "統制ID"
};

export const projectInsightCanvasFormExportHeaders = {
    EngagementID: "エンゲージメントID",
    DocumentID: "文書ID",
    ControlID: "統制ID"
};

export const projectInsightSCOTToWCGWToControlHeaders = {
    engagementID: "エンゲージメントID",
    scotName: "SCOT名",
    strategyTypeName: "戦略タイプ名",
    wcgwName: "WCGW名",
    controlID: "統制ID",
    controlName: "統制名",
    controlFrequencyTypeName: "統制の頻度タイプ名",
    controlTypeName: "統制タイプ名",
    isLowerRiskHeader: "低リスク",
    hasControlTestingHeader: "統制テストあり",
    operativeEffectiveness: "運用状況の有効性"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
    engagementId: "エンゲージメントID",
    accountId: "勘定科目ID",
    accountName: "勘定科目名",
    accountTypeId: "勘定科目タイプID ",
    accountDesignation: "勘定科目の指定",
    pspIndexTitle: "PSPインデックス",
    knowledgeAssertion: "アサーション略称",
    inherentRiskType: "固有リスク評価",
    controlRiskType: "統制リスク評価",
    craValue: "CRA",
    riskId: "リスクID",
    riskTypeId: "リスクタイプID",
    riskTypeEnum: "リスクタイプ",
    riskName: "リスク名",
    isHigherRiskText: "高リスク",
    rejectedTaskId: "タスクID",
    rejectedTaskName: "差し戻されたPSP",
    rejectedTaskRationale: "差し戻されたPSPの理由"
};

export const projectInsightControlToITApplicationHeaders = {
    engagementID: "エンゲージメントID",
    controlID: "統制ID",
    itApplicationID: "ITアプリケーションID",
    controlITApplication: "統制のITアプリケーション"
};

export const projectInsightControlToAssertionHeaders = {
    engagementID: "エンゲージメントID",
    controlID: "統制ID",
    Accountname: "勘定科目名",
    AssertionAbbreviation: "アサーション略称"
};

export const projectInsightRisksToWCGWsHeaders = {
    engagementId: "エンゲージメントID",
    accountName: "勘定科目名",
    accountId: "勘定科目ID",
    knowledgeAssertion: "アサーション",
    CRA: "CRA",
    RelatedRisk: "関連するリスク",
    riskId: "リスクID",
    riskType: "リスクタイプ",
    WCGW: "WCGW",
    wcgwId: "WCGWID",
    RelatedSCOT: "関連するSCOT",
    scotId: "SCOTID"
};

export const ipeControlsHeaders = {
    EngagementID: "エンゲージメントID",
    DocumentID: "文書ID"
};

export const ipeSubstantiveHeaders = {
    EngagementID: "エンゲージメントID",
    DocumentID: "文書ID"
};

export const ipeITGCHeaders = {
    EngagementID: "エンゲージメントID",
    DocumentID: "文書ID"
};

export const iTAppSOReport = {
    relatedITSO: "関連するIT app/SO",
    iTAppType: "ITアプリケーションタイプ",
    iTAppControl: "ITアプリケーション統制",
    testingSelection: "テストの選択",
    relatedSCOTs: "関連するSCOTs",
    relatedSCOTStrategy: "関連するSCOT戦略",
    itdm: "ITDM",
    manualPrevent: "手作業防止",
    manualDetect: "手作業発見",
    noRelatedControls: "関連する統制がありません",
    controlsStatistics: "タイプ別統制",
    relatedSCOTType: "関連するSCOTタイプ",
    controlType: "統制タイプ",
    grandTotal: "合計",
    yes: "はい",
    no: "いいえ",
    notSelected: "未選択",
    controls: "統制",
    substantive: "実証",
    routine: "経常",
    nonRoutine: "非経常",
    estimation: "見積"
};

export const IndependenceSummaryReport = {
    id: "ID",
    userName: "ユーザー名",
    order: "番号",
    questionFormatted: "質問",
    answer: "回答",
    actionTypeID: "アクションタイプID",
    independenceStatusID: "独立性ステータスID",
    EngagementUserStatusName: "エンゲージメントユーザーステータス",
    engagementUserStatusID: "エンゲージメントユーザーステータスID",
    IndependenceStatusName: "独立性ステータス",
    requiresExecutiveClearance: "エグゼクティブのクリアランスが必要です"
};

export const additionalInfoBasedOnValidationTypeId = {
    1: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    2: "チームは、最新バージョンの109 - チームメンバーの独立フォームを使用していません",
    3: "チームメンバーが、独立性の問題のある別のチームメンバーにアクセス権を付与した後、PPEDDロールからロールを変更しました",
    4: "チームメンバーは、独立性の問題のある別のチームメンバーを上書きした後、PPEDDロールからロールを変更しました",
    5: "検証リンクをクリックして、数字バッジが付いていないSCOTを識別します。SCOTを勘定科目に関連付けます",
    6: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    7: "関連するWCGW数が空白のSCOTを識別します。それぞれのビルドタスクに移動します。SCOTを展開して、必要に応じてWCGWを追加します",
    8: "関連する統制数が空白のSCOTを識別します。それぞれのビルドタスクに移動します。SCOTを展開して、WCGWに統制を追加します",
    9: "検証を要するSCOTを特定して、SCOTの詳細を展開し、WCGWごとに少なくとも1つの統制がテストに「はい」が選択されていることを確認します",
    10: "検証を要するSCOTを特定して、SCOTの詳細を展開します。WCGWごとに少なくとも1つの統制でテストに「はい」が選択されていることを確認します",
    11: "検証リンクをクリックして、数字バッジが付いていないリスクを識別します。適切なアサーションをリスクに関連付けます",
    12: "固有リスク及び/又は統制リスクがないアサーションを識別します。不足しているフィールドを完了します",
    13: "検証リンクをクリックして、「WCGWの追加」ドロワーを開きます。一度に1つのSCOTを選択して、数字バッジのないWCGWsを識別します。WCGWを適切なアサーションに関連付けます",
    14: "数字バッジがない勘定科目を識別します。SCOTビルドフローに移動して、SCOTを勘定科目に関連付けます",
    15: "検証で勘定科目/アサーションを識別して、「WCGWsの追加」ボタンをクリックし、WCGWをアサーションに関連付けます",
    16: "この検証チェックでは、統制戦略のアサーションに関連するすべての WCGWが、テストする統制にカバーされていることを確認します。検証を要するアサーションを特定して、「WCGWの追加」ボタンをクリックし、WCGWをアサーションに関連付けます",
    17: "アサーションに関連付けられている各WCGWを確認して、テスト戦略の少なくとも1つの統制にカバーされていることを確認します",
    18: "依拠戦略のアサーションのすべてのWCGWsは、テストの値が「はい」に設定された統制によってカバーされる必要があります",
    19: "IT/SOには、削除されず、IT/SO プロセスにも関連付けられていない依拠戦略があります",
    20: "IT/SO統制/IT実証手続が、IT/SOリスクに関連付けられていません",
    21: "IT/SO プロセス作成後の「依拠する」から「依拠しない」戦略への変更",
    22: "リスクがアサーションに関連付けられていません",
    23: "IT/SO統制/IT実証手続が、IT/SOリスクに関連付けられていません",
    24: "IT/SO リスクに関連付けられているIT/SO統制/実証手続がテスト対象として選択されていません",
    25: "IT/SO統制/IT実証手続が、IT/SOリスクに関連付けられていません",
    26: "タスクのないリスクが限定的な勘定科目を特定します。1つ以上のOSPを追加します",
    27: "PSPをインポートしたことを確認します。PSPがインポートされていない場合は、「PSPのインポート」をクリックします。アサーションのPSPがない場合は、OSPを作成します",
    28: "SCOTビルドフローに移動して、「統制テストの追加」ドロワーを開き、数字バッジが付いてないTOCタスクを特定します。TOCタスクを統制に関連付けます",
    29: "エンゲージメントには、SCOTに関連付けられていないウォークスルータスクが少なくとも1つ含まれています",
    30: "SCOTに、少なくとも1つのウォークスルータスクが関連付けられていません",
    31: "SCOTビルドフローに移動して、「統制テストの追加」ドロワーを開き、数字バッジが付いてないTOCタスクを特定します。TOCタスクを統制に関連付けます",
    32: "IT/SO ウォークスルーが、少なくとも1つのIT/SOプロセスに関連付けられていません",
    33: "IT/SO統制テストが、テストの値が「はい」に設定された少なくとも1つのIT/SO統制/実証手続に関連付いていません",
    34: "IT/SOその他の実証手続が、テストの値が「はい」に設定された少なくとも1つのIT/SO統制/実証手続に関連付けられていません",
    35: "IT/SOプロセスに、少なくとも1つのウォークスルータスクが関連付けられていません",
    36: "テストの値が「はい」に設定された統制に、統制タスクのテストが関連付けられていません",
    37: "IT/SOその他の実証手続が、テストの値が「はい」に設定された少なくとも1つのIT/SO統制/実証手続に関連付けられていません",
    38: "検証リンクをクリックして、エビデンスリストから競合アイコンをクリックし文書の競合状態を解消します",
    39: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    40: "作成者または査閲者がサインオフしていない文書のエビデンスリストから、検証リンクをクリックします。作成または査閲したファイルにのみサインオフします",
    41: "検証リンクをクリックして、フィルターされたタスクリストから各タスクを確認し、適切なエビデンスファイルを関連付けます",
    42: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    43: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    44: "検証リンクをクリックして、エビデンスリストから重複するファイル名を持つ文書の名称を変更してください",
    45: "ITプロセスの評価が選択されていないか、ITCG/ITSPの運用状況の有効性評価と一致していません",
    46: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    47: "1つ以上のアプリケーション/ITDM統制に対して、IT総合評価が選択されていません",
    48: "Canvasフォームに未記入のフィールドが少なくとも1つあります",
    49: "検証リンクをクリックして、「アサーションの追加」をクリックし、アサーションまたはリスクが限定的な勘定科目を関連付けます",
    50: "タスクにアサーションまたはリスクが限定的な勘定科目が関連付けられていません。「アサーションの追加」をクリックし、アサーションまたはリスクが限定的な勘定科目を関連付けます",
    51: "WCGWが実証タスクに関連付けられていません",
    52: "エンゲージメントには、少なくとも１つのWCGWに関連付けられていない固有リスク、特別な検討を必要とするリスクまたは不正リスクが少なくとも1つあります",
    53: "見積勘定科目にEST-会計上の見積りインデックスが存在しません。PSPインデックスリストから追加してください。",
    54: "見積勘定科目を識別し、その勘定科目を開いて、関連付けられている見積SCOTがあるかどうかを確認します。見積SCOTが存在しない勘定科目がある場合、見積SCOTを関連付ける必要があります。",
    55: "見積勘定科目に関連付けられていない見積SCOTを識別します。見積勘定科目が存在しない見積SCOTがある場合、見積SCOTを見積勘定科目に関連付ける必要があります。",
    56: "特別な検討を必要とするリスクまたは不正リスクには、少なくとも1つの実証手続、1つの統制及び1つの統制テストのタスク (該当する場合)が必要です。",
    57: "特別な検討を必要とするリスクまたは不正リスクには、少なくとも1つの実証手続、1つの統制及び1つの統制テストのタスク (該当する場合)が必要です。",
    58: "検証のあるリスクをクリックして、アサーションを展開します。少なくとも1つのタスクが「はい」に選択されていることを確認します",
    59: "検証のあるリスクをクリックして、アサーションを展開します。少なくとも1つの統制が「はい」に選択されていることを確認します。この統制についてデザインの有効性も完成する必要があります",
    60: "検証リンク「Canvasフォームコメントの対応」をクリックします。各Canvasフォームを開き、「未解決のコメントを表示」を選択します。すべてのコメントをクリア済またはクローズ済にする必要があります",
    61: "検証リンク「未完了のCanvasフォームへの対応の確定」をクリックします。各Canvasフォームを開き、「不完全な回答を表示」を選択します。Canvasフォームのすべての質問に回答する必要があります",
    62: "検証リンクをクリックして、オープンコメントを確認し、すべてのオープンコメントをクリア済またはクローズ済にします。",
    63: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    64: "検証リンクをクリックして、フィルターされたタスクリストから各タスクを確認し、オープンタスクを完了としてマークします",
    65: "すべてのリンクを解除ボタンをクリックして、すべての共有エビデンスのリンクを解除します",
    66: "フォーム440に、変更理由が選択されていない文書が少なくとも1つあります",
    67: "フォーム440に、「事務的でない」変更理由が選択されており、根拠が記入されていない文書が少なくとも1つあります",
    68: "フォーム440に、「事務的でない」変更理由が選択されていますが、マネージャー以上が承認していない文書が少なくとも1つあります。",
    69: "フォーム440は、業務執行社員または筆頭業務執行社員によってサインオフされていません",
    70: "アーカイブチェックリストのグループからリンクを解除ボタンをクリックします",
    71: "Canvasフォームにヘッダーや標準コンテンツがありません",
    72: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    73: "Canvasフォームの検証チェックアイコンをクリックすると、不完全な回答の数が表示されます",
    74: "リンクをクリックして、Engagement Profile.smtの更新バージョンを送信します",
    75: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    76: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    77: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    78: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    79: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    80: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    81: "ITプロセスを識別し、ITアプリケーションに関連付ける",
    82: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    83: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    84: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    85: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    86: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    87: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    88: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    89: "ITプロセスの評価が選択されていないか、ITCG/ITSPの運用状況の有効性評価と一致していません",
    90: "統制にデザインの有効性の選択がありません",
    91: "SCOTおよび監査に関連するITアプリケーションを表示する",
    92: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    93: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    94: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    95: "エンゲージメントには、「チームの管理」の担当者として登録された特定のチームメンバーが存在しません",
    96: "リスク要因がリスクに関連付けられていないか、「ROMMではない」とマークされていません",
    97: "リスクがアサーションに関連付けられていません",
    98: "見込基礎値を入力する必要があります。",
    99: "見込基礎値の根拠を入力する必要があります",
    100: "調整後基礎値を入力する必要があります",
    101: "PMパーセンテージが選択されていません",
    102: "PMパーセンテージが許容範囲外です",
    103: "選択したPMパーセンテージの根拠を入力する必要があります",
    104: "TEが入力されていません",
    105: "TEパーセンテージが許容範囲外です",
    106: "選択したTEパーセンテージの根拠を入力する必要があります",
    107: "SADパーセンテージが選択されていません",
    108: "SADパーセンテージが許容範囲外です",
    109: "選択したSADパーセンテージの根拠を入力する必要があります",
    110: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    111: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    112: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    113: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    114: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    115: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    116: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    117: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    118: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    119: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    120: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    121: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    122: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    123: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    124: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    125: "保護された文書は、必要でない限り、エンゲージメント内のファイルとして保管すべきではありません。",
    126: "文書の削除および再アップロード",
    127: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    128: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    129: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    130: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    131: "見積り一覧フォームに移動して、 「文書の作成」オプションを使用してください",
    132: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    133: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    134: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    135: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    136: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    137: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    138: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    139: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    140: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    141: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    142: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    143: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    144: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    145: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    146: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    147: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    148: "この検証を解決するには、「EY Canvas検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    149: "検証チェックの「Canvasフォームの未対応項目を完了する」をクリックします。各Canvasフォームを開き、要求事項に関連付けられたすべての必須文書に関連するPIC/EQRサインオフがあるか確認してください。自分が実施又は査閲したファイルにのみサインオフをしてください。",
    150: "検証チェックの「Canvasフォームの未対応項目を完了する」をクリックします。各Canvasフォームを開き、要求事項に関連付けられたすべての必須文書に関連するPIC/EQRサインオフがあるか確認してください。",
    151: "すべての重要な勘定科目及び開示が少なくとも一つのアサーションが関連付けられていることを確認してください。",
    152: "各Canvasフォームを開き、要求事項に関連付けられたすべての必須文書に実施者及び査閲者サインオフがあることを確認してください。自分が実施又は査閲したファイルにのみサインオフをしてください。",
    153: "調整に移動して、「エビデンスの追加」オプションを使用して適切なエビデンスを関連付けてください",
    154: "会計上の見積りに関する文書に移動し、高/低リスク見積項目に、見積勘定科目が関連付けられていることを確認してください。極めて低いリスクの見積項目には、少なくとも １つの勘定科目が関連付けられる必要があります。",
    155: "会計上の見積りに関する文書に移動し、関連付けられた勘定科目を確認してください。監査調書に基づいて、非見積勘定科目の関連付けを解除するか、見積勘定科目に変更してください。",
    156: "会計上の見積りに関する文書に移動し、回答を確認してください。",
    157: "会計上の見積りに関する文書に移動し、高/低リスク見積項目に見積SCOTが関連付けられていることを確認してください。極めて低いリスクの見積項目には、少なくとも １つのSCOTが関連付けられる必要があります。",
    158: "勘定科目文書に移動し、少なくとも1つの高/低リスク見積項目が関連付けられていることを確認してください。",
    159: "勘定科目文書に移動し、少なくとも1つのリスク高/低リスク見積項目が関連付けられていることを確認してください。",
    160: "見積項目リードシートに移動し、関連する見積項目がない見積SCOTを特定してください。監査調書に基づいて、それらのSCOTを非見積項目に変更するか、見積項目をそれらのSCOTに関連付けてください。",
    161: "調整に移動し、借方の合計が貸方の合計と一致することを確認してください。",
    162: "会計上の見積りに関する文書に移動し、少なくとも1つの特別な検討を必要とするリスク又は不正リスクが関連付けられていることを確認してください。",
    163: "この検証を解決するには、「EY Canvasの検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    164: "この検証を解決するには、「EY Canvasの検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    165: "この検証を解決するには、「EY Canvasの検証チェック解消マニュアル」イネーブラーのガイダンスに従ってください",
    166: "会計上の見積りに関する文書に移動し、関連付けられたリスクを確認してください。監査調書に基づいて、特別な検討を必要とするリスク及び不正リスクの関連付けを解除するか、見積カテゴリを高リスクに更新してください。"
};

export const validationChecksReportHeaderLabels = {
    validationType: "検証タイプ",
    validationDescription: "検証の説明",
    itemName: "項目名",
    auditPhase: "監査フェーズ",
    additionalInformation: "追加情報",
    localization: "ローカライズ",
    itemType: "項目タイプ",
    location: labels.location,
    count: "数",
    validationCount: "検証の数",
    itemID: "項目ID",
    validationTypeID: "検証タイプID",
    category: "カテゴリー",
    auditPhaseID: "監査フェーズID",
    entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
    annotationID: "注釈ID",
    assignToUserID: "ユーザーIDへの割当て",
    assignedtoUser: labels.assignedTo,
    createUserID: "作成者ID",
    createdBy: "作成者",
    createdDate: "作成日",
    dueDateLabel: "期日",
    relatedEvidence: "関連するエビデンス",
    reviewNote: labels.reviewNotesLabel,
    lastModifiedBy: "最終編集者",
    modifyUserID: "ユーザーIDによる編集者",
    lastModifiedOnLabel: "最終編集日",
    priorityType: labels.priorityLabel,
    annotationParentID: "親注釈ID",
    referenceNumber: "リファレンス",
    relatedTasks: "関連するタスク",
    replies: labels.reply,
    reviewNoteStatus: labels.status,
    statusChangedByUserID: "ユーザーIDによるステータス変更者",
    statusChangedBy: "ステータス変更者：",
    statusChangedDateLabel: "ステータス変更者",
    startDateLabel: "当初作成(UTC)",
    clearedDateLabel: "最終クリア(UTC)",
    closedDateLabel: "最終クローズ(UTC)",
    documentTypeID: "ステータス変更日",
    childAnnotationID: "文書タイプID"
};

export const taskDueDateCategoryIdLabels = {
    0: "過去数週間",
    1: "今週",
    2: "来週",
    3: "今後数週間"
};

export const taskSummaryReportHeaderLabels = {
    engagementID: "エンゲージメントID",
    taskID: "タスクID",
    displayedTaskName: labels.TaskName,
    taskNamePrefix: "タスクのプレフィックス",
    taskNameSuffix: "タスクのサフィックス",
    dueDateColumn: labels.taskDueDateHeader,
    dueDateWeek: labels.dueLabel,
    assignmentType: labels.assignmentType,
    assignmentTypeID: "割当てタイプID",
    assignmentName: labels.assignmentName,
    assignmentStatus: labels.taskAssigmentStatusHeader,
    reviewNoteAssignedOpen: "割当てされたオープンなレビューノート",
    reviewNoteAssignedCleared: "割当てされたクリア済レビューノート",
    reviewNoteAuthoredOpen: "作成されたオープンなレビューノート",
    reviewNoteAuthoredCleared: "作成されたクリア済レビューノート",
    taskStatus: labels.taskStatusLabel,
    taskStatusID: "タスクのステータスID",
    taskType: labels.taskType,
    taskTypeID: "タスクのタイプID",
    milestone: labels.filterMilestoneLabel,
    milestoneID: "マイルストーンID",
    isOverdueColumn: labels.Overdue,
    timephaseName: labels.timephase,
    relatedObjectName: "関連付けられたオブジェクト",
    relatedEntityID: "関連付けられたオブジェクトID",
    openAssignmentsOverdue: "オープンな割当て-期限切れ",
    openAssignmentsThisWeek: "オープンな割当て-今週",
    openAssignmentsNextWeek: "オープンな割当て-来週",
    openAssignmentsTotal: "オープンな割当て-合計",
    inProgressAssignmentsOverdue: "進行中の割当て-期限切れ",
    inProgressAssignmentsThisWeek: "進行中の割当て-今週期限",
    inProgressAssignmentsNextWeek: "進行中の割当て-来週期限",
    inProgressAssignmentsTotal: "進行中の割当て-合計"
};

export const crtControlSummaryReportHeaderLabels = {
    scotID: "SCOT ID",
    scotName: "SCOT",
    strategyTypeName: "戦略タイプ",
    wcgwID: "WCGW  ID",
    wcgwName: "WCGW",
    controlID: "統制ID",
    controlName: "統制",
    operatingEvaluation: "運用評価",
    assertions: "アサーション",
    controlTypeName: "統制タイプ",
    testingFormatted: "テスト対象の選択",
    scotStrategy: "SCOT戦略",
    itApplicationName: "関連する IT App/SO",
    controlFrequencyTypeName: "頻度",
    scotTypeID: "SCOTタイプID",
    scotTypeName: "SCOTタイプ",
    itAppType: "IT/SO アプリケーション",
    lowerRiskControl: "低リスク統制"
};

export const trialBalanceReportHeaderLabels = {
    engagementID: "エンゲージメントID",
    trialBalanceID: "試算表ID",
    trialBalanceTypeID: "試算表タイプID",
    trialBalanceTypeName: "試算表タイプ名",
    financialStatementID: "財務諸表ID",
    financialStatementName: "財務諸表名",
    financialStatementTypeID: "財務諸表タイプID",
    financialStatementTypeName: "財務諸表タイプ名",
    financialStatementSubTypeID: "財務諸表サブタイプID",
    financialStatementSubTypeName: "財務諸表サブタイプ名",
    analysisPeriodBalance: "分析日の残高",
    comparativePeriodBalance: "比較日付の残高",
    analysisComparativeBalanceChange: "比較残高変動分析",
    analysisComparativeBalanceChangePercent: "比較残高変動率分析",
    secondComparativePeriodBalance: "第2比較日付の残高",
    analysisSecondComparativeBalanceChange: "第2比較残高変動分析",
    analysisSecondComparativeBalanceChangePercent: "第2比較残高変動率分析",
    parentFinancialStatementID: "親財務諸表ID",
    displayOrder: "表示順",
    eyCanvasAccountName: "EY Canvas 勘定科目名",
    relatedEntities: "関連するエンティティ"
};

export const taskSourceTypes = {
    1: labels.internal,
    2: labels.external
};

export const taskNatureTypes = {
    1: labels.testOfDetail,
    2: labels.substantiveAnalyticalProcedure,
    3: labels.testOfControl
};

export const priorityTypesCollaboration = [{
        value: 1,
        label: "標準"
    },
    {
        value: 3,
        label: "高"
    },
    {
        value: 4,
        label: "クリティカル"
    }
];

export const StatementType = [{
    id: 1,
    value: "損益計算書"
}, {
    id: 2,
    value: "貸借対照表"
}, {
    id: 3,
    value: "両方"
}];

export const AccountTypes = [{
        id: 1,
        accountTypeName: "重要な"
    },
    {
        id: 2,
        accountTypeName: "リスクが限定的な"
    },
    {
        id: 3,
        accountTypeName: "軽微な"
    },
    {
        id: 4,
        accountTypeName: "その他"
    },
    {
        id: 5,
        accountTypeName: "重要な開示"
    }
];

export const ITAppSOAttributes = [{
    id: 1,
    value: "テストの選択"
}, {
    id: 2,
    value: "関連するIT app/SO"
}, {
    id: 3,
    value: "関連するSCOT"
}, {
    id: 4,
    value: "関連するSCOT戦略"
}, {
    id: 5,
    value: "関連するSCOTタイプ"
}];

export const notesEditorLabels = {
    addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
    saveNoteButtonLabel: labels.saveLabel,
    messagePlaceholder: labels.addNewNoteModalTitle,
    messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
    messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
    messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
    addReplyButtonLabel: reviewNoteModalLabels?.reply,
    characters: labels.characters,
    of: labels.of,
    formRequired: labels.required,
    formMaxLength: labels.formMaxLength,
    toFieldLabel: labels.assignedTo,
    priorityFieldLabel: labels.rnhPriority,
    dueDateFieldLabel: labels.dueDate,
    voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
    stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
    cancelButtonLabel: labels.cancelButtonLabel,
    noResultsFound: labels.noResultsFound,
    microphoneBlockedMessage: labels.microphoneBlockedMessage,
    microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
    notInMainWindowVoice: labels.notInMainWindowVoice,
    notInMainWindowScreen: labels.notInMainWindowScreen,
    voiceNoteNotAvailable: "ボイスノートと画面録画は、ドロワービューでは利用できません。これらの機能を使用するには、全画面表示に切り替えてください。",
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel,
    screenRecord: labels.screenRecord,
    playbackReview: labels.playbackReview,
    close: labels.reviewNotesModalClose
};


export const noteModalLabels = {
    ...notesEditorLabels,
    closeButton: labels.reviewNotesModalClose,
    closed: labels.closed,
    open: labels.open,
    cleared: labels.cleared,
    allNotes: labels.allNotes,
    myNotes: labels.myNotes,
    assignedToMe: labels.assignedToMe,
    noNotesFound: reviewNoteModalLabels?.noNotesFound,
    noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
    assignedTo: labels.assignedTo,
    dueDate: labels.dueDate,
    edit: labels.edit,
    delete: labels.delete,
    clear: labels.clear,
    reopen: labels.reopen,
    close: labels.closeTitle,
    reply: labels.reply,
    confirm: labels.confirm,
    cancel: labels.cancelButtonLabel,
    deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
    deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
    deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
    deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
    showMore: reviewNoteModalLabels?.showMore,
    showLess: reviewNoteModalLabels?.showLess,
    view: labels.view,
    notSelected: labels.notSelectedText,
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
    close: "閉じる",
    cancel: "キャンセル",
    repNoRecordMessage: "結果が見つかりません",
    edit: "編集",
    delete: "削除",
    actions: "アクション",
    show: "表示",
    first: "最初のページ",
    last: "最後のページ",
    prev: "前のページ",
    next: "次のページ",

	[Entity.Account]: {
        manageEntity: "勘定科目及び開示の管理",
        searchEntity: "勘定科目の検索",
        createEntity: "新しい勘定科目",
        entityName: "勘定科目",
        entityNameCaps: "勘定科目",
        entityNamePlural: "勘定科目",
        placeholderText: "新しい勘定科目及び開示を作成するか、以下の既存の勘定科目及び開示を編集または削除します。",
        deleteConfirmLabel: "この勘定科目を削除してよろしいですか？全ての関連付けが解除されます。この操作は元に戻せません。"
    },
	[Entity.Estimate]: {
        manageEntity: "見積りの管理",
        searchEntity: "見積りの検索",
        createEntity: "新しい見積り",
        entityName: "見積り",
        entityNameCaps: "見積り",
        entityNamePlural: "見積り",
        placeholderText: "新しい見積りの作成、又は既存の見積りの編集と削除は以下から行えます。",
        deleteConfirmLabel: "この見積りを削除してよろしいですか？全ての関連付けが解除されます。この操作は元に戻せません。"
    },
    [Entity.Risk]: {
        manageEntity: "リスクの管理",
        searchEntity: "リスクを検索する",
        createEntity: "新しいリスク",
        entityName: "リスク",
        entityNameCaps: "リスク",
        entityNamePlural: "リスク",
        placeholderText: "新しいリスクの作成、又は既存のリスクの編集と削除は以下から行えます。",
        deleteConfirmLabel: "このリスクを削除してよろしいですか？全ての関連付けが解除されます。この操作は元に戻せません。"
    },
	[Entity.STEntity]: {
        manageEntity: "エンティティの管理",
        searchEntity: "エンティティの検索",
        createEntity: "新しいエンティティ",
        entityName: "エンティティ",
        entityNameCaps: "エンティティ",
        entityNamePlural: "エンティティ",
        placeholderText: "新しいエンティティを作成するか、以下の既存のエンティティを編集又は削除します。",
        deleteEntity: "エンティティの削除",
        deleteConfirmLabel: "このエンティティを削除してよろしいですか？全ての関連付けが解除されます。この操作は元に戻せません。"
    },
	[Entity.Control]: {
        manageEntity: "統制の管理",
        searchEntity: "統制の検索",
        createEntity: "新しい統制",
        entityName: "統制",
        entityNameCaps: "統制",
        entityNamePlural: "統制",
        placeholderText: "新しい統制を作成するか、以下の既存の統制を編集又は削除します。",
        deleteEntity: "統制の削除",
        deleteConfirmLabel: "この統制を削除してよろしいですか？全ての関連付けが解除されます。この操作は元に戻せません。"
    },
	[Entity.SCOT]: {
        manageEntity: "SCOTsの管理",
        searchEntity: "SCOTsの検索",
        createEntity: "新しいSCOT",
        entityName: "SCOT",
        entityNameCaps: "SCOT",
        entityNamePlural: "SCOTs",
        placeholderText: "新しいSCOTsを作成するか、以下の既存のSCOTsを編集または削除します。",
        deleteEntity: "SCOTの削除",
        deleteConfirmLabel: "このSCOTを削除してよろしいですか？全ての関連付けが解除されます。この操作は元に戻せません。"
    },
	[Entity.ITApplication]: {
        manageEntity: "ITアプリケーションの管理",
        searchEntity: "検索",
        createEntity: "新しいITアプリケーション",
        entityName: "ITアプリケーション",
        entityNameCaps: "ITアプリケーション",
        entityNamePlural: "ITアプリケーション",
        placeholderText: "新しいITアプリケーションの作成、又は既存のITアプリケーションの編集と削除は以下から行えます。",
        deleteEntity: "ITアプリケーションの削除",
        deleteConfirmLabel: "このITアプリケーションを削除してよろしいですか？全ての関連付けが解除されます。この操作は元に戻せません。"
    },
    [Entity.TaskSection]: {
        manageEntity: "タスクグループの管理",
        searchEntity: "タスクグループの検索",
        createEntity: "新しいタスクグループ",
        entityName: "タスクグループ",
        entityNameCaps: "タスクグループ",
        entityNamePlural: "タスクグループ",
        placeholderText: "新しいタスクグループを作成するか、以下の既存のタスクグループを編集又は削除します。",
        deleteEntity: "タスクグループの削除",
        deleteConfirmLabel: "選択した調整を削除してもよろしいですか？この操作は元に戻せません。"
    },
    [Entity.WCGW]: {
        manageEntity: "WCGWsの管理",
        searchEntity: "WCGWsの検索",
        createEntity: "新しいWCGWs",
        entityName: "WCGW",
        entityNameCaps: "WCGW",
        entityNamePlural: "WCGWs",
        placeholderText: "新しいWCGWの作成、又は既存のWCGWの編集と削除は以下から行えます。",
        deleteEntity: "WCGWの削除",
        deleteConfirmLabel: "このWCGWを削除してよろしいですか？全ての関連付けが解除されます。この操作は元に戻せません。"
    },
    [Entity.Misstatement]: {
        manageEntity: "調整の管理",
        searchEntity: "調整の検索",
        createEntity: "新しい調整",
        entityName: "調整",
        entityNameCaps: "調整",
        entityNamePlural: "調整",
        placeholderText: "新しい調整を作成するか以下の既存の調整を編集及び削除する。",
        deleteConfirmLabel: "選択した調整を削除してもよろしいですか？この操作は元に戻せません。"
    },
    [Entity.AdjustmentValidation]: {
        manageEntity: "検証チェック付調整の管理",
        searchEntity: "検索",
        entityName: "調整",
        entityNameCaps: "調整",
        entityNamePlural: "調整",
        placeholderText: "各調整には少なくとも1つのエビデンスを関連付ける必要があり、各調整について借方の合計は貸方の合計と一致する必要があります。次の調整には1つ以上のバリデーションの問題があります。<b>「編集」</b>をクリックしてそれらを解消してください。",
        deleteConfirmLabel: "選択した調整を削除してもよろしいですか？この操作は元に戻せません。",
        adjustmentHeader: "調整",
        validationTyeHeader: "検証タイプ",
        validationTypeAmtMissmatch: "借方の合計が貸方の合計と一致しません",
        validationTypeNoEvidence: "関連するエビデンスがありません"
    },
    [Entity.SampleItem]: {
        manageEntity: "サンプルタグの管理",
        searchEntity: "タグの検索",
        createEntity: "新しいタグ",
        createManageTagEntity: "タググループの管理",
        entityName: "タグ",
        entityNamePlural: "タグ",
        entityNameForTagGroupPlural: "タググループ",
        placeholderText: "新しいタグを作成するか、以下の既存のタグを編集又は削除します。"
    },
    [Entity.SampleTagGroups]: {
        manageEntity: "サンプルタググループの管理",
        searchEntity: "検索",
        createEntity: "新しいタググループ",
        entityName: "タググループ",
        entityNameCaps: "タググループ",
        entityNamePlural: "タググループ",
        placeholderText: "新しいサンプルタググループを作成するか、以下の既存のサンプルタググループを編集又は削除します。",
    }
};

export const executionType = [{
        id: 1,
        label: '',
        toolTip: '',
        value: "このエンゲージメント"
    },
    {
        id: 2,
        label: 'CT',
        toolTip: "他のエンゲージメントの手続[PT-only]",
        value: "他のエンゲージメント[PT-only]"
    },
    {
        id: 3,
        label: 'PT/CT',
        toolTip: "このエンゲージメントと他のエンゲージメントの手続[PT-only]",
        value: "このエンゲージメントと他のエンゲージメント[PT-only]"
    }
];

export const AccountType = [{
        id: 1,
        accounttypename: "重要な勘定科目"
    },
    {
        id: 2,
        accounttypename: "リスクが限定的な勘定科目"
    },
    {
        id: 3,
        accounttypename: "軽微な勘定科目"
    },
    {
        id: 4,
        accounttypename: "他の勘定科目"
    },
    {
        id: 5,
        accounttypename: "重要な開示"
    }
];

export const statementTypes = [{
        id: 1,
        name: "損益計算書"
    },
    {
        id: 2,
        name: "貸借対照表"
    },
    {
        id: 3,
        name: "両方"
    }
];

export const CreateEditAccountLabels = {
    createModalDescription: "以下に新しい勘定科目の詳細を入力し'<b>{0}</b>'を選択して終了してください。他の勘定科目を作成する場合は'<b>{1}</b>'を選択してください。",
    editModalDescription: "以下に勘定科目の詳細を編集し  '<b>{0}</b>' を選択して終了してください。",
    close: "閉じる",
    cancel: "キャンセル",
    yes: "はい",
    no: "いいえ",
    createAccount: "新しい勘定科目",
    editAccount: "勘定科目の編集",
    delete: "削除",
    save: "保存",
    saveAndCloseLabel: "保存して閉じる",
    saveAndCreateLabel: "保存して別の勘定科目を作成",
    accountNameLabel: "勘定科目名（必須）",
    accountDesignationLabel: "指定",
    accountExecutionTypeLabel: "この勘定科目の手続はどのCanvas エンゲージメントで実施され、文書化されていますか？",
    accountEstimateLabel: "この勘定科目は見積りの影響を受けますか？",
    accountStatementTypeLabel: "文書タイプ",
    pspIndexDropdownLabel: "PSPインデックス（必須：最大5つ）",
    removePSPIndexLabel: "PSPインデックスの削除",
    assertionsLabel: "関連するアサーションの選択",
    assertionOptions: assertions,
    executionTypeOptions: executionType,
    accountTypeOptions: AccountType,
    statementTypeOptions: statementTypes,
    confirm: "確認",
    pspIndexErrorMsg: "必須",
    assertionWarningMessage: "特別な検討を必要とするリスク、不正リスク又は重要な虚偽表示リスク又は見積りに関連付けられたアサーションを変更することはできません。まずこれらの関連付けを削除する必要があります。",
    confirmChanges: "変更を確認",
    executionTypeWarningMessage: "この勘定科目に保存しようとしている変更は既存のアサーションと PSPに影響し、リンクの関連付けは解除されます。続行してもよろしいですか？この操作は元に戻せません。",
    contentUpdateToastMessage: "{0} のコンテンツ更新が利用可能です。コンテンツ更新ページからコンテンツ更新を開始してください。",
    assertionsRequired: "少なくとも1つのアサーションを選択する必要があります",
    pspIndexDisabledLabel: "最大5つの PSP インデックスを選択してください。続行するには、1つ以上のオプションの選択を解除してください。",
    newSignificantDisclosure: "新しい重要な開示",
    noOptionsMessage: "結果が見つかりません",
    accountNameErrorMsg: "必須"
};

export const CreateMestLabels = {
    createModalTitle: "新しいエンティティ",
    createModalDescription: "以下にエンティティを入力して'<b>{0}</b>' を選択して終了してください。別のエンティティを作成するには、'<b>{1}</b>' を選択してください。エンティティはどのような監査アプローチを計画するかであり、法律上のエンティティではなく、ビジネスユニット又は他の組み合わせの場合もあります。",
    close: "閉じる",
    cancel: "キャンセル",
    save: "保存",
    saveAndCloseLabel: "保存して閉じる",
    saveAndCreateLabel: "保存して別のエンティティを作成",
    entityNameLabel: "エンティティ名",
    entityStandardIndexLabel: "エンティティ標準インデックス",
    entityDescriptionLabel: "エンティティの説明（任意）",
    entityNameErrorMsg: "必須",
    entityStandardIndexErrorMsg: "必須"
}

export const CreateEditSCOTLabels = {
    createModalTitle: "新しいSCOT",
    editModalTitle: "SCOTの編集",
    createModalDescription: "以下に新しいSCOTの詳細を入力し'<b>{0}</b>'を選択して終了してください。他のSCOTを作成する場合は'<b>{1}</b>'を選択してください。",
    editModalDescription: "以下のSCOTの詳細を編集し、終了するには'<b>{0}</b>'を選択してください。",
    close: "閉じる",
    cancel: "キャンセル",
    save: "保存",
    saveAndCloseLabel: "保存して閉じる",
    saveAndCreateLabel: "保存して別のものを作成",
    scotNameLabel: "SCOT名（必須）",
    scotStrategyLabel: "SCOT戦略",
    scotTypeLabel: "SCOTタイプ",
    scotTypeOptions: scotTypes,
    hasEstimateLabel: "このSCOTは見積りの影響を受けますか？",
    itAPPUsedLabel: "ITアプリケーションが使用されていません",
    routine: "経常",
    nonRoutine: "非経常",
    controls: "統制",
    substantive: "実証",
    yes: "はい",
    scotNameErrorMsg: "必須",
    remove: "削除",
    noOptionsMessage: "結果が見つかりません",
    wtDetailPrefix: "<p>全ての経常及び非経常のSCOTs並びに重要な開示プロセスについて、ウォークスルー手続を実施することで、毎期理解を確認します。さらに、PCAOB監査では、見積SCOTsのウォークスルー手続を実施します。<br/>統制依拠戦略を採用する全てのSCOTs及び特別な検討を必要とするリスクに対応する統制については、関連する統制が適切にデザインされ、適用されていることを確認します。統制依拠戦略を採用するという決定が依然として適切であることを確認します。<br/><br/>文書化によりSCOTの運用状況を正確に記述しており、ITの利用から生じるリスクを含む全ての適切なWCGWs及び関連する統制(該当する場合)を識別していると結論付けます。<br/><br/> 実証戦略を採用する場合の見積SCOTsについては、実証手続に基づいて、見積SCOTの理解が適切かどうかを判断します。</p>",
    disabledTabTooltipMessage: "「ITアプリケーションが使用されていません」の選択を解除し、ITアプリケーションを関連付けます",
    itAppLabels: {
        tabLabel: "IT Apps",
        dropdownLabel: "ITアプリケーションの関連付け",
        noRelatedItems: "関連するITアプリケーションがありません",
        itApplications: "ITアプリケーション"
    },
    soLabels: {
        tabLabel: "サービス受託会社",
        dropdownLabel: "関連するサービス受託会社",
        noRelatedItems: "関連するサービス受託会社がありません",
        serviceOrganizations: "サービス受託会社"
    }
};

export const CreateEditWCGWLabels = {
    wcgwName: "WCGW名(必須)",
    editWCGW: "WCGWの編集",
    editTheWCGW: "以下のWCGWの詳細を編集し、終了するには'<b>{0}</b>'を選択してください。",
    createNewWCGW: "以下に新しいWCGWの詳細を入力し'<b>{0}</b>'を選択して終了してください。他のWCGWを作成する場合は'<b>{1}</b>'を選択してください。",
    createEditWCGWModelScot: "SCOT",
    newWCGWTitel: "New WCGW",
    editWCGWSave: "保存",
    editWCGWClose: "キャンセル",
    closeTitle: "閉じる",
    wcgwNameIsRequired: "必須",
    saveAndCloseLabel: "保存して閉じる",
    saveAndCreateLabel: "保存して別のエンティティを作成"
};

export const controlFrequencyTypes = [{
        value: 1,
        label: "毎日何度も"
    },
    {
        value: 2,
        label: "日次"
    },
    {
        value: 3,
        label: "週次"
    },
    {
        value: 4,
        label: "月次"
    },
    {
        value: 5,
        label: "四半期毎"
    },
    {
        value: 6,
        label: "年次"
    },
    {
        value: 8,
        label: "その他"
    }
];

export const controlTypes = [{
        value: 1,
        label: "ITアプリケーション統制"
    },
    {
        value: 2,
        label: "IT依存手作業統制"
    },
    {
        value: 3,
        label: "手作業防止"
    },
    {
        value: 4,
        label: "手作業発見"
    }
];

export const CreateEditControlLabels = {
    createModalTitle: "新しい統制",
    editModalTitle: "統制の編集",
    close: "閉じる",
    cancel: "キャンセル",
    save: "保存",
    saveAndCloseLabel: "保存して閉じる",
    saveAndCreateLabel: "保存して別のものを作成",
    controlNameLabel: "統制名（必須）",
    frequency: "頻度",
    controlType: "統制タイプ",
    frequencyTypeOptions: controlFrequencyTypes,
    controlTypeOptions: controlTypes,
    designEffectiveness: "デザインの有効性",
    operatingEffectiveness: "運用状況の有効性",
    testingLabel: "テスト",
    lowerRiskLabel: "低リスク統制か？",
    ITDMControlSubstantiveTestingOptionLabel: "このIT依存手作業統制の自動処理部分はシステム生成のレポートを使用することのみであり、そのレポートは実証的にテスト済みである。",
    effective: "有効",
    ineffective: "非有効",
    yes: "はい",
    no: "いいえ",
    required: "必須",
    remove: "削除",
    noOptionsMessage: "結果が見つかりません",
    disabledTabTooltipMessage: "ITアプリケーションを関連付けるには、「統制タイプ」で「ITアプリケーション統制」又は「IT依存手作業統制」を選択します",
    itAppLabels: {
        tabLabel: "IT Apps",
        dropdownLabel: "関連するITアプリケーション",
        noRelatedItems: "関連するITアプリケーションがありません",
        itApplications: "ITアプリケーション"
    },
    soLabels: {
        tabLabel: "サービス受託会社",
        dropdownLabel: "サービス受託会社の関連付け",
        noRelatedItems: "関連するサービス受託会社がありません",
        serviceOrganizations: "サービス受託会社"
    },
    controlNameErrorMsg: "必須",
    createModalDescriptionLabel: "以下に新しい統制の詳細を入力し'<b>{0}</b>'を選択して終了してください。他の統制を作成する場合は'<b>{1}</b>'を選択してください。",
    editModalDescriptionLabel: "以下の統制の詳細を編集し、終了するには'<b>{0}</b>'を選択してください。",
    wcgwLabel: "WCGW"
};

export const CreateEditITApplicationLabels = {
    close: "閉じる",
    cancel: "キャンセル",
    yes: "はい",
    no: "いいえ",
    delete: "削除",
    save: "保存",
    closeTitle: "閉じる",
    saveAndCloseLabel: "保存して閉じる",
    saveAndCreateLabel: "保存して別のものを作成",
    iTApplicationNameLabel: "ITアプリケーション名(必須)",
    iTSOApplicationNameLabel: "サービス受託会社名",
    newITApplicationLabel: "新しいITアプリケーション",
    newITSOApplicationLabel: "新しいサービス受託会社",
    editITApplicationLabel: "ITアプリケーションの編集",
    confirm: "確認",
    confirmChanges: "変更を確認",
    noOptionsMessage: "結果が見つかりません",
    iTAppNameErrorMsg: "必須",
    iTSOAppNameErrorMsg: "必須",
    controls: "統制",
    substantive: "実証",
    remove: "削除",
    iTApplicationStrategyLabel: "ITアプリケーション戦略",
    SCOTsLabel: "SCOT名",
    StrategyLabel: "戦略",
    ControlsLabel: "統制名",
    ControlTypeLabel: "タイプ",
    addDescriptionLabel: "以下に新しいITアプリケーションの詳細を入力し'<b>{0}</b>'を選択して終了してください。他のITアプリケーションを作成する場合は'<b>{1}</b>'を選択してください。",

    editDescriptionLabel: "以下のITアプリケーションの詳細を編集し、終了するには'<b>{0}</b>'を選択してください。",

    addSODescriptionLabel: "以下に新しいサービス受託会社の詳細を入力し'<b>{0}</b>'を選択して終了してください。他のサービス受託会社を作成する場合は'<b>{1}</b>'を選択してください。",

    scotErrorMessage: "関連する統制があるため、SCOTはITアプリケーションと関連付いていない可能性があります。",
    SCOTsLabels: {
        tabLabel: "SCOTs",
        dropdownLabel: "SCOTsの関連付け",
        noRelatedItems: "関連するSCOTsなし"
    },
    ControlsLabels: {
        tabLabel: "統制",
        dropdownLabel: "統制の関連付け",
        noRelatedItems: "関連する統制がありません。"
    },
    strategyType: {
        1: "統制",
        2: "実証",
        3: "依拠する",
        4: "依拠しない"
    },
    controlType: {
        1: "ITアプリケーション統制",
        2: "IT依存手作業統制",
        3: "手作業防止",
        4: "手作業発見"
    }
};

export const groupComponentAccountReportHeaderLabels = {
    primaryEngagementId: "エンゲージメントID",
    gaScopeName: "スコープ",
    gaComponentId: "GA構成単位ID",
    shortName: "構成単位名",
    pocText: "連絡先",
    accountId: "勘定科目ID",
    accountName: "勘定科目名称",
    accountType: "勘定科目の指定",
    knowledgeAssertion: "アサーション",
    inherentRiskType: "固有リスク",
    riskId: "リスクID",
    riskType: "リスクタイプ",
    riskName: "リスク名",
    isHigherRiskText: "高リスク"
};

export const AccountTypeIDs = {
    1: "重要な勘定科目",
    2: "リスクが限定的な勘定科目",
    3: "軽微な勘定科目",
    4: "勘定科目-その他",
    5: "重要な開示"
};

export const InherentRiskTypeIDs = {
    1: "高",
    2: "低",
    3: "極めて低い"
};

export const riskTypeIDs = {
    1: "特別な検討を必要とするリスク ",
    2: "不正リスク",
    3: "重要な虚偽表示リスク"
};

export const riskTypeIDsShortForm = {
    1: "SR",
    2: "FR",
    3: "ROMM"
};

export const ControlRiskTypeIDs = {
    1: "依拠する",
    2: "依拠しない",
    3: "MPをテストする"
};

export const knowledgeAssertions = {
    1: "網羅性",
    2: "実在性",
    3: "評価",
    4: "権利と義務",
    5: "表示と開示",
    6: "網羅性",
    7: "発生",
    8: "測定",
    9: "表示と開示",
    10: "網羅性",
    11: "実在性/発生",
    12: "測定/評価",
    13: "権利と義務",
    14: "表示と開示"
};

export const gaInstructionStatuslabels = {
    0: "未定義",
    [instructionStatus.notSent]: "未送信",
    [instructionStatus.pending]: "未了",
    [instructionStatus.accepted]: "承諾済",
    [instructionStatus.rejected]: "返却済",
    [instructionStatus.systemError]: "システムエラー",
    [instructionStatus.expired]: "期限切れ",
    [instructionStatus.sent]: "送信済",
    [instructionStatus.unlinked]: "リンク解除済",
    [instructionStatus.queued]: "キュー済"
};

export const financialStatementTypeLabels = {
    [financialStatementType.Asset]: "資産",
    [financialStatementType.CurrentAsset]: "流動資産",
    [financialStatementType.NonCurrentAsset]: "非流動資産",
    [financialStatementType.Liability]: "負債",
    [financialStatementType.CurrentLiability]: "流動負債",
    [financialStatementType.NonCurrentLiability]: "非流動負債",
    [financialStatementType.Equity]: "純資産",
    [financialStatementType.Revenue]: "収益",
    [financialStatementType.Expense]: "費用",
    [financialStatementType.NonOperatingIncome]: "営業外収益/(費用)",
    [financialStatementType.OtherComprehensiveIncome]: "その他の包括利益",
    [financialStatementType.Other]: "その他",
    [financialStatementType.AccountType]: "勘定科目タイプ",
    [financialStatementType.AccountSubType]: "勘定科目サブタイプ",
    [financialStatementType.AccountClass]: "勘定科目クラス",
    [financialStatementType.AccountSubClass]: "勘定科目サブクラス",
    [financialStatementType.NetIncomeExpense]: "純(利益)/損失",
    18: "GL勘定科目"
};

export const trialBalanceTypeLabels = {
    [trialBalanceType.Planning]: "計画"
};

export const createEditRiskModalLabels = {
    createModalDescription: "以下に新しいリスクの詳細を入力し'<b>{0}</b>'を選択して終了してください。他のリスクを作成する場合は'<b>{1}</b>'を選択してください。",
    editModalDescription: "以下のリスクの詳細を編集し、<b>{0}</b> を選択して終了します。",
    close: "閉じる",
    cancel: "キャンセル",
    createRisk: "新しいリスク",
    editRisk: "リスクの編集",
    riskType: "リスクタイプ(必須)",

    riskTypeOptions: [{
            value: 1,
            label: "特別な検討を必要とするリスク"
        },
        {
            value: 2,
            label: "不正リスク"
        },
        {
            value: 3,
            label: "重要な虚偽表示リスク"
        }
    ],
    save: "保存",
    saveAndCloseLabel: "保存して閉じる",
    saveAndCreateLabel: "保存して別のものを作成",
    riskNameLabel: "リスク名（必須）",
    relatedAccountsAssertionsLabel: "関連する勘定科目とアサーション（任意）",
    relateAccounts: "勘定科目とアサーションの関連付け（任意）",
    assertionsLabel: "関連するアサーションの選択",
    riskNameErrorMsg: "必須",
    riskTypeErrorMsg: "必須",
    assertionOptions: assertions,
    removeAccountLabel: "勘定科目の削除",
    required: "必須",
    assertionsRequired: "少なくとも1つのアサーションを選択する必要があります"
};

export const activityTypeLabels = {
    104: "追加済",
    105: "削除済"
};

export const superModalNavigationLabels = {
    identifyAccountsAndDisclosures: "勘定科目及び開示の識別",
    identifySCOTs: "SCOTsの識別と勘定科目への関連付け",
    determineSCOTStrategy: "SCOT戦略の決定",
    identifyWCGWAndControls: "WCGWs及び統制の識別",
    selectControlToTest: "テストする統制の選択",
    identifyRisks: "リスクの識別",
    relateWCGWsToAssertions: "WCGWsとアサーションの関連付け",
    relateRisksToWCGWs: "リスクをWCGWに関連付ける",
    determineCRA: "CRAの決定",
    timephase: "タイムフェーズ",
    SCOTWT: "WTの作成",
    controlTOC: "TOCの作成",
    ITProcessUDP: "UDPの作成",
    ITGC_ITSP_TOC_OSP: "IT TOC/OSPの作成",
    accountPSP: "PSPの作成",
    accountOSP: "OSPの作成",
    relateWCGWTo: "WCGWの関連付け先",
    relatedWCGWToTask: "WCGWとタスクの関連付け",
    respondToSignificant_fraudRisks: "特別な検討を必要とするリスク/不正リスクへの回答",
    OST: "OST",
    accountSummary: "勘定科目サマリー",
    SCOTSummary: "SCOTサマリー",
    ITSummary: "ITサマリー",
    understandITProcesses: "ITプロセスの理解",
    evaluateIT: "IT評価",
    CRASummary: "CRAサマリー",
    auditPlan: "監査計画",
    workplanSummary: "作業計画サマリー",
    buildSteps: "ビルドステップ",
    ITApplicationsAndITProcesses: "ITアプリケーション及びITプロセス",
    workPlan: "作業計画",
    accounts: "勘定科目",
    scots: "SCOT",
    cra: "CRA",
    openInNewTab: "新しいタブで開く"
}

export const auditPlanITProcessLabels = {
    itProcess: "ITプロセス",
    itProcesses: "ITプロセス",
    tasks: "タスク",
    sectionHeading: "ITプロセス及び関連するプロセスの理解（UDP）タスク",
    subHeader: "ITプロセスの理解",
    visualDistinctMessage: "各ITプロセスには関連するUDPが少なくとも１つ必要です。{0} 又は {1} を作成してください。",
    addUdp: "新規UDP",
    relatedUdp: "UDPsの関連付け",
    toggleFilter: "UDPが関連付けられていないITプロセスのみを表示する",
    noResultsFound: "結果が見つかりません",
    taskTitle: "ITプロセスの理解及び文書化 {0}",
    taskDescription: "ITプロセスの理解を文書化してください。 もしくはITプロセスの理解を裏付ける監査証拠として、関連するフォームを添付してください。 ITGCがタスク属性セクションに表示されたら、ウォークスルー手続を実施してITGCの理解を確認し、内部統制のデザイン及び業務への適用を評価してください。監査手続によって入手した証拠を添付してください。",
    noRecordsAvailable: "利用可能なITプロセスがありません",
    unrelatedLabel: "関連付けられていないUDPを表示",
    unrelatedModalHeader: "関連付けられていないUDPタスク",
    noUnrelatedTaskPlaceholder: "利用可能な関連付けられていないUDPタスクはありません",
    noTaskselectedLabel: "少なくとも1つのタスクを削除対象として選択する必要があります。",
    relateITProcessTaskTitle: "UDPをITプロセスに関連付ける",
    understandITProcesses: "ITプロセスの理解",
    unrelatedTasksMustBeAssociated: "関連付けのないタスクはITプロセスに関連付けるか、削除する必要があります。"
}

export const noEvidenceReferencedReasonsLabels = {
    immaterialReason: "軽微: 残高/アクティビティがテストのスコープ対象外となっています - さらなる調査は不要",
    strikethroughMText: "m",
    waivedReason: "省略: SAD未満の金額です - さらなる調査は不要",
    strikethroughWText: "w"
}

export const auditPlanScotListLabels = {
    scot: "SCOT",
    scots: "SCOT",
    tasks: "タスク",
    sectionHeading: "SCOT及び関連付けられたウォークスルータスク",
    subHeader: "ウォークスルータスク",
    visualDistinctMessage: "各SCOTには関連するウォークスルーが少なくとも１つ必要です。{0} 又は {1} を作成してください。",
    newWT: "新規WT",
    relatedWT: "WTsの関連付け",
    toggleFilter: "WTが関連付けられていないSCOTsのみを表示する",
    noResultsFound: "結果が見つかりません",
    noRecordsAvailable: "利用可能なSCOTがありません",
    relateScotTaskTitle: "WTsをSCOTに関連付ける",
    taskTitle: "ウォークスルー: {0}",
    taskDescription: "<p>全ての経常及び非経常のSCOTs並びに重要な開示プロセスについて、ウォークスルー手続を実施することで、毎期理解を確認します。さらに、PCAOB監査では、見積SCOTsのウォークスルー手続を実施します。<br/>統制依拠戦略を採用する全てのSCOTs及び特別な検討を必要とするリスクに対応する統制については、関連する統制が適切にデザインされ、適用されていることを確認します。統制依拠戦略を採用するという決定が依然として適切であることを確認します。<br/><br/>文書化によりSCOTの運用状況を正確に記述しており、ITの利用から生じるリスクを含む全ての適切なWCGWs及び関連する統制(該当する場合)を識別していると結論付けます。<br/><br/> 実証戦略を採用する場合の見積SCOTsについては、実証手続に基づいて、見積SCOTの理解が適切かどうかを判断します。</p>",
    unrelatedLabel: "関連付けられていないWTsを表示",
    unrelatedModalHeader: "関連付けのないWTタスク",
    noUnrelatedTaskPlaceholder: "利用可能な関連付けのないWTタスクがありません",
    noTaskselectedLabel: "削除するタスクを少なくとも1つ選択する必要があります。",
    manageScots: "SCOTsの管理",
    unrelatedTasksMustBeAssociated: "関連付けのないタスクはSCOTに関連付けるか、削除する必要があります。"
}

export const auditPlanControlsLabels = {
    control: "統制",
    controls: "テスト対象として選定された統制",
    tasks: "タスク",
    sectionHeading: "統制及び関連付けられた統制テスト",
    subHeader: "統制テストタスク",
    visualDistinctMessage: "各統制には関連する統制テストが少なくとも１つ必要です。{0} 又は {1} を作成してください。",
    addToc: "新規TOC",
    relatedToc: "TOCsの関連付け",
    toggleFilter: "TOCが関連付けられていない統制のみを表示する",
    noResultsFound: "結果が見つかりません",
    noRecordsAvailable: "統制テストのために選択された統制がありません",
    unrelatedLabel: "関連付けのないTOCsを表示",
    unrelatedModalHeader: "関連付けのないTOCタスク",
    noUnrelatedTaskPlaceholder: "利用可能な関連付けのないTOCタスクがありません",
    noTaskselectedLabel: "削除するタスクを少なくとも1つ選択する必要があります。",
    relateControlTaskTitle: "TOCsの統制への関連付け",
    manageControl: "統制の管理",
    taskTitleTOC: "統制テスト: {0}",
    taskDescriptionTOC: "依拠対象期間の全体にわたってアサーションレベルで重要な虚偽表示を防止または発見及び是正するために設計されたとおりに統制が運用されているという十分かつ適切な監査証拠を得るため、統制テストの種類、実施時期及び実施範囲を立案します。<br>サンプルサイズの拡大や補完統制のテスト実施を含め、統制テストの結果を評価し、統制の運用状況の有効性について結論付けます。",
    manageControls: "統制の管理",
    unrelatedTasksMustBeAssociated: "関連付けのないタスクは統制に関連付けるか、削除する必要があります。"
}

export const industrySelectionGroupLabels = {
    1: "選択した業種",
    2: "その他の業種"
}

export const knowledgeDataLabels = {
    industry: "業種",
    showSelected: "選択中のみ表示",
    noContent: "選択した業種のナレッジから利用できるコンテンツはありません",
    importFromKnowledge: "ナレッジからインポートする",
    importAccounts: "勘定科目のインポート",
    importAccountsAndDisclosures: "勘定科目及び開示のインポート",
    accountBuild1: "勘定科目ビルドステップ1",
    import: "インポート",
    close: "閉じる",
    cancel: "キャンセル",
    selected: "選択済",
    scotTitle: "SCOTビルド1",
    importScots: "SCOTのインポート",
    noKnowledgeDataResult: "選択できるコンテンツがありません",
    showOnlySelectedLabel: "選択中のみ表示",
    scot: "SCOT",
    scotDropdownLabel: "選択した業種のSCOT",
    importWcgw: "WCGWsのインポート",
    importFailedLabel: "インポートが失敗しました。もう一度インポートしてください。",
    wtDetailPrefix: "<p>全ての経常及び非経常のSCOTs並びに重要な開示プロセスについて、ウォークスルー手続を実施することで、毎期理解を確認します。さらに、PCAOB監査では、見積SCOTsのウォークスルー手続を実施します。<br/>統制依拠戦略を採用する全てのSCOTs及び特別な検討を必要とするリスクに対応する統制については、関連する統制が適切にデザインされ、適用されていることを確認します。統制依拠戦略を採用するという決定が依然として適切であることを確認します。<br/><br/>文書化によりSCOTの運用状況を正確に記述しており、ITの利用から生じるリスクを含む全ての適切なWCGWs及び関連する統制(該当する場合)を識別していると結論付けます。<br/><br/> 実証戦略を採用する場合の見積SCOTsについては、実証手続に基づいて、見積SCOTの理解が適切かどうかを判断します。</p>",
    importOSP: "OSPのインポート",
    auditPlanBuild7: "監査計画ビルド7",
    account: "勘定科目",
    accountName: "PSPインデックス",
    wcgwName: "WCGWs",
    selectScot: "SCOTの選択",
    wcgwTitle: "SCOTビルド3",
    noResultFound: "結果が見つかりません",
    importValidationMessage: "選択が必須です",
    searchIconHoverLabel: "検索",
    scotsHeader: "SCOTs",
    controlsHeader: "統制",
    ospsHeader: "OSPs",
    wcgw: "WCGW",
    importControls: "統制のインポート",
    accountAssertionsValidationMessage: "タスクのアサーションがありません",
    accountsAndDisclosures: "勘定科目及び開示",
}

export const auditPlanITControlsLabels = {
    itcontrol: "IT統制",
    itcontrols: "テスト対象として選定されたIT統制",
    tasks: "タスク",
    type: "タイプ",
    sectionHeading: "ITGCs、ITSPs、関連する統制テスト及び実証タスク",
    subHeader: "TOC/OSPタスク",
    visualTOCDistinctMessage: "各ITGCには関連する統制テストが少なくとも１つ必要です。{0} 又は {2} を作成してください。",
    visualOSPDistinctMessage: "各ITSPには関連する実証手続が少なくとも１つ必要です。{1} 又は {3} を作成してください。",
    addTOC: "新しいTOC",
    addOSP: "新規OSP",
    relatedTOCOSP: "TOCs/OSPsの関連付け",
    relatedTOC: "TOCsの関連付け",
    relatedOSP: "OSPの関連付け",
    toggleFilter: "TOC/OSPが関連付けられていないIT統制のみを表示する",
    noResultsFound: "結果が見つかりません",
    noRecordsAvailable: "テストのために選択されたITGCがありません",
    taskTitleTOC: "統制テスト: {0}",
    taskDescriptionTOC: "ITGCに関する設計したテストを実施して、依拠する期間全体におけるITGCの運用状況の有効性に関する十分かつ適切な監査証拠を入手してください。",
    taskTitleOSP: "その他の実証手続: {0}",
    taskDescriptionOSP: "依拠対象期間の全体にわたってITリスクに有効に対応されているという十分かつ適切な監査証拠を得るため、このタスクの説明をカスタマイズして、IT実証手続の種類、実施時期及び実施範囲を立案します。<br>IT実証手続が期中に実施された場合、ITリスクに対して期中手続時から期末までの期間をカバーするように追加の監査証拠を得るための手続を立案し、実施します。<br>IT実証手続の結果について結論付けます。",
    relateITControlTaskTitle: "TOCs/OSPsのIT統制への関連付け",
    relateITControlTOCTaskTitle: "TOCsのITGCへの関連付け",
    relateITControlOSPTaskTitle: "OSPsのITSPへの関連付け",
    unrelatedModalHeader: "関連付けのないTOC/OSPタスク",
    noUnrelatedTaskPlaceholder: "利用可能な関連付けのないTOC/OSPタスクがありません",
    noTaskselectedLabel: "削除するタスクを少なくとも1つ選択する必要があります。",
    unrelatedLabel: "関連付けのないTOCs/OSPsを表示",
    understandITProcesses: "ITプロセスの理解",
    unrelatedTasksMustBeAssociated: "関連付けのないタスクはIT統制に関連付けるか、削除する必要があります。"
}

export const generalLabelsForMobile = {
    noRecordsFound: "このタスクカテゴリ―内で検索結果は見つかりませんでした。",
    taskListTitle: "私のタスク",
    taskEvidenceTitle: "エビデンス",
    cameraPagesTitle: "ページ",
    cameraTitle: "カメラ",
    taskDetailsTitle: "タスク詳細",
    invalidPage: "ページが見つかりません",
    combinedTaskLabel: "PIC/EQR",
    picTaskLabel: "PIC",
    eqrTaskLabel: "EQR",
    pageLabel: "ページ",
    ofLabel: "of",
    noTasksAvailable: "タスクがありません",
    searchLabel: "検索",
    noDescriptionAvailable: 'No description available.',
    knowledge: 'Knowledge',
    description: 'Description',
    knowledgeDescription: 'Knowledge description',
    customized: 'Customized',
    taskDetailsTitle: "タスク詳細",
    unassigned: "未割当て",
    assignTo: "割当て先",
    signOffLabel: "サインオフ",
    evidenceNoteLabel: "エビデンスノート",
    attributeLabel: "属性",
    addNoteLabel: "新規のノート",
    addCommentLabel: "コメントの追加",
    editCommentLabel: "コメントの更新",
    addReplyNoteLabel: "このノートへの回答",
    replyNoteLabel: "返信",
    replyEditNoteLabel: "返信を編集",
    enterReplyPlaceholder: "返信を入力",
    editNoteLabel: "編集",
    deleteNoteLabel: "削除",
    reopenNoteLabel: "再オープン",
    closeNoteLabel: "クローズ",
    clearNoteLabel: "クリア",
    preparerAbbrv: "P",
    reviewerAbbrv: "R",
    uploadPhoto: "写真のアップロード",
    noEvidenceFound: "タスクに関連付けられたエビデンスがありません",
    noRegionComponentFound: "リージョナルチームまたは構成単位チームから文書を受領していません",
    noEvidenceMessage: "「写真をアップロード」をクリックしてエビデンスをアップロードします",
    noNotesFound: "ノートが見つかりません",
    noNotesStatement: "以下の入力欄を使用してコメントを残してください。ノートをユーザーに割当て、優先度と期日を指定します。",
    regionComponentEvidence: "リージョン及び構成単位のエビデンス",
    documentWarning: "ダウンロードされた文書は読み取り専用です。終了時にはファイルを削除してください。",
    preparerTitle: "実施者サインオフ",
    reviewerTitle: "査閲者サインオフ",
    teamLabel: "チーム",
    saveEvidenceTitle: "エビデンスの保存",
    saveButton: "保存",
    cancelButton: "キャンセル",
    confirmButtonLabel: "確認",
    previewButton: "プレビュー",
    evidenceLable: "エビデンス名",
    mergingTitleLable: "PDFにマージされた画像。",
    showErrFileExistMsg: "ファイル名は既に存在します。ファイル名を変更してください。",
    showErrForNoImgExist: "PDFの生成に利用可能な画像がありません。",
    showErrBlankFileNameMsg: "ファイル名は空白にできません。",
    showIsCompletedMessage: "ファイルは正常にアップロードされました。",
    uploadingTitle: "処理中",
    showErrImgContext: "useImagesはImagesProvider内で使用する必要があります。",
    PagePreviewTitle: "ページ",
    regionComponentEvidenceLabel: "リージョン及び構成単位のエビデンス",
    downloadProcessLabel: "ダウンロードしています・・・",
    downloadCompleteLabel: "ダウンロード完了",
    taskNotes: "タスクノート",
    documentNotes: "文書ノート",
    dueDateLabel: "期日",
    view: "ビュー：",
    documentNotes: "文書ノート",
    newNote: "ノートの追加",
    editNote: "ノートの編集",
    assignedTo: "割当て先",
    priority: "優先度",
    select: "選択",
    dueDate: "期日",
    addNewNote: "新規ノートの追加",
    addNote: "ノートの追加",
    updateNote: "ノートの更新",
    enterDescription: "説明の入力…",
    allnotes: "全てのノート",
    mynotes: "私のノート",
    assignedToMe: "私への割当て",
    hashValue: "#",
    showLessToggle: "表示を減らす",
    showMoreToggle: "表示を増やす",
    delete: "削除",
    deleteNoteModalTitle: "メッセージの削除",
    deleteReplyModalTitle: "返信の削除",
    confirmDeleteNoteLabel: "選択されたノートを削除してよろしいですか？",
    confirmDeleteReplyLabel: "このノートに対する返答を削除してよろしいですか？",
    downloadInfo: "#文字を含むファイルはダウンロードできません。",
	evidenceFileValidationInfo: '以下の文字は、ファイル名に使用できません： */ : <>\?| "',
    previewPageTitle: "プレビュー",
    redirecting: "まもなくランディングページにリダイレクトします・・・",
    redirectingToTask: "まもなく\'マイタスク\'ページにリダイレクトします・・・",
    errorApplyingConstraints: "制約の適用エラー:",
    zoomIsNotSupported: "拡大はこのデバイスではサポートされていません。",
    errorCheckingCameraCapability: "エラーチェックカメラ機能:",
    previous: "前",
    next: "次",
    after: "後",
    redirectingToTaskDetails: "まもなくタスクの詳細にリダイレクトします",
    mobileURL: '/mobile'
};

export const RNHNoteMobileStatusOptions = [{
        value: 1,
        label: "オープン"
    },
    {
        value: 2,
        label: "クリア済"
    },
    {
        value: 3,
        label: "クローズ済"
    }
];

export const auditPhaseTypes = [{
        value: 1,
        label: "スコープ及び戦略"
    },
    {
        value: 2,
        label: "実施"
    },
    {
        value: 3,
        label: "結論"
    },
];

export const CreateEditTaskSectionLabels = {
    createModalTitle: "新しいタスクグループ",
    editModalTitle: "タスクグループの編集",
    createModalDescription: "以下にタスクグループの詳細を入力し、'<b>{0}</b>'を選択して終了します。 '<b>{1}</b>'を選択すると、別のタスクグループを作成できます。",
    editModalDescription: "以下のタスクグループの詳細を編集し、'<b>{0}</b>'を選択して終了します。",
    close: "閉じる",
    cancel: "キャンセル",
    save: "保存",
    saveAndCloseLabel: "保存して閉じる",
    saveAndCreateLabel: "保存して別の勘定科目を作成",
    taskSectionNameLabel: "タスクグループ名(必須)",
    taskSectionNameErrorMsg: "必須",
    engagementPhaseOptions: auditPhaseTypes,
    engagementPhaseLabel: "エンゲージメントフェーズ(必須)",
    engagementPhaseErrorMsg: "必須",
};

export const auditPhaseLabels = {
    1: "スコープ及び戦略",
    2: "実施",
    3: "結論",
    4: "監査契約に係る予備的な活動の実施",
    5: "リスクの識別及び評価",
    6: "リスクへの対応",
    7: "結論及び報告"
};

export const ITApproachType = {
    1: "ITGC",
    2: "ITSP"
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [{
        id: 1,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 31,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 5,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 32,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 6,
        label: superModalNavigationLabels.determineSCOTStrategy
    },
    {
        id: 7,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 38,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 8,
        label: superModalNavigationLabels.selectControlToTest
    },
    {
        id: 2,
        label: superModalNavigationLabels.identifyRisks
    },
    {
        id: 15,
        label: superModalNavigationLabels.relateWCGWsToAssertions
    },
    {
        id: 30,
        label: superModalNavigationLabels.relateRisksToWCGWs
    },
    {
        id: 3,
        label: superModalNavigationLabels.determineCRA
    },
    {
        id: 18,
        label: superModalNavigationLabels.SCOTWT
    },
    {
        id: 19,
        label: superModalNavigationLabels.controlTOC
    },
    {
        id: 20,
        label: superModalNavigationLabels.ITProcessUDP
    },
    {
        id: 21,
        label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
    },
    {
        id: 25,
        label: superModalNavigationLabels.accountPSP
    },
    {
        id: 26,
        label: superModalNavigationLabels.accountOSP,
    },
    {
        id: 27,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 56,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 29,
        label: superModalNavigationLabels.relatedWCGWToTask
    },
    {
        id: 39,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 50,
        label: superModalNavigationLabels.OST
    }
];

export const noEvidenceReferencedReasons = [{
        id: 1,
        reason: noEvidenceReferencedReasonsLabels.immaterialReason,
        glAccountTypeId: 12,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
    },
    {
        id: 2,
        reason: noEvidenceReferencedReasonsLabels.waivedReason,
        glAccountTypeId: 13,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
    }
];


export const createEditAdjustmentLabels = {
    createModalTitle: "新しい調整",
    editModalTitle: "調整の編集",
    createModalDescription: "調整の詳細を以下に入力し、'<b>{0}</b>'を選択して終了します。別の調整を作成するには、'<b>{1}</b>'を選択します。",
    editModalDescription: "以下の調整の詳細を編集し、 '<b>{0}</b>'を選択し終了します。この調整を削除するには、'<b>{1}</b>'をクリックしてください。",
    close: "閉じる",
    cancel: "キャンセル",
    save: "保存",
    saveAndCloseLabel: "保存して閉じる",
    saveAndCreateLabel: "保存して別のものを作成",
    delete: "削除",
    adjustmentNameLabel: "調整インデックス（必須）",
    adjustmentDescriptionLabel: "調整の説明（必須）",
    adjustmentDescriptionPlaceholder: "調整の説明（必須）",
    required: "必須",
    editDescriptionModal: "調整の説明を編集",
    descriptionRequired: "調整の説明が必要です。",
    uploadDocumentPlaceholder: "エビデンスに関連付ける前に調整を保存しなければなりません。",
    generalLedgerAccount: "GL勘定科目（必須）",
    documentHeader: "文書(必須)",
    addDocumentButton: "エビデンスの追加",
    glAccountPlaceholder: 'GL account is not available. To add the account click {0}.',
    adjustmentIndex: "調整インデックス",
    addglaccountbutton: "GL勘定科目の追加",
    descriptionMaxLengthError: "返信が最大許容数を超えています。",
    glaccountTotalError: "借方の入力額の合計は貸方の入力額の合計と一致する必要があります",
    glaccountIdDuplicate: "各GL勘定科目は調整において一度だけしか使えません",
    placeholderText: 'No related documents. To relate a document click <a>Add evidence<a>',
    editAdjustmentDescriptionHeader: "調整の説明の編集",
    editAdjustmentDescriptionSubHead: "以下の調整の説明を編集し、\'<b>保存する</b>\'を選択し終了する。"
};

export const addUpdateGlAccountLabels = {
    addGLaccountTitle: "GL勘定科目の追加",
    glaccountDescription: "以下にGL勘定科目の詳細を入力して'<b>{0}</b>'を選択し終了してください。別のGL勘定科目を追加するには'<b>{0}</b>'を選択してください。",
    addAndClose: "追加して閉じる",
    addAnother: "別のものを追加",
    accountSubClassPlaceholder: "勘定科目サブクラス",
    glAccountsPlaceholder: "勘定科目サブクラスを選択して利用可能なGL勘定科目を表示する",
    glAccountListHeaderColumn: "GL勘定科目",
    amountLabel: "金額（必須）",
    debitCreditOptions: [{
            id: 1,
            label: "借方"
        },
        {
            id: 2,
            label: "貸方"
        }
    ],
    searchPlaceholder: "検索",
    newGlAccount: "新しい調整勘定科目",
    noResultsFound: "結果が見つかりません",
    noRecordsPlaceholder: "選択した勘定科目サブクラスの調整勘定科目が見つかりません。別のサブクラスを選択するか、{0}をクリックして、選択した勘定科目サブクラスに調整勘定科目を追加します。",
    editTitleTip: "調整勘定科目の編集",
    removeTitleTip: "調整勘定科目の削除",
    custom: "カスタム",
    duplicateGLAccount: "各GL勘定科目は調整において一度だけしか使えません",
    updateModalTitle: "調整勘定科目の更新",
    updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
    accountClassLabel: "Account class",
    glAccountLabel: "GL account",
    updateLabel: "アップデート",
    updateGlAccountModalTitle: "GL勘定科目の更新"
}

export const deleteGLAccountLabels = {
    deleteConfirmationModallHeader: "調整勘定科目の削除",
    deleteConfirmationModalBodyHeader: "選択した調整勘定科目を削除してよろしいですか? この操作は取消しができません。",
    deleteConfirmationModalAccountSubClass: "勘定科目サブクラス：",
    deleteConfirmationModalAccountName: "勘定科目名：",
    deleteConfirmationModalGLAccountName: "調整勘定科目名：",
    closeButtonTitle: "キャンセル",
    confirmBtnTitle: "削除"
}

export const glAccountListLabel = {
    accountClass: "勘定科目クラス",
    accountSubClass: "勘定科目サブクラス",
    glAccount: "GL勘定科目",
    debit: "借方",
    credit: "貸方",
    actions: "アクション",
    editTitleTip: "GL勘定科目の編集",
    removeTitleTip: "GL勘定科目の削除"
}

export const EngagementMapLabels = {
    objectivePreviewMessage: 'Hover over a map item to preview',
    noMapAvailableMessage: "利用可能なマッピングがありません。",
    takeContentUpdateMessage: "コンテンツアップデートを行い最新のマッピングに更新する。",
    noRecordsLabel: "レコードがありません",
    auditTopic: "監査トピック",
    auditTopicPlaceholder: "トピックを選択して表示する",
    numberSelected: "{0}トピックが選択されています",
    refreshMapTitletip: "エンゲージメントマッピングの更新を開始するにはこちらをクリック",
    mapUpdateInProgress: "更新中です。更新が完了するまでに最大10分かかる場合があります。",
    refreshMapsLabel: "Refresh maps"
}

export const createEditGLAccountLabels = {
    createModalTitle: "新しい調整勘定科目",
    editModalTitle: "調整勘定科目の編集",
    createModalDescription: "以下に調整勘定科目の詳細を入力し'<b>{0}</b>'を選択して終了してください。他の調整勘定科目を作成する場合は'<b>{1}</b>'を選択してください。",
    editModalDescription: "以下の調整勘定科目の詳細を編集し、終了するには'<b>{0}</b>'を選択してください。",
    accountSubClass: "勘定サブクラス",
    accountName: "勘定科目（必須）",
    glAccountName: "調整勘定科目名（必須）",
    cancelbtn: "キャンセル",
    saveAndAddbtn: "保存して別のものを作成",
    saveAndClosebtn: "保存して閉じる",
    save: "保存",
    required: "必須",
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

    [receiveInstructionSwitcherIds.groupInstructions]: "グループインストラクション",
    [receiveInstructionSwitcherIds.groupRiskAssessment]: "グループリスク評価",
    [receiveInstructionSwitcherIds.documents]: "文書"
};

export const misstatementEvidenceLabels = {
    placeholderText: "関連するエビデンスがありません。少なくとも1つのサポートするエビデンスが関連付けられている必要があります。{0}をクリックしてエビデンスを関連付けてください。",
    addEvidenceBtn: "エビデンスの追加",
};

export const misstatementTempLabels = {
    placeholderText: "関連する一時文書がありません。一時文書を関連付けるには、{0}をクリックします。",
    addEvidenceBtn: "一時ファイルの追加",
};

export const inherentRiskFactorTypes = [{
        id: 1,
        label: "複雑性",
        displayOrder: 1
    },
    {
        id: 2,
        label: "主観性 不確実性",
        displayOrder: 2
    },
    {
        id: 3,
        label: "不正又は誤謬",
        displayOrder: 3
    },
    {
        id: 4,
        label: "変更",
        displayOrder: 4
    },
    {
        id: 5,
        label: "勘定科目の種類",
        displayOrder: 5
    },
    {
        id: 6,
        label: "関連当事者",
        displayOrder: 6
    }
];

export const helixSettingsStepLabels = {
    title: "接続の設定を決定する",
    subTitle: "アナライザー接続の設定を選択する",
    connectionNameLabel: "接続名",
    connectionNamePlaceholder: "接続名(必須)",
    connetionTypesLabel: "接続タイプ",
    connectionTypeScopeAndStrategy: "スコープ及び戦略",
    connectionTypeFinancionStatement: "財務諸表",
    includeAllBusinessUnitsField: "全てのビジネスユニットを含めますか？",
    yes: "はい",
    no: "いいえ",
    businessUnitsLabel: "ビジネスユニット",
    businessUnitsPlaceholder: "ビジネスユニット",
    analysisPeriodLabel: "分析日",
    analysisPeriodPlaceholder: "分析日",
    comparativePeriod1Label: "比較日付1",
    comparativePeriod1Placeholder: "比較日付1 (任意)",
    comparativePeriod2Label: "比較日付2",
    comparativePeriod2Placeholder: "比較日付2 (任意)",
    currencyTypeField: "通貨タイプ",
    reporting: "報告通貨",
    functional: "機能通貨",
    currencyCodeField: "通貨コード",
    currencyCodePlaceholder: "通貨コード(必須)",
    scopeAndStrategyLabel: "スコープ及び戦略",
    financialStatementLabel: "財務諸表",

    required: "必須",
    comparativePeriodError: "日付が無効です。分析日より前の日付を選択してください。",

    dataConnectionLink: 'How to manage data connections',
    helixfiscalDropDownLabel: "日付{0}-{1}",

    helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    businessUnitsSelectedCount: "{0}選択済",
    allBusinessUnitsLabel: "全てのビジネスユニット"
};

export const importDataModalLabels = ({
    title,
    description,
    buttonLabel
}) => {
    return {
        title: title,
        description: description,
        entity: "エンティティ",
        trialBalanceName: "試算表名",
        reporting: "報告通貨",
        functional: "機能通貨",
        analysisPeriod: "分析日",
        comparativePeriod: "比較日付",
        secondComparativePeriod: "第2比較日付（任意）",
        includeFinancialStatements: "財務諸表を含める",
        carryForwardReferencesAndAdjustments: "リファレンスと調整を新しいインポートに繰り越しますか？",
        import: buttonLabel,
        businessUnitSelectedCount: "{0} ビジネスユニット",
        businessUnitsSelectedCount: "{0} ビジネスユニット",
        allBusinessUnitsLabel: "全てのビジネスユニット",
        businessUnitsPlaceholder: "ビジネスユニット",
        required: "必須",
        comparativePeriodError: "日付が無効です。分析日より前の日付を選択してください。",
        secondComparativePeriodError: "比較日付と同じかそれ以降の第2比較日付。",
        equalComparativePeriodError: "日付を同じにすることはできません。",
        analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates.'
    };
};

export const AnalyzerHelixErrors = {
    400: "選択した接続のEY Helixプロジェクトは使用できなくなりました。詳細については、EY Helixの管理者にお問い合わせください。接続を完全に削除するには、まず接続に関連付けられている全てのインポートを削除します。次に、Moreメニューの「アナライザーの接続を切断する」をクリックします。別のアナライザーを接続する必要があるかどうかを検討してください。",
    403: "接続したアナライザーにチームメンバーとしてのアクセス権がありません。EY Helixプロジェクト管理者へ連絡しアクセス権を取得してください。",
    405: "リンクされた接続ではアナリティクスは利用できません。EY Helixに移動し、データとアナリティクスの処理ステップを完了して続行します。",
    406: "選択した接続のEY Helixアナライザーは使用できなくなりました。詳細については、EY Helixの管理者にお問い合わせください。接続を完全に削除するには、まず接続に関連付けられている全てのインポートを削除します。次に、Moreメニューの「アナライザーの接続を切断する」をクリックします。別のアナライザーを接続する必要があるかどうかを検討してください。",
    408: "選択した接続のEY Helixプロジェクトは使用できなくなりました。詳細については、EY Helixの管理者にお問い合わせください。接続を完全に削除するには、まず接続に関連付けられている全てのインポートを削除します。次に、Moreメニューの「アナライザーの接続を切断する」をクリックします。別のアナライザーを接続する必要があるかどうかを検討してください。",
    411: "選択したアナライザーには必須のパラメーターが全て揃っていません。詳細についてはEY Helix管理者に連絡してください。",
    430: "選択したアナライザーには必須のパラメーターが全て揃っていません。詳細についてはEY Helix管理者に連絡してください。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    800: "EY Helixへアクセスされた履歴がありません。EY Helixへ移動して、ログインの上インストラクションに従いアカウントをセットアップしてください",
    801: "リンクされたプロジェクトの承認されたチームメンバーではありません。アクセスするには、EY Helixプロジェクトの管理者へ連絡してください。",
    901: "選択した接続のEY Helixプロジェクトは利用できなくなりました。詳細についてはEY Helixの管理者へ連絡してください。接続を完全に削除するには、以下の詳細メニューで'削除'をクリックしてください。また、別のアナライザーを接続する必要がないか検討してください。",
    902: "選択した接続のEY Helixプロジェクトは削除対象としてマークされています。詳細についてはEY Helixの管理者へ連絡してください。接続を完全に削除するには、以下の詳細メニューで'削除'をクリックしてください。また、別のアナライザーを接続する必要がないか検討してください。",
    903: "選択した接続のEY Helixプロジェクトは保存対象としてマークされています。詳細についてはEY Helixの管理者へ連絡してください。接続を完全に削除するには、以下の詳細メニューで'削除'をクリックしてください。また、別のアナライザーを接続する必要がないか検討してください。",
    926: "選択されたEY Helixのアナライザーは利用できません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    927: "分析はリンクされたプロジェクトにおいて利用できません。EY Helixに移動しデータ及び分析プロセスのステップを完了したうえで続行してください。",
    928: "EY Helixのアナライザーが無効又はありません。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    929: "リンクされたEY Helixプロジェクトでエラーが発生しました。データのインポートができません。"
};

export const validationLabels = {
    viewAdjustmentWithValidations: "バリデーション有の調整 {0} を表示",
    validationTypeAmtMissmatch: "借方の合計は貸方の合計と一致しません",
    validationTypeNoEvidence: "関連するエビデンスがありません"
};

export const canavsImportErrors = {
    400: "インポートに失敗しました。選択した接続のEY Helixプロジェクトは使用できなくなりました。詳細については、EY Helixの管理者にお問い合わせください。接続を完全に削除するには、まず接続に関連付けられている全てのインポートを削除します。次に、Moreメニューの「アナライザーの接続を切断する」をクリックします。別のアナライザーを接続する必要があるかどうかを検討してください。",
    403: "インポートに失敗しました。接続したアナライザーにチームメンバーとしてのアクセス権がありません。EY Helixプロジェクト管理者へ連絡してアクセス権を取得し、ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    405: "インポートに失敗しました。リンクされた接続ではアナリティクスは利用できません。EY Helixに移動し、データとアナリティクスの処理ステップを完了して続行します。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    406: "インポートに失敗しました。選択した接続のEY Helixアナライザーは使用できなくなりました。詳細については、EY Helixの管理者にお問い合わせください。接続を完全に削除するには、まず接続に関連付けられている全てのインポートを削除します。次に、Moreメニューの「アナライザーの接続を切断する」をクリックします。別のアナライザーを接続する必要があるかどうかを検討してください。",
    408: "インポートに失敗しました。選択した接続のEY Helixプロジェクトは使用できなくなりました。詳細については、EY Helixの管理者にお問い合わせください。接続を完全に削除するには、まず接続に関連付けられている全てのインポートを削除します。次に、Moreメニューの「アナライザーの接続を切断する」をクリックします。別のアナライザーを接続するかどうかを検討してください。",
    411: "インポートに失敗しました。選択したアナライザーには必須のパラメーターが全て揃っていません。詳細についてはEY Helix管理者に連絡してください。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    430: "インポートに失敗しました。選択したアナライザーには必須のパラメーターが全て揃っていません。詳細についてはEY Helix管理者に連絡してください。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    113082: "分析期間を空にすることはできません。"
};
